// Autogenerated with: yarn tsx scripts/generateSvgInfo.ts
// To make changes to this file, edit that script.
// To resolve merge conflicts in this file, simply re-run that script.
// This script is also run by `yarn codegen`.

import { type SvgNameFixed } from './_generatedSvgTypes';

export const SVGNAME_TO_DIMENSIONS_MAP_FIXED: Record<
  SvgNameFixed,
  { width: number; height: number }
> = {
  '3-D_shapes_on_isometric_paper/3D_outline_shape_cone1_isometric_paper': {
    width: 395,
    height: 362
  },
  '3-D_shapes_on_isometric_paper/3D_outline_shape_cone2_isometric_paper': {
    width: 395,
    height: 362
  },
  '3-D_shapes_on_isometric_paper/3D_outline_shape_cone3_isometric_paper': {
    width: 395,
    height: 362
  },
  '3-D_shapes_on_isometric_paper/3D_outline_shape_cone4_isometric_paper': {
    width: 395,
    height: 362
  },
  '3-D_shapes_on_isometric_paper/3D_outline_shape_cylinder1_isometric_paper': {
    width: 395,
    height: 362
  },
  '3-D_shapes_on_isometric_paper/3D_outline_shape_cylinder2_isometric_paper': {
    width: 395,
    height: 362
  },
  '3-D_shapes_on_isometric_paper/3D_outline_shape_cylinder3_isometric_paper': {
    width: 395,
    height: 362
  },
  '3-D_shapes_on_isometric_paper/3D_outline_shape_hexagonal_prism1_isometric_paper': {
    width: 395,
    height: 362
  },
  '3-D_shapes_on_isometric_paper/3D_outline_shape_hexagonal_prism2_isometric_paper': {
    width: 395,
    height: 362
  },
  '3-D_shapes_on_isometric_paper/3D_outline_shape_hexagonal_prism3_isometric_paper': {
    width: 395,
    height: 362
  },
  '3-D_shapes_on_isometric_paper/3D_outline_shape_pentagonal_prism1_isometric_paper': {
    width: 395,
    height: 362
  },
  '3-D_shapes_on_isometric_paper/3D_outline_shape_pentagonal_prism2_isometric_paper': {
    width: 395,
    height: 362
  },
  '3-D_shapes_on_isometric_paper/3D_outline_shape_pentagonal_prism3_isometric_paper': {
    width: 395,
    height: 362
  },
  '3-D_shapes_on_isometric_paper/3D_outline_shape_square_based_pyramid1_isometric_paper': {
    width: 395,
    height: 362
  },
  '3-D_shapes_on_isometric_paper/3D_outline_shape_square_based_pyramid2_isometric_paper': {
    width: 395,
    height: 362
  },
  '3-D_shapes_on_isometric_paper/3D_outline_shape_square_based_pyramid3_isometric_paper': {
    width: 395,
    height: 362
  },
  '3-D_shapes_on_isometric_paper/3D_outline_shape_triangular_based_pyramid1_isometric_paper': {
    width: 395,
    height: 362
  },
  '3-D_shapes_on_isometric_paper/3D_outline_shape_triangular_based_pyramid2_isometric_paper': {
    width: 395,
    height: 362
  },
  '3-D_shapes_on_isometric_paper/3D_outline_shape_triangular_based_pyramid3_isometric_paper': {
    width: 395,
    height: 362
  },
  '3-D_shapes_on_isometric_paper/3D_outline_shape_triangular_prism1_isometric_paper': {
    width: 395,
    height: 362
  },
  '3-D_shapes_on_isometric_paper/3D_outline_shape_triangular_prism2_isometric_paper': {
    width: 395,
    height: 362
  },
  '3-D_shapes_on_isometric_paper/3D_outline_shape_triangular_prism3_isometric_paper': {
    width: 395,
    height: 362
  },
  '3-D_shapes_on_isometric_paper/3D_shape_cone1_isometric_paper': { width: 395, height: 362 },
  '3-D_shapes_on_isometric_paper/3D_shape_cone2_isometric_paper': { width: 395, height: 362 },
  '3-D_shapes_on_isometric_paper/3D_shape_cone3_isometric_paper': { width: 395, height: 362 },
  '3-D_shapes_on_isometric_paper/3D_shape_cone4_isometric_paper': { width: 395, height: 362 },
  '3-D_shapes_on_isometric_paper/3D_shape_cylinder1_isometric_paper': { width: 395, height: 362 },
  '3-D_shapes_on_isometric_paper/3D_shape_cylinder2_isometric_paper': { width: 395, height: 362 },
  '3-D_shapes_on_isometric_paper/3D_shape_cylinder3_isometric_paper': { width: 395, height: 362 },
  '3-D_shapes_on_isometric_paper/3D_shape_hexagonal_prism1_isometric_paper': {
    width: 395,
    height: 362
  },
  '3-D_shapes_on_isometric_paper/3D_shape_hexagonal_prism2_isometric_paper': {
    width: 395,
    height: 362
  },
  '3-D_shapes_on_isometric_paper/3D_shape_hexagonal_prism3_isometric_paper': {
    width: 395,
    height: 362
  },
  '3-D_shapes_on_isometric_paper/3D_shape_pentagonal_prism1_isometric_paper': {
    width: 395,
    height: 362
  },
  '3-D_shapes_on_isometric_paper/3D_shape_pentagonal_prism2_isometric_paper': {
    width: 395,
    height: 362
  },
  '3-D_shapes_on_isometric_paper/3D_shape_pentagonal_prism3_isometric_paper': {
    width: 395,
    height: 362
  },
  '3-D_shapes_on_isometric_paper/3D_shape_square_based_pyramid1_isometric_paper': {
    width: 395,
    height: 362
  },
  '3-D_shapes_on_isometric_paper/3D_shape_square_based_pyramid2_isometric_paper': {
    width: 395,
    height: 362
  },
  '3-D_shapes_on_isometric_paper/3D_shape_square_based_pyramid3_isometric_paper': {
    width: 395,
    height: 362
  },
  '3-D_shapes_on_isometric_paper/3D_shape_triangular_based_pyramid1_isometric_paper': {
    width: 395,
    height: 362
  },
  '3-D_shapes_on_isometric_paper/3D_shape_triangular_based_pyramid2_isometric_paper': {
    width: 395,
    height: 362
  },
  '3-D_shapes_on_isometric_paper/3D_shape_triangular_based_pyramid3_isometric_paper': {
    width: 395,
    height: 362
  },
  '3-D_shapes_on_isometric_paper/3D_shape_triangular_prism1_isometric_paper': {
    width: 395,
    height: 362
  },
  '3-D_shapes_on_isometric_paper/3D_shape_triangular_prism2_isometric_paper': {
    width: 395,
    height: 362
  },
  '3-D_shapes_on_isometric_paper/3D_shape_triangular_prism3_isometric_paper': {
    width: 395,
    height: 362
  },
  '3-D_shapes_with_multi-link_cubes/3D_shape10_multi_link_cubes': {
    width: 217.45079,
    height: 285.15082
  },
  '3-D_shapes_with_multi-link_cubes/3D_shape11_multi_link_cubes': {
    width: 216.4328,
    height: 216.43027
  },
  '3-D_shapes_with_multi-link_cubes/3D_shape12_multi_link_cubes': {
    width: 216.78065,
    height: 259.0368
  },
  '3-D_shapes_with_multi-link_cubes/3D_shape13_multi_link_cubes': {
    width: 258.0628,
    height: 229.38232
  },
  '3-D_shapes_with_multi-link_cubes/3D_shape14_multi_link_cubes': {
    width: 270.60345,
    height: 309.40994
  },
  '3-D_shapes_with_multi-link_cubes/3D_shape15_multi_link_cubes': {
    width: 216.1192,
    height: 373.43961
  },
  '3-D_shapes_with_multi-link_cubes/3D_shape16_multi_link_cubes': {
    width: 162.91279,
    height: 279.76547
  },
  '3-D_shapes_with_multi-link_cubes/3D_shape17_multi_link_cubes': {
    width: 216.32546,
    height: 216.78287
  },
  '3-D_shapes_with_multi-link_cubes/3D_shape18_multi_link_cubes': {
    width: 270.04785,
    height: 266.59543
  },
  '3-D_shapes_with_multi-link_cubes/3D_shape19_multi_link_cubes': {
    width: 162.61053,
    height: 423.52847
  },
  '3-D_shapes_with_multi-link_cubes/3D_shape1_multi_link_cubes': {
    width: 154.69814,
    height: 228.79234
  },
  '3-D_shapes_with_multi-link_cubes/3D_shape20_multi_link_cubes': {
    width: 425.13785,
    height: 339.52661
  },
  '3-D_shapes_with_multi-link_cubes/3D_shape21_multi_link_cubes': {
    width: 323.91,
    height: 292.36841
  },
  '3-D_shapes_with_multi-link_cubes/3D_shape22_multi_link_cubes': {
    width: 216.49039,
    height: 309.93201
  },
  '3-D_shapes_with_multi-link_cubes/3D_shape23_multi_link_cubes': {
    width: 269.77667,
    height: 402.76492
  },
  '3-D_shapes_with_multi-link_cubes/3D_shape24_multi_link_cubes': {
    width: 269.74667,
    height: 242.3284
  },
  '3-D_shapes_with_multi-link_cubes/3D_shape25_multi_link_cubes': {
    width: 269.74667,
    height: 199.38121
  },
  '3-D_shapes_with_multi-link_cubes/3D_shape26_multi_link_cubes': {
    width: 162.87959,
    height: 242.14667
  },
  '3-D_shapes_with_multi-link_cubes/3D_shape27_multi_link_cubes': {
    width: 216.88626,
    height: 242.1544
  },
  '3-D_shapes_with_multi-link_cubes/3D_shape28_multi_link_cubes': {
    width: 215.99319,
    height: 369.65545
  },
  '3-D_shapes_with_multi-link_cubes/3D_shape29_multi_link_cubes': {
    width: 317.96478,
    height: 352.47693
  },
  '3-D_shapes_with_multi-link_cubes/3D_shape2_multi_link_cubes': {
    width: 203.87906,
    height: 292.67486
  },
  '3-D_shapes_with_multi-link_cubes/3D_shape30_multi_link_cubes': {
    width: 323.99359,
    height: 224.64574
  },
  '3-D_shapes_with_multi-link_cubes/3D_shape31_multi_link_cubes': {
    width: 323.99359,
    height: 224.64562
  },
  '3-D_shapes_with_multi-link_cubes/3D_shape32_multi_link_cubes': {
    width: 322.85638,
    height: 225.12454
  },
  '3-D_shapes_with_multi-link_cubes/3D_shape33_multi_link_cubes': {
    width: 269.74668,
    height: 268.00122
  },
  '3-D_shapes_with_multi-link_cubes/3D_shape34_multi_link_cubes': {
    width: 216.44507,
    height: 377.82428
  },
  '3-D_shapes_with_multi-link_cubes/3D_shape35_multi_link_cubes': {
    width: 216.44507,
    height: 377.33948
  },
  '3-D_shapes_with_multi-link_cubes/3D_shape36_multi_link_cubes': {
    width: 270.32572,
    height: 403.26294
  },
  '3-D_shapes_with_multi-link_cubes/3D_shape37_multi_link_cubes': {
    width: 323.11331,
    height: 361.31613
  },
  '3-D_shapes_with_multi-link_cubes/3D_shape38_multi_link_cubes': {
    width: 210.71387,
    height: 343.88898
  },
  '3-D_shapes_with_multi-link_cubes/3D_shape39_multi_link_cubes': {
    width: 213.66707,
    height: 440.00567
  },
  '3-D_shapes_with_multi-link_cubes/3D_shape3_multi_link_cubes': {
    width: 154.08173,
    height: 268.53635
  },
  '3-D_shapes_with_multi-link_cubes/3D_shape40_multi_link_cubes': {
    width: 213.10826,
    height: 305.90677
  },
  '3-D_shapes_with_multi-link_cubes/3D_shape41_multi_link_cubes': {
    width: 163.61,
    height: 324.30521
  },
  '3-D_shapes_with_multi-link_cubes/3D_shape42_multi_link_cubes': {
    width: 204.70706,
    height: 229.06685
  },
  '3-D_shapes_with_multi-link_cubes/3D_shape43_multi_link_cubes': {
    width: 323.2944,
    height: 292.51331
  },
  '3-D_shapes_with_multi-link_cubes/3D_shape44_multi_link_cubes': {
    width: 376.65854,
    height: 318.43103
  },
  '3-D_shapes_with_multi-link_cubes/3D_shape45_multi_link_cubes': {
    width: 255.02853,
    height: 253.56404
  },
  '3-D_shapes_with_multi-link_cubes/3D_shape46_multi_link_cubes': {
    width: 269.76227,
    height: 334.78238
  },
  '3-D_shapes_with_multi-link_cubes/3D_shape47_multi_link_cubes': {
    width: 376.65106,
    height: 292.5133
  },
  '3-D_shapes_with_multi-link_cubes/3D_shape4_multi_link_cubes': {
    width: 163.26399,
    height: 258.32507
  },
  '3-D_shapes_with_multi-link_cubes/3D_shape5_multi_link_cubes': {
    width: 162.61186,
    height: 216.03267
  },
  '3-D_shapes_with_multi-link_cubes/3D_shape6_multi_link_cubes': {
    width: 204.56172,
    height: 292.92593
  },
  '3-D_shapes_with_multi-link_cubes/3D_shape7_multi_link_cubes': {
    width: 204.56172,
    height: 228.92181
  },
  '3-D_shapes_with_multi-link_cubes/3D_shape8_multi_link_cubes': {
    width: 270.36374,
    height: 268.51788
  },
  '3-D_shapes_with_multi-link_cubes/3D_shape9_multi_link_cubes': {
    width: 163.21213,
    height: 258.12106
  },
  '3D_Shapes_Cubes/3D_shape10_cubes': { width: 113.75002, height: 216.09337 },
  '3D_Shapes_Cubes/3D_shape11_cubes': { width: 150.75722, height: 237.85056 },
  '3D_Shapes_Cubes/3D_shape12_cubes': { width: 150.07016, height: 216.3971 },
  '3D_Shapes_Cubes/3D_shape13_cubes': { width: 186.51349, height: 237.76416 },
  '3D_Shapes_Cubes/3D_shape14_cubes': { width: 150.07016, height: 259.41657 },
  '3D_Shapes_Cubes/3D_shape15_cubes': { width: 149.17775, height: 215.90323 },
  '3D_Shapes_Cubes/3D_shape16_cubes': { width: 186.73402, height: 237.34616 },
  '3D_Shapes_Cubes/3D_shape17_cubes': { width: 186.51349, height: 259.47989 },
  '3D_Shapes_Cubes/3D_shape18_cubes': { width: 186.73403, height: 238.28257 },
  '3D_Shapes_Cubes/3D_shape19_cubes': { width: 185.84149, height: 152.5683 },
  '3D_Shapes_Cubes/3D_shape1_cubes': { width: 76.742827, height: 173.26683 },
  '3D_Shapes_Cubes/3D_shape20_cubes': { width: 149.17775, height: 237.31082 },
  '3D_Shapes_Cubes/3D_shape21_cubes': { width: 187.07749, height: 216.09323 },
  '3D_Shapes_Cubes/3D_shape22_cubes': { width: 150.7571, height: 259.53937 },
  '3D_Shapes_Cubes/3D_shape23_cubes': { width: 186.97469, height: 259.37537 },
  '3D_Shapes_Cubes/3D_shape24_cubes': { width: 149.62416, height: 131.14296 },
  '3D_Shapes_Cubes/3D_shape25_cubes': { width: 150.0703, height: 173.23377 },
  '3D_Shapes_Cubes/3D_shape26_cubes': { width: 149.62416, height: 215.67056 },
  '3D_Shapes_Cubes/3D_shape27_cubes': { width: 149.62416, height: 258.33991 },
  '3D_Shapes_Cubes/3D_shape28_cubes': { width: 186.18495, height: 152.5063 },
  '3D_Shapes_Cubes/3D_shape29_cubes': { width: 186.18495, height: 195.17563 },
  '3D_Shapes_Cubes/3D_shape2_cubes': { width: 76.74283, height: 216.09337 },
  '3D_Shapes_Cubes/3D_shape30_cubes': { width: 186.18495, height: 237.74162 },
  '3D_Shapes_Cubes/3D_shape31_cubes': { width: 186.73389, height: 237.0087 },
  '3D_Shapes_Cubes/3D_shape32_cubes': { width: 222.40256, height: 174.28296 },
  '3D_Shapes_Cubes/3D_shape33_cubes': { width: 223.25415, height: 216.70096 },
  '3D_Shapes_Cubes/3D_shape34_cubes': { width: 223.25403, height: 259.37015 },
  '3D_Shapes_Cubes/3D_shape35_cubes': { width: 222.50522, height: 173.00349 },
  '3D_Shapes_Cubes/3D_shape36_cubes': { width: 222.50522, height: 215.36163 },
  '3D_Shapes_Cubes/3D_shape37_cubes': { width: 222.50522, height: 257.99789 },
  '3D_Shapes_Cubes/3D_shape38_cubes': { width: 259.43576, height: 194.48736 },
  '3D_Shapes_Cubes/3D_shape39_cubes': { width: 259.50656, height: 237.12377 },
  '3D_Shapes_Cubes/3D_shape3_cubes': { width: 113.45162, height: 237.19643 },
  '3D_Shapes_Cubes/3D_shape40_cubes': { width: 259.50656, height: 279.79309 },
  '3D_Shapes_Cubes/3D_shape41_cubes': { width: 149.62402, height: 154.1935 },
  '3D_Shapes_Cubes/3D_shape42_cubes': { width: 221.63362, height: 216.01669 },
  '3D_Shapes_Cubes/3D_shape43_cubes': { width: 294.95041, height: 284.35882 },
  '3D_Shapes_Cubes/3D_shape44_cubes': { width: 150.41362, height: 173.69936 },
  '3D_Shapes_Cubes/3D_shape45_cubes': { width: 150.41376, height: 216.3687 },
  '3D_Shapes_Cubes/3D_shape46_cubes': { width: 150.41376, height: 259.03815 },
  '3D_Shapes_Cubes/3D_shape47_cubes': { width: 150.41362, height: 301.99896 },
  '3D_Shapes_Cubes/3D_shape48_cubes': { width: 185.91536, height: 194.41496 },
  '3D_Shapes_Cubes/3D_shape49_cubes': { width: 185.9155, height: 237.08429 },
  '3D_Shapes_Cubes/3D_shape4_cubes': { width: 113.40656, height: 152.44603 },
  '3D_Shapes_Cubes/3D_shape50_cubes': { width: 185.9155, height: 279.75363 },
  '3D_Shapes_Cubes/3D_shape51_cubes': { width: 223.63829, height: 238.25656 },
  '3D_Shapes_Cubes/3D_shape52_cubes': { width: 259.8559, height: 259.29123 },
  '3D_Shapes_Cubes/3D_shape53_cubes': { width: 186.63123, height: 184.72603 },
  '3D_Shapes_Cubes/3D_shape54_cubes': { width: 222.84855, height: 205.76069 },
  '3D_Shapes_Cubes/3D_shape57_cubes': { width: 149.17912, height: 215.18984 },
  '3D_Shapes_Cubes/3D_shape58_cubes': { width: 186.18632, height: 236.93463 },
  '3D_Shapes_Cubes/3D_shape59_cubes': { width: 149.96886, height: 173.76851 },
  '3D_Shapes_Cubes/3D_shape5_cubes': { width: 113.40656, height: 194.70976 },
  '3D_Shapes_Cubes/3D_shape60_cubes': { width: 118.15333, height: 116.96022 },
  '3D_Shapes_Cubes/3D_shape61_cubes': { width: 201.577, height: 117.13253 },
  '3D_Shapes_Cubes/3D_shape62_cubes': { width: 149.96886, height: 173.76851 },
  '3D_Shapes_Cubes/3D_shape63_cubes': { width: 201.91893, height: 117.12449 },
  '3D_Shapes_Cubes/3D_shape64_cubes': { width: 259.86661, height: 132.68369 },
  '3D_Shapes_Cubes/3D_shape65_cubes': { width: 276.02493, height: 106.43666 },
  '3D_Shapes_Cubes/3D_shape66_cubes': { width: 222.97032, height: 195.42317 },
  '3D_Shapes_Cubes/3D_shape67_cubes': { width: 222.35658, height: 215.82477 },
  '3D_Shapes_Cubes/3D_shape68_cubes': { width: 367.62683, height: 426.77588 },
  '3D_Shapes_Cubes/3D_shape69_cubes': { width: 76.742827, height: 88.739 },
  '3D_Shapes_Cubes/3D_shape6_cubes': { width: 149.17789, height: 172.9247 },
  '3D_Shapes_Cubes/3D_shape70_cubes': { width: 294.879, height: 341.913 },
  '3D_Shapes_Cubes/3D_shape7_cubes': { width: 149.17775, height: 215.18843 },
  '3D_Shapes_Cubes/3D_shape8_cubes': { width: 186.73402, height: 194.46789 },
  '3D_Shapes_Cubes/3D_shape9_cubes': { width: 149.17775, height: 172.92456 },
  '3D_Shapes_Cubes_on_Iso_Grid/3D_shape10_cubes_isometric_paper': {
    width: 401.392,
    height: 361.71066
  },
  '3D_Shapes_Cubes_on_Iso_Grid/3D_shape11_cubes_isometric_paper': {
    width: 434.31467,
    height: 361.71066
  },
  '3D_Shapes_Cubes_on_Iso_Grid/3D_shape12_cubes_isometric_paper': {
    width: 434.31467,
    height: 361.71066
  },
  '3D_Shapes_Cubes_on_Iso_Grid/3D_shape13_cubes_isometric_paper': {
    width: 434.31467,
    height: 361.71066
  },
  '3D_Shapes_Cubes_on_Iso_Grid/3D_shape1_cubes_isometric_paper': {
    width: 392.44266,
    height: 361.71066
  },
  '3D_Shapes_Cubes_on_Iso_Grid/3D_shape2_cubes_isometric_paper': {
    width: 390.66132,
    height: 361.71066
  },
  '3D_Shapes_Cubes_on_Iso_Grid/3D_shape3_cubes_isometric_paper': {
    width: 393.11066,
    height: 361.71066
  },
  '3D_Shapes_Cubes_on_Iso_Grid/3D_shape4_cubes_isometric_paper': {
    width: 434.31467,
    height: 361.71066
  },
  '3D_Shapes_Cubes_on_Iso_Grid/3D_shape5_cubes_isometric_paper': {
    width: 434.31467,
    height: 361.71066
  },
  '3D_Shapes_Cubes_on_Iso_Grid/3D_shape6_cubes_isometric_paper': {
    width: 434.31467,
    height: 361.71066
  },
  '3D_Shapes_Cubes_on_Iso_Grid/3D_shape7_cubes_isometric_paper': {
    width: 434.31467,
    height: 361.71066
  },
  '3D_Shapes_Cubes_on_Iso_Grid/3D_shape8_cubes_isometric_paper': {
    width: 434.31467,
    height: 361.71066
  },
  '3D_Shapes_Cubes_on_Iso_Grid/3D_shape9_cubes_isometric_paper': {
    width: 434.31467,
    height: 361.71066
  },
  '3D_Shapes_Cubes_w_no_identations_on_Iso_Grid/3D_outline_shape10_isometric_paper': {
    width: 404.83331,
    height: 361.71066
  },
  '3D_Shapes_Cubes_w_no_identations_on_Iso_Grid/3D_outline_shape11_isometric_paper': {
    width: 434.31467,
    height: 361.71066
  },
  '3D_Shapes_Cubes_w_no_identations_on_Iso_Grid/3D_outline_shape12_isometric_paper': {
    width: 434.31467,
    height: 361.71066
  },
  '3D_Shapes_Cubes_w_no_identations_on_Iso_Grid/3D_outline_shape13_isometric_paper': {
    width: 434.31467,
    height: 361.71066
  },
  '3D_Shapes_Cubes_w_no_identations_on_Iso_Grid/3D_outline_shape1_isometric_paper': {
    width: 391.45334,
    height: 361.71066
  },
  '3D_Shapes_Cubes_w_no_identations_on_Iso_Grid/3D_outline_shape2_isometric_paper': {
    width: 394.56534,
    height: 361.71066
  },
  '3D_Shapes_Cubes_w_no_identations_on_Iso_Grid/3D_outline_shape3_isometric_paper': {
    width: 394.56534,
    height: 361.71066
  },
  '3D_Shapes_Cubes_w_no_identations_on_Iso_Grid/3D_outline_shape4_isometric_paper': {
    width: 434.31467,
    height: 361.71066
  },
  '3D_Shapes_Cubes_w_no_identations_on_Iso_Grid/3D_outline_shape5_isometric_paper': {
    width: 429.47333,
    height: 361.71066
  },
  '3D_Shapes_Cubes_w_no_identations_on_Iso_Grid/3D_outline_shape6_isometric_paper': {
    width: 439.96399,
    height: 361.71066
  },
  '3D_Shapes_Cubes_w_no_identations_on_Iso_Grid/3D_outline_shape7_isometric_paper': {
    width: 434.31467,
    height: 361.71066
  },
  '3D_Shapes_Cubes_w_no_identations_on_Iso_Grid/3D_outline_shape8_isometric_paper': {
    width: 405.496,
    height: 361.71066
  },
  '3D_Shapes_Cubes_w_no_identations_on_Iso_Grid/3D_outline_shape9_isometric_paper': {
    width: 404.01999,
    height: 361.71066
  },
  '3D_Shapes_Cubes_w_no_identations_on_Iso_Grid/3D_shape10_isometric_paper': {
    width: 404.83331,
    height: 361.71066
  },
  '3D_Shapes_Cubes_w_no_identations_on_Iso_Grid/3D_shape11_isometric_paper': {
    width: 434.31467,
    height: 361.71066
  },
  '3D_Shapes_Cubes_w_no_identations_on_Iso_Grid/3D_shape12_isometric_paper': {
    width: 434.31467,
    height: 361.71066
  },
  '3D_Shapes_Cubes_w_no_identations_on_Iso_Grid/3D_shape13_isometric_paper': {
    width: 434.31467,
    height: 361.71066
  },
  '3D_Shapes_Cubes_w_no_identations_on_Iso_Grid/3D_shape1_isometric_paper': {
    width: 391.45334,
    height: 361.71066
  },
  '3D_Shapes_Cubes_w_no_identations_on_Iso_Grid/3D_shape2_isometric_paper': {
    width: 394.56534,
    height: 361.71066
  },
  '3D_Shapes_Cubes_w_no_identations_on_Iso_Grid/3D_shape3_isometric_paper': {
    width: 394.56534,
    height: 361.71066
  },
  '3D_Shapes_Cubes_w_no_identations_on_Iso_Grid/3D_shape4_isometric_paper': {
    width: 434.31467,
    height: 361.71066
  },
  '3D_Shapes_Cubes_w_no_identations_on_Iso_Grid/3D_shape5_isometric_paper': {
    width: 429.47333,
    height: 361.71066
  },
  '3D_Shapes_Cubes_w_no_identations_on_Iso_Grid/3D_shape6_isometric_paper': {
    width: 439.96399,
    height: 361.71066
  },
  '3D_Shapes_Cubes_w_no_identations_on_Iso_Grid/3D_shape7_isometric_paper': {
    width: 434.31467,
    height: 361.71066
  },
  '3D_Shapes_Cubes_w_no_identations_on_Iso_Grid/3D_shape8_isometric_paper': {
    width: 405.496,
    height: 361.71066
  },
  '3D_Shapes_Cubes_w_no_identations_on_Iso_Grid/3D_shape9_isometric_paper': {
    width: 404.01999,
    height: 361.71066
  },
  '3D_compound_shapes_on_isometric_paper/3D_compound_shape1': { width: 333, height: 338 },
  '3D_compound_shapes_on_isometric_paper/3D_compound_shape10': { width: 333, height: 339 },
  '3D_compound_shapes_on_isometric_paper/3D_compound_shape11': { width: 335, height: 339 },
  '3D_compound_shapes_on_isometric_paper/3D_compound_shape12': { width: 334, height: 339 },
  '3D_compound_shapes_on_isometric_paper/3D_compound_shape13': { width: 333, height: 339 },
  '3D_compound_shapes_on_isometric_paper/3D_compound_shape14': { width: 333, height: 339 },
  '3D_compound_shapes_on_isometric_paper/3D_compound_shape15': { width: 333, height: 339 },
  '3D_compound_shapes_on_isometric_paper/3D_compound_shape16': { width: 334, height: 339 },
  '3D_compound_shapes_on_isometric_paper/3D_compound_shape2': { width: 334, height: 339 },
  '3D_compound_shapes_on_isometric_paper/3D_compound_shape3': { width: 333, height: 340 },
  '3D_compound_shapes_on_isometric_paper/3D_compound_shape4': { width: 333, height: 339 },
  '3D_compound_shapes_on_isometric_paper/3D_compound_shape5': { width: 333, height: 339 },
  '3D_compound_shapes_on_isometric_paper/3D_compound_shape6': { width: 333, height: 339 },
  '3D_compound_shapes_on_isometric_paper/3D_compound_shape7': { width: 333, height: 339 },
  '3D_compound_shapes_on_isometric_paper/3D_compound_shape8': { width: 333, height: 339 },
  '3D_compound_shapes_on_isometric_paper/3D_compound_shape9': { width: 334, height: 339 },
  '3D_shapes_full_colors/Cones/Cone_blue': { width: 283.50763, height: 297.01584 },
  '3D_shapes_full_colors/Cones/Cone_green': { width: 283.50763, height: 297.01584 },
  '3D_shapes_full_colors/Cones/Cone_orange': { width: 283.50763, height: 297.01584 },
  '3D_shapes_full_colors/Cones/Cone_pink': { width: 283.50763, height: 297.01584 },
  '3D_shapes_full_colors/Cones/Cone_purple': { width: 283.50763, height: 297.01584 },
  '3D_shapes_full_colors/Cones/Cone_red': { width: 283.50763, height: 297.01584 },
  '3D_shapes_full_colors/Cones/Cone_transparent': { width: 283.50763, height: 297.01584 },
  '3D_shapes_full_colors/Cones/Cone_yellow': { width: 283.50763, height: 297.01584 },
  '3D_shapes_full_colors/Cubes/Cube_blue': { width: 299.14658, height: 324.82065 },
  '3D_shapes_full_colors/Cubes/Cube_blue_2': { width: 97, height: 164 },
  '3D_shapes_full_colors/Cubes/Cube_blue_3': { width: 97, height: 223 },
  '3D_shapes_full_colors/Cubes/Cube_green': { width: 299.14658, height: 324.82065 },
  '3D_shapes_full_colors/Cubes/Cube_green_2': { width: 97, height: 164 },
  '3D_shapes_full_colors/Cubes/Cube_green_3': { width: 97, height: 223 },
  '3D_shapes_full_colors/Cubes/Cube_orange': { width: 299.14658, height: 324.82065 },
  '3D_shapes_full_colors/Cubes/Cube_orange_2': { width: 97, height: 164 },
  '3D_shapes_full_colors/Cubes/Cube_orange_3': { width: 97, height: 223 },
  '3D_shapes_full_colors/Cubes/Cube_pink': { width: 299.14658, height: 324.82065 },
  '3D_shapes_full_colors/Cubes/Cube_pink_2': { width: 97, height: 164 },
  '3D_shapes_full_colors/Cubes/Cube_pink_3': { width: 97, height: 223 },
  '3D_shapes_full_colors/Cubes/Cube_purple': { width: 299.14658, height: 324.82065 },
  '3D_shapes_full_colors/Cubes/Cube_purple_2': { width: 97, height: 164 },
  '3D_shapes_full_colors/Cubes/Cube_purple_3': { width: 97, height: 223 },
  '3D_shapes_full_colors/Cubes/Cube_red': { width: 299.14658, height: 324.82065 },
  '3D_shapes_full_colors/Cubes/Cube_red_2': { width: 97, height: 164 },
  '3D_shapes_full_colors/Cubes/Cube_red_3': { width: 97, height: 223 },
  '3D_shapes_full_colors/Cubes/Cube_transparent': { width: 299.14658, height: 324.82065 },
  '3D_shapes_full_colors/Cubes/Cube_yellow': { width: 299.14658, height: 324.82065 },
  '3D_shapes_full_colors/Cubes/Cube_yellow_2': { width: 97, height: 164 },
  '3D_shapes_full_colors/Cubes/Cube_yellow_3': { width: 97, height: 223 },
  '3D_shapes_full_colors/Cuboids/Cuboid_blue': { width: 407.49799, height: 325.1648 },
  '3D_shapes_full_colors/Cuboids/Cuboid_green': { width: 407.49799, height: 325.1648 },
  '3D_shapes_full_colors/Cuboids/Cuboid_orange': { width: 407.49799, height: 325.1648 },
  '3D_shapes_full_colors/Cuboids/Cuboid_pink': { width: 407.49799, height: 325.1648 },
  '3D_shapes_full_colors/Cuboids/Cuboid_purple': { width: 407.49799, height: 325.1648 },
  '3D_shapes_full_colors/Cuboids/Cuboid_red': { width: 407.49799, height: 325.1648 },
  '3D_shapes_full_colors/Cuboids/Cuboid_transparent': { width: 407.49799, height: 325.1648 },
  '3D_shapes_full_colors/Cuboids/Cuboid_yellow': { width: 407.49799, height: 325.1648 },
  '3D_shapes_full_colors/Cylinders/Cylinder_blue': { width: 260.92221, height: 397.89957 },
  '3D_shapes_full_colors/Cylinders/Cylinder_green': { width: 260.92221, height: 397.89957 },
  '3D_shapes_full_colors/Cylinders/Cylinder_orange': { width: 260.92221, height: 397.89957 },
  '3D_shapes_full_colors/Cylinders/Cylinder_pink': { width: 260.92221, height: 397.89957 },
  '3D_shapes_full_colors/Cylinders/Cylinder_purple': { width: 260.92221, height: 397.89957 },
  '3D_shapes_full_colors/Cylinders/Cylinder_red': { width: 260.92221, height: 397.89957 },
  '3D_shapes_full_colors/Cylinders/Cylinder_transparent': { width: 260.92221, height: 397.89957 },
  '3D_shapes_full_colors/Cylinders/Cylinder_yellow': { width: 260.92221, height: 397.89957 },
  '3D_shapes_full_colors/Front_face_cubes/Cube_front_face_blue': {
    width: 352.12463,
    height: 325.1648
  },
  '3D_shapes_full_colors/Front_face_cubes/Cube_front_face_green': {
    width: 352.12463,
    height: 325.1648
  },
  '3D_shapes_full_colors/Front_face_cubes/Cube_front_face_orange': {
    width: 352.12463,
    height: 325.1648
  },
  '3D_shapes_full_colors/Front_face_cubes/Cube_front_face_pink': {
    width: 352.12463,
    height: 325.1648
  },
  '3D_shapes_full_colors/Front_face_cubes/Cube_front_face_purple': {
    width: 352.12463,
    height: 325.1648
  },
  '3D_shapes_full_colors/Front_face_cubes/Cube_front_face_red': {
    width: 352.12463,
    height: 325.1648
  },
  '3D_shapes_full_colors/Front_face_cubes/Cube_front_face_transparent': {
    width: 351.70242,
    height: 325.1648
  },
  '3D_shapes_full_colors/Front_face_cubes/Cube_front_face_yellow': {
    width: 352.12463,
    height: 325.1648
  },
  '3D_shapes_full_colors/Hexagonal_prisms/Hexagonal_prism_blue': {
    width: 243.9223,
    height: 339.24252
  },
  '3D_shapes_full_colors/Hexagonal_prisms/Hexagonal_prism_green': {
    width: 243.9223,
    height: 339.24252
  },
  '3D_shapes_full_colors/Hexagonal_prisms/Hexagonal_prism_orange': {
    width: 243.9223,
    height: 339.24252
  },
  '3D_shapes_full_colors/Hexagonal_prisms/Hexagonal_prism_pink': {
    width: 243.9223,
    height: 339.24252
  },
  '3D_shapes_full_colors/Hexagonal_prisms/Hexagonal_prism_purple': {
    width: 243.9223,
    height: 339.24252
  },
  '3D_shapes_full_colors/Hexagonal_prisms/Hexagonal_prism_red': {
    width: 243.9223,
    height: 339.24252
  },
  '3D_shapes_full_colors/Hexagonal_prisms/Hexagonal_prism_transparent': {
    width: 243.9223,
    height: 339.24252
  },
  '3D_shapes_full_colors/Hexagonal_prisms/Hexagonal_prism_yellow': {
    width: 243.9223,
    height: 339.24252
  },
  '3D_shapes_full_colors/Pentagonal_prisms/Pentagonal_prism_blue': {
    width: 208.37843,
    height: 320.00559
  },
  '3D_shapes_full_colors/Pentagonal_prisms/Pentagonal_prism_green': {
    width: 208.37843,
    height: 320.00559
  },
  '3D_shapes_full_colors/Pentagonal_prisms/Pentagonal_prism_orange': {
    width: 208.37843,
    height: 320.00559
  },
  '3D_shapes_full_colors/Pentagonal_prisms/Pentagonal_prism_pink': {
    width: 208.37843,
    height: 320.00559
  },
  '3D_shapes_full_colors/Pentagonal_prisms/Pentagonal_prism_purple': {
    width: 208.37843,
    height: 320.00559
  },
  '3D_shapes_full_colors/Pentagonal_prisms/Pentagonal_prism_red': {
    width: 208.37843,
    height: 320.00559
  },
  '3D_shapes_full_colors/Pentagonal_prisms/Pentagonal_prism_transparent': {
    width: 208.37843,
    height: 320.00559
  },
  '3D_shapes_full_colors/Pentagonal_prisms/Pentagonal_prism_yellow': {
    width: 208.37843,
    height: 320.00559
  },
  '3D_shapes_full_colors/Spheres/Sphere_blue': { width: 280.87155, height: 280.94608 },
  '3D_shapes_full_colors/Spheres/Sphere_green': { width: 280.87155, height: 280.94608 },
  '3D_shapes_full_colors/Spheres/Sphere_orange': { width: 280.87155, height: 280.94608 },
  '3D_shapes_full_colors/Spheres/Sphere_pink': { width: 280.87155, height: 280.94608 },
  '3D_shapes_full_colors/Spheres/Sphere_purple': { width: 280.87155, height: 280.94608 },
  '3D_shapes_full_colors/Spheres/Sphere_red': { width: 280.87155, height: 280.94608 },
  '3D_shapes_full_colors/Spheres/Sphere_transparent': { width: 280.87155, height: 280.94608 },
  '3D_shapes_full_colors/Spheres/Sphere_yellow': { width: 280.87155, height: 280.94608 },
  '3D_shapes_full_colors/Square_pyramids/Square_pyramid_blue': {
    width: 321.92477,
    height: 291.74646
  },
  '3D_shapes_full_colors/Square_pyramids/Square_pyramid_green': {
    width: 321.92477,
    height: 291.74646
  },
  '3D_shapes_full_colors/Square_pyramids/Square_pyramid_orange': {
    width: 321.92477,
    height: 291.74646
  },
  '3D_shapes_full_colors/Square_pyramids/Square_pyramid_pink': {
    width: 321.92477,
    height: 291.74646
  },
  '3D_shapes_full_colors/Square_pyramids/Square_pyramid_purple': {
    width: 321.92477,
    height: 291.74646
  },
  '3D_shapes_full_colors/Square_pyramids/Square_pyramid_red': {
    width: 321.92477,
    height: 291.74646
  },
  '3D_shapes_full_colors/Square_pyramids/Square_pyramid_transparent': {
    width: 321.92477,
    height: 291.74646
  },
  '3D_shapes_full_colors/Square_pyramids/Square_pyramid_yellow': {
    width: 321.92477,
    height: 291.74646
  },
  '3D_shapes_full_colors/Triangle_pyramids/Triangle_pyramid_blue': {
    width: 271.82831,
    height: 299.99765
  },
  '3D_shapes_full_colors/Triangle_pyramids/Triangle_pyramid_green': {
    width: 271.82831,
    height: 299.99765
  },
  '3D_shapes_full_colors/Triangle_pyramids/Triangle_pyramid_orange': {
    width: 271.82831,
    height: 299.99765
  },
  '3D_shapes_full_colors/Triangle_pyramids/Triangle_pyramid_pink': {
    width: 271.82831,
    height: 299.99765
  },
  '3D_shapes_full_colors/Triangle_pyramids/Triangle_pyramid_purple': {
    width: 271.82831,
    height: 299.99765
  },
  '3D_shapes_full_colors/Triangle_pyramids/Triangle_pyramid_red': {
    width: 271.82831,
    height: 299.99765
  },
  '3D_shapes_full_colors/Triangle_pyramids/Triangle_pyramid_transparent': {
    width: 271.82831,
    height: 299.99765
  },
  '3D_shapes_full_colors/Triangle_pyramids/Triangle_pyramid_yellow': {
    width: 271.82831,
    height: 299.99765
  },
  '3D_shapes_full_colors/Triangular_prisms/Triangular_prism_blue': {
    width: 183.62399,
    height: 327.98877
  },
  '3D_shapes_full_colors/Triangular_prisms/Triangular_prism_green': {
    width: 183.62399,
    height: 327.98877
  },
  '3D_shapes_full_colors/Triangular_prisms/Triangular_prism_orange': {
    width: 183.62399,
    height: 327.98877
  },
  '3D_shapes_full_colors/Triangular_prisms/Triangular_prism_pink': {
    width: 183.62399,
    height: 327.98877
  },
  '3D_shapes_full_colors/Triangular_prisms/Triangular_prism_purple': {
    width: 183.62399,
    height: 327.98877
  },
  '3D_shapes_full_colors/Triangular_prisms/Triangular_prism_red': {
    width: 183.62399,
    height: 327.98877
  },
  '3D_shapes_full_colors/Triangular_prisms/Triangular_prism_transparent': {
    width: 183.62399,
    height: 327.98877
  },
  '3D_shapes_full_colors/Triangular_prisms/Triangular_prism_yellow': {
    width: 183.62399,
    height: 327.98877
  },
  '3D_shapes_in_real_life_objects/Cone_objects/Chips_cone': { width: 508.74263, height: 656.22662 },
  '3D_shapes_in_real_life_objects/Cone_objects/Christmas_tree': {
    width: 590.14903,
    height: 834.6778
  },
  '3D_shapes_in_real_life_objects/Cone_objects/Cooking_funnel': {
    width: 661.70311,
    height: 711.20386
  },
  '3D_shapes_in_real_life_objects/Cone_objects/Megaphone': { width: 654.09172, height: 685.94183 },
  '3D_shapes_in_real_life_objects/Cone_objects/Party_hat': { width: 464.11147, height: 690.89441 },
  '3D_shapes_in_real_life_objects/Cone_objects/Pine_cone': { width: 539.84581, height: 588.51709 },
  '3D_shapes_in_real_life_objects/Cone_objects/Traffic_cone': {
    width: 558.69786,
    height: 771.44397
  },
  '3D_shapes_in_real_life_objects/Cone_objects/Waffle_cone': {
    width: 508.74263,
    height: 656.22662
  },
  '3D_shapes_in_real_life_objects/Cube_objects/Brick': { width: 324.99291, height: 356.99146 },
  '3D_shapes_in_real_life_objects/Cube_objects/Dice': { width: 221.66522, height: 230.69066 },
  '3D_shapes_in_real_life_objects/Cube_objects/Ice_cube': { width: 179.31962, height: 193.33638 },
  '3D_shapes_in_real_life_objects/Cube_objects/Open_cardboard_box': {
    width: 571.79375,
    height: 622.63086
  },
  '3D_shapes_in_real_life_objects/Cube_objects/Present': { width: 452.32396, height: 518.76038 },
  '3D_shapes_in_real_life_objects/Cube_objects/Rubix_cube': { width: 388.86492, height: 449.38812 },
  '3D_shapes_in_real_life_objects/Cube_objects/Stacking_crate': {
    width: 452.32396,
    height: 496.94159
  },
  '3D_shapes_in_real_life_objects/Cube_objects/White_sugar_cube': {
    width: 103.72953,
    height: 112.83758
  },
  '3D_shapes_in_real_life_objects/Cube_objects/Wooden_letter_block': {
    width: 452.32503,
    height: 496.93671
  },
  '3D_shapes_in_real_life_objects/Cuboid_objects/Brick': { width: 371.50411, height: 356.13879 },
  '3D_shapes_in_real_life_objects/Cuboid_objects/Cardboard_box_cuboid': {
    width: 469.96965,
    height: 593.9256
  },
  '3D_shapes_in_real_life_objects/Cuboid_objects/Cereal_box': {
    width: 353.5805,
    height: 601.78937
  },
  '3D_shapes_in_real_life_objects/Cuboid_objects/Chest_cuboid': {
    width: 567.62572,
    height: 544.10571
  },
  '3D_shapes_in_real_life_objects/Cuboid_objects/Chocolate_cuboid': {
    width: 442.87737,
    height: 411.17285
  },
  '3D_shapes_in_real_life_objects/Cuboid_objects/Domino': { width: 564.74266, height: 347.59467 },
  '3D_shapes_in_real_life_objects/Cuboid_objects/Tissue_box': {
    width: 450.55251,
    height: 453.77972
  },
  '3D_shapes_in_real_life_objects/Sphere_objects/Ball_of_yarn': {
    width: 327.33864,
    height: 327.33865
  },
  '3D_shapes_in_real_life_objects/Sphere_objects/Basketball': { width: 504.4493, height: 504.448 },
  '3D_shapes_in_real_life_objects/Sphere_objects/Bubble': { width: 321.01333, height: 321.01199 },
  '3D_shapes_in_real_life_objects/Sphere_objects/Coloured_marble': {
    width: 220.66132,
    height: 220.66133
  },
  '3D_shapes_in_real_life_objects/Square_based_pyramid_objects/Communication_tower': {
    width: 541.73064,
    height: 841.20453
  },
  '3D_shapes_in_real_life_objects/Square_based_pyramid_objects/Egyptian_pyramid': {
    width: 1089.728,
    height: 661.46674
  },
  '3D_shapes_in_real_life_objects/Square_based_pyramid_objects/Louvre_pyramid': {
    width: 1213.7801,
    height: 542.83948
  },
  '3D_shapes_in_real_life_objects/Square_based_pyramid_objects/Mayan_pyramid': {
    width: 864.49808,
    height: 729.93994
  },
  '3D_shapes_in_real_life_objects/Square_based_pyramid_objects/Safety_sign': {
    width: 540.31865,
    height: 636.66827
  },
  '3D_shapes_in_real_life_objects/Square_based_pyramid_objects/Tower': {
    width: 583.37596,
    height: 864.07837
  },
  '3D_shapes_in_real_life_objects/Triangular_prism_objects/Cheese': {
    width: 401.36422,
    height: 724.73987
  },
  '3D_shapes_in_real_life_objects/Triangular_prism_objects/Chocolate_triangular_prism': {
    width: 807.46,
    height: 649.96088
  },
  '3D_shapes_in_real_life_objects/Triangular_prism_objects/Tent': {
    width: 1180.3786,
    height: 870.93988
  },
  '3D_shapes_in_real_life_objects/Triangular_prism_objects/Wood_triangular_prism': {
    width: 439.26287,
    height: 718.79327
  },
  '3D_shapes_straws_marshmallows/Cuboid_shapes_straws_marshmallows': {
    width: 838.92564,
    height: 701.88104
  },
  '3D_shapes_straws_marshmallows/Hexagonal_prism_straws_marshmallows': {
    width: 471.35134,
    height: 720.91962
  },
  '3D_shapes_straws_marshmallows/Pentagonal_prism_straws_marshmallows': {
    width: 405.67934,
    height: 674.84961
  },
  '3D_shapes_straws_marshmallows/Square_based_pyramid_straws_marshmallows': {
    width: 694.76677,
    height: 614.0575
  },
  '3D_shapes_straws_marshmallows/Tetrahedron_shapes_straws_marshmallows': {
    width: 625.71574,
    height: 633.13177
  },
  '3D_shapes_straws_marshmallows/Triangular_prism_straws_marshmallows': {
    width: 838.92564,
    height: 655.20972
  },
  '3D_shapes_straws_marshmallows/cube_straws_marshmallows': { width: 541.03198, height: 522.96765 },
  Alex_birds_eye: { width: 274, height: 214 },
  'Angles_in_a_triangle_multiple_lines/Isosceles_triangle1': { width: 563, height: 541 },
  'Angles_in_a_triangle_multiple_lines/Isosceles_triangle2': { width: 563, height: 541 },
  'Angles_in_a_triangle_multiple_lines/Scalene_Isosceles_joined_triangle1': {
    width: 1705,
    height: 883
  },
  'Angles_in_a_triangle_multiple_lines/Scalene_Isosceles_joined_triangle2': {
    width: 1704,
    height: 883
  },
  'Angles_in_a_triangle_multiple_lines/Scalene_Isosceles_joined_triangle3': {
    width: 1704,
    height: 883
  },
  'Angles_in_a_triangle_multiple_lines/Scalene_Isosceles_joined_triangle4': {
    width: 1704,
    height: 883
  },
  'Angles_in_a_triangle_multiple_lines/Scalene_triangle1': { width: 1012, height: 845 },
  'Angles_in_a_triangle_multiple_lines/Scalene_triangle2': { width: 883, height: 766 },
  'Angles_in_a_triangle_multiple_lines/Scalene_triangle3': { width: 837, height: 903 },
  'Angles_in_a_triangle_multiple_lines/Scalene_triangle4': { width: 697, height: 872 },
  'Angles_in_a_triangle_multiple_lines/Scalene_triangle5': { width: 1726, height: 1464 },
  'Angles_in_a_triangle_multiple_lines/Scalene_triangle6': { width: 1121, height: 552 },
  'Angles_in_a_triangle_multiple_lines/Scalene_triangle7': { width: 1120, height: 1243 },
  'Angles_in_a_triangle_multiple_lines/Scalene_triangle8': { width: 1120, height: 552 },
  'Angles_on_a_straight_line/2_angles_1_line1': { width: 1101.3759, height: 321.03766 },
  'Angles_on_a_straight_line/2_angles_1_line2': { width: 1101.3759, height: 454.88568 },
  'Angles_on_a_straight_line/2_angles_1_line3': { width: 1101.3759, height: 268.12775 },
  'Angles_on_a_straight_line/2_angles_1_line4': { width: 1101.3759, height: 465.52985 },
  Annie_birds_eye: { width: 274, height: 216 },
  Ant: { width: 277.5708, height: 259.84494 },
  Apple_juice_carton: { width: 213.49399, height: 361.18252 },
  'Array_objects/AppleGreen': { width: 263.2959, height: 274.7121 },
  'Array_objects/AppleRed': { width: 263.2959, height: 274.7121 },
  'Array_objects/Banana': { width: 425.71402, height: 304.8259 },
  'Array_objects/Orange': { width: 351.22803, height: 369.45392 },
  'Array_objects/Pear': { width: 188.11447, height: 299.03488 },
  'Array_objects/Pineapple': { width: 277.6145, height: 457.55829 },
  'Array_objects/Strawberry': { width: 174.89328, height: 207.94752 },
  ArrowDown: { width: 48, height: 100 },
  ArrowDownLong: { width: 22, height: 256 },
  ArrowDownLongPDF: { width: 44, height: 256 },
  ArrowRight: { width: 48, height: 49 },
  ArrowRightLong: { width: 257, height: 23 },
  ArrowUp: { width: 48, height: 100 },
  ArrowUpShort: { width: 30, height: 48 },
  'Arrows/arrow': { width: 431.08823, height: 253.75083 },
  'Arrows/arrow_blue': { width: 431.08823, height: 253.75083 },
  'Arrows/arrow_green': { width: 431.08823, height: 253.75083 },
  'Arrows/arrow_pink': { width: 431.08823, height: 253.75083 },
  'Arrows/arrow_purple': { width: 431.08823, height: 253.75083 },
  'Arrows/arrow_white': { width: 431.08823, height: 253.75083 },
  'Arrows/arrow_yellow': { width: 431.08823, height: 253.75083 },
  Backspace: { width: 52, height: 37 },
  Bag_of_Flour: { width: 177.64319, height: 257.98892 },
  Bag_of_Pasta: { width: 176.31796, height: 206.27733 },
  Bag_of_Rice: { width: 196.91933, height: 207.98918 },
  Bag_of_carrots: { width: 281.95731, height: 304.1282 },
  Bag_of_chocolate_chips: { width: 262.48517, height: 341.324 },
  Bag_of_potatoes: { width: 283.76395, height: 299.53805 },
  Bag_of_white_sugar: { width: 176.25, height: 257.14813 },
  BalloonBlue: { width: 246.33073, height: 565.69598 },
  Bar_of_chocolate: { width: 315.84586, height: 176.7677 },
  'Base_Ten/1000cube': { width: 190, height: 179 },
  'Base_Ten/100cube': { width: 152, height: 157 },
  'Base_Ten/10BluePens': { width: 93, height: 221 },
  'Base_Ten/10RedPens': { width: 93, height: 221 },
  'Base_Ten/10cube': { width: 15.9954, height: 156.54184 },
  'Base_Ten/1BluePen': { width: 78.793006, height: 309.76837 },
  'Base_Ten/1RedPen': { width: 78.793006, height: 309.76837 },
  'Base_Ten/1cube': { width: 15.9954, height: 16.5541 },
  'Base_Ten/Balloons1': { width: 64.368377, height: 34.577572 },
  'Base_Ten/Balloons10': { width: 66.04425, height: 109.24117 },
  'Base_Ten/Balloons100': { width: 115.46089, height: 193.17212 },
  'Base_Ten/Bricks1': { width: 31.180504, height: 21.628925 },
  'Base_Ten/Bricks10': { width: 75.777329, height: 49.053333 },
  'Base_Ten/Bricks100': { width: 120.96933, height: 80.262664 },
  'Base_Ten/Crayons10': { width: 58.809329, height: 90.194663 },
  'Base_Ten/Crayons100': { width: 509.79172, height: 257.01373 },
  'Base_Ten/Crayons1_blue': { width: 58, height: 39 },
  'Base_Ten/Crayons1_green': { width: 58, height: 39 },
  'Base_Ten/Crayons1_lightblue': { width: 58, height: 39 },
  'Base_Ten/Crayons1_lime': { width: 58, height: 39 },
  'Base_Ten/Crayons1_orange': { width: 56, height: 38 },
  'Base_Ten/Crayons1_pink': { width: 58, height: 39 },
  'Base_Ten/Crayons1_purple': { width: 58, height: 39 },
  'Base_Ten/Crayons1_red': { width: 58, height: 39 },
  'Base_Ten/Crayons1_white': { width: 58, height: 39 },
  'Base_Ten/Crayons1_yellow': { width: 58, height: 39 },
  'Base_Ten/Lollipops1': { width: 45.228836, height: 122.91897 },
  'Base_Ten/Lollipops10': { width: 98.870667, height: 177.99466 },
  'Base_Ten/Lollipops100': { width: 209, height: 356 },
  'Base_Ten/Marbles1': { width: 43.216904, height: 43.214665 },
  'Base_Ten/Marbles10': { width: 201.08304, height: 84.509507 },
  'Base_Ten/Marbles100': { width: 501.73913, height: 114.71432 },
  'Base_Ten/Nails1': { width: 77.278518, height: 156.48961 },
  'Base_Ten/Nails10': { width: 205.78204, height: 273.30166 },
  'Base_Ten/Nails100': { width: 405.09579, height: 254.97342 },
  'Base_Ten/Nails1000': { width: 561, height: 389 },
  'Base_Ten/Straws1': { width: 120.88981, height: 175.72894 },
  'Base_Ten/Straws10': { width: 167.69876, height: 207.72233 },
  'Base_Ten/Sweets1': { width: 70.184448, height: 48.657335 },
  'Base_Ten/Sweets10': { width: 89.691749, height: 117.19845 },
  'Base_Ten/Sweets100': { width: 131.9086, height: 172.36132 },
  Basketball: { width: 318.11465, height: 318.17792 },
  Bath: { width: 524.28387, height: 369.19711 },
  Bee: { width: 793.70135, height: 793.70135 },
  Bee_2: { width: 241.62653, height: 259.75412 },
  Bee_from_above: { width: 534.06024, height: 437.93188 },
  'Before_and_after_images/Balloon_blue': { width: 246.33073, height: 565.69598 },
  'Before_and_after_images/Balloon_blue_popped': { width: 291.03967, height: 107.75867 },
  'Before_and_after_images/Balloon_blue_uninflated': { width: 223.13855, height: 90.565065 },
  'Before_and_after_images/Banana_bite': { width: 291.00165, height: 271.50256 },
  'Before_and_after_images/Banana_peeled': { width: 293.61078, height: 313.30707 },
  'Before_and_after_images/Banana_single': { width: 285.52356, height: 204.57008 },
  'Before_and_after_images/Bar_of_chocolate_bite': { width: 315.84534, height: 250.30722 },
  'Before_and_after_images/Bar_of_chocolate_unwrapped': { width: 315.84534, height: 250.30722 },
  'Before_and_after_images/Bar_of_chocolate_wr_noto': { width: 315.84586, height: 176.76799 },
  'Before_and_after_images/Cookie_biscuit_bite': { width: 230.10933, height: 186.60998 },
  'Before_and_after_images/Cookie_biscuit_crumbs': { width: 164.4844, height: 51.406131 },
  'Before_and_after_images/Cookie_biscuit_no_bite': { width: 230.10933, height: 190.10133 },
  'Before_and_after_images/Donut_bite': { width: 238.57463, height: 159.76759 },
  'Before_and_after_images/Donut_crumbs': { width: 201.00201, height: 47.065464 },
  'Before_and_after_images/Donut_no_bite': { width: 232.5811, height: 159.76759 },
  'Before_and_after_images/Not_wrapped_gift': { width: 838.24591, height: 330.17676 },
  'Before_and_after_images/Paper_blank': { width: 292.66666, height: 363.33331 },
  'Before_and_after_images/Paper_drawing_house_colour': { width: 292.66666, height: 363.33331 },
  'Before_and_after_images/Paper_drawing_house_line': { width: 292.66666, height: 363.33331 },
  'Before_and_after_images/Plant_pot_soil': { width: 252.00037, height: 284.19198 },
  'Before_and_after_images/Plant_pot_sunflower': { width: 212.07147, height: 554.36206 },
  'Before_and_after_images/Sunflower_seed': { width: 269.03641, height: 166.07866 },
  'Before_and_after_images/Wrapped_gift': { width: 296.08478, height: 293.31207 },
  'Before_and_after_images/Wrapped_gift_without_bow': { width: 296.10199, height: 225.97867 },
  Bike: { width: 597.49359, height: 350.19 },
  Bird_yellow: { width: 396.22467, height: 318.81748 },
  Bone: { width: 395.29864, height: 178.77733 },
  Book: { width: 306.75607, height: 221.64584 },
  BookRed: { width: 293.01987, height: 376.17318 },
  Book_Red_set_down: { width: 411.58017, height: 90.847679 },
  Bouquet: { width: 393.77, height: 398.12 },
  Bread_loaf: { width: 372.65277, height: 255.53428 },
  Bread_roll: { width: 71.926666, height: 56.047999 },
  Bread_rolls_10: { width: 343.13891, height: 86.329993 },
  'Broken_shapes/arrow_break_1': { width: 432.98651, height: 256.19489 },
  'Broken_shapes/arrow_break_2': { width: 432.9858, height: 256.19543 },
  'Broken_shapes/circle_break_1': { width: 323.93002, height: 329.33331 },
  'Broken_shapes/circle_break_2': { width: 318.86981, height: 329.33414 },
  'Broken_shapes/circle_semi_break_1': { width: 164.66666, height: 329.35358 },
  'Broken_shapes/circle_semi_break_2': { width: 164.66719, height: 329.35297 },
  'Broken_shapes/cross_break_1': { width: 329.33331, height: 329.33331 },
  'Broken_shapes/cross_break_2': { width: 329.33374, height: 329.33331 },
  'Broken_shapes/hexagon_break_1': { width: 378.15838, height: 327.49466 },
  'Broken_shapes/hexagon_break_2': { width: 378.15799, height: 327.49505 },
  'Broken_shapes/kite_break_1': { width: 243.65067, height: 329.32987 },
  'Broken_shapes/kite_break_2': { width: 243.65148, height: 329.32984 },
  'Broken_shapes/parallelogram_break_1': { width: 585.14477, height: 329.33331 },
  'Broken_shapes/parallelogram_break_2': { width: 585.14477, height: 329.33331 },
  'Broken_shapes/pentagon_break_1': { width: 343.55902, height: 326.74417 },
  'Broken_shapes/pentagon_break_2': { width: 343.55944, height: 326.7446 },
  'Broken_shapes/pentagon_house_break_1': { width: 329.33331, height: 329.97232 },
  'Broken_shapes/pentagon_house_break_2': { width: 329.33331, height: 329.97244 },
  'Broken_shapes/rectangle_break_1': { width: 578.66662, height: 329.33331 },
  'Broken_shapes/rectangle_break_2': { width: 578.66681, height: 329.33331 },
  'Broken_shapes/rhombus_break_1': { width: 372.74839, height: 329.33331 },
  'Broken_shapes/rhombus_break_2': { width: 372.74768, height: 329.33331 },
  'Broken_shapes/square_break_1': { width: 329.33331, height: 329.33331 },
  'Broken_shapes/square_break_2': { width: 329.33374, height: 329.33331 },
  'Broken_shapes/trapezium_RA_break_1': { width: 484.21222, height: 329.33331 },
  'Broken_shapes/trapezium_RA_break_2': { width: 484.2118, height: 329.33331 },
  'Broken_shapes/trapezium_isosceles_break_1': { width: 437.69733, height: 329.33331 },
  'Broken_shapes/trapezium_isosceles_break_2': { width: 437.6972, height: 329.33331 },
  'Broken_shapes/triangle_RA_break_1': { width: 333.10455, height: 333.10455 },
  'Broken_shapes/triangle_RA_break_2': { width: 333.10443, height: 333.10455 },
  'Broken_shapes/triangle_break_1': { width: 382.17919, height: 331.52933 },
  'Broken_shapes/triangle_break_2': { width: 382.17923, height: 331.52936 },
  'Broken_shapes/triangle_isos_narrow_break_1': { width: 274.24481, height: 333.19639 },
  'Broken_shapes/triangle_isos_narrow_break_2': { width: 272.25467, height: 330.77789 },
  'Broken_shapes/triangle_isos_wide_break_1': { width: 441.78482, height: 329.11145 },
  'Broken_shapes/triangle_isos_wide_break_2': { width: 444.28607, height: 330.97468 },
  'Broken_shapes/triangle_scalene_break_1': { width: 449.38441, height: 332.43897 },
  'Broken_shapes/triangle_scalene_break_2': { width: 449.38452, height: 332.43808 },
  Brown_bag_of_apples: { width: 330.10608, height: 312.17261 },
  Bubble: { width: 73.932, height: 73.930665 },
  'Bunches_of_bananas/Bunch_of_bananas_1': { width: 425.71402, height: 304.8259 },
  'Bunches_of_bananas/Bunch_of_bananas_2': { width: 196.18544, height: 158.27194 },
  'Bunches_of_bananas/Bunch_of_bananas_3': { width: 229.2173, height: 186.60732 },
  'Bunches_of_bananas/Bunch_of_bananas_4': { width: 243.05955, height: 186.60732 },
  'Bunches_of_bananas/Bunch_of_bananas_5': { width: 247.51063, height: 221.97311 },
  'Bunches_of_bananas/Bunch_of_bananas_6': { width: 275.04568, height: 221.97311 },
  Bundle_of_10_straws: { width: 167.7103, height: 207.76112 },
  Bus: { width: 598.84516, height: 226.6028 },
  Button_blue: { width: 423.41971, height: 423.41971 },
  Button_yellow: { width: 423.41971, height: 423.41971 },
  Cake: { width: 481.33639, height: 377.31268 },
  Can_of_fizzy_drink: { width: 180.25333, height: 328.05691 },
  Candle: { width: 194.80533, height: 281.91632 },
  Cans_unlabelled_Green: { width: 208.66933, height: 320.91345 },
  'Capacity_images/Beaker_1000mlcap_100mlint': { width: 729.27549, height: 546.70667 },
  'Capacity_images/Beaker_1000mlcap_200mlint': { width: 729.27549, height: 546.70667 },
  'Capacity_images/Beaker_1000mlcap_250mlint': { width: 729.27549, height: 546.70667 },
  'Capacity_images/Beaker_1000mlcap_500mlint': { width: 729.27549, height: 546.70667 },
  'Capacity_images/Beaker_1000mlcap_50mlint': { width: 729.27549, height: 546.70667 },
  'Capacity_images/Beaker_100mlcap_10mlint': { width: 347.08321, height: 546.70667 },
  'Capacity_images/Beaker_100mlcap_20mlint': { width: 347.08321, height: 546.70667 },
  'Capacity_images/Beaker_100mlcap_25mlint': { width: 347.08321, height: 546.70667 },
  'Capacity_images/Beaker_100mlcap_50mlint': { width: 347.08321, height: 546.70667 },
  'Capacity_images/Beaker_200mlcap_100mlint': { width: 347.08321, height: 546.70667 },
  'Capacity_images/Beaker_200mlcap_10mlint': { width: 347.08321, height: 546.70667 },
  'Capacity_images/Beaker_200mlcap_20mlint': { width: 347.08321, height: 546.70667 },
  'Capacity_images/Beaker_200mlcap_25mlint': { width: 347.08321, height: 546.70667 },
  'Capacity_images/Beaker_200mlcap_50mlint': { width: 347.08321, height: 546.70667 },
  'Capacity_images/Beaker_250mlcap_125mlint': { width: 347.08321, height: 546.70667 },
  'Capacity_images/Beaker_250mlcap_25mlint': { width: 347.08321, height: 546.70667 },
  'Capacity_images/Beaker_250mlcap_50mlint': { width: 347.08321, height: 546.70667 },
  'Capacity_images/Beaker_300mlcap_100mlint': { width: 347.08321, height: 546.70667 },
  'Capacity_images/Beaker_300mlcap_20mlint': { width: 347.08321, height: 546.70667 },
  'Capacity_images/Beaker_300mlcap_25mlint': { width: 347.08321, height: 546.70667 },
  'Capacity_images/Beaker_300mlcap_50mlint': { width: 347.08321, height: 546.70667 },
  'Capacity_images/Beaker_400mlcap_100mlint': { width: 515.442, height: 546.70667 },
  'Capacity_images/Beaker_400mlcap_200mlint': { width: 515.442, height: 546.70667 },
  'Capacity_images/Beaker_400mlcap_20mlint': { width: 515.442, height: 546.70667 },
  'Capacity_images/Beaker_400mlcap_25mlint': { width: 515.442, height: 546.70667 },
  'Capacity_images/Beaker_400mlcap_50mlint': { width: 515.442, height: 546.70667 },
  'Capacity_images/Beaker_500mlcap_100mlint': { width: 515.44157, height: 546.70667 },
  'Capacity_images/Beaker_500mlcap_250mlint': { width: 515.44157, height: 546.70667 },
  'Capacity_images/Beaker_500mlcap_25mlint': { width: 515.442, height: 546.70667 },
  'Capacity_images/Beaker_500mlcap_50mlint': { width: 515.44157, height: 546.70667 },
  'Capacity_images/Beaker_600mlcap_100mlint': { width: 515.442, height: 546.70667 },
  'Capacity_images/Beaker_600mlcap_200mlint': { width: 515.44164, height: 546.70667 },
  'Capacity_images/Beaker_600mlcap_50mlint': { width: 515.442, height: 546.70667 },
  'Capacity_images/Beaker_700mlcap_100mlint': { width: 729.27549, height: 546.70667 },
  'Capacity_images/Beaker_700mlcap_50mlint': { width: 729.27549, height: 546.70667 },
  'Capacity_images/Beaker_800mlcap_100mlint': { width: 729.27549, height: 546.70667 },
  'Capacity_images/Beaker_800mlcap_200mlint': { width: 729.27549, height: 546.70667 },
  'Capacity_images/Beaker_800mlcap_50mlint': { width: 729.27549, height: 546.70667 },
  'Capacity_images/Beaker_900mlcap_100mlint': { width: 729.27549, height: 546.70667 },
  'Capacity_images/Beaker_900mlcap_50mlint': { width: 729.27549, height: 546.70667 },
  'Capacity_images/Empty_jug': { width: 705.87225, height: 781.52411 },
  'Capacity_images/Empty_jug_blue': { width: 705.87225, height: 781.52411 },
  'Capacity_images/Extra_large_juice_bottle': { width: 476.5659, height: 849.96399 },
  'Capacity_images/Full_beaker_100mlcap_10mlint': { width: 346.33013, height: 545.51465 },
  'Capacity_images/Full_beaker_1litrecap_100mlint': { width: 505.29405, height: 797.10797 },
  'Capacity_images/Large_juice_bottle': { width: 272.25857, height: 795.448 },
  'Capacity_images/Medium_juice_bottle': { width: 222.37768, height: 648.29065 },
  'Capacity_images/Mostly_full_orange_pitcher': { width: 541.53874, height: 652.39862 },
  'Capacity_images/Mostly_full_water_pitcher': { width: 541.53874, height: 652.39862 },
  'Capacity_images/None_Transparent/Jug1_1000mlcap_100mlint': {
    width: 910.5026,
    height: 910.50262
  },
  'Capacity_images/None_Transparent/Jug1_1000mlcap_200mlint': {
    width: 910.5026,
    height: 910.50262
  },
  'Capacity_images/None_Transparent/Jug1_1000mlcap_250mlint': {
    width: 910.5026,
    height: 910.50262
  },
  'Capacity_images/None_Transparent/Jug1_1000mlcap_500mlint': {
    width: 910.5026,
    height: 910.50262
  },
  'Capacity_images/None_Transparent/Jug1_200mlcap_100mlint': { width: 910.5026, height: 910.50262 },
  'Capacity_images/None_Transparent/Jug1_200mlcap_20mlint': { width: 910.5026, height: 910.50262 },
  'Capacity_images/None_Transparent/Jug1_200mlcap_25mlint': { width: 910.5026, height: 910.50262 },
  'Capacity_images/None_Transparent/Jug1_200mlcap_50mlint': { width: 910.5026, height: 910.50262 },
  'Capacity_images/None_Transparent/Jug1_500mlcap_100mlint': { width: 910.5026, height: 910.50262 },
  'Capacity_images/None_Transparent/Jug1_500mlcap_250mlint': { width: 910.5026, height: 910.50262 },
  'Capacity_images/None_Transparent/Jug1_500mlcap_50mlint': { width: 910.5026, height: 910.50262 },
  'Capacity_images/Part_filled_beaker_1litrecap_100mlint': { width: 505.29405, height: 797.10797 },
  'Capacity_images/Small_juice_bottle': { width: 194.81997, height: 566.992 },
  Car: { width: 332.58392, height: 192.68742 },
  Car_tyre: { width: 318.62467, height: 320.07199 },
  Card_pack: { width: 138.20427, height: 178.92949 },
  CardboardBox: { width: 75.18666, height: 48.677336 },
  CardboardBox1: { width: 173.14053, height: 167.63533 },
  CardboardBox2: { width: 199.33333, height: 89.230667 },
  CardboardBox3: { width: 237.14, height: 229.6176 },
  CardboardBox4: { width: 88.667465, height: 187.26346 },
  Carrot: { width: 243.91688, height: 76.224548 },
  'Carton_of_eggs_0_-12/Carton_of_eggs_0': { width: 527.15149, height: 330.1492 },
  'Carton_of_eggs_0_-12/Carton_of_eggs_1': { width: 527.15149, height: 330.1492 },
  'Carton_of_eggs_0_-12/Carton_of_eggs_10': { width: 527.15149, height: 330.1492 },
  'Carton_of_eggs_0_-12/Carton_of_eggs_11': { width: 527.15149, height: 330.1492 },
  'Carton_of_eggs_0_-12/Carton_of_eggs_12': { width: 527.15149, height: 330.1492 },
  'Carton_of_eggs_0_-12/Carton_of_eggs_2': { width: 527.15149, height: 330.1492 },
  'Carton_of_eggs_0_-12/Carton_of_eggs_3': { width: 527.15149, height: 330.1492 },
  'Carton_of_eggs_0_-12/Carton_of_eggs_4': { width: 527.15149, height: 330.1492 },
  'Carton_of_eggs_0_-12/Carton_of_eggs_5': { width: 527.15149, height: 330.1492 },
  'Carton_of_eggs_0_-12/Carton_of_eggs_6': { width: 527.15149, height: 330.1492 },
  'Carton_of_eggs_0_-12/Carton_of_eggs_7': { width: 527.15149, height: 330.1492 },
  'Carton_of_eggs_0_-12/Carton_of_eggs_8': { width: 527.15149, height: 330.1492 },
  'Carton_of_eggs_0_-12/Carton_of_eggs_9': { width: 527.15149, height: 330.1492 },
  Cat: { width: 763.06995, height: 692.44397 },
  Cat_w_food_bowl: { width: 793.70135, height: 793.70135 },
  Celebration_card: { width: 261, height: 461 },
  Celebration_card_1: { width: 260.51205, height: 459.9191 },
  Celebration_card_2: { width: 260.51199, height: 459.91895 },
  Cell: { width: 34, height: 34 },
  CellTop: { width: 34, height: 34 },
  ChairBlue: { width: 331.34979, height: 561.14026 },
  ChairPink: { width: 214.76337, height: 332.64667 },
  'Characters/AlexHead': { width: 262.6199, height: 164.48204 },
  'Characters/AlexStanding': { width: 298.62772, height: 413.9158 },
  'Characters/AmirHead': { width: 197.71199, height: 153.74776 },
  'Characters/AmirStanding': { width: 298.62772, height: 407.72751 },
  'Characters/AnnieHead': { width: 210.54503, height: 169.49178 },
  'Characters/AnnieStanding': { width: 298.68427, height: 398.87845 },
  'Characters/DexterHead': { width: 189.87161, height: 159.78227 },
  'Characters/DexterStanding': { width: 270, height: 460 },
  'Characters/Direction/Jack_body': { width: 156.96, height: 324.48 },
  'Characters/Direction/Kim_body': { width: 146.88, height: 313.92 },
  'Characters/Direction/Max_body': { width: 136.8, height: 326.88 },
  'Characters/EvaHead': { width: 240.08499, height: 188.76009 },
  'Characters/EvaStanding': { width: 298.68427, height: 446.61167 },
  'Characters/JackHead': { width: 196.79318, height: 170.13109 },
  'Characters/JackStanding': { width: 298.62772, height: 417.13217 },
  'Characters/JoHead': { width: 200.30664, height: 245.42926 },
  'Characters/JoStanding': { width: 298.62772, height: 399.85111 },
  'Characters/KimHead': { width: 235.49026, height: 199.63081 },
  'Characters/KimStanding': { width: 298.62772, height: 400.77985 },
  'Characters/MaxHead': { width: 184.78198, height: 170.37303 },
  'Characters/MaxStanding': { width: 270, height: 417.234 },
  'Characters/MoHead': { width: 185.05058, height: 139.46216 },
  'Characters/MoStanding': { width: 298.62772, height: 399.85111 },
  'Characters/RonHead': { width: 185.34377, height: 152.5241 },
  'Characters/RonStanding': { width: 298.62772, height: 404.04071 },
  'Characters/RosieHead': { width: 197.86449, height: 204.79428 },
  'Characters/RosieStanding': { width: 298.68427, height: 398.87845 },
  'Characters/SamHead': { width: 214.11614, height: 210.31564 },
  'Characters/SamStanding': { width: 298.68427, height: 453.05722 },
  'Characters/TeddyHead': { width: 196.18579, height: 170.70523 },
  'Characters/TeddyStanding': { width: 270, height: 415.449 },
  'Characters/TommyHead': { width: 186.54134, height: 160.8021 },
  'Characters/TommyStanding': { width: 298.62772, height: 425.15897 },
  'Characters/WhitneyHead': { width: 275.90741, height: 155.79347 },
  'Characters/WhitneyStanding': { width: 270, height: 400.223 },
  CheckersBoard: { width: 529.09375, height: 549.67822 },
  Cherry: { width: 139.85967, height: 211.75256 },
  Chew_sweet_candy_bar: { width: 535.69903, height: 108.75732 },
  'Circles/Circle_quarter_white': { width: 330, height: 330 },
  'Circles/Inner_outer_circles/Inner_outer_circle_large_A': { width: 168.8058, height: 168.8058 },
  'Circles/Inner_outer_circles/Inner_outer_circle_large_B': { width: 168.8058, height: 168.8058 },
  'Circles/Inner_outer_circles/Inner_outer_circle_large_C': { width: 168.8058, height: 168.8058 },
  'Circles/Inner_outer_circles/Inner_outer_circle_medium_A': { width: 168.8058, height: 168.8058 },
  'Circles/Inner_outer_circles/Inner_outer_circle_medium_B': { width: 168.8058, height: 168.8058 },
  'Circles/Inner_outer_circles/Inner_outer_circle_medium_C': { width: 168.8058, height: 168.8058 },
  'Circles/Parts_of_a_circle/Circle_parts_centre_arrow': { width: 231.88105, height: 180.96187 },
  'Circles/Parts_of_a_circle/Circle_parts_circumference_arrow': {
    width: 231.70316,
    height: 180.96187
  },
  'Circles/Parts_of_a_circle/Circle_parts_diameter_arrow': { width: 229.65947, height: 180.96187 },
  'Circles/Parts_of_a_circle/Circle_parts_diameter_correct': {
    width: 180.96187,
    height: 180.96187
  },
  'Circles/Parts_of_a_circle/Circle_parts_diameter_incorrect_A': {
    width: 180.96187,
    height: 180.96187
  },
  'Circles/Parts_of_a_circle/Circle_parts_diameter_incorrect_B': {
    width: 180.96187,
    height: 180.96187
  },
  'Circles/Parts_of_a_circle/Circle_parts_diameter_incorrect_C': {
    width: 180.96187,
    height: 180.96187
  },
  'Circles/Parts_of_a_circle/Circle_parts_diameter_incorrect_D': {
    width: 180.96187,
    height: 180.96187
  },
  'Circles/Parts_of_a_circle/Circle_parts_diameter_incorrect_E': {
    width: 180.96187,
    height: 180.96187
  },
  'Circles/Parts_of_a_circle/Circle_parts_diameter_incorrect_F': {
    width: 180.96187,
    height: 180.96187
  },
  'Circles/Parts_of_a_circle/Circle_parts_radius_arrow': { width: 229.65947, height: 180.96187 },
  'Circles/Parts_of_a_circle/Circle_parts_radius_correct': { width: 180.96187, height: 180.96187 },
  'Circles/Parts_of_a_circle/Circle_parts_radius_incorrect_A': {
    width: 180.96187,
    height: 180.96187
  },
  'Circles/Parts_of_a_circle/Circle_parts_radius_incorrect_B': {
    width: 180.96187,
    height: 180.96187
  },
  'Circles/Parts_of_a_circle/Circle_parts_radius_incorrect_C': {
    width: 180.96187,
    height: 180.96187
  },
  'Circles/Parts_of_a_circle/Circle_parts_radius_incorrect_D': {
    width: 180.96187,
    height: 180.96187
  },
  'Circles/Parts_of_a_circle/Circle_parts_radius_incorrect_E': {
    width: 180.96187,
    height: 180.96187
  },
  'Circles/Parts_of_a_circle/Circle_parts_radius_incorrect_F': {
    width: 180.96187,
    height: 180.96187
  },
  'Circles/circle_': { width: 328, height: 328 },
  'Circles/circle_black': { width: 328, height: 328 },
  'Circles/circle_blue': { width: 328, height: 328 },
  'Circles/circle_green': { width: 328, height: 328 },
  'Circles/circle_grey': { width: 328, height: 328 },
  'Circles/circle_orange': { width: 328, height: 328 },
  'Circles/circle_orange_protractor': { width: 55, height: 55 },
  'Circles/circle_pink': { width: 328, height: 328 },
  'Circles/circle_purple': { width: 328, height: 328 },
  'Circles/circle_red': { width: 329.333, height: 329.333 },
  'Circles/circle_turquoise': { width: 328, height: 328 },
  'Circles/circle_white': { width: 328, height: 328 },
  'Circles/circle_yellow': { width: 329.333, height: 329.333 },
  Clock: { width: 224.8, height: 224.8 },
  ClockFaceBlue: { width: 224.79998, height: 224.80002 },
  ClockFaceBlueWithoutMinuteIntervals: { width: 224.8, height: 224.80002 },
  ClockFaceOrange: { width: 224.79998, height: 224.80002 },
  ClockFaceOrangeWithoutMinuteIntervals: { width: 224.8, height: 224.80002 },
  ClockFaceRomanBlue: { width: 224.79998, height: 224.80002 },
  ClockFaceRomanBlueWithoutMinuteIntervals: { width: 224.79998, height: 224.80002 },
  ClockFaceRomanOrange: { width: 224.79998, height: 224.80002 },
  ClockFaceRomanOrangeWithoutMinuteIntervals: { width: 224.79998, height: 224.80002 },
  ClockFaceRomanYellow: { width: 224.79998, height: 224.80002 },
  ClockFaceRomanYellowWithoutMinuteIntervals: { width: 224.79998, height: 224.80002 },
  ClockFaceYellow: { width: 224.79998, height: 224.80002 },
  ClockFaceYellowWithoutMinuteIntervals: { width: 224.8, height: 224.80002 },
  ClockHour: { width: 224.8, height: 224.8 },
  ClockMinute: { width: 224.8, height: 224.8 },
  ClockMinuteCircle: { width: 224.8, height: 224.8 },
  Close: { width: 32, height: 32 },
  Closed_book: { width: 306.75607, height: 221.64584 },
  'Clothes/Gloves_mittens_blue': { width: 448.67935, height: 493.73755 },
  'Clothes/Gloves_mittens_green': { width: 448.67935, height: 493.73755 },
  'Clothes/Gloves_mittens_orange': { width: 448.67935, height: 493.73755 },
  'Clothes/Gloves_mittens_red': { width: 448.67935, height: 493.73755 },
  'Clothes/Gloves_mittens_yellow.ai': { width: 448.67935, height: 493.73755 },
  'Clothes/Hat_blue': { width: 298.54507, height: 199.09602 },
  'Clothes/Hat_cap': { width: 346.522, height: 174.68577 },
  'Clothes/Hat_woolly': { width: 229.61378, height: 204.33066 },
  'Clothes/Jumper_blue': { width: 451.7449, height: 373.36993 },
  'Clothes/Scarf_purple': { width: 611.281, height: 703.39611 },
  'Clothes/Scarf_white': { width: 611.28112, height: 703.39611 },
  'Clothes/Shorts_grey': { width: 195.42361, height: 180.27913 },
  'Clothes/T-shirt_blue': { width: 370.74267, height: 373.0812 },
  Compass_4_labels: { width: 306.32266, height: 306.32266 },
  Compass_8_labels: { width: 306.32266, height: 306.32266 },
  Compost_bag: { width: 299.74219, height: 364.62903 },
  'CompoundShapes/EquilateralTriangle_2_parts_1': { width: 570, height: 332 },
  'CompoundShapes/EquilateralTriangle_3_parts_1': { width: 756, height: 333 },
  'CompoundShapes/EquilateralTriangle_4_parts_1': { width: 948, height: 333 },
  'CompoundShapes/EquilateralTriangle_4_parts_2': { width: 757, height: 657 },
  'CompoundShapes/EquilateralTriangle_5_parts_1': { width: 948, height: 657 },
  'CompoundShapes/QuarterCircle_2_parts_1': { width: 654, height: 330 },
  'CompoundShapes/QuarterCircle_3_parts_1': { width: 654, height: 654 },
  'CompoundShapes/QuarterCircle_4_parts_1': { width: 654, height: 654 },
  'CompoundShapes/QuarterCircle_5_parts_1': { width: 978, height: 654 },
  'CompoundShapes/RATriangle_2_parts_1': { width: 330, height: 330 },
  'CompoundShapes/RATriangle_3_parts_1': { width: 658, height: 325 },
  'CompoundShapes/RATriangle_4_parts_1': { width: 646, height: 325 },
  'CompoundShapes/RATriangle_4_parts_2': { width: 990, height: 326 },
  'CompoundShapes/RATriangle_4_parts_3': { width: 658, height: 654 },
  'CompoundShapes/RATriangle_5_parts_1': { width: 972, height: 325 },
  'CompoundShapes/Rectangle_2_parts_1': { width: 450, height: 508 },
  'CompoundShapes/Rectangle_3_parts_1': { width: 894, height: 508 },
  'CompoundShapes/Rectangle_4_parts_1': { width: 894, height: 508 },
  'CompoundShapes/Rectangle_4_parts_2': { width: 1010, height: 450 },
  'CompoundShapes/Rectangle_5_parts_1': { width: 1337, height: 508 },
  'CompoundShapes/Square_2_parts_1': { width: 330, height: 654 },
  'CompoundShapes/Square_3_parts_1': { width: 654, height: 654 },
  'CompoundShapes/Square_3_parts_2': { width: 978, height: 330 },
  'CompoundShapes/Square_4_parts_1': { width: 654, height: 654 },
  'CompoundShapes/Square_4_parts_2': { width: 1302, height: 330 },
  'CompoundShapes/Square_5_parts_1': { width: 978, height: 654 },
  'CompoundShapes/Square_5_parts_2': { width: 1626, height: 330 },
  Cone_dotted_lines: { width: 590.14903, height: 628.5412 },
  'Containers/container': { width: 111, height: 165 },
  Cookie: { width: 115.94, height: 85.308 },
  'Cookie_biscuit/Cookie_biscuit_5': { width: 230.10933, height: 190.10133 },
  'Cookie_biscuit/Cookie_biscuit_6': { width: 230.10933, height: 190.10133 },
  'Cookie_biscuit/Cookie_biscuit_7': { width: 230.10933, height: 190.10133 },
  Cookie_jar: { width: 190.02133, height: 258.20132 },
  Cooking_pot: { width: 459.54959, height: 322.46533 },
  'Coordinates/CirclePoint': { width: 36, height: 36 },
  'Coordinates/CrossPoint': { width: 36, height: 36 },
  'Coordinates/FilledSquarePoint': { width: 36, height: 36 },
  'Coordinates/SquarePoint': { width: 36, height: 36 },
  'Coordinates/TrianglePoint': { width: 36, height: 36 },
  'CountIn50/Balloons50': { width: 115.46089, height: 193.17212 },
  'CountIn50/Bricks50': { width: 75.777329, height: 49.053333 },
  'CountIn50/Crayons50': { width: 509.79172, height: 257.01373 },
  'CountIn50/Lollipops50': { width: 240.54637, height: 438.02679 },
  'CountIn50/Marbles50': { width: 501.73913, height: 114.71432 },
  'CountIn50/Sweets50': { width: 131.9086, height: 172.36132 },
  Counter: { width: 300, height: 300 },
  CounterRed: { width: 104, height: 104 },
  CounterWhite: { width: 104, height: 104 },
  'Counters_fractions/Counters_unit_fractions1_10': { width: 136, height: 136 },
  'Counters_fractions/Counters_unit_fractions1_11': { width: 136, height: 136 },
  'Counters_fractions/Counters_unit_fractions1_12': { width: 136, height: 136 },
  'Counters_fractions/Counters_unit_fractions1_2': { width: 136, height: 136 },
  'Counters_fractions/Counters_unit_fractions1_3': { width: 136, height: 136 },
  'Counters_fractions/Counters_unit_fractions1_4': { width: 136, height: 136 },
  'Counters_fractions/Counters_unit_fractions1_5': { width: 136, height: 136 },
  'Counters_fractions/Counters_unit_fractions1_6': { width: 136, height: 136 },
  'Counters_fractions/Counters_unit_fractions1_7': { width: 136, height: 136 },
  'Counters_fractions/Counters_unit_fractions1_8': { width: 136, height: 136 },
  'Counters_fractions/Counters_unit_fractions1_9': { width: 136, height: 136 },
  'Counters_fractions/Text_outlined/Counters_unit_fractions1_10_text_outlined': {
    width: 136,
    height: 136
  },
  'Counters_fractions/Text_outlined/Counters_unit_fractions1_11_text_outlined': {
    width: 136,
    height: 136
  },
  'Counters_fractions/Text_outlined/Counters_unit_fractions1_12_text_outlined': {
    width: 136,
    height: 136
  },
  'Counters_fractions/Text_outlined/Counters_unit_fractions1_2_text_outlined': {
    width: 136,
    height: 136
  },
  'Counters_fractions/Text_outlined/Counters_unit_fractions1_3_text_outlined': {
    width: 136,
    height: 136
  },
  'Counters_fractions/Text_outlined/Counters_unit_fractions1_4_text_outlined': {
    width: 136,
    height: 136
  },
  'Counters_fractions/Text_outlined/Counters_unit_fractions1_5_text_outlined': {
    width: 136,
    height: 136
  },
  'Counters_fractions/Text_outlined/Counters_unit_fractions1_6.ai_text_outlined': {
    width: 136,
    height: 136
  },
  'Counters_fractions/Text_outlined/Counters_unit_fractions1_7_text_outlined': {
    width: 136,
    height: 136
  },
  'Counters_fractions/Text_outlined/Counters_unit_fractions1_8_text_outlined': {
    width: 136,
    height: 136
  },
  'Counters_fractions/Text_outlined/Counters_unit_fractions1_9_text_outlined': {
    width: 136,
    height: 136
  },
  Cow: { width: 403.45038, height: 316.41641 },
  CrayonBox: { width: 111.804, height: 171.468 },
  Crayons_box_pack_of_8: { width: 151, height: 259 },
  'Crosses/cross': { width: 328, height: 328 },
  'Crosses/cross_blue': { width: 328, height: 328 },
  'Crosses/cross_green': { width: 328, height: 328 },
  'Crosses/cross_orange': { width: 328, height: 328 },
  'Crosses/cross_pink': { width: 328, height: 328 },
  'Crosses/cross_purple': { width: 328, height: 328 },
  'Crosses/cross_red': { width: 328, height: 328 },
  'Crosses/cross_turquoise': { width: 328, height: 328 },
  'Crosses/cross_white': { width: 328, height: 328 },
  'Crosses/cross_yellow': { width: 328, height: 328 },
  'Cubes_With_1_Arrow/cube1_arrow': { width: 865.06279, height: 814.77623 },
  'Cubes_With_1_Arrow/cube2_arrow': { width: 826.31944, height: 853.04558 },
  'Cubes_With_1_Arrow/cube3_arrow': { width: 850.12663, height: 823.77568 },
  'Cubes_With_3_Arrows/Cube_3_arrows_blue': { width: 888.77018, height: 855.35405 },
  'Cubes_With_3_Arrows/Cube_3_arrows_green': { width: 888.77018, height: 855.35405 },
  'Cubes_With_3_Arrows/Cube_3_arrows_red': { width: 888.77018, height: 855.35405 },
  'Cubes_With_3_Arrows/Cube_3_arrows_white': { width: 888.77018, height: 855.35405 },
  'Cubes_With_3_Arrows/Cube_3_arrows_yellow': { width: 888.77018, height: 855.35405 },
  'Cubes_blank/Coloured_cube_unlabelled_blue': { width: 220.69319, height: 201.61674 },
  'Cubes_blank/Coloured_cube_unlabelled_green': { width: 220.25453, height: 201.21687 },
  'Cubes_blank/Coloured_cube_unlabelled_orange': { width: 220.25453, height: 201.21687 },
  'Cubes_blank/Coloured_cube_unlabelled_purple': { width: 220.69319, height: 201.61674 },
  'Cubes_blank/Coloured_cube_unlabelled_red': { width: 220.25453, height: 201.21687 },
  'Cubes_blank/Coloured_cube_unlabelled_yellow': { width: 221.64691, height: 202.48634 },
  'Cubes_labelled/Coloured_cube_labelled_blue': { width: 220.69319, height: 201.61674 },
  'Cubes_labelled/Coloured_cube_labelled_green': { width: 220.25453, height: 201.21687 },
  'Cubes_labelled/Coloured_cube_labelled_orange': { width: 220.25453, height: 201.21687 },
  'Cubes_labelled/Coloured_cube_labelled_purple': { width: 220.69319, height: 201.61674 },
  'Cubes_labelled/Coloured_cube_labelled_red': { width: 220.25453, height: 201.21687 },
  'Cubes_labelled/Coloured_cube_labelled_yellow': { width: 221.64691, height: 202.48634 },
  'Cuboids/Cuboid1': { width: 436.09177, height: 360.00042 },
  'Cuboids/Cuboid2': { width: 403.49799, height: 321.1648 },
  'Cuboids/Cuboid3': { width: 267.17493, height: 360.13931 },
  'Cuboids_With_3_Arrows/cuboid1_3_arrows': { width: 745.31145, height: 463.85305 },
  'Cuboids_With_3_Arrows/cuboid2_3_arrows': { width: 435.56039, height: 541.32721 },
  'Cuboids_With_3_Arrows/cuboid3_3_arrows': { width: 511.4757, height: 539.16772 },
  'Cuboids_With_3_Arrows/cuboid4_3_arrows': { width: 811.62328, height: 422.00226 },
  'Cuboids_With_3_Arrows/cuboid5_3_arrows': { width: 1298.5899, height: 354.39081 },
  'Cuboids_With_3_Arrows/cuboid6_3_arrows': { width: 546.45294, height: 1240.2152 },
  Desk: { width: 331.71585, height: 306.40866 },
  Dice: { width: 793.70135, height: 793.70135 },
  'Dice_faces/1': { width: 342.38532, height: 342.38532 },
  'Dice_faces/2': { width: 342.38532, height: 342.38532 },
  'Dice_faces/3': { width: 342.38532, height: 342.38532 },
  'Dice_faces/4': { width: 342.38532, height: 342.38532 },
  'Dice_faces/5': { width: 342.38532, height: 342.38532 },
  'Dice_faces/6': { width: 342.38532, height: 342.38532 },
  DigitalStopwatch: { width: 484, height: 551 },
  'Dodecagons/Irregular_dodecagon1_blue': { width: 416.88668, height: 416.88925 },
  'Dodecagons/Irregular_dodecagon1_green': { width: 416.88668, height: 416.88925 },
  'Dodecagons/Irregular_dodecagon1_orange': { width: 416.88668, height: 416.88925 },
  'Dodecagons/Irregular_dodecagon1_pink': { width: 416.88668, height: 416.88925 },
  'Dodecagons/Irregular_dodecagon1_purple': { width: 416.88668, height: 416.88925 },
  'Dodecagons/Irregular_dodecagon1_red': { width: 416.88668, height: 416.88925 },
  'Dodecagons/Irregular_dodecagon1_turquoise': { width: 416.88668, height: 416.88925 },
  'Dodecagons/Irregular_dodecagon1_white': { width: 416.88668, height: 416.88925 },
  'Dodecagons/Irregular_dodecagon1_yellow': { width: 416.88668, height: 416.88925 },
  'Dodecagons/Irregular_dodecagon2_blue': { width: 418.05965, height: 397.47153 },
  'Dodecagons/Irregular_dodecagon2_green': { width: 418.05965, height: 397.47153 },
  'Dodecagons/Irregular_dodecagon2_orange': { width: 418.05965, height: 397.47153 },
  'Dodecagons/Irregular_dodecagon2_pink': { width: 418.05965, height: 397.47153 },
  'Dodecagons/Irregular_dodecagon2_purple': { width: 418.05965, height: 397.47153 },
  'Dodecagons/Irregular_dodecagon2_red': { width: 418.05965, height: 397.47153 },
  'Dodecagons/Irregular_dodecagon2_turquoise': { width: 418.05965, height: 397.47153 },
  'Dodecagons/Irregular_dodecagon2_white': { width: 418.05965, height: 397.47153 },
  'Dodecagons/Irregular_dodecagon2_yellow': { width: 418.05965, height: 397.47153 },
  'Dogs/dog1': { width: NaN, height: NaN },
  'Dogs/dog2': { width: NaN, height: NaN },
  'Dogs/dog3': { width: 540.89867, height: 462.48978 },
  'Donuts_in_a_box/Donuts_in_a_box_0': { width: 240.39061, height: 242.12546 },
  'Donuts_in_a_box/Donuts_in_a_box_1': { width: 240.39061, height: 242.12546 },
  'Donuts_in_a_box/Donuts_in_a_box_10': { width: 240.39061, height: 242.12546 },
  'Donuts_in_a_box/Donuts_in_a_box_11': { width: 240.39061, height: 242.12546 },
  'Donuts_in_a_box/Donuts_in_a_box_12': { width: 240.39061, height: 242.12546 },
  'Donuts_in_a_box/Donuts_in_a_box_2': { width: 240.39061, height: 242.12546 },
  'Donuts_in_a_box/Donuts_in_a_box_3': { width: 240.39061, height: 242.12546 },
  'Donuts_in_a_box/Donuts_in_a_box_4': { width: 240.39061, height: 242.12546 },
  'Donuts_in_a_box/Donuts_in_a_box_5': { width: 240.39061, height: 242.12546 },
  'Donuts_in_a_box/Donuts_in_a_box_6': { width: 240.39061, height: 242.12546 },
  'Donuts_in_a_box/Donuts_in_a_box_7': { width: 240.39061, height: 242.12546 },
  'Donuts_in_a_box/Donuts_in_a_box_8': { width: 240.39061, height: 242.12546 },
  'Donuts_in_a_box/Donuts_in_a_box_9': { width: 240.39061, height: 242.12546 },
  'Donuts_individual/Donut_1': { width: 232.5811, height: 159.76759 },
  'Donuts_individual/Donut_2': { width: 233.00967, height: 160.8351 },
  'Donuts_individual/Donut_3': { width: 228.54422, height: 157.81711 },
  'Donuts_individual/Donut_4': { width: 228.54422, height: 157.81711 },
  'Donuts_individual/Donut_5': { width: 233.74306, height: 161.33082 },
  'Donuts_individual/Donut_6': { width: 228.54422, height: 164.4033 },
  Door: { width: 239.88133, height: 477.03333 },
  Dumbbell_weights: { width: 391.08972, height: 153.72656 },
  Elephant: { width: 533.92175, height: 442.59176 },
  'Ellipses/Ellipse_blue': { width: 569.82971, height: 327.99918 },
  'Ellipses/Ellipse_green': { width: 569.82971, height: 327.99918 },
  'Ellipses/Ellipse_orange': { width: 569.82971, height: 327.99918 },
  'Ellipses/Ellipse_pink': { width: 569.82971, height: 327.99918 },
  'Ellipses/Ellipse_purple': { width: 569.82971, height: 327.99918 },
  'Ellipses/Ellipse_red': { width: 569.82971, height: 327.99918 },
  'Ellipses/Ellipse_turquoise': { width: 569.82971, height: 327.99918 },
  'Ellipses/Ellipse_yellow': { width: 569.82971, height: 327.99918 },
  Empty_bucket: { width: 574.27464, height: 652.89331 },
  Empty_bucket_blue: { width: 699.9268, height: 780 },
  Empty_bucket_rectangular: { width: 701.66105, height: 780 },
  Empty_bucket_rectangular_blue: { width: 701.66105, height: 780 },
  Empty_bucket_transparent: { width: 699.9268, height: 780 },
  Empty_jug: { width: 271.66815, height: 360.948 },
  'Equal_groups/Apples0': { width: 286.25168, height: 384.87314 },
  'Equal_groups/Apples1': { width: 286.25168, height: 384.87314 },
  'Equal_groups/Apples2': { width: 286.25168, height: 384.87314 },
  'Equal_groups/Apples3': { width: 286.25168, height: 384.87314 },
  'Equal_groups/Apples4': { width: 286.25168, height: 384.87314 },
  'Equal_groups/Apples5': { width: 286.25168, height: 384.87314 },
  'Equal_groups/Apples6': { width: 286.25168, height: 384.87314 },
  'Equal_groups/Cookies0': { width: 237.08266, height: 185.34132 },
  'Equal_groups/Cookies1': { width: 237.08266, height: 185.34132 },
  'Equal_groups/Cookies2': { width: 237.08266, height: 185.34132 },
  'Equal_groups/Cookies3': { width: 237.08266, height: 185.34132 },
  'Equal_groups/Cookies4': { width: 237.08266, height: 185.34132 },
  'Equal_groups/Cookies5': { width: 237.08266, height: 185.34132 },
  'Equal_groups/Cookies6': { width: 237.08266, height: 185.34132 },
  'Equal_groups/Eggs0': { width: 320.11795, height: 252.24707 },
  'Equal_groups/Eggs1': { width: 320.11795, height: 252.24707 },
  'Equal_groups/Eggs2': { width: 320.11795, height: 252.24707 },
  'Equal_groups/Eggs3': { width: 320.11795, height: 252.24707 },
  'Equal_groups/Eggs4': { width: 320.11795, height: 252.24707 },
  'Equal_groups/Eggs5': { width: 320.11795, height: 252.24707 },
  'Equal_groups/Eggs6': { width: 320.11795, height: 252.24707 },
  'Equal_groups/Flowers0': { width: 135.49791, height: 187.30826 },
  'Equal_groups/Flowers1': { width: 139.6288, height: 324.06919 },
  'Equal_groups/Flowers2': { width: 216.40427, height: 301.51987 },
  'Equal_groups/Flowers3': { width: 216.51862, height: 328.66385 },
  'Equal_groups/Flowers4': { width: 228.71968, height: 355.66635 },
  'Equal_groups/Flowers5': { width: 250.52574, height: 367.43247 },
  'Equal_groups/Flowers6': { width: 250.52705, height: 367.431 },
  'Equal_groups/Pencils0': { width: 293.61133, height: 277.45358 },
  'Equal_groups/Pencils1': { width: 293.61133, height: 401.3168 },
  'Equal_groups/Pencils2': { width: 293.61133, height: 401.3168 },
  'Equal_groups/Pencils3': { width: 293.61065, height: 401.31833 },
  'Equal_groups/Pencils4': { width: 293.61133, height: 405.47302 },
  'Equal_groups/Pencils5': { width: 293.61133, height: 405.47302 },
  'Equal_groups/Pencils6': { width: 293.61133, height: 405.47302 },
  'Equal_groups/Pizza1': { width: 221.02733, height: 264.20666 },
  'Equal_groups/Pizza2': { width: 221.02733, height: 354.44772 },
  'Equal_groups/Pizza3': { width: 239.27133, height: 435.90786 },
  'Equal_groups/Pizza4': { width: 435.90799, height: 435.90786 },
  'Equal_groups/Pizza5': { width: 435.90799, height: 435.90786 },
  'Equal_groups/Pizza6': { width: 435.90799, height: 435.90786 },
  'Equal_shapes_10_parts/Circle_equal_10-10': { width: 310.09598, height: 310.09598 },
  'Equal_shapes_10_parts/Pentagon_10-10': { width: 341.99026, height: 325.25348 },
  'Equal_shapes_10_parts/Square_equal_10-10': { width: 286.728, height: 286.728 },
  'Equal_shapes_11_parts/Circle_equal_11-11': { width: 310.09598, height: 310.09598 },
  'Equal_shapes_11_parts/Rectangle_equal_11-11': { width: 406.944, height: 231.71066 },
  'Equal_shapes_11_parts/Square_equal_11-11': { width: 286.728, height: 286.728 },
  'Equal_shapes_12_parts/Hexagon_12-12': { width: 345.34946, height: 299.08133 },
  'Equal_shapes_12_parts/Rectangle_equal_12-12': { width: 406.944, height: 231.71066 },
  'Equal_shapes_12_parts/Square_equal_12-12': { width: 286.728, height: 286.728 },
  'Equal_shapes_2_parts/Circle_equal_2-0_1': { width: 308, height: 308 },
  'Equal_shapes_2_parts/Circle_equal_2-1_1_blue': { width: 308, height: 308 },
  'Equal_shapes_2_parts/Circle_equal_2-1_1_green': { width: 308, height: 308 },
  'Equal_shapes_2_parts/Circle_equal_2-1_1_yellow': { width: 308, height: 308 },
  'Equal_shapes_2_parts/Circle_equal_2-2_1_blue': { width: 308, height: 308 },
  'Equal_shapes_2_parts/Circle_equal_2-2_1_green': { width: 308, height: 308 },
  'Equal_shapes_2_parts/Circle_equal_2-2_1_yellow': { width: 308, height: 308 },
  'Equal_shapes_2_parts/Hexagon_equal_2-1_1_blue': { width: 378, height: 328 },
  'Equal_shapes_2_parts/Hexagon_equal_2-1_1_green': { width: 378, height: 328 },
  'Equal_shapes_2_parts/Hexagon_equal_2-1_1_yellow': { width: 378, height: 328 },
  'Equal_shapes_2_parts/Hexagon_equal_2-2_1_blue': { width: 378, height: 328 },
  'Equal_shapes_2_parts/Hexagon_equal_2-2_1_green': { width: 378, height: 328 },
  'Equal_shapes_2_parts/Hexagon_equal_2-2_1_yellow': { width: 378, height: 328 },
  'Equal_shapes_2_parts/Kite_equal_1-2': { width: 241.97533, height: 327.06537 },
  'Equal_shapes_2_parts/Kite_equal_2-1_1_blue': { width: 241.97533, height: 327.06537 },
  'Equal_shapes_2_parts/Kite_equal_2-1_1_green': { width: 241.97533, height: 327.06537 },
  'Equal_shapes_2_parts/Kite_equal_2-1_1_yellow': { width: 241.97533, height: 327.06537 },
  'Equal_shapes_2_parts/Kite_equal_2-2': { width: 241.97533, height: 327.06537 },
  'Equal_shapes_2_parts/Kite_equal_2-2_1_blue': { width: 241.97533, height: 327.06537 },
  'Equal_shapes_2_parts/Kite_equal_2-2_1_green': { width: 241.97533, height: 327.06537 },
  'Equal_shapes_2_parts/Kite_equal_2-2_1_yellow': { width: 241.97533, height: 327.06537 },
  'Equal_shapes_2_parts/Octagon_equal_2-1_1_blue': { width: 334, height: 334 },
  'Equal_shapes_2_parts/Octagon_equal_2-1_1_green': { width: 334, height: 334 },
  'Equal_shapes_2_parts/Octagon_equal_2-1_1_yellow': { width: 334, height: 334 },
  'Equal_shapes_2_parts/Octagon_equal_2-2_1_blue': { width: 334, height: 334 },
  'Equal_shapes_2_parts/Octagon_equal_2-2_1_green': { width: 334, height: 334 },
  'Equal_shapes_2_parts/Octagon_equal_2-2_1_yellow': { width: 334, height: 334 },
  'Equal_shapes_2_parts/Rectangle_equal_2-0_2': { width: 548, height: 289 },
  'Equal_shapes_2_parts/Rectangle_equal_2-1_1_blue': { width: 548, height: 287 },
  'Equal_shapes_2_parts/Rectangle_equal_2-1_1_green': { width: 548, height: 287 },
  'Equal_shapes_2_parts/Rectangle_equal_2-1_1_yellow': { width: 548, height: 287 },
  'Equal_shapes_2_parts/Rectangle_equal_2-1_2_blue': { width: 548, height: 289 },
  'Equal_shapes_2_parts/Rectangle_equal_2-1_2_green': { width: 548, height: 289 },
  'Equal_shapes_2_parts/Rectangle_equal_2-1_2_yellow': { width: 548, height: 289 },
  'Equal_shapes_2_parts/Rectangle_equal_2-1_3_blue': { width: 548, height: 287 },
  'Equal_shapes_2_parts/Rectangle_equal_2-1_3_green': { width: 548, height: 287 },
  'Equal_shapes_2_parts/Rectangle_equal_2-1_3_yellow': { width: 548, height: 287 },
  'Equal_shapes_2_parts/Rectangle_equal_2-2_1_blue': { width: 548, height: 287 },
  'Equal_shapes_2_parts/Rectangle_equal_2-2_1_green': { width: 548, height: 287 },
  'Equal_shapes_2_parts/Rectangle_equal_2-2_1_yellow': { width: 548, height: 287 },
  'Equal_shapes_2_parts/Rectangle_equal_2-2_2_blue': { width: 548, height: 289 },
  'Equal_shapes_2_parts/Rectangle_equal_2-2_2_green': { width: 548, height: 289 },
  'Equal_shapes_2_parts/Rectangle_equal_2-2_2_yellow': { width: 548, height: 289 },
  'Equal_shapes_2_parts/Rectangle_equal_2-2_3_blue': { width: 548, height: 287 },
  'Equal_shapes_2_parts/Rectangle_equal_2-2_3_green': { width: 548, height: 287 },
  'Equal_shapes_2_parts/Rectangle_equal_2-2_3_yellow': { width: 548, height: 287 },
  'Equal_shapes_2_parts/Square_equal_1-2': { width: 286.728, height: 286.728 },
  'Equal_shapes_2_parts/Square_equal_2-0_1': { width: 283, height: 285 },
  'Equal_shapes_2_parts/Square_equal_2-1_1_blue': { width: 283, height: 285 },
  'Equal_shapes_2_parts/Square_equal_2-1_1_green': { width: 283, height: 285 },
  'Equal_shapes_2_parts/Square_equal_2-1_1_yellow': { width: 283, height: 285 },
  'Equal_shapes_2_parts/Square_equal_2-1_2_blue': { width: 286.728, height: 286.728 },
  'Equal_shapes_2_parts/Square_equal_2-1_2_green': { width: 286.728, height: 286.728 },
  'Equal_shapes_2_parts/Square_equal_2-1_2_yellow': { width: 286.728, height: 286.728 },
  'Equal_shapes_2_parts/Square_equal_2-2': { width: 286.728, height: 286.728 },
  'Equal_shapes_2_parts/Square_equal_2-2_1_blue': { width: 283, height: 285 },
  'Equal_shapes_2_parts/Square_equal_2-2_1_green': { width: 283, height: 285 },
  'Equal_shapes_2_parts/Square_equal_2-2_1_yellow': { width: 283, height: 285 },
  'Equal_shapes_2_parts/Square_equal_2-2_2_blue': { width: 286.728, height: 286.728 },
  'Equal_shapes_2_parts/Square_equal_2-2_2_green': { width: 286.728, height: 286.728 },
  'Equal_shapes_2_parts/Square_equal_2-2_2_yellow': { width: 286.728, height: 286.728 },
  'Equal_shapes_2_parts/Triangle_equal_1-2': { width: 323.30908, height: 280.57993 },
  'Equal_shapes_2_parts/Triangle_equal_2-0_1': { width: 379, height: 280 },
  'Equal_shapes_2_parts/Triangle_equal_2-1_1_blue': { width: 379, height: 280 },
  'Equal_shapes_2_parts/Triangle_equal_2-1_1_green': { width: 379, height: 280 },
  'Equal_shapes_2_parts/Triangle_equal_2-1_1_yellow': { width: 379, height: 280 },
  'Equal_shapes_2_parts/Triangle_equal_2-2': { width: 323.30908, height: 280.57993 },
  'Equal_shapes_2_parts/Triangle_equal_2-2_1_blue': { width: 379, height: 280 },
  'Equal_shapes_2_parts/Triangle_equal_2-2_1_green': { width: 379, height: 280 },
  'Equal_shapes_2_parts/Triangle_equal_2-2_1_yellow': { width: 379, height: 280 },
  'Equal_shapes_3_parts/Arrow_equal_3-1_1_blue': { width: 820, height: 440 },
  'Equal_shapes_3_parts/Arrow_equal_3-1_1_green': { width: 820, height: 441 },
  'Equal_shapes_3_parts/Arrow_equal_3-1_1_yellow': { width: 820, height: 441 },
  'Equal_shapes_3_parts/Circle_equal_3-0_1': { width: 304, height: 304 },
  'Equal_shapes_3_parts/Circle_equal_3-1_1_blue': { width: 304, height: 304 },
  'Equal_shapes_3_parts/Circle_equal_3-1_1_green': { width: 304, height: 304 },
  'Equal_shapes_3_parts/Circle_equal_3-1_1_yellow': { width: 304, height: 304 },
  'Equal_shapes_3_parts/Circle_equal_3-2_1_blue': { width: 304, height: 304 },
  'Equal_shapes_3_parts/Circle_equal_3-2_1_green': { width: 304, height: 304 },
  'Equal_shapes_3_parts/Circle_equal_3-2_1_yellow': { width: 304, height: 304 },
  'Equal_shapes_3_parts/Circle_equal_3-3': { width: 310.31466, height: 310.31467 },
  'Equal_shapes_3_parts/Circle_equal_3-3_1_blue': { width: 304, height: 304 },
  'Equal_shapes_3_parts/Circle_equal_3-3_1_green': { width: 304, height: 304 },
  'Equal_shapes_3_parts/Circle_equal_3-3_1_yellow': { width: 304, height: 304 },
  'Equal_shapes_3_parts/Rectangle_equal_3-0_1': { width: 243.44673, height: 120.89347 },
  'Equal_shapes_3_parts/Rectangle_equal_3-1_1_blue': { width: 243.44673, height: 120.89347 },
  'Equal_shapes_3_parts/Rectangle_equal_3-1_1_green': { width: 243.44673, height: 120.89347 },
  'Equal_shapes_3_parts/Rectangle_equal_3-1_1_yellow': { width: 243.89346, height: 120.89347 },
  'Equal_shapes_3_parts/Rectangle_equal_3-2_1_blue': { width: 243.44673, height: 120.89347 },
  'Equal_shapes_3_parts/Rectangle_equal_3-2_1_green': { width: 243.44673, height: 120.89347 },
  'Equal_shapes_3_parts/Rectangle_equal_3-2_1_yellow': { width: 243.89346, height: 120.89347 },
  'Equal_shapes_3_parts/Rectangle_equal_3-3_1_blue': { width: 243, height: 120 },
  'Equal_shapes_3_parts/Rectangle_equal_3-3_1_green': { width: 243, height: 120 },
  'Equal_shapes_3_parts/Rectangle_equal_3-3_1_yellow': { width: 243.89346, height: 120.89347 },
  'Equal_shapes_3_parts/Square_equal_1-3': { width: 286.728, height: 286.728 },
  'Equal_shapes_3_parts/Square_equal_3-0_1': { width: 244, height: 244 },
  'Equal_shapes_3_parts/Square_equal_3-1_1_blue': { width: 244, height: 244 },
  'Equal_shapes_3_parts/Square_equal_3-1_1_green': { width: 244, height: 244 },
  'Equal_shapes_3_parts/Square_equal_3-1_1_yellow': { width: 244, height: 244 },
  'Equal_shapes_3_parts/Square_equal_3-2_1_blue': { width: 244, height: 244 },
  'Equal_shapes_3_parts/Square_equal_3-2_1_green': { width: 244, height: 244 },
  'Equal_shapes_3_parts/Square_equal_3-2_1_yellow': { width: 244, height: 244 },
  'Equal_shapes_3_parts/Square_equal_3-3': { width: 286.728, height: 286.728 },
  'Equal_shapes_3_parts/Square_equal_3-3_1_blue': { width: 244, height: 244 },
  'Equal_shapes_3_parts/Square_equal_3-3_1_green': { width: 244, height: 244 },
  'Equal_shapes_3_parts/Square_equal_3-3_1_yellow': { width: 244, height: 244 },
  'Equal_shapes_3_parts/Triangle_equal_1-3': { width: 323.30908, height: 280.461 },
  'Equal_shapes_3_parts/Triangle_equal_3-0_1': { width: 244, height: 211.846 },
  'Equal_shapes_3_parts/Triangle_equal_3-1_1_blue': { width: 244, height: 211.846 },
  'Equal_shapes_3_parts/Triangle_equal_3-1_1_green': { width: 244, height: 211.846 },
  'Equal_shapes_3_parts/Triangle_equal_3-1_1_yellow': { width: 244, height: 211.846 },
  'Equal_shapes_3_parts/Triangle_equal_3-2_1_blue': { width: 244, height: 211.846 },
  'Equal_shapes_3_parts/Triangle_equal_3-2_1_green': { width: 244, height: 211.846 },
  'Equal_shapes_3_parts/Triangle_equal_3-2_1_yellow': { width: 244, height: 211.846 },
  'Equal_shapes_3_parts/Triangle_equal_3-3': { width: 323.30908, height: 280.461 },
  'Equal_shapes_3_parts/Triangle_equal_3-3_1_blue': { width: 244, height: 211.846 },
  'Equal_shapes_3_parts/Triangle_equal_3-3_1_green': { width: 244, height: 211.846 },
  'Equal_shapes_3_parts/Triangle_equal_3-3_1_yellow': { width: 244, height: 211.846 },
  'Equal_shapes_4_parts/Circle_equal_4-0_1': { width: 312, height: 312 },
  'Equal_shapes_4_parts/Circle_equal_4-1_1_blue': { width: 312, height: 312 },
  'Equal_shapes_4_parts/Circle_equal_4-1_1_green': { width: 312, height: 312 },
  'Equal_shapes_4_parts/Circle_equal_4-1_1_yellow': { width: 312, height: 312 },
  'Equal_shapes_4_parts/Circle_equal_4-2_1_blue': { width: 312, height: 312 },
  'Equal_shapes_4_parts/Circle_equal_4-2_1_green': { width: 312, height: 312 },
  'Equal_shapes_4_parts/Circle_equal_4-2_1_yellow': { width: 312, height: 312 },
  'Equal_shapes_4_parts/Circle_equal_4-3_1_blue': { width: 312, height: 312 },
  'Equal_shapes_4_parts/Circle_equal_4-3_1_green': { width: 312, height: 312 },
  'Equal_shapes_4_parts/Circle_equal_4-3_1_yellow': { width: 312, height: 312 },
  'Equal_shapes_4_parts/Circle_equal_4-4': { width: 310.09598, height: 310.09598 },
  'Equal_shapes_4_parts/Circle_equal_4-4_1_blue': { width: 312, height: 312 },
  'Equal_shapes_4_parts/Circle_equal_4-4_1_green': { width: 312, height: 312 },
  'Equal_shapes_4_parts/Circle_equal_4-4_1_yellow': { width: 312, height: 312 },
  'Equal_shapes_4_parts/Cross_equal_1-4': { width: 328, height: 328 },
  'Equal_shapes_4_parts/Cross_equal_3-4': { width: 328, height: 328 },
  'Equal_shapes_4_parts/Cross_equal_4-4': { width: 328, height: 328 },
  'Equal_shapes_4_parts/Hexagon_equal_4-1_1_blue': { width: 380, height: 330 },
  'Equal_shapes_4_parts/Hexagon_equal_4-1_1_green': { width: 380, height: 330 },
  'Equal_shapes_4_parts/Hexagon_equal_4-1_1_yellow': { width: 380, height: 330 },
  'Equal_shapes_4_parts/Hexagon_equal_4-2_1_blue': { width: 380, height: 330 },
  'Equal_shapes_4_parts/Hexagon_equal_4-2_1_green': { width: 380, height: 330 },
  'Equal_shapes_4_parts/Hexagon_equal_4-2_1_yellow': { width: 380, height: 330 },
  'Equal_shapes_4_parts/Hexagon_equal_4-3_1_blue': { width: 380, height: 330 },
  'Equal_shapes_4_parts/Hexagon_equal_4-3_1_green': { width: 380, height: 330 },
  'Equal_shapes_4_parts/Hexagon_equal_4-3_1_yellow': { width: 380, height: 330 },
  'Equal_shapes_4_parts/Hexagon_equal_4-4_1_blue': { width: 380, height: 330 },
  'Equal_shapes_4_parts/Hexagon_equal_4-4_1_green': { width: 380, height: 330 },
  'Equal_shapes_4_parts/Hexagon_equal_4-4_1_yellow': { width: 380, height: 330 },
  'Equal_shapes_4_parts/Octagon_equal_4-1_1_blue': { width: 334, height: 334 },
  'Equal_shapes_4_parts/Octagon_equal_4-1_1_green': { width: 334, height: 334 },
  'Equal_shapes_4_parts/Octagon_equal_4-1_1_yellow': { width: 334, height: 334 },
  'Equal_shapes_4_parts/Octagon_equal_4-2_1_blue': { width: 334, height: 334 },
  'Equal_shapes_4_parts/Octagon_equal_4-2_1_green': { width: 334, height: 334 },
  'Equal_shapes_4_parts/Octagon_equal_4-2_1_yellow': { width: 334, height: 334 },
  'Equal_shapes_4_parts/Octagon_equal_4-3_1_blue': { width: 334, height: 334 },
  'Equal_shapes_4_parts/Octagon_equal_4-3_1_green': { width: 334, height: 334 },
  'Equal_shapes_4_parts/Octagon_equal_4-3_1_yellow': { width: 334, height: 334 },
  'Equal_shapes_4_parts/Octagon_equal_4-4_1_blue': { width: 334, height: 334 },
  'Equal_shapes_4_parts/Octagon_equal_4-4_1_green': { width: 334, height: 334 },
  'Equal_shapes_4_parts/Octagon_equal_4-4_1_yellow': { width: 334, height: 334 },
  'Equal_shapes_4_parts/Rectangle_equal_4-0_2': { width: 552, height: 291 },
  'Equal_shapes_4_parts/Rectangle_equal_4-1_1_blue': { width: 553, height: 291 },
  'Equal_shapes_4_parts/Rectangle_equal_4-1_1_green': { width: 553, height: 291 },
  'Equal_shapes_4_parts/Rectangle_equal_4-1_1_yellow': { width: 553, height: 291 },
  'Equal_shapes_4_parts/Rectangle_equal_4-1_2_blue': { width: 552, height: 291 },
  'Equal_shapes_4_parts/Rectangle_equal_4-1_2_green': { width: 552, height: 291 },
  'Equal_shapes_4_parts/Rectangle_equal_4-1_2_yellow': { width: 552, height: 291 },
  'Equal_shapes_4_parts/Rectangle_equal_4-1_3_blue': { width: 552, height: 291 },
  'Equal_shapes_4_parts/Rectangle_equal_4-1_3_green': { width: 552, height: 291 },
  'Equal_shapes_4_parts/Rectangle_equal_4-1_3_yellow': { width: 552, height: 291 },
  'Equal_shapes_4_parts/Rectangle_equal_4-2_1_blue': { width: 553, height: 291 },
  'Equal_shapes_4_parts/Rectangle_equal_4-2_1_green': { width: 553, height: 291 },
  'Equal_shapes_4_parts/Rectangle_equal_4-2_1_yellow': { width: 553, height: 291 },
  'Equal_shapes_4_parts/Rectangle_equal_4-2_2_blue': { width: 552, height: 291 },
  'Equal_shapes_4_parts/Rectangle_equal_4-2_2_green': { width: 552, height: 291 },
  'Equal_shapes_4_parts/Rectangle_equal_4-2_2_yellow': { width: 552, height: 291 },
  'Equal_shapes_4_parts/Rectangle_equal_4-3_1_blue': { width: 553, height: 291 },
  'Equal_shapes_4_parts/Rectangle_equal_4-3_1_green': { width: 553, height: 291 },
  'Equal_shapes_4_parts/Rectangle_equal_4-3_1_yellow': { width: 553, height: 291 },
  'Equal_shapes_4_parts/Rectangle_equal_4-3_2_blue': { width: 552, height: 291 },
  'Equal_shapes_4_parts/Rectangle_equal_4-3_2_green': { width: 552, height: 291 },
  'Equal_shapes_4_parts/Rectangle_equal_4-3_2_yellow': { width: 552, height: 291 },
  'Equal_shapes_4_parts/Rectangle_equal_4-4_1_blue': { width: 553, height: 291 },
  'Equal_shapes_4_parts/Rectangle_equal_4-4_1_green': { width: 553, height: 291 },
  'Equal_shapes_4_parts/Rectangle_equal_4-4_1_yellow': { width: 553, height: 291 },
  'Equal_shapes_4_parts/Rectangle_equal_4-4_2_blue': { width: 552, height: 291 },
  'Equal_shapes_4_parts/Rectangle_equal_4-4_2_green': { width: 552, height: 291 },
  'Equal_shapes_4_parts/Rectangle_equal_4-4_2_yellow': { width: 552, height: 291 },
  'Equal_shapes_4_parts/Square_equal_1-4': { width: 286.728, height: 286.728 },
  'Equal_shapes_4_parts/Square_equal_4-0_1': { width: 286.728, height: 286.728 },
  'Equal_shapes_4_parts/Square_equal_4-1_1_blue': { width: 244, height: 244 },
  'Equal_shapes_4_parts/Square_equal_4-1_1_green': { width: 244, height: 244 },
  'Equal_shapes_4_parts/Square_equal_4-1_1_yellow': { width: 244, height: 244 },
  'Equal_shapes_4_parts/Square_equal_4-2_1_blue': { width: 244, height: 244 },
  'Equal_shapes_4_parts/Square_equal_4-2_1_green': { width: 244, height: 244 },
  'Equal_shapes_4_parts/Square_equal_4-2_1_yellow': { width: 244, height: 244 },
  'Equal_shapes_4_parts/Square_equal_4-3_1_blue': { width: 244, height: 244 },
  'Equal_shapes_4_parts/Square_equal_4-3_1_green': { width: 244, height: 244 },
  'Equal_shapes_4_parts/Square_equal_4-3_1_yellow': { width: 244, height: 244 },
  'Equal_shapes_4_parts/Square_equal_4-4': { width: 286.728, height: 286.728 },
  'Equal_shapes_4_parts/Square_equal_4-4_1_blue': { width: 244, height: 244 },
  'Equal_shapes_4_parts/Square_equal_4-4_1_green': { width: 244, height: 244 },
  'Equal_shapes_4_parts/Square_equal_4-4_1_yellow': { width: 244, height: 244 },
  'Equal_shapes_5_parts/Circle_equal_5-1_1_blue': { width: 304, height: 304 },
  'Equal_shapes_5_parts/Circle_equal_5-1_1_green': { width: 304, height: 304 },
  'Equal_shapes_5_parts/Circle_equal_5-1_1_yellow': { width: 304, height: 304 },
  'Equal_shapes_5_parts/Circle_equal_5-2_1_blue': { width: 304, height: 304 },
  'Equal_shapes_5_parts/Circle_equal_5-2_1_green': { width: 304, height: 304 },
  'Equal_shapes_5_parts/Circle_equal_5-2_1_yellow': { width: 304, height: 304 },
  'Equal_shapes_5_parts/Circle_equal_5-3_1_blue': { width: 304, height: 304 },
  'Equal_shapes_5_parts/Circle_equal_5-3_1_green': { width: 304, height: 304 },
  'Equal_shapes_5_parts/Circle_equal_5-3_1_yellow': { width: 304, height: 304 },
  'Equal_shapes_5_parts/Circle_equal_5-4_1_blue': { width: 304, height: 304 },
  'Equal_shapes_5_parts/Circle_equal_5-4_1_green': { width: 304, height: 304 },
  'Equal_shapes_5_parts/Circle_equal_5-4_1_yellow': { width: 304, height: 304 },
  'Equal_shapes_5_parts/Circle_equal_5-5': { width: 310.31466, height: 310.31467 },
  'Equal_shapes_5_parts/Circle_equal_5-5_1_blue': { width: 304, height: 304 },
  'Equal_shapes_5_parts/Circle_equal_5-5_1_green': { width: 304, height: 304 },
  'Equal_shapes_5_parts/Circle_equal_5-5_1_yellow': { width: 304, height: 304 },
  'Equal_shapes_5_parts/Pentagon_1-5': { width: 341.99026, height: 325.25348 },
  'Equal_shapes_5_parts/Pentagon_5-5': { width: 341.99026, height: 325.25348 },
  'Equal_shapes_5_parts/Pentagon_equal_5-1_1_blue': { width: 232, height: 221 },
  'Equal_shapes_5_parts/Pentagon_equal_5-1_1_green': { width: 232, height: 221 },
  'Equal_shapes_5_parts/Pentagon_equal_5-1_1_yellow': { width: 232, height: 221 },
  'Equal_shapes_5_parts/Pentagon_equal_5-2_1_blue': { width: 232, height: 221 },
  'Equal_shapes_5_parts/Pentagon_equal_5-2_1_green': { width: 232, height: 221 },
  'Equal_shapes_5_parts/Pentagon_equal_5-2_1_yellow': { width: 232, height: 221 },
  'Equal_shapes_5_parts/Pentagon_equal_5-3_1_blue': { width: 232, height: 221 },
  'Equal_shapes_5_parts/Pentagon_equal_5-3_1_green': { width: 232, height: 221 },
  'Equal_shapes_5_parts/Pentagon_equal_5-3_1_yellow': { width: 232, height: 221 },
  'Equal_shapes_5_parts/Pentagon_equal_5-4_1_blue': { width: 232, height: 221 },
  'Equal_shapes_5_parts/Pentagon_equal_5-4_1_green': { width: 232, height: 221 },
  'Equal_shapes_5_parts/Pentagon_equal_5-4_1_yellow': { width: 232, height: 221 },
  'Equal_shapes_5_parts/Pentagon_equal_5-5_1_blue': { width: 232, height: 221 },
  'Equal_shapes_5_parts/Pentagon_equal_5-5_1_green': { width: 232, height: 221 },
  'Equal_shapes_5_parts/Pentagon_equal_5-5_1_yellow': { width: 232, height: 221 },
  'Equal_shapes_5_parts/Square_equal_1-5': { width: 286.728, height: 286.728 },
  'Equal_shapes_5_parts/Square_equal_5-1_1_blue': { width: 244, height: 244 },
  'Equal_shapes_5_parts/Square_equal_5-1_1_green': { width: 244, height: 244 },
  'Equal_shapes_5_parts/Square_equal_5-1_1_yellow': { width: 244, height: 244 },
  'Equal_shapes_5_parts/Square_equal_5-2_1_blue': { width: 244, height: 244 },
  'Equal_shapes_5_parts/Square_equal_5-2_1_green': { width: 244, height: 244 },
  'Equal_shapes_5_parts/Square_equal_5-2_1_yellow': { width: 244, height: 244 },
  'Equal_shapes_5_parts/Square_equal_5-3_1_blue': { width: 244, height: 244 },
  'Equal_shapes_5_parts/Square_equal_5-3_1_green': { width: 244, height: 244 },
  'Equal_shapes_5_parts/Square_equal_5-3_1_yellow': { width: 244, height: 244 },
  'Equal_shapes_5_parts/Square_equal_5-4_1_blue': { width: 244, height: 244 },
  'Equal_shapes_5_parts/Square_equal_5-4_1_green': { width: 244, height: 244 },
  'Equal_shapes_5_parts/Square_equal_5-4_1_yellow': { width: 244, height: 244 },
  'Equal_shapes_5_parts/Square_equal_5-5': { width: 286.728, height: 286.728 },
  'Equal_shapes_5_parts/Square_equal_5-5_1_blue': { width: 244, height: 244 },
  'Equal_shapes_5_parts/Square_equal_5-5_1_green': { width: 244, height: 244 },
  'Equal_shapes_5_parts/Square_equal_5-5_1_yellow': { width: 244, height: 244 },
  'Equal_shapes_6_parts/Circle_equal_6-6': { width: 310.31466, height: 310.31467 },
  'Equal_shapes_6_parts/Hexagon_6-6': { width: 345.34946, height: 299.08133 },
  'Equal_shapes_6_parts/Square_equal_6-6': { width: 286.728, height: 286.728 },
  'Equal_shapes_7_parts/Circle_equal_7-7': { width: 305.26932, height: 305.26932 },
  'Equal_shapes_7_parts/Rectangle_equal_7-7': { width: 406.944, height: 231.71066 },
  'Equal_shapes_7_parts/Square_equal_7-7': { width: 286.728, height: 286.728 },
  'Equal_shapes_8_parts/Circle_equal_8-8': { width: 310.09598, height: 310.09598 },
  'Equal_shapes_8_parts/Cross_equal_8-8': { width: 328, height: 328 },
  'Equal_shapes_8_parts/Square_equal_8-8': { width: 286.728, height: 286.728 },
  'Equal_shapes_9_parts/Circle_equal_9-9': { width: 305.26932, height: 305.26932 },
  'Equal_shapes_9_parts/Rectangle_equal_9-9': { width: 406.944, height: 231.71066 },
  'Equal_shapes_9_parts/Square_equal_9-9': { width: 286.728, height: 286.728 },
  'Equilateral_triangles/triangle_equal_': { width: 379.87177, height: 329.52768 },
  'Equilateral_triangles/triangle_equal_blue': { width: 379.87177, height: 329.52768 },
  'Equilateral_triangles/triangle_equal_green': { width: 379.87177, height: 329.52768 },
  'Equilateral_triangles/triangle_equal_orange': { width: 379.87177, height: 329.52768 },
  'Equilateral_triangles/triangle_equal_pink': { width: 379.87177, height: 329.52768 },
  'Equilateral_triangles/triangle_equal_purple': { width: 379.87177, height: 329.52768 },
  'Equilateral_triangles/triangle_equal_red': { width: 379.87177, height: 329.52768 },
  'Equilateral_triangles/triangle_equal_turquoise': { width: 379.87177, height: 329.52768 },
  'Equilateral_triangles/triangle_equal_white': { width: 379.87177, height: 329.52768 },
  'Equilateral_triangles/triangle_equal_yellow': { width: 379.87177, height: 329.52768 },
  Factor_Bug: { width: 256.8136, height: 409.69424 },
  'Flags/Armenia_horizontal_flag': { width: 462.04531, height: 347.03467 },
  'Flags/Australia_both_flag': { width: 462.04396, height: 347.03467 },
  'Flags/Austria_horizontal_flag': { width: 462.04531, height: 347.03467 },
  'Flags/Belgium_vertical_flag': { width: 462.04531, height: 347.03467 },
  'Flags/Botswana_horizontal_flag': { width: 462.04531, height: 347.03467 },
  'Flags/Bulgaria_horizontal_flag': { width: 462.04531, height: 347.03467 },
  'Flags/Cameroon_vertical_flag': { width: 462.04531, height: 347.03467 },
  'Flags/Canada_vertical_flag': { width: 461.54265, height: 347.03491 },
  'Flags/Chad_vertical_flag': { width: 462.04531, height: 347.03467 },
  'Flags/Columbia_horizontal_flag': { width: 462.04531, height: 347.03467 },
  'Flags/Denmark_both_flag': { width: 462.11757, height: 347.03479 },
  'Flags/Estonia_horizontal_flag': { width: 462.04531, height: 347.03333 },
  'Flags/Finland_both_flag': { width: 462.04543, height: 347.03534 },
  'Flags/France_vertical_flag': { width: 462.04531, height: 347.03467 },
  'Flags/Germany_horizontal_flag': { width: 462.04531, height: 347.03467 },
  'Flags/Greece_both_flag': { width: 462.04558, height: 347.03412 },
  'Flags/Iceland_both_flag': { width: 462.04531, height: 347.03467 },
  'Flags/Indonesia_horizontal_flag': { width: 462.04531, height: 347.03333 },
  'Flags/Ireland_vertical_flag': { width: 462.04531, height: 347.03467 },
  'Flags/Italy_vertical_flag': { width: 462.04531, height: 347.03467 },
  'Flags/Latvia_horizontal_flag': { width: 462.04531, height: 347.03467 },
  'Flags/Lithuania_horizontal_flag': { width: 462.05864, height: 347.04666 },
  'Flags/Madagascar_both_flag': { width: 462.04531, height: 347.03467 },
  'Flags/Mali_vertical_flag': { width: 462.04598, height: 347.03506 },
  'Flags/Mauritius_horizontal_flag': { width: 462.04531, height: 347.03333 },
  'Flags/Netherlands_horizontal_flag': { width: 462.04531, height: 347.03467 },
  'Flags/Nigeria_vertical_flag': { width: 462.04531, height: 347.03467 },
  'Flags/Norway_both_flag': { width: 462.04585, height: 347.03534 },
  'Flags/Poland_horizontal_flag': { width: 462.04531, height: 347.03467 },
  'Flags/Romania_vertical_flag': { width: 462.04396, height: 347.03467 },
  'Flags/Senagal_vertical_flag': { width: 462.04396, height: 347.03467 },
  'Flags/Sierra_Leone_horizontal_flag': { width: 462.04531, height: 347.03333 },
  'Flags/Sweden_both_flag': { width: 462.04531, height: 347.03506 },
  'Flags/Thailand_horizontal_flag': { width: 462.04531, height: 347.03467 },
  'Flags/Togo_horizontal_flag': { width: 462.06798, height: 347.03467 },
  'Flags/UAE_both_flag': { width: 462.04531, height: 347.03467 },
  'Flags/UK_both_flag': { width: 464.05925, height: 348.98792 },
  'Flags/USA_horizontal_flag': { width: 462.04531, height: 347.03467 },
  'Flowers/Flower_Blue': { width: 162.84175, height: 314.47415 },
  'Flowers/Flower_Orange': { width: 166.16539, height: 323.14328 },
  'Flowers/Flower_Purple': { width: 191.02978, height: 335.39615 },
  'Flowers/Flower_Red': { width: 190.11296, height: 287.31879 },
  'Flowers/Flower_White': { width: 166.16539, height: 314.47415 },
  'Flowers/Flower_Yellow': { width: 196.93075, height: 322.05252 },
  'Food_fractions/Cake/Cake_Eighths/Cake_1_Eighths': { width: 183.09054, height: 257.76361 },
  'Food_fractions/Cake/Cake_Eighths/Cake_2_Eighths': { width: 255.99986, height: 257.76413 },
  'Food_fractions/Cake/Cake_Eighths/Cake_3_Eighths': { width: 255, height: 435 },
  'Food_fractions/Cake/Cake_Eighths/Cake_4_Eighths': { width: 255, height: 505 },
  'Food_fractions/Cake/Cake_Eighths/Cake_5_Eighths': { width: 435, height: 505 },
  'Food_fractions/Cake/Cake_Eighths/Cake_6_Eighths': { width: 505, height: 505 },
  'Food_fractions/Cake/Cake_Eighths/Cake_7_Eighths': { width: 505, height: 505 },
  'Food_fractions/Cake/Cake_Eighths/Cake_8_Eighths': { width: 505, height: 505 },
  'Food_fractions/Cake/Cake_Fifths/Cake_1_Fifths': { width: 245.64792, height: 258.01456 },
  'Food_fractions/Cake/Cake_Fifths/Cake_2_Fifths': { width: 258.54562, height: 462.43853 },
  'Food_fractions/Cake/Cake_Fifths/Cake_3_Fifths': { width: 405, height: 505 },
  'Food_fractions/Cake/Cake_Fifths/Cake_4_Fifths': { width: 505, height: 505 },
  'Food_fractions/Cake/Cake_Fifths/Cake_5_Fifths': { width: 511.75793, height: 511.62564 },
  'Food_fractions/Cake/Cake_Half/Cake_1_half': { width: 255, height: 505 },
  'Food_fractions/Cake/Cake_Half/Cake_2_halves': { width: 509.19464, height: 509.19464 },
  'Food_fractions/Cake/Cake_Quarters/Cake_1_quarters': { width: 256, height: 257.76398 },
  'Food_fractions/Cake/Cake_Quarters/Cake_2_quarters': { width: 255, height: 505 },
  'Food_fractions/Cake/Cake_Quarters/Cake_3_quarters': { width: 505, height: 505 },
  'Food_fractions/Cake/Cake_Quarters/Cake_4_quarters': { width: 505, height: 505 },
  'Food_fractions/Cake/Cake_Sevenths/Cake_1_Sevenths': { width: 204.39322, height: 258.00503 },
  'Food_fractions/Cake/Cake_Sevenths/Cake_2_Sevenths': { width: 258.57562, height: 314.84393 },
  'Food_fractions/Cake/Cake_Sevenths/Cake_3_Sevenths': { width: 255, height: 485 },
  'Food_fractions/Cake/Cake_Sevenths/Cake_4_Sevenths': { width: 365, height: 505 },
  'Food_fractions/Cake/Cake_Sevenths/Cake_5_Sevenths': { width: 505, height: 505 },
  'Food_fractions/Cake/Cake_Sevenths/Cake_6_Sevenths': { width: 505, height: 505 },
  'Food_fractions/Cake/Cake_Sevenths/Cake_7_Sevenths': { width: 505, height: 505 },
  'Food_fractions/Cake/Cake_Sixths/Cake_1_Sixths': { width: 223.36789, height: 256.76114 },
  'Food_fractions/Cake/Cake_Sixths/Cake_2_Sixths': { width: 257.32852, height: 382.90014 },
  'Food_fractions/Cake/Cake_Sixths/Cake_3_Sixths': { width: 255, height: 505 },
  'Food_fractions/Cake/Cake_Sixths/Cake_4_Sixths': { width: 475, height: 505 },
  'Food_fractions/Cake/Cake_Sixths/Cake_5_Sixths': { width: 505, height: 505 },
  'Food_fractions/Cake/Cake_Sixths/Cake_6_Sixths': { width: 505, height: 505 },
  'Food_fractions/Cake/Cake_Thirds/Cake_1_thirds': { width: 256.11066, height: 381.97259 },
  'Food_fractions/Cake/Cake_Thirds/Cake_2_thirds': { width: 475, height: 505 },
  'Food_fractions/Cake/Cake_Thirds/Cake_3_thirds': { width: 505, height: 505 },
  'Food_fractions/Cake/Cake_Whole/Cake_1_Whole': { width: 505, height: 505 },
  'Food_fractions/Pie/Pie_Eighths/Pie_1_Eighths': { width: 183.09054, height: 257.76361 },
  'Food_fractions/Pie/Pie_Eighths/Pie_2_Eighths': { width: 255.99986, height: 257.76413 },
  'Food_fractions/Pie/Pie_Eighths/Pie_3_Eighths': { width: 255.99986, height: 435.01187 },
  'Food_fractions/Pie/Pie_Eighths/Pie_4_Eighths': { width: 255.99986, height: 509.16266 },
  'Food_fractions/Pie/Pie_Eighths/Pie_5_Eighths': { width: 434.50506, height: 509.17865 },
  'Food_fractions/Pie/Pie_Eighths/Pie_6_Eighths': { width: 509.18731, height: 509.17865 },
  'Food_fractions/Pie/Pie_Eighths/Pie_7_Eighths': { width: 509.19317, height: 509.17865 },
  'Food_fractions/Pie/Pie_Eighths/Pie_8_Eighths': { width: 510.11053, height: 509.95398 },
  'Food_fractions/Pie/Pie_Fifths/Pie_1_Fifths': { width: 245.64792, height: 258.01456 },
  'Food_fractions/Pie/Pie_Fifths/Pie_2_Fifths': { width: 258.54562, height: 462.43853 },
  'Food_fractions/Pie/Pie_Fifths/Pie_3_Fifths': { width: 408.12643, height: 511.62564 },
  'Food_fractions/Pie/Pie_Fifths/Pie_4_Fifths': { width: 511.75793, height: 511.62564 },
  'Food_fractions/Pie/Pie_Fifths/Pie_5_Fifths': { width: 511.75793, height: 511.62564 },
  'Food_fractions/Pie/Pie_Halves/Pie_1_half': { width: 257.54666, height: 509.19333 },
  'Food_fractions/Pie/Pie_Halves/Pie_2_halves': { width: 509.194, height: 509.19464 },
  'Food_fractions/Pie/Pie_Quarters/Pie_1_Quarters': { width: 256.74515, height: 255.9987 },
  'Food_fractions/Pie/Pie_Quarters/Pie_2_Quarters': { width: 256.74515, height: 509.20132 },
  'Food_fractions/Pie/Pie_Quarters/Pie_3_Quarters': { width: 509.19116, height: 509.20132 },
  'Food_fractions/Pie/Pie_Quarters/Pie_4_Quarters': { width: 511.44464, height: 512.61779 },
  'Food_fractions/Pie/Pie_Sevenths/Pie_1_Sevenths': { width: 205.10254, height: 258.71435 },
  'Food_fractions/Pie/Pie_Sevenths/Pie_2_Sevenths': { width: 259.28247, height: 315.55325 },
  'Food_fractions/Pie/Pie_Sevenths/Pie_3_Sevenths': { width: 259.28247, height: 487.71322 },
  'Food_fractions/Pie/Pie_Sevenths/Pie_4_Sevenths': { width: 370.01971, height: 512.46399 },
  'Food_fractions/Pie/Pie_Sevenths/Pie_5_Sevenths': { width: 506.37307, height: 512.46399 },
  'Food_fractions/Pie/Pie_Sevenths/Pie_6_Sevenths': { width: 512.45929, height: 512.46399 },
  'Food_fractions/Pie/Pie_Sevenths/Pie_7_Sevenths': { width: 512.45929, height: 512.92053 },
  'Food_fractions/Pie/Pie_Sixths/Pie_1_sixths': { width: 223.36789, height: 256.76114 },
  'Food_fractions/Pie/Pie_Sixths/Pie_2_sixths': { width: 257.32852, height: 382.90014 },
  'Food_fractions/Pie/Pie_Sixths/Pie_3_sixths': { width: 257.32879, height: 509.19464 },
  'Food_fractions/Pie/Pie_Sixths/Pie_4_sixths': { width: 476.68377, height: 509.19464 },
  'Food_fractions/Pie/Pie_Sixths/Pie_5_sixths': { width: 509.19317, height: 509.19464 },
  'Food_fractions/Pie/Pie_Sixths/Pie_6_sixths': { width: 509.19317, height: 509.19464 },
  'Food_fractions/Pie/Pie_Thirds/Pie_1_Thirds': { width: 256.11066, height: 381.97259 },
  'Food_fractions/Pie/Pie_Thirds/Pie_2_Thirds': { width: 474.8186, height: 511.49557 },
  'Food_fractions/Pie/Pie_Thirds/Pie_3_Thirds': { width: 510.2576, height: 514.18756 },
  'Food_fractions/Pie/Pie_Whole/Pie_whole': { width: 509.19333, height: 509.19464 },
  'Food_fractions/Pizza/Pizza_Eighths/Pizza_1_Eighths': { width: 156.59721, height: 219.25294 },
  'Food_fractions/Pizza/Pizza_Eighths/Pizza_2_Eighths': { width: 219.25333, height: 219.25333 },
  'Food_fractions/Pizza/Pizza_Eighths/Pizza_3_Eighths': { width: 219.25336, height: 370.51721 },
  'Food_fractions/Pizza/Pizza_Eighths/Pizza_4_Eighths': { width: 219.25336, height: 433.17318 },
  'Food_fractions/Pizza/Pizza_Eighths/Pizza_5_Eighths': { width: 370.51721, height: 433.17318 },
  'Food_fractions/Pizza/Pizza_Eighths/Pizza_6_Eighths': { width: 433.17331, height: 433.17318 },
  'Food_fractions/Pizza/Pizza_Eighths/Pizza_7_Eighths': { width: 433.17331, height: 433.17318 },
  'Food_fractions/Pizza/Pizza_Eighths/Pizza_8_Eighths': { width: 435.90799, height: 435.90664 },
  'Food_fractions/Pizza/Pizza_Fifths/Pizza_1_fifths': { width: 211.59193, height: 221.7879 },
  'Food_fractions/Pizza/Pizza_Fifths/Pizza_2_fifths': { width: 221.70799, height: 396.65774 },
  'Food_fractions/Pizza/Pizza_Fifths/Pizza_3_fifths': { width: 367.55279, height: 435.90759 },
  'Food_fractions/Pizza/Pizza_Fifths/Pizza_4_fifths': { width: 435.90771, height: 435.90732 },
  'Food_fractions/Pizza/Pizza_Fifths/Pizza_5_fifths': { width: 435.90719, height: 435.90759 },
  'Food_fractions/Pizza/Pizza_Halves/Pizza_1_halves': { width: 220.168, height: 435.89599 },
  'Food_fractions/Pizza/Pizza_Halves/Pizza_2_halves': { width: 436.82306, height: 435.89599 },
  'Food_fractions/Pizza/Pizza_Quarters/Pizza_1_Quarters': { width: 220.61999, height: 220.61999 },
  'Food_fractions/Pizza/Pizza_Quarters/Pizza_2_Quarters': { width: 220.62039, height: 435.90704 },
  'Food_fractions/Pizza/Pizza_Quarters/Pizza_3_Quarters': { width: 435.90704, height: 435.90759 },
  'Food_fractions/Pizza/Pizza_Quarters/Pizza_4_Quarters': { width: 436.45172, height: 436.5877 },
  'Food_fractions/Pizza/Pizza_Sevenths/Pizza_1_Sevenths': { width: 175.24388, height: 220.813 },
  'Food_fractions/Pizza/Pizza_Sevenths/Pizza_2_Sevenths': { width: 221.29382, height: 269.12659 },
  'Food_fractions/Pizza/Pizza_Sevenths/Pizza_3_Sevenths': { width: 221.29382, height: 415.46255 },
  'Food_fractions/Pizza/Pizza_Sevenths/Pizza_4_Sevenths': { width: 315.42038, height: 436.49502 },
  'Food_fractions/Pizza/Pizza_Sevenths/Pizza_5_Sevenths': { width: 431.32043, height: 436.49502 },
  'Food_fractions/Pizza/Pizza_Sevenths/Pizza_6_Sevenths': { width: 436.49118, height: 436.49502 },
  'Food_fractions/Pizza/Pizza_Sevenths/Pizza_7_Sevenths': { width: 436.49118, height: 436.49502 },
  'Food_fractions/Pizza/Pizza_Sixths/pizza_1_sixths': { width: 221.02733, height: 264.20666 },
  'Food_fractions/Pizza/Pizza_Sixths/pizza_2_sixths': { width: 221.02733, height: 354.44772 },
  'Food_fractions/Pizza/Pizza_Sixths/pizza_3_sixths': { width: 239.27133, height: 435.90786 },
  'Food_fractions/Pizza/Pizza_Sixths/pizza_4_sixths': { width: 435.90799, height: 435.90786 },
  'Food_fractions/Pizza/Pizza_Sixths/pizza_5_sixths': { width: 435.90799, height: 435.90786 },
  'Food_fractions/Pizza/Pizza_Sixths/pizza_6_sixths': { width: 435.90799, height: 435.90786 },
  'Food_fractions/Pizza/Pizza_Thirds/Pizza_1_Thirds': { width: 220.61999, height: 324.89721 },
  'Food_fractions/Pizza/Pizza_Thirds/Pizza_2_Thirds': { width: 435.90799, height: 435.90811 },
  'Food_fractions/Pizza/Pizza_Thirds/Pizza_3_Thirds': { width: 407.55322, height: 435.90811 },
  'Food_fractions/Pizza/Pizza_Whole/Pizza': { width: 435.90799, height: 435.90664 },
  'Food_on_a_plate/Cookies_cakes_plate_1': { width: 336.61465, height: 200.22665 },
  'Food_on_a_plate/Cookies_cakes_plate_2': { width: 336.61465, height: 200.22665 },
  'Food_on_a_plate/Cookies_cakes_plate_3': { width: 336.61465, height: 200.22665 },
  'Food_on_a_plate/Cookies_cakes_plate_4': { width: 336.61465, height: 200.22665 },
  'Food_on_a_plate/Cookies_cakes_plate_5': { width: 336.61465, height: 200.22665 },
  'Food_on_a_plate/Cookies_cakes_plate_6': { width: 343.39752, height: 207.34599 },
  'Food_on_a_plate/Muffins_plate_1': { width: 336.61465, height: 200.22665 },
  'Food_on_a_plate/Muffins_plate_2': { width: 336.61465, height: 200.22665 },
  'Food_on_a_plate/Muffins_plate_3': { width: 336.61465, height: 228.12964 },
  'Food_on_a_plate/Muffins_plate_4': { width: 336.61465, height: 228.12964 },
  'Food_on_a_plate/Muffins_plate_5': { width: 336.61465, height: 202.2475 },
  'Food_on_a_plate/Muffins_plate_6': { width: 336.61465, height: 243.45163 },
  Football_sticker_book: { width: 582.53601, height: 411.69198 },
  Fork: { width: 1297.3333, height: 205.916 },
  Frog: { width: 793.70135, height: 793.70135 },
  Full_bathtub: { width: 524.28387, height: 369.19711 },
  Full_bucket: { width: 574.27464, height: 655.44 },
  GamesConsole: { width: 458.64398, height: 392.77243 },
  Giraffe: { width: 406, height: 612 },
  'Glasses_of_orange_juice/glass1_oj_eighth_full': { width: 110.44, height: 120.15 },
  'Glasses_of_orange_juice/glass1_oj_empty': { width: 110.4373, height: 120.152 },
  'Glasses_of_orange_juice/glass1_oj_full': { width: 110.4373, height: 120.152 },
  'Glasses_of_orange_juice/glass1_oj_half_full': { width: 110.4373, height: 120.152 },
  'Glasses_of_orange_juice/glass1_oj_quarter_full': { width: 110.4373, height: 120.152 },
  'Glasses_of_orange_juice/glass1_oj_seven_eighths_full': { width: 110.44, height: 120.15 },
  'Glasses_of_orange_juice/glass1_oj_third_full': { width: 110.4373, height: 120.152 },
  'Glasses_of_orange_juice/glass1_oj_three_quarters_full': { width: 110.4373, height: 120.152 },
  'Glasses_of_orange_juice/glass1_oj_two_thirds_full': { width: 110.4373, height: 120.152 },
  'Glasses_of_orange_juice/glass2_oj_eighth_full': { width: 96.67, height: 120.15 },
  'Glasses_of_orange_juice/glass2_oj_empty': { width: 96.667998, height: 120.152 },
  'Glasses_of_orange_juice/glass2_oj_full': { width: 96.668, height: 120.152 },
  'Glasses_of_orange_juice/glass2_oj_half_full': { width: 96.668001, height: 120.152 },
  'Glasses_of_orange_juice/glass2_oj_quarter_full': { width: 96.668, height: 120.152 },
  'Glasses_of_orange_juice/glass2_oj_seven_eighths_full': { width: 96.67, height: 120.15 },
  'Glasses_of_orange_juice/glass2_oj_third_full': { width: 96.668001, height: 120.152 },
  'Glasses_of_orange_juice/glass2_oj_three_quarters_full': { width: 96.668001, height: 120.152 },
  'Glasses_of_orange_juice/glass2_oj_two_thirds_full': { width: 96.668, height: 120.152 },
  'Glasses_of_water/glass_water_full': { width: 97, height: 121 },
  'Glasses_of_water/glass_water_half_full': { width: 97, height: 121 },
  'Glasses_of_water/glass_water_quarter_full': { width: 97, height: 121 },
  'Glasses_of_water/glass_water_three_quarters_full': { width: 97, height: 121 },
  'Goldfish_in_a_tank/Goldfish_in_a_tank_0': { width: 394.12665, height: 262.67026 },
  'Goldfish_in_a_tank/Goldfish_in_a_tank_1': { width: 394.12665, height: 262.67026 },
  'Goldfish_in_a_tank/Goldfish_in_a_tank_10': { width: 394.12665, height: 262.67026 },
  'Goldfish_in_a_tank/Goldfish_in_a_tank_2': { width: 394.12665, height: 262.67026 },
  'Goldfish_in_a_tank/Goldfish_in_a_tank_3': { width: 394.12665, height: 262.67026 },
  'Goldfish_in_a_tank/Goldfish_in_a_tank_4': { width: 394.12665, height: 262.67026 },
  'Goldfish_in_a_tank/Goldfish_in_a_tank_5': { width: 394.12665, height: 262.67026 },
  'Goldfish_in_a_tank/Goldfish_in_a_tank_6': { width: 394.12665, height: 262.67026 },
  'Goldfish_in_a_tank/Goldfish_in_a_tank_7': { width: 394.12665, height: 262.67026 },
  'Goldfish_in_a_tank/Goldfish_in_a_tank_8': { width: 394.12665, height: 262.67026 },
  'Goldfish_in_a_tank/Goldfish_in_a_tank_9': { width: 394.12665, height: 262.67026 },
  Grape_green: { width: 126.80076, height: 115.70895 },
  Grapes_green_bunch: { width: 361.28049, height: 278.46027 },
  GreyStar: { width: 41, height: 40 },
  'Gummy_bears/gummybear_green': { width: 189.39333, height: 224.64667 },
  'Gummy_bears/gummybear_orange': { width: 189.39333, height: 224.64667 },
  'Gummy_bears/gummybear_purple': { width: 189.39333, height: 224.64667 },
  'Gummy_bears/gummybear_red': { width: 189.39333, height: 224.64667 },
  'Gummy_bears/gummybear_yellow': { width: 189.39333, height: 224.64667 },
  Hand_open_fingers: { width: 264.16, height: 355.76 },
  Hands_open_pair: { width: 583.84882, height: 355.76992 },
  Hay_bale: { width: 437.81616, height: 256.94 },
  Headphones: { width: 292.53366, height: 402.58819 },
  Heart_purple: { width: 291.47733, height: 275.17157 },
  'Heptagons/Heptagon_blue': { width: 502.57463, height: 490.02399 },
  'Heptagons/Heptagon_green': { width: 502.57463, height: 490.02399 },
  'Heptagons/Heptagon_orange': { width: 502.57463, height: 490.02399 },
  'Heptagons/Heptagon_pink': { width: 502.57463, height: 490.02399 },
  'Heptagons/Heptagon_purple': { width: 502.57463, height: 490.02399 },
  'Heptagons/Heptagon_red': { width: 502.57463, height: 490.02399 },
  'Heptagons/Heptagon_turquoise': { width: 502.57463, height: 490.02399 },
  'Heptagons/Heptagon_yellow': { width: 502.57463, height: 490.02399 },
  'Heptagons/Irregular_heptagon1_blue': { width: 846.95339, height: 496.73599 },
  'Heptagons/Irregular_heptagon1_green': { width: 846.95339, height: 496.73599 },
  'Heptagons/Irregular_heptagon1_orange': { width: 846.95339, height: 496.73599 },
  'Heptagons/Irregular_heptagon1_pink': { width: 846.95339, height: 496.73599 },
  'Heptagons/Irregular_heptagon1_purple': { width: 846.95339, height: 496.73599 },
  'Heptagons/Irregular_heptagon1_red': { width: 846.95339, height: 496.73599 },
  'Heptagons/Irregular_heptagon1_turquoise': { width: 846.95339, height: 496.73599 },
  'Heptagons/Irregular_heptagon1_yellow': { width: 846.95339, height: 496.73599 },
  'Heptagons/Irregular_heptagon2_blue': { width: 632.50236, height: 496.08133 },
  'Heptagons/Irregular_heptagon2_green': { width: 632.50236, height: 496.08133 },
  'Heptagons/Irregular_heptagon2_orange': { width: 632.50236, height: 496.08133 },
  'Heptagons/Irregular_heptagon2_pink': { width: 632.50236, height: 496.08133 },
  'Heptagons/Irregular_heptagon2_purple': { width: 632.50236, height: 496.08133 },
  'Heptagons/Irregular_heptagon2_red': { width: 632.50236, height: 496.08133 },
  'Heptagons/Irregular_heptagon2_turquoise': { width: 632.50236, height: 496.08133 },
  'Heptagons/Irregular_heptagon2_yellow': { width: 632.50236, height: 496.08133 },
  'Heptagons/Irregular_heptagon3_blue': { width: 738.10246, height: 472.51184 },
  'Heptagons/Irregular_heptagon3_green': { width: 738.10246, height: 472.51184 },
  'Heptagons/Irregular_heptagon3_orange': { width: 738.10246, height: 472.51184 },
  'Heptagons/Irregular_heptagon3_pink': { width: 738.10246, height: 472.51184 },
  'Heptagons/Irregular_heptagon3_purple': { width: 738.10246, height: 472.51184 },
  'Heptagons/Irregular_heptagon3_red': { width: 738.10246, height: 472.51184 },
  'Heptagons/Irregular_heptagon3_turquoise': { width: 738.10246, height: 472.51184 },
  'Heptagons/Irregular_heptagon3_yellow': { width: 738.10246, height: 472.51184 },
  'Heptagons/Irregular_heptagon4_blue': { width: 502.57454, height: 490.02399 },
  'Heptagons/Irregular_heptagon4_green': { width: 502.57454, height: 490.02399 },
  'Heptagons/Irregular_heptagon4_orange': { width: 502.57454, height: 490.02399 },
  'Heptagons/Irregular_heptagon4_pink': { width: 502.57454, height: 490.02399 },
  'Heptagons/Irregular_heptagon4_purple': { width: 502.57454, height: 490.02399 },
  'Heptagons/Irregular_heptagon4_red': { width: 502.57454, height: 490.02399 },
  'Heptagons/Irregular_heptagon4_turquoise': { width: 502.57454, height: 490.02399 },
  'Heptagons/Irregular_heptagon4_yellow': { width: 502.57454, height: 490.02399 },
  'Hexagons/Irregular_hexagon1_blue': { width: 520.35997, height: 600.29065 },
  'Hexagons/Irregular_hexagon1_blue_one_interior_angle_lhs': { width: 304, height: 351 },
  'Hexagons/Irregular_hexagon1_blue_one_interior_angle_rhs': { width: 309, height: 356 },
  'Hexagons/Irregular_hexagon1_green': { width: 520.35997, height: 600.29065 },
  'Hexagons/Irregular_hexagon1_green_one_interior_angle_lhs': { width: 304, height: 351 },
  'Hexagons/Irregular_hexagon1_green_one_interior_angle_rhs': { width: 309, height: 356 },
  'Hexagons/Irregular_hexagon1_orange': { width: 520.35997, height: 600.29065 },
  'Hexagons/Irregular_hexagon1_pink': { width: 520.35997, height: 600.29065 },
  'Hexagons/Irregular_hexagon1_pink_one_interior_angle_lhs': { width: 304, height: 351 },
  'Hexagons/Irregular_hexagon1_pink_one_interior_angle_rhs': { width: 309, height: 356 },
  'Hexagons/Irregular_hexagon1_purple': { width: 520.35997, height: 600.29065 },
  'Hexagons/Irregular_hexagon1_purple_one_interior_angle_lhs': { width: 304, height: 351 },
  'Hexagons/Irregular_hexagon1_purple_one_interior_angle_rhs': { width: 309, height: 356 },
  'Hexagons/Irregular_hexagon1_red': { width: 520.35997, height: 600.29065 },
  'Hexagons/Irregular_hexagon1_turquoise': { width: 520.35997, height: 600.29065 },
  'Hexagons/Irregular_hexagon1_white': { width: 520.35997, height: 600.29065 },
  'Hexagons/Irregular_hexagon1_white_one_interior_angle_lhs': { width: 304, height: 351 },
  'Hexagons/Irregular_hexagon1_white_one_interior_angle_rhs': { width: 309, height: 356 },
  'Hexagons/Irregular_hexagon1_yellow': { width: 520.35997, height: 600.29065 },
  'Hexagons/Irregular_hexagon1_yellow_one_interior_angle_lhs': { width: 304, height: 351 },
  'Hexagons/Irregular_hexagon1_yellow_one_interior_angle_rhs': { width: 309, height: 356 },
  'Hexagons/Irregular_hexagon2_blue': { width: 1033.6238, height: 494.73599 },
  'Hexagons/Irregular_hexagon2_green': { width: 1033.6238, height: 494.73599 },
  'Hexagons/Irregular_hexagon2_orange': { width: 1033.6238, height: 494.73599 },
  'Hexagons/Irregular_hexagon2_pink': { width: 1033.6238, height: 494.73599 },
  'Hexagons/Irregular_hexagon2_purple': { width: 1033.6238, height: 494.73599 },
  'Hexagons/Irregular_hexagon2_red': { width: 1033.6238, height: 494.73599 },
  'Hexagons/Irregular_hexagon2_turquoise': { width: 1033.6238, height: 494.73599 },
  'Hexagons/Irregular_hexagon2_white': { width: 1033.6238, height: 494.73599 },
  'Hexagons/Irregular_hexagon2_yellow': { width: 1033.6238, height: 494.73599 },
  'Hexagons/Irregular_hexagon3_blue': { width: 730.3386, height: 464.39331 },
  'Hexagons/Irregular_hexagon3_green': { width: 730.3386, height: 464.39331 },
  'Hexagons/Irregular_hexagon3_orange': { width: 730.3386, height: 464.39331 },
  'Hexagons/Irregular_hexagon3_pink': { width: 730.3386, height: 464.39331 },
  'Hexagons/Irregular_hexagon3_purple': { width: 730.3386, height: 464.39331 },
  'Hexagons/Irregular_hexagon3_red': { width: 730.3386, height: 464.39331 },
  'Hexagons/Irregular_hexagon3_turquoise': { width: 730.3386, height: 464.39331 },
  'Hexagons/Irregular_hexagon3_white': { width: 730.3386, height: 464.39331 },
  'Hexagons/Irregular_hexagon3_yellow': { width: 730.3386, height: 464.39331 },
  'Hexagons/Irregular_hexagon4_blue': { width: 632.50236, height: 496.08133 },
  'Hexagons/Irregular_hexagon4_green': { width: 632.50236, height: 496.08133 },
  'Hexagons/Irregular_hexagon4_orange': { width: 632.50236, height: 496.08133 },
  'Hexagons/Irregular_hexagon4_pink': { width: 632.50236, height: 496.08133 },
  'Hexagons/Irregular_hexagon4_purple': { width: 632.50236, height: 496.08133 },
  'Hexagons/Irregular_hexagon4_red': { width: 632.50236, height: 496.08133 },
  'Hexagons/Irregular_hexagon4_turquoise': { width: 632.50236, height: 496.08133 },
  'Hexagons/Irregular_hexagon4_white': { width: 632.50236, height: 496.08133 },
  'Hexagons/Irregular_hexagon4_yellow': { width: 632.50236, height: 496.08133 },
  'Hexagons/Irregular_hexagon5_blue': { width: 738.10246, height: 472.51184 },
  'Hexagons/Irregular_hexagon5_green': { width: 738.10246, height: 472.51184 },
  'Hexagons/Irregular_hexagon5_orange': { width: 738.10246, height: 472.51184 },
  'Hexagons/Irregular_hexagon5_pink': { width: 738.10246, height: 472.51184 },
  'Hexagons/Irregular_hexagon5_purple': { width: 738.10246, height: 472.51184 },
  'Hexagons/Irregular_hexagon5_red': { width: 738.10246, height: 472.51184 },
  'Hexagons/Irregular_hexagon5_turquoise': { width: 738.10246, height: 472.51184 },
  'Hexagons/Irregular_hexagon5_white': { width: 738.10246, height: 472.51184 },
  'Hexagons/Irregular_hexagon5_yellow': { width: 738.10246, height: 472.51184 },
  'Hexagons/Irregular_hexagon6_blue': { width: 844.37986, height: 256.69992 },
  'Hexagons/Irregular_hexagon6_green': { width: 844.37986, height: 256.69992 },
  'Hexagons/Irregular_hexagon6_orange': { width: 844.37986, height: 256.69992 },
  'Hexagons/Irregular_hexagon6_pink': { width: 844.37986, height: 256.69992 },
  'Hexagons/Irregular_hexagon6_purple': { width: 844.37986, height: 256.69992 },
  'Hexagons/Irregular_hexagon6_red': { width: 844.37986, height: 256.69992 },
  'Hexagons/Irregular_hexagon6_turquoise': { width: 844.37986, height: 256.69992 },
  'Hexagons/Irregular_hexagon6_white': { width: 844.37986, height: 256.69992 },
  'Hexagons/Irregular_hexagon6_yellow': { width: 844.37986, height: 256.69992 },
  'Hexagons/hexagon': { width: 376.6188, height: 326.16132 },
  'Hexagons/hexagon_1_arrow': { width: 377, height: 379 },
  'Hexagons/hexagon_1_arrow_blue': { width: 377, height: 379 },
  'Hexagons/hexagon_1_arrow_green': { width: 377, height: 379 },
  'Hexagons/hexagon_1_arrow_orange': { width: 377, height: 379 },
  'Hexagons/hexagon_1_arrow_pink': { width: 377, height: 379 },
  'Hexagons/hexagon_1_arrow_purple': { width: 377, height: 379 },
  'Hexagons/hexagon_1_arrow_turquoise': { width: 377, height: 379 },
  'Hexagons/hexagon_1_arrow_yellow': { width: 377, height: 379 },
  'Hexagons/hexagon_blue': { width: 376.6188, height: 326.16132 },
  'Hexagons/hexagon_green': { width: 376.6188, height: 326.16132 },
  'Hexagons/hexagon_orange': { width: 376.6188, height: 326.16132 },
  'Hexagons/hexagon_pink': { width: 376.6188, height: 326.16132 },
  'Hexagons/hexagon_purple': { width: 376.6188, height: 326.16132 },
  'Hexagons/hexagon_red': { width: 376.6188, height: 326.16132 },
  'Hexagons/hexagon_turquoise': { width: 376.6188, height: 326.16132 },
  'Hexagons/hexagon_white': { width: 376.6188, height: 326.16132 },
  'Hexagons/hexagon_yellow': { width: 376.6188, height: 326.16132 },
  Horizontal_Thermoter_blank: { width: 371.18305, height: 44.615733 },
  Horse: { width: 338.63669, height: 358.35193 },
  House: { width: 149.2804, height: 172.07333 },
  Hulahoop: { width: 713.79467, height: 267.3873 },
  Icecreamcone: { width: 175.75149, height: 292.5289 },
  Individual_lolly_stick: { width: 26.285332, height: 224.66133 },
  Info: { width: 25, height: 26 },
  'Isosceles_triangles_narrow/triangle_isos_narrow': { width: 272.25427, height: 330.77796 },
  'Isosceles_triangles_narrow/triangle_isos_narrow_blue': { width: 272.25427, height: 330.77796 },
  'Isosceles_triangles_narrow/triangle_isos_narrow_blue_one_interior_angle_lhs': {
    width: 273,
    height: 331
  },
  'Isosceles_triangles_narrow/triangle_isos_narrow_blue_one_interior_angle_rhs': {
    width: 273,
    height: 331
  },
  'Isosceles_triangles_narrow/triangle_isos_narrow_green': { width: 272.25427, height: 330.77796 },
  'Isosceles_triangles_narrow/triangle_isos_narrow_green_one_interior_angle_lhs': {
    width: 273,
    height: 331
  },
  'Isosceles_triangles_narrow/triangle_isos_narrow_green_one_interior_angle_rhs': {
    width: 273,
    height: 331
  },
  'Isosceles_triangles_narrow/triangle_isos_narrow_orange': { width: 272.25427, height: 330.77796 },
  'Isosceles_triangles_narrow/triangle_isos_narrow_pink': { width: 272.25427, height: 330.77796 },
  'Isosceles_triangles_narrow/triangle_isos_narrow_pink_one_interior_angle_lhs': {
    width: 273,
    height: 331
  },
  'Isosceles_triangles_narrow/triangle_isos_narrow_pink_one_interior_angle_rhs': {
    width: 273,
    height: 331
  },
  'Isosceles_triangles_narrow/triangle_isos_narrow_purple': { width: 272.25427, height: 330.77796 },
  'Isosceles_triangles_narrow/triangle_isos_narrow_purple_one_interior_angle_lhs': {
    width: 273,
    height: 331
  },
  'Isosceles_triangles_narrow/triangle_isos_narrow_purple_one_interior_angle_rhs': {
    width: 273,
    height: 331
  },
  'Isosceles_triangles_narrow/triangle_isos_narrow_red': { width: 272.25427, height: 330.77796 },
  'Isosceles_triangles_narrow/triangle_isos_narrow_turquoise': {
    width: 272.25427,
    height: 330.77796
  },
  'Isosceles_triangles_narrow/triangle_isos_narrow_white': { width: 272.25427, height: 330.77796 },
  'Isosceles_triangles_narrow/triangle_isos_narrow_white_one_interior_angle_lhs': {
    width: 273,
    height: 331
  },
  'Isosceles_triangles_narrow/triangle_isos_narrow_white_one_interior_angle_rhs': {
    width: 273,
    height: 331
  },
  'Isosceles_triangles_narrow/triangle_isos_narrow_yellow': { width: 272.25427, height: 330.77796 },
  'Isosceles_triangles_narrow/triangle_isos_narrow_yellow_one_interior_angle_lhs': {
    width: 273,
    height: 331
  },
  'Isosceles_triangles_narrow/triangle_isos_narrow_yellow_one_interior_angle_rhs': {
    width: 273,
    height: 331
  },
  'Isosceles_triangles_wide/triangle_isos_wide': { width: 441.78482, height: 329.11145 },
  'Isosceles_triangles_wide/triangle_isos_wide_blue': { width: 441.78482, height: 329.11145 },
  'Isosceles_triangles_wide/triangle_isos_wide_blue_one_interior_angle_lhs': {
    width: 443,
    height: 330
  },
  'Isosceles_triangles_wide/triangle_isos_wide_blue_one_interior_angle_rhs': {
    width: 443,
    height: 330
  },
  'Isosceles_triangles_wide/triangle_isos_wide_green': { width: 441.78482, height: 329.11145 },
  'Isosceles_triangles_wide/triangle_isos_wide_green_one_interior_angle_lhs': {
    width: 443,
    height: 330
  },
  'Isosceles_triangles_wide/triangle_isos_wide_green_one_interior_angle_rhs': {
    width: 443,
    height: 330
  },
  'Isosceles_triangles_wide/triangle_isos_wide_orange': { width: 441.78482, height: 329.11145 },
  'Isosceles_triangles_wide/triangle_isos_wide_pink': { width: 441.78482, height: 329.11145 },
  'Isosceles_triangles_wide/triangle_isos_wide_pink_one_interior_angle_lhs': {
    width: 443,
    height: 330
  },
  'Isosceles_triangles_wide/triangle_isos_wide_pink_one_interior_angle_rhs': {
    width: 443,
    height: 330
  },
  'Isosceles_triangles_wide/triangle_isos_wide_purple': { width: 441.78482, height: 329.11145 },
  'Isosceles_triangles_wide/triangle_isos_wide_purple_one_interior_angle_lhs': {
    width: 443,
    height: 330
  },
  'Isosceles_triangles_wide/triangle_isos_wide_purple_one_interior_angle_rhs': {
    width: 443,
    height: 330
  },
  'Isosceles_triangles_wide/triangle_isos_wide_red': { width: 441.78482, height: 329.11145 },
  'Isosceles_triangles_wide/triangle_isos_wide_turquoise': { width: 441.78482, height: 329.11145 },
  'Isosceles_triangles_wide/triangle_isos_wide_white': { width: 441.78482, height: 329.11145 },
  'Isosceles_triangles_wide/triangle_isos_wide_white_one_interior_angle_lhs': {
    width: 443,
    height: 330
  },
  'Isosceles_triangles_wide/triangle_isos_wide_white_one_interior_angle_rhs': {
    width: 443,
    height: 330
  },
  'Isosceles_triangles_wide/triangle_isos_wide_yellow': { width: 441.78482, height: 329.11145 },
  'Isosceles_triangles_wide/triangle_isos_wide_yellow_one_interior_angle_lhs': {
    width: 443,
    height: 330
  },
  'Isosceles_triangles_wide/triangle_isos_wide_yellow_one_interior_angle_rhs': {
    width: 443,
    height: 330
  },
  Jack_birds_eye: { width: 274, height: 216 },
  Juice: { width: 400.70135, height: 793.70135 },
  Ketchup: { width: 238.43178, height: 565.91571 },
  Kettle: { width: 264.56839, height: 325.04852 },
  Keychain1: { width: 144.20809, height: 307.82196 },
  'Kite/kite': { width: 241.97533, height: 327.06537 },
  'Kite/kite_blue': { width: 241.97533, height: 327.06537 },
  'Kite/kite_green': { width: 241.97533, height: 327.06537 },
  'Kite/kite_grey': { width: 241.97533, height: 327.06537 },
  'Kite/kite_orange': { width: 241.97533, height: 327.06537 },
  'Kite/kite_pink': { width: 241.97533, height: 327.06537 },
  'Kite/kite_purple': { width: 241.97533, height: 327.06537 },
  'Kite/kite_red': { width: 241.97533, height: 327.06537 },
  'Kite/kite_turquoise': { width: 241.97533, height: 327.06537 },
  'Kite/kite_white': { width: 241.97533, height: 327.06537 },
  'Kite/kite_yellow': { width: 241.97533, height: 327.06537 },
  Kiwi_fruit: { width: 276.11066, height: 190.30932 },
  'L_shapes/L_shape_blue': { width: 327.79291, height: 327.79291 },
  'L_shapes/L_shape_green': { width: 327.79291, height: 327.79291 },
  'L_shapes/L_shape_orange': { width: 327.79291, height: 327.79291 },
  'L_shapes/L_shape_pink': { width: 327.79291, height: 327.79291 },
  'L_shapes/L_shape_purple': { width: 327.79291, height: 327.79291 },
  'L_shapes/L_shape_red': { width: 327.79291, height: 327.79291 },
  'L_shapes/L_shape_turquoise': { width: 327.79291, height: 327.79291 },
  'L_shapes/L_shape_yellow': { width: 327.79291, height: 327.79291 },
  Labelled_box_A: { width: 236.6664, height: 164.33469 },
  Labelled_box_B: { width: 236.6664, height: 164.33469 },
  Labelled_box_C: { width: 236.6664, height: 164.33469 },
  Labelled_box_D: { width: 236.6664, height: 164.33469 },
  Labelled_box_bricks: { width: 278.74265, height: 132.53999 },
  Laptop: { width: 328.09161, height: 204.27519 },
  Large_bin: { width: 377.89123, height: 510.59597 },
  'Layered_shapes/Layered_compound_shapes1': { width: 480.58061, height: 603.33008 },
  'Layered_shapes/Layered_compound_shapes2': { width: 538.83733, height: 538.83734 },
  'Layered_shapes/Layered_compound_shapes3': { width: 732.64494, height: 538.776 },
  'Layered_shapes/Layered_compound_shapes4': { width: 552.58128, height: 538.77667 },
  'Layered_shapes/Layered_compound_shapes5': { width: 737.93876, height: 737.93878 },
  'Layered_shapes/Layered_compound_shapes6': { width: 596.35301, height: 777.04224 },
  'Lego_bricks/thick_lego_6_circles_pink': { width: 289.50253, height: 211.22933 },
  'Lego_bricks/thick_lego_6_circles_red': { width: 308.16907, height: 168.56217 },
  'Lego_bricks/thick_lego_6_circles_yellow': { width: 289.50213, height: 181.89572 },
  'Lego_bricks/thick_lego_8_circles_white': { width: 385.1488, height: 168.56226 },
  'Lego_bricks/thin_lego_6_circles1_purple': { width: 289.50186, height: 128.56215 },
  'Lego_bricks/thin_lego_6_circles2_green': { width: 289.50265, height: 140.5623 },
  Lemon: { width: 1251.286, height: 481.49252 },
  Lemonade_bottle: { width: 164.3376, height: 487.62399 },
  Lettuce: { width: 263.78616, height: 232.54799 },
  Lion: { width: 568.37091, height: 524.65002 },
  Lion_side_profile: { width: 1119.869, height: 814.5705 },
  Loaf_of_bread: { width: 291.49066, height: 145.30933 },
  'Lolly_stick_shapes/Decagon_lolly_sticks': { width: 677.22245, height: 701.30054 },
  'Lolly_stick_shapes/Heptagon_lolly_sticks': { width: 695.35716, height: 524.41138 },
  'Lolly_stick_shapes/Hexagon1_lolly_sticks': { width: 699.90995, height: 297.32333 },
  'Lolly_stick_shapes/Hexagon2_lolly_sticks': { width: 491.28887, height: 297.32333 },
  'Lolly_stick_shapes/Nonagon1_lolly_sticks': { width: 643.9694, height: 496.27283 },
  'Lolly_stick_shapes/Nonagon2_lolly_sticks': { width: 643.9694, height: 496.27283 },
  'Lolly_stick_shapes/Octagon1_lolly_sticks': { width: 643.9694, height: 653.96289 },
  'Lolly_stick_shapes/Octagon2_lolly_sticks': { width: 553.61235, height: 558.30316 },
  'Lolly_stick_shapes/Pentagon_lolly_sticks': { width: 504.86965, height: 297.32333 },
  'Lolly_stick_shapes/Quadrilateral1_lolly_sticks': { width: 298.08172, height: 309.72891 },
  'Lolly_stick_shapes/Quadrilateral2_lolly_sticks': { width: 448.66893, height: 289.17047 },
  'Lolly_stick_shapes/Rectangle10_lolly_sticks': { width: 558.46556, height: 555.58356 },
  'Lolly_stick_shapes/Rectangle11_lolly_sticks': { width: 691.83781, height: 555.58356 },
  'Lolly_stick_shapes/Rectangle12_lolly_sticks': { width: 823.53928, height: 555.58356 },
  'Lolly_stick_shapes/Rectangle13_lolly_sticks': { width: 427.22985, height: 688.76746 },
  'Lolly_stick_shapes/Rectangle14_lolly_sticks': { width: 558.64024, height: 688.76746 },
  'Lolly_stick_shapes/Rectangle15_lolly_sticks': { width: 691.01225, height: 688.76746 },
  'Lolly_stick_shapes/Rectangle16_lolly_sticks': { width: 823.86478, height: 688.76746 },
  'Lolly_stick_shapes/Rectangle17_lolly_sticks': { width: 422.57198, height: 822.27863 },
  'Lolly_stick_shapes/Rectangle18_lolly_sticks': { width: 552.47356, height: 822.27863 },
  'Lolly_stick_shapes/Rectangle19_lolly_sticks': { width: 688.8889, height: 822.27863 },
  'Lolly_stick_shapes/Rectangle1_lolly_sticks': { width: 415.02398, height: 301.30399 },
  'Lolly_stick_shapes/Rectangle20_lolly_sticks': { width: 821.06022, height: 822.27863 },
  'Lolly_stick_shapes/Rectangle2_lolly_sticks': { width: 546.71037, height: 301.30399 },
  'Lolly_stick_shapes/Rectangle3_lolly_sticks': { width: 680.43675, height: 301.30399 },
  'Lolly_stick_shapes/Rectangle4_lolly_sticks': { width: 812.1229, height: 301.30399 },
  'Lolly_stick_shapes/Rectangle5_lolly_sticks': { width: 425.02718, height: 424.33386 },
  'Lolly_stick_shapes/Rectangle6_lolly_sticks': { width: 559.04771, height: 423.68051 },
  'Lolly_stick_shapes/Rectangle7_lolly_sticks': { width: 692.07066, height: 423.68051 },
  'Lolly_stick_shapes/Rectangle8_lolly_sticks': { width: 823.53928, height: 423.68051 },
  'Lolly_stick_shapes/Rectangle9_lolly_sticks': { width: 429.02983, height: 555.58356 },
  'Lolly_stick_shapes/Rectilinear_shape1_lolly_sticks': { width: 274.35571, height: 301.30399 },
  'Lolly_stick_shapes/Rectilinear_shape2_lolly_sticks': { width: 274.35571, height: 301.30399 },
  'Lolly_stick_shapes/Rectilinear_shape3_lolly_sticks': { width: 274.35571, height: 432.99011 },
  'Lolly_stick_shapes/Rectilinear_shape4_lolly_sticks': { width: 432.9901, height: 274.35571 },
  'Lolly_stick_shapes/Rectilinear_shape5_lolly_sticks': { width: 564.6765, height: 274.35571 },
  'Lolly_stick_shapes/Rectilinear_shape6_lolly_sticks': { width: 564.6765, height: 274.35571 },
  'Lolly_stick_shapes/Rectilinear_shape7_lolly_sticks': { width: 564.6765, height: 274.35571 },
  'Lolly_stick_shapes/Rectilinear_shape8_lolly_sticks': { width: 274.35571, height: 696.36267 },
  'Lolly_stick_shapes/Rectilinear_shape9_lolly_sticks': { width: 564.67662, height: 269.86398 },
  'Lolly_stick_shapes/Triangle_lolly_sticks': { width: 304, height: 252 },
  'Lolly_sticks/FiveLollyStickPentagon': { width: 352, height: 347 },
  'Lolly_sticks/FourLollyStickPentagon': { width: 352, height: 344 },
  'Lolly_sticks/FourLollyStickSquare': { width: 242, height: 238 },
  'Lolly_sticks/LollyStickDiamond': { width: 235.89822, height: 370.07355 },
  'Lolly_sticks/LollyStickHouse': { width: 244.42319, height: 412.05832 },
  'Lolly_sticks/LollyStickRectangle': { width: 244.42319, height: 459.44745 },
  'Lolly_sticks/LollyStickTriangle': { width: 255.22632, height: 224.46677 },
  'Lolly_sticks/LollySticksPatterns/LollySticksDiamondPattern': {
    width: 1077.0462,
    height: 218.97855
  },
  'Lolly_sticks/LollySticksPatterns/LollySticksHousePatternA': {
    width: 1523.0408,
    height: 179.616
  },
  'Lolly_sticks/LollySticksPatterns/LollySticksHousePatternB': {
    width: 1241.6935,
    height: 289.14197
  },
  'Lolly_sticks/LollySticksPatterns/LollySticksRectanglePattern': {
    width: 1193.3028,
    height: 331.53106
  },
  'Lolly_sticks/LollySticksPatterns/LollySticksSquarePattern': {
    width: 1186.6358,
    height: 175.53026
  },
  'Lolly_sticks/LollySticksPatterns/LollySticksTrianglePattern': {
    width: 959.94862,
    height: 162.66761
  },
  'Lolly_sticks/SingleLollyStickPentagon': { width: 83, height: 196 },
  'Lolly_sticks/SingleLollyStickSquare': { width: 26, height: 202 },
  'Lolly_sticks/SixLollyStickHexagon': { width: 425, height: 387 },
  'Lolly_sticks/ThreeLollyStickPentagon': { width: 278, height: 344 },
  'Lolly_sticks/ThreeLollyStickSquare': { width: 222, height: 238 },
  'Lolly_sticks/ThreeLollyStickTriangle': { width: 237, height: 207 },
  'Lolly_sticks/TwoLollyStickPentagon': { width: 278, height: 213 },
  'Lolly_sticks/TwoLollyStickSquare': { width: 222, height: 220 },
  Magazine: { width: 333.86719, height: 443.33004 },
  Marble: { width: 108.38267, height: 108.38133 },
  Marble_bag: { width: 183.56933, height: 224.91643 },
  'Measure/pencil': { width: 12, height: 112 },
  Metre_stick: { width: 290, height: 670 },
  Microwave: { width: 421.26681, height: 251.27052 },
  Milk_Carton: { width: 265.39718, height: 513.30426 },
  Milk_carton_2l: { width: 42.4048, height: 90.677202 },
  Milk_carton_5l: { width: 64.211731, height: 107.7676 },
  Milkshake: { width: 342.76666, height: 829.36449 },
  Mo_birds_eye: { width: 274, height: 216 },
  'Money/Pence1': { width: 369.01864, height: 369.01864 },
  'Money/Pence10': { width: 643.70398, height: 643.70398 },
  'Money/Pence2': { width: 513.67199, height: 513.67199 },
  'Money/Pence20': { width: 543.2818, height: 535.18365 },
  'Money/Pence5': { width: 423.33066, height: 423.33066 },
  'Money/Pence50': { width: 598.80255, height: 589.31164 },
  'Money/Pounds1': { width: 576.74548, height: 576.752 },
  'Money/Pounds2': { width: 710.47198, height: 710.47197 },
  Moon_white: { width: 216.73003, height: 329.33331 },
  Moon_yellow: { width: 216.73003, height: 329.33331 },
  'Muffins_donuts/Muffins_on_a_rack_0': { width: 390.436, height: 403.02533 },
  'Muffins_donuts/Muffins_on_a_rack_1': { width: 390.436, height: 456.06238 },
  'Muffins_donuts/Muffins_on_a_rack_10': { width: 390.436, height: 456.06238 },
  'Muffins_donuts/Muffins_on_a_rack_11': { width: 390.436, height: 456.06238 },
  'Muffins_donuts/Muffins_on_a_rack_12': { width: 390.436, height: 456.06238 },
  'Muffins_donuts/Muffins_on_a_rack_2': { width: 390.436, height: 456.06238 },
  'Muffins_donuts/Muffins_on_a_rack_3': { width: 390.436, height: 456.06238 },
  'Muffins_donuts/Muffins_on_a_rack_4': { width: 390.436, height: 456.06238 },
  'Muffins_donuts/Muffins_on_a_rack_5': { width: 390.436, height: 456.06238 },
  'Muffins_donuts/Muffins_on_a_rack_6': { width: 390.436, height: 456.06238 },
  'Muffins_donuts/Muffins_on_a_rack_7': { width: 390.436, height: 456.06238 },
  'Muffins_donuts/Muffins_on_a_rack_8': { width: 390.436, height: 456.06238 },
  'Muffins_donuts/Muffins_on_a_rack_9': { width: 390.436, height: 456.06238 },
  'Muffins_individually/Muffin_1': { width: 160.90387, height: 145.76453 },
  'Muffins_individually/Muffin_2': { width: 158.32358, height: 144.8588 },
  'Muffins_individually/Muffin_3': { width: 159.48323, height: 144.52907 },
  'Muffins_individually/Muffin_4': { width: 159.33731, height: 146.67839 },
  'Muffins_individually/Muffin_5': { width: 156.06435, height: 139.00414 },
  'Muffins_individually/Muffin_6': { width: 159.48323, height: 144.52907 },
  'Muffins_individually/Muffin_7': { width: 152.02534, height: 136.06532 },
  Mug: { width: 333.70135, height: 363.70135 },
  Mug_yellow: { width: 278.30932, height: 303.23611 },
  'Multi_link_cubes/Multilink_cube_individual_horizontal_labelled_blue': {
    width: 199.75351,
    height: 175.54666
  },
  'Multi_link_cubes/Multilink_cube_individual_horizontal_labelled_green': {
    width: 199.9135,
    height: 175.62732
  },
  'Multi_link_cubes/Multilink_cube_individual_horizontal_labelled_red': {
    width: 199.9135,
    height: 175.62732
  },
  'Multi_link_cubes/Multilink_cube_individual_horizontal_labelled_yellow': {
    width: 199.9135,
    height: 175.62732
  },
  'Multi_link_cubes/Multilink_cube_individual_vertical_blue': { width: 176, height: 197 },
  'Multi_link_cubes/Multilink_cube_individual_vertical_green': { width: 170, height: 191 },
  'Multi_link_cubes/Multilink_cube_individual_vertical_labelled_blue': {
    width: 175.16535,
    height: 196.26318
  },
  'Multi_link_cubes/Multilink_cube_individual_vertical_labelled_green': {
    width: 169.82333,
    height: 190.24206
  },
  'Multi_link_cubes/Multilink_cube_individual_vertical_labelled_red': {
    width: 175.32533,
    height: 196.42283
  },
  'Multi_link_cubes/Multilink_cube_individual_vertical_labelled_yellow': {
    width: 175.32533,
    height: 196.42283
  },
  'Multi_link_cubes/Multilink_cube_individual_vertical_red': { width: 176, height: 197 },
  'Multi_link_cubes/Multilink_cube_individual_vertical_yellow': { width: 176, height: 197 },
  'Multi_link_cubes/column_1_blue': { width: 96.1, height: 104.4 },
  'Multi_link_cubes/column_1_green': { width: 96.1, height: 104.7 },
  'Multi_link_cubes/column_1_orange': { width: 96.1, height: 104.5 },
  'Multi_link_cubes/column_1_purple': { width: 96.1, height: 104.6 },
  'Multi_link_cubes/column_1_red': { width: 96.1, height: 104.5 },
  'Multi_link_cubes/column_2_blue': { width: 96.1, height: 163.7 },
  'Multi_link_cubes/column_2_green': { width: 96.1, height: 163.6 },
  'Multi_link_cubes/column_2_orange': { width: 96.1, height: 164.6 },
  'Multi_link_cubes/column_2_purple': { width: 96.1, height: 163.2 },
  'Multi_link_cubes/column_2_red': { width: 96.1, height: 163.2 },
  'Multi_link_cubes/column_3_blue': { width: 96.077, height: 221.795 },
  'Multi_link_cubes/column_3_green': { width: 96.077, height: 221.795 },
  'Multi_link_cubes/column_3_orange': { width: 96.077, height: 224.462 },
  'Multi_link_cubes/column_3_purple': { width: 96.077, height: 221.795 },
  'Multi_link_cubes/column_3_red': { width: 96.077, height: 221.795 },
  'Multi_link_cubes/column_4_blue': { width: 96.077, height: 280.462 },
  'Multi_link_cubes/column_4_green': { width: 96.077, height: 280.462 },
  'Multi_link_cubes/column_4_orange': { width: 96.077, height: 284.462 },
  'Multi_link_cubes/column_4_purple': { width: 96.077, height: 280.462 },
  'Multi_link_cubes/column_4_red': { width: 96.077, height: 280.462 },
  'Multi_link_cubes/column_5_blue': { width: 96.077, height: 339.129 },
  'Multi_link_cubes/column_5_green': { width: 96.077, height: 339.129 },
  'Multi_link_cubes/column_5_orange': { width: 96.077, height: 344.462 },
  'Multi_link_cubes/column_5_purple': { width: 96.077, height: 339.129 },
  'Multi_link_cubes/column_5_red': { width: 96.077, height: 339.129 },
  'Multi_link_cubes/column_6_blue': { width: 96.077, height: 397.795 },
  'Multi_link_cubes/column_6_green': { width: 96.077, height: 397.795 },
  'Multi_link_cubes/column_6_orange': { width: 96.077, height: 404.462 },
  'Multi_link_cubes/column_6_purple': { width: 96.077, height: 397.795 },
  'Multi_link_cubes/column_6_red': { width: 96.077, height: 397.795 },
  'Multi_link_cubes/column_7_blue': { width: 96.077, height: 456.462 },
  'Multi_link_cubes/column_7_green': { width: 96.077, height: 456.462 },
  'Multi_link_cubes/column_7_orange': { width: 96.077, height: 464.462 },
  'Multi_link_cubes/column_7_purple': { width: 96.077, height: 456.462 },
  'Multi_link_cubes/column_7_red': { width: 96.077, height: 456.462 },
  'Multi_link_cubes/column_8_blue': { width: 96.077, height: 515.129 },
  'Multi_link_cubes/column_8_green': { width: 96.077, height: 515.129 },
  'Multi_link_cubes/column_8_orange': { width: 96.077, height: 524.462 },
  'Multi_link_cubes/column_8_purple': { width: 96.077, height: 515.129 },
  'Multi_link_cubes/column_8_red': { width: 96.077, height: 515.129 },
  'Multi_link_cubes/front_column_blue': { width: 108, height: 115 },
  'Multi_link_cubes/front_column_green': { width: 108, height: 115 },
  'Multi_link_cubes/front_column_orange': { width: 108, height: 115 },
  'Multi_link_cubes/front_column_purple': { width: 108, height: 115 },
  'Multi_link_cubes/front_column_red': { width: 108, height: 115 },
  'Multi_link_cubes/front_column_yellow': { width: 108, height: 115 },
  'Multilink_shapes/Multilink_cubes_and_cuboids1': { width: 328.64266, height: 299.95999 },
  'Multilink_shapes/Multilink_cubes_and_cuboids10': { width: 216, height: 188 },
  'Multilink_shapes/Multilink_cubes_and_cuboids11': { width: 175, height: 152 },
  'Multilink_shapes/Multilink_cubes_and_cuboids12': { width: 776, height: 188 },
  'Multilink_shapes/Multilink_cubes_and_cuboids13': { width: 441, height: 524 },
  'Multilink_shapes/Multilink_cubes_and_cuboids2': { width: 397.54879, height: 150.68213 },
  'Multilink_shapes/Multilink_cubes_and_cuboids3': { width: 481.61745, height: 448.07092 },
  'Multilink_shapes/Multilink_cubes_and_cuboids4': { width: 287, height: 600 },
  'Multilink_shapes/Multilink_cubes_and_cuboids5': { width: 328, height: 412 },
  'Multilink_shapes/Multilink_cubes_and_cuboids6': { width: 552, height: 188 },
  'Multilink_shapes/Multilink_cubes_and_cuboids7': { width: 175, height: 487 },
  'Multilink_shapes/Multilink_cubes_and_cuboids8': { width: 655, height: 617 },
  'Multilink_shapes/Multilink_cubes_and_cuboids9': { width: 526, height: 373 },
  'Multilink_shapes/Multilink_shape1_10cubes': { width: 397.73824, height: 487.00677 },
  'Multilink_shapes/Multilink_shape1_12cubes': { width: 509.46611, height: 487.00677 },
  'Multilink_shapes/Multilink_shape1_4cubes': { width: 285.7625, height: 375.03119 },
  'Multilink_shapes/Multilink_shape1_6cubes': { width: 285.7625, height: 487.00677 },
  'Multilink_shapes/Multilink_shape1_8cubes': { width: 285.7625, height: 599.38025 },
  'Multilink_shapes/Multilink_shape2_10cubes': { width: 621.44169, height: 375.03119 },
  'Multilink_shapes/Multilink_shape2_12cubes': { width: 621.44169, height: 375.03119 },
  'Multilink_shapes/Multilink_shape2_4cubes': { width: 397.73824, height: 262.65771 },
  'Multilink_shapes/Multilink_shape2_7cubes': { width: 509.46611, height: 262.65771 },
  'Multilink_shapes/Multilink_shape2_8cubes': { width: 621.44169, height: 262.65771 },
  'Multilink_shapes/Multilink_shape3_10cubes': { width: 397.73824, height: 599.38025 },
  'Multilink_shapes/Multilink_shape3_12cubes': { width: 397.73824, height: 599.38025 },
  'Multilink_shapes/Multilink_shape3_4cubes': { width: 285.7625, height: 375.03119 },
  'Multilink_shapes/Multilink_shape3_6cubes': { width: 285.7625, height: 599.38025 },
  'Multilink_shapes/Multilink_shape3_8cubes': { width: 397.73824, height: 487.00677 },
  'Nonagons/Irregular_nonagon_blue': { width: 403.70931, height: 404.1333 },
  'Nonagons/Irregular_nonagon_green': { width: 403.70931, height: 404.1333 },
  'Nonagons/Irregular_nonagon_orange': { width: 403.70931, height: 404.1333 },
  'Nonagons/Irregular_nonagon_pink': { width: 403.70931, height: 404.1333 },
  'Nonagons/Irregular_nonagon_purple': { width: 403.70931, height: 404.1333 },
  'Nonagons/Irregular_nonagon_red': { width: 403.70931, height: 404.1333 },
  'Nonagons/Irregular_nonagon_turquoise': { width: 403.70931, height: 404.1333 },
  'Nonagons/Irregular_nonagon_white': { width: 403.70931, height: 404.1333 },
  'Nonagons/Irregular_nonagon_yellow': { width: 403.70931, height: 404.1333 },
  'Nonagons/Regular_nonagon_1_arrow': { width: 521, height: 421 },
  'Nonagons/Regular_nonagon_1_arrow_blue': { width: 521, height: 421 },
  'Nonagons/Regular_nonagon_1_arrow_green': { width: 521, height: 421 },
  'Nonagons/Regular_nonagon_1_arrow_pink': { width: 521, height: 421 },
  'Nonagons/Regular_nonagon_1_arrow_purple': { width: 521, height: 421 },
  'Nonagons/Regular_nonagon_1_arrow_yellow': { width: 521, height: 421 },
  'Nonagons/Regular_nonagon_blue': { width: 425.0533, height: 418.71597 },
  'Nonagons/Regular_nonagon_green': { width: 425.0533, height: 418.71597 },
  'Nonagons/Regular_nonagon_orange': { width: 425.0533, height: 418.71597 },
  'Nonagons/Regular_nonagon_pink': { width: 425.0533, height: 418.71597 },
  'Nonagons/Regular_nonagon_purple': { width: 425.0533, height: 418.71597 },
  'Nonagons/Regular_nonagon_red': { width: 425.0533, height: 418.71597 },
  'Nonagons/Regular_nonagon_turquoise': { width: 425.0533, height: 418.71597 },
  'Nonagons/Regular_nonagon_white': { width: 425.0533, height: 418.71597 },
  'Nonagons/Regular_nonagon_yellow': { width: 425.0533, height: 418.71597 },
  'Ocean_Scene_depiciting_depths/Ocean_Scene_1': { width: 513.01214, height: 329.64276 },
  'Ocean_Scene_depiciting_depths/Ocean_Scene_10': { width: 513.01214, height: 329.64276 },
  'Ocean_Scene_depiciting_depths/Ocean_Scene_11': { width: 513.01214, height: 329.64276 },
  'Ocean_Scene_depiciting_depths/Ocean_Scene_12': { width: 513.01214, height: 329.64276 },
  'Ocean_Scene_depiciting_depths/Ocean_Scene_13': { width: 513.01214, height: 329.64276 },
  'Ocean_Scene_depiciting_depths/Ocean_Scene_14': { width: 513.01214, height: 329.64276 },
  'Ocean_Scene_depiciting_depths/Ocean_Scene_15': { width: 513.01214, height: 329.64276 },
  'Ocean_Scene_depiciting_depths/Ocean_Scene_16': { width: 513.01214, height: 329.64276 },
  'Ocean_Scene_depiciting_depths/Ocean_Scene_17': { width: 513.01214, height: 329.64276 },
  'Ocean_Scene_depiciting_depths/Ocean_Scene_18': { width: 513.01214, height: 329.64276 },
  'Ocean_Scene_depiciting_depths/Ocean_Scene_19': { width: 513.01214, height: 329.64276 },
  'Ocean_Scene_depiciting_depths/Ocean_Scene_2': { width: 513.01214, height: 329.64276 },
  'Ocean_Scene_depiciting_depths/Ocean_Scene_20': { width: 513.01214, height: 329.64276 },
  'Ocean_Scene_depiciting_depths/Ocean_Scene_21': { width: 513.01214, height: 329.64276 },
  'Ocean_Scene_depiciting_depths/Ocean_Scene_22': { width: 513.01214, height: 329.64276 },
  'Ocean_Scene_depiciting_depths/Ocean_Scene_23': { width: 513.01214, height: 329.64276 },
  'Ocean_Scene_depiciting_depths/Ocean_Scene_24': { width: 513.01214, height: 329.64276 },
  'Ocean_Scene_depiciting_depths/Ocean_Scene_3': { width: 513.01214, height: 329.64276 },
  'Ocean_Scene_depiciting_depths/Ocean_Scene_4': { width: 513.01214, height: 329.64276 },
  'Ocean_Scene_depiciting_depths/Ocean_Scene_5': { width: 513.01214, height: 329.64276 },
  'Ocean_Scene_depiciting_depths/Ocean_Scene_6': { width: 513.01214, height: 329.64276 },
  'Ocean_Scene_depiciting_depths/Ocean_Scene_7': { width: 513.01214, height: 329.64276 },
  'Ocean_Scene_depiciting_depths/Ocean_Scene_8': { width: 513.01214, height: 329.64276 },
  'Ocean_Scene_depiciting_depths/Ocean_Scene_9': { width: 513.01214, height: 329.64276 },
  'Octagons/Irregular_octagon1_blue': { width: 998.50662, height: 472.94 },
  'Octagons/Irregular_octagon1_green': { width: 998.50662, height: 472.94 },
  'Octagons/Irregular_octagon1_orange': { width: 998.50662, height: 472.94 },
  'Octagons/Irregular_octagon1_pink': { width: 998.50662, height: 472.94 },
  'Octagons/Irregular_octagon1_purple': { width: 998.50662, height: 472.94 },
  'Octagons/Irregular_octagon1_red': { width: 998.50662, height: 472.94 },
  'Octagons/Irregular_octagon1_turquoise': { width: 998.50662, height: 472.94 },
  'Octagons/Irregular_octagon1_white': { width: 998.50662, height: 472.94 },
  'Octagons/Irregular_octagon1_yellow': { width: 998.50662, height: 472.94 },
  'Octagons/Irregular_octagon2_blue': { width: 379.47332, height: 460.31863 },
  'Octagons/Irregular_octagon2_green': { width: 379.47332, height: 460.31863 },
  'Octagons/Irregular_octagon2_orange': { width: 379.47332, height: 460.31863 },
  'Octagons/Irregular_octagon2_pink': { width: 379.47332, height: 460.31863 },
  'Octagons/Irregular_octagon2_purple': { width: 379.47332, height: 460.31863 },
  'Octagons/Irregular_octagon2_red': { width: 379.47332, height: 460.31863 },
  'Octagons/Irregular_octagon2_turquoise': { width: 379.47332, height: 460.31863 },
  'Octagons/Irregular_octagon2_white': { width: 379.47332, height: 460.31863 },
  'Octagons/Irregular_octagon2_yellow': { width: 379.47332, height: 460.31863 },
  'Octagons/Irregular_octagon3_blue': { width: 437.79332, height: 407.9465 },
  'Octagons/Irregular_octagon3_green': { width: 437.79332, height: 407.9465 },
  'Octagons/Irregular_octagon3_orange': { width: 437.79332, height: 407.9465 },
  'Octagons/Irregular_octagon3_pink': { width: 437.79332, height: 407.9465 },
  'Octagons/Irregular_octagon3_purple': { width: 437.79332, height: 407.9465 },
  'Octagons/Irregular_octagon3_red': { width: 437.79332, height: 407.9465 },
  'Octagons/Irregular_octagon3_turquoise': { width: 437.79332, height: 407.9465 },
  'Octagons/Irregular_octagon3_white': { width: 437.79332, height: 407.9465 },
  'Octagons/Irregular_octagon3_yellow': { width: 437.79332, height: 407.9465 },
  'Octagons/Octagon_blue': { width: 420.625, height: 420.62531 },
  'Octagons/Octagon_green': { width: 420.625, height: 420.62531 },
  'Octagons/Octagon_orange': { width: 420.625, height: 420.62531 },
  'Octagons/Octagon_pink': { width: 420.625, height: 420.62531 },
  'Octagons/Octagon_purple': { width: 420.625, height: 420.62531 },
  'Octagons/Octagon_red': { width: 420.625, height: 420.62531 },
  'Octagons/Octagon_turquoise': { width: 420.625, height: 420.62531 },
  'Octagons/Octagon_yellow': { width: 420.625, height: 420.62531 },
  'Octagons/Regular_octagon_1_arrow': { width: 451, height: 421 },
  'Octagons/Regular_octagon_1_arrow_blue': { width: 451, height: 421 },
  'Octagons/Regular_octagon_1_arrow_green': { width: 451, height: 421 },
  'Octagons/Regular_octagon_1_arrow_pink': { width: 451, height: 421 },
  'Octagons/Regular_octagon_1_arrow_purple': { width: 451, height: 421 },
  'Octagons/Regular_octagon_1_arrow_yellow': { width: 451, height: 421 },
  Orange_juice_carton: { width: 275.39651, height: 397.56314 },
  Orange_juice_carton_blank: { width: 275.39651, height: 397.56314 },
  'Other_shapes/4_angles_around_a_point': { width: 1269.7999, height: 746.89197 },
  'Other_shapes/5_angles_around_a_point': { width: 1269.7999, height: 746.89197 },
  'Other_shapes/6_angles_around_a_point': { width: 1269.7999, height: 746.89197 },
  'Other_shapes/7_angles_around_a_point': { width: 1269.7999, height: 746.89197 },
  'Other_shapes/Angles_on_a_straight_line': { width: 1269.7999, height: 746.89197 },
  'Other_shapes/Anti_clockwise_shaded_diagram_full_turn': { width: 519.38396, height: 519.38397 },
  'Other_shapes/Anti_clockwise_shaded_diagram_half_turn': { width: 519.38396, height: 519.38397 },
  'Other_shapes/Anti_clockwise_shaded_diagram_quarter_turn': {
    width: 519.38396,
    height: 519.38397
  },
  'Other_shapes/Anti_clockwise_shaded_diagram_three_quarter_turn': {
    width: 519.38396,
    height: 519.38397
  },
  'Other_shapes/Clockwise_shaded_diagram_full_turn': { width: 519.38396, height: 519.38397 },
  'Other_shapes/Clockwise_shaded_diagram_half_turn': { width: 519.38396, height: 519.38397 },
  'Other_shapes/Clockwise_shaded_diagram_quarter_turn': { width: 519.38396, height: 519.38397 },
  'Other_shapes/Clockwise_shaded_diagram_three_quarter_turn': {
    width: 519.38396,
    height: 519.38397
  },
  'Other_shapes/Coloured_arrow1': { width: 220.34365, height: 280.69995 },
  'Other_shapes/Coloured_arrow2': { width: 280.69994, height: 220.34366 },
  'Other_shapes/Coloured_arrow3': { width: 220.34365, height: 280.69995 },
  'Other_shapes/Coloured_arrow4': { width: 280.69994, height: 220.34366 },
  'Other_shapes/Cones_dotted_lines': { width: 590.14903, height: 628.5412 },
  'Other_shapes/Cube1': { width: 273.04266, height: 315.35007 },
  'Other_shapes/Cube3': { width: 354.78451, height: 323.90326 },
  'Other_shapes/Cube4': { width: 273.04266, height: 315.35007 },
  'Other_shapes/Cube_dottedlines1': { width: 288.36092, height: 316.7305 },
  'Other_shapes/Cube_dottedlines2': { width: 469.96971, height: 516.33008 },
  'Other_shapes/Cuboid_dottedlines1': { width: 259.92797, height: 437.60199 },
  'Other_shapes/Cuboid_dottedlines2': { width: 469.96971, height: 792.33008 },
  'Other_shapes/Cuboid_dottedlines3': { width: 567.62608, height: 544.10571 },
  'Other_shapes/Cylinder1': { width: 82.964531, height: 125.63333 },
  'Other_shapes/Cylinder3': { width: 82.964531, height: 127.39333 },
  'Other_shapes/Cylinder_dotted_lines1': { width: 588.61461, height: 726.60529 },
  'Other_shapes/Cylinder_dotted_lines2': { width: 355.68026, height: 776.00934 },
  'Other_shapes/Decagon_non_example1': { width: 520.09599, height: 520.09467 },
  'Other_shapes/Decagon_non_example2': { width: 520.09465, height: 520.09467 },
  'Other_shapes/Decagon_non_example3': { width: 520.09465, height: 520.09467 },
  'Other_shapes/Equilateraltriangle_markedlines': { width: 472.28554, height: 517.86932 },
  'Other_shapes/Heptagon_non_example1': { width: 533.41875, height: 520.09479 },
  'Other_shapes/Heptagon_non_example2': { width: 533.41838, height: 520.09497 },
  'Other_shapes/Hexagon_non_example1': { width: 597.093, height: 517.63385 },
  'Other_shapes/Hexagon_non_example2': { width: 582.71544, height: 515.6333 },
  'Other_shapes/Hexagon_non_example4': { width: 594.29722, height: 515.6333 },
  'Other_shapes/Hexagonal_prism1': { width: 243.9223, height: 339.24252 },
  'Other_shapes/Hexagonal_prism2': { width: 243.9223, height: 275.81558 },
  'Other_shapes/Hexagonalprism_dottedlines1': { width: 707.835, height: 521.51947 },
  'Other_shapes/Hexagonalprism_dottedlines2': { width: 395.55266, height: 682.65796 },
  'Other_shapes/Hexagonalpyramid_dottedlines1': { width: 395.04381, height: 390.67725 },
  'Other_shapes/Interior_angles_card': { width: 1269.7999, height: 746.89197 },
  'Other_shapes/Irregular_decagon1': { width: 361.15679, height: 418.19717 },
  'Other_shapes/Irregular_decagon1_blue': { width: 364.4901, height: 425.14022 },
  'Other_shapes/Irregular_decagon1_green': { width: 364.4901, height: 425.14022 },
  'Other_shapes/Irregular_decagon1_orange': { width: 364.4901, height: 425.14022 },
  'Other_shapes/Irregular_decagon1_pink': { width: 364.4901, height: 425.14022 },
  'Other_shapes/Irregular_decagon1_purple': { width: 364.4901, height: 425.14022 },
  'Other_shapes/Irregular_decagon1_red': { width: 364.4901, height: 425.14022 },
  'Other_shapes/Irregular_decagon1_turquoise': { width: 364.4901, height: 425.14022 },
  'Other_shapes/Irregular_decagon1_yellow': { width: 364.4901, height: 425.14022 },
  'Other_shapes/Irregular_decagon2': { width: 456.56594, height: 514.61877 },
  'Other_shapes/Irregular_decagon2_blue': { width: 456.56594, height: 514.61877 },
  'Other_shapes/Irregular_decagon2_green': { width: 456.56594, height: 514.61877 },
  'Other_shapes/Irregular_decagon2_orange': { width: 456.56594, height: 514.61877 },
  'Other_shapes/Irregular_decagon2_pink': { width: 456.56594, height: 514.61877 },
  'Other_shapes/Irregular_decagon2_purple': { width: 456.56594, height: 514.61877 },
  'Other_shapes/Irregular_decagon2_red': { width: 456.56594, height: 514.61877 },
  'Other_shapes/Irregular_decagon2_turquoise': { width: 456.56594, height: 514.61877 },
  'Other_shapes/Irregular_decagon2_yellow': { width: 456.56594, height: 514.61877 },
  'Other_shapes/Irregular_heptagon': { width: 502.57454, height: 490.02399 },
  'Other_shapes/Irregular_heptagon_blue': { width: 502.57454, height: 490.02399 },
  'Other_shapes/Irregular_heptagon_green': { width: 502.57454, height: 490.02399 },
  'Other_shapes/Irregular_heptagon_pink': { width: 502.57454, height: 490.02399 },
  'Other_shapes/Irregular_heptagon_purple': { width: 502.57454, height: 490.02399 },
  'Other_shapes/Irregular_heptagon_yellow': { width: 502.57454, height: 490.02399 },
  'Other_shapes/Isosceles_triangle_angles_card': { width: 1269.7999, height: 746.89197 },
  'Other_shapes/Nonagon_non_example1': { width: 522.8936, height: 518.40662 },
  'Other_shapes/Nonagon_non_example2': { width: 524.89519, height: 520.05414 },
  'Other_shapes/Nonagon_non_example3': { width: 525.42229, height: 520.09564 },
  'Other_shapes/Octagon_non_example1': { width: 520.09465, height: 520.09467 },
  'Other_shapes/Octagon_non_example2': { width: 520.09465, height: 520.09467 },
  'Other_shapes/Octagon_non_example3': { width: 520.09465, height: 520.09601 },
  'Other_shapes/Parallelogram1_marked_lines_and_angles': { width: 647.73967, height: 357.79022 },
  'Other_shapes/Parallelogram2_marked_lines_and_angles': { width: 671.59721, height: 358.94263 },
  'Other_shapes/Parallelogram3_marked_lines_and_angles': { width: 671.59721, height: 358.77151 },
  'Other_shapes/Parallelogram4_marked_lines_and_angles': { width: 642.74626, height: 359.8085 },
  'Other_shapes/Pentagon_non_example1': { width: 529.11473, height: 507.22525 },
  'Other_shapes/Pentagon_non_example2': { width: 543.15617, height: 516.67078 },
  'Other_shapes/Pentagon_non_example3': { width: 543.15569, height: 516.66998 },
  'Other_shapes/Pentagon_non_example4': { width: 543.15727, height: 553.80664 },
  'Other_shapes/Pentagon_non_example5': { width: 543.15593, height: 515.0202 },
  'Other_shapes/Pentagon_regular_marked_lines': { width: 549.48528, height: 547.02478 },
  'Other_shapes/Pentagonalprism_dottedlines1': { width: 664.13047, height: 612.82178 },
  'Other_shapes/Pentagonalprism_dottedlines2': { width: 504.99782, height: 654.38629 },
  'Other_shapes/Rectangle1_marked_lines_and_angles': { width: 647.78984, height: 359.14426 },
  'Other_shapes/Rectangle2_marked_lines_and_angles': { width: 429.6429, height: 647.78986 },
  'Other_shapes/Rectangle3_marked_lines_and_angles': { width: 701.9799, height: 721.88788 },
  'Other_shapes/Rectangle4_marked_lines_and_angles': { width: 1174.3193, height: 359.14426 },
  'Other_shapes/Regular_decagon': { width: 447.30781, height: 425.41464 },
  'Other_shapes/Regular_decagon1_marked_lines': { width: 445.08104, height: 463.86856 },
  'Other_shapes/Regular_decagon2_marked_lines': { width: 438.2769, height: 416.92361 },
  'Other_shapes/Regular_decagon_1_arrow': { width: 447, height: 462 },
  'Other_shapes/Regular_decagon_1_arrow_blue': { width: 447, height: 462 },
  'Other_shapes/Regular_decagon_1_arrow_green': { width: 447, height: 462 },
  'Other_shapes/Regular_decagon_1_arrow_pink': { width: 447, height: 462 },
  'Other_shapes/Regular_decagon_1_arrow_purple': { width: 447, height: 462 },
  'Other_shapes/Regular_decagon_1_arrow_yellow': { width: 447, height: 462 },
  'Other_shapes/Regular_decagon_blue': { width: 443.8029, height: 422.08133 },
  'Other_shapes/Regular_decagon_equal_sides_one_angle': { width: 456.05123, height: 455.59372 },
  'Other_shapes/Regular_decagon_green': { width: 443.8029, height: 422.08133 },
  'Other_shapes/Regular_decagon_orange': { width: 443.8029, height: 422.08133 },
  'Other_shapes/Regular_decagon_pink': { width: 443.8029, height: 422.08133 },
  'Other_shapes/Regular_decagon_purple': { width: 443.8029, height: 422.08133 },
  'Other_shapes/Regular_decagon_red': { width: 443.8029, height: 422.08133 },
  'Other_shapes/Regular_decagon_turquoise': { width: 443.8029, height: 422.08133 },
  'Other_shapes/Regular_decagon_yellow': { width: 443.8029, height: 422.08133 },
  'Other_shapes/Regular_heptagon': { width: 505.90794, height: 493.3573 },
  'Other_shapes/Regular_heptagon_1_arrow': { width: 505, height: 541 },
  'Other_shapes/Regular_heptagon_1_arrow_blue': { width: 505, height: 541 },
  'Other_shapes/Regular_heptagon_1_arrow_green': { width: 505, height: 541 },
  'Other_shapes/Regular_heptagon_1_arrow_pink': { width: 505, height: 541 },
  'Other_shapes/Regular_heptagon_1_arrow_purple': { width: 505, height: 541 },
  'Other_shapes/Regular_heptagon_1_arrow_yellow': { width: 505, height: 541 },
  'Other_shapes/Regular_heptagon_blue': { width: 502.57463, height: 490.02399 },
  'Other_shapes/Regular_heptagon_equal_sides_one_angle': { width: 437.75728, height: 444.42078 },
  'Other_shapes/Regular_heptagon_green': { width: 502.57463, height: 490.02399 },
  'Other_shapes/Regular_heptagon_marked_lines': { width: 502.82652, height: 513.38934 },
  'Other_shapes/Regular_heptagon_pink': { width: 502.57463, height: 490.02399 },
  'Other_shapes/Regular_heptagon_purple': { width: 502.57463, height: 490.02399 },
  'Other_shapes/Regular_heptagon_yellow': { width: 502.57463, height: 490.02399 },
  'Other_shapes/Regular_hexagon_equal_sides_one_angle': { width: 492.55461, height: 462.00986 },
  'Other_shapes/Regular_hexagon_marked_lines': { width: 541.96129, height: 547.85065 },
  'Other_shapes/Regular_nonagon_equal_sides_one_angle': { width: 443.04381, height: 444.01065 },
  'Other_shapes/Regular_nonagon_marked_lines': { width: 448.25551, height: 443.6795 },
  'Other_shapes/Regular_octagon': { width: 421.95866, height: 421.95865 },
  'Other_shapes/Regular_octagon_blue': { width: 418.62532, height: 418.62534 },
  'Other_shapes/Regular_octagon_equal_sides_one_angle': { width: 457.69457, height: 457.69458 },
  'Other_shapes/Regular_octagon_green': { width: 418.62532, height: 418.62534 },
  'Other_shapes/Regular_octagon_marked_lines': { width: 466.15422, height: 468.65225 },
  'Other_shapes/Regular_octagon_pink': { width: 420.62535, height: 420.62534 },
  'Other_shapes/Regular_octagon_purple': { width: 418.62532, height: 418.62534 },
  'Other_shapes/Regular_octagon_yellow': { width: 418.62532, height: 418.62534 },
  'Other_shapes/Regular_pentagon_equal_sides_one_angle': { width: 443.90233, height: 448.56128 },
  'Other_shapes/Rhombus1_marked_lines_and_angles': { width: 733.41056, height: 625.83026 },
  'Other_shapes/Rhombus2_marked_lines_and_angles': { width: 564.90788, height: 496.74149 },
  'Other_shapes/Rhombus_markedlines': { width: 527.14342, height: 421.05692 },
  'Other_shapes/Right_angle_dotted_lines': { width: 671.01274, height: 670.35107 },
  'Other_shapes/Square_based_pyramid1': { width: 175.46765, height: 95.099793 },
  'Other_shapes/Square_based_pyramid2': { width: 132.79849, height: 120.55827 },
  'Other_shapes/Square_based_pyramid3': { width: 154.13179, height: 120.55834 },
  'Other_shapes/Square_equal_sides_one_angle': { width: 579.59459, height: 579.59406 },
  'Other_shapes/Square_marked_lines_and_angles': { width: 647.78984, height: 647.78986 },
  'Other_shapes/Square_markedlines1': { width: 567.5106, height: 567.51062 },
  'Other_shapes/Square_markedlines2': { width: 668.55723, height: 668.55725 },
  'Other_shapes/Square_non_example1': { width: 520.09465, height: 520.09467 },
  'Other_shapes/Square_non_example2': { width: 520.09465, height: 520.09601 },
  'Other_shapes/Square_non_example3': { width: 520.0949, height: 520.09521 },
  'Other_shapes/Square_non_example4': { width: 520.09465, height: 526.04816 },
  'Other_shapes/Tetrahedron1': { width: 129.77055, height: 144.9436 },
  'Other_shapes/Tetrahedron4': { width: 106.47991, height: 144.94353 },
  'Other_shapes/Tetrehedron1_dotted_lines': { width: 578.507, height: 635.33331 },
  'Other_shapes/Tetrehedron2_dotted_lines': { width: 952.42691, height: 635.33331 },
  'Other_shapes/Tetrehedron3_dotted_lines': { width: 653.78123, height: 635.33331 },
  'Other_shapes/Trapezium1_marked_lines_and_angles': { width: 855.84647, height: 300.66669 },
  'Other_shapes/Trapezium2_marked_lines_and_angles': { width: 705.84654, height: 300.66669 },
  'Other_shapes/Trapezium3_marked_lines_and_angles': { width: 625.50389, height: 607.88708 },
  'Other_shapes/Trapezium4_marked_lines_and_angles': { width: 705.8466, height: 560.06799 },
  'Other_shapes/Triangle1_line_extension_3_angles': { width: 882.24906, height: 486.78912 },
  'Other_shapes/Triangle2_line_extension_3_angles': { width: 704.53672, height: 557.69147 },
  'Other_shapes/Triangle3_line_extension_3_angles': { width: 811.33604, height: 496.08063 },
  'Other_shapes/Triangle4_line_extension_3_angles': { width: 859.71329, height: 282.29678 },
  'Other_shapes/Triangle5_line_extension_3_angles': { width: 704.53672, height: 557.69147 },
  'Other_shapes/Triangle_non_example1': { width: 570.99272, height: 500.06342 },
  'Other_shapes/Triangle_non_example2': { width: 596.29063, height: 516.67065 },
  'Other_shapes/Triangular_prism1': { width: 183.62399, height: 327.98877 },
  'Other_shapes/Triangular_prism2': { width: 243.62799, height: 328.60355 },
  'Other_shapes/Triangular_prism2by3': { width: 187.46826, height: 175.23494 },
  'Other_shapes/Triangular_prism2by4': { width: 222.71929, height: 195.88705 },
  'Other_shapes/Triangular_prism3': { width: 404.30243, height: 292.86917 },
  'Other_shapes/Triangular_prism3by3': { width: 224.49965, height: 230.06985 },
  'Other_shapes/Triangular_prism3by4': { width: 260.10672, height: 252.14625 },
  'Other_shapes/Triangularprism_dottedlines1': { width: 284.07345, height: 466.06985 },
  'Other_shapes/Triangularprism_dottedlines2': { width: 427.27599, height: 701.66687 },
  'Other_shapes/Triangularprism_dottedlines3': { width: 458.0081, height: 386.96051 },
  'Other_shapes/Vertically_opposite_angles_card': { width: 1269.7999, height: 746.89197 },
  'Other_shapes/cube2': { width: 452.32396, height: 496.93665 },
  'Other_shapes/cuboid2': { width: 269.64266, height: 447.52716 },
  'Other_shapes/cuboid3': { width: 469.96932, height: 780.9978 },
  'Other_shapes/cylinder2': { width: 588.61461, height: 726.60529 },
  'Other_shapes/hexagonalprism2': { width: 707.835, height: 521.18683 },
  'Other_shapes/hexagonalpyramid1': { width: 394.70205, height: 390.67725 },
  'Other_shapes/pentagonalprism2': { width: 664.13047, height: 612.82178 },
  'Other_shapes/squarebasedpyramid1': { width: 857.1666, height: 716.5213 },
  'Other_shapes/squarebasedpyramid2': { width: 420.70583, height: 473.57611 },
  'Other_shapes/squarebasedpyramid3': { width: 621.71354, height: 700.80017 },
  'Other_shapes/stamp3dshape1': { width: 516.41063, height: 516.41064 },
  'Other_shapes/stamp3dshape2': { width: 494.87196, height: 494.87198 },
  'Other_shapes/stamp3dshape3': { width: 532.88957, height: 532.88977 },
  'Other_shapes/stamp3dshape4': { width: 590.00798, height: 299.02847 },
  'Other_shapes/stamp3dshape5': { width: 486.75197, height: 462.92798 },
  'Other_shapes/stamp3dshape6': { width: 514.94426, height: 445.95541 },
  'Other_shapes/tetrahedron2': { width: 952.42643, height: 635.33331 },
  'Other_shapes/tetrahedron3': { width: 653.78123, height: 635.33331 },
  'Other_shapes/triangularprism2': { width: 427.27599, height: 701.66687 },
  'Other_shapes/triangularprism3': { width: 458.00798, height: 386.96027 },
  Owl_bird: { width: 793.70135, height: 793.70135 },
  Pack_of_10_crayons: { width: 298.66666, height: 234.51919 },
  Pack_of_marbles_blank: { width: 387.75451, height: 184.28966 },
  Pack_of_sweets_unlabelled: { width: 435.78494, height: 343.57773 },
  Packaged_sandwich: { width: 175.72528, height: 216.67714 },
  Packs_of_pins_pack_of_100: { width: 246.15199, height: 336.75452 },
  Paddle: { width: 272.39212, height: 241.64297 },
  Paddling_pool: { width: 553.3482, height: 264.82763 },
  Paint_brush: { width: 703.53344, height: 92.330154 },
  Paint_palette: { width: 372.89584, height: 243.22688 },
  PairedsocksBlue: { width: 149.92381, height: 154.89282 },
  PairedsocksGreen: { width: 147.20181, height: 154.89296 },
  PairedsocksOrange: { width: 147.20181, height: 154.89296 },
  PairedsocksPurple: { width: 147.20181, height: 154.89296 },
  PairedsocksRed: { width: 147.20181, height: 154.89282 },
  PairedsocksYellow: { width: 151.96715, height: 154.89296 },
  Paper_clip: { width: 2573.2629, height: 121.83279 },
  'Parallelogram/parallelogram': { width: 583.19189, height: 328 },
  'Parallelogram/parallelogram_blue': { width: 583.19189, height: 328 },
  'Parallelogram/parallelogram_green': { width: 583.19189, height: 328 },
  'Parallelogram/parallelogram_orange': { width: 583.19189, height: 328 },
  'Parallelogram/parallelogram_pink': { width: 583.19189, height: 328 },
  'Parallelogram/parallelogram_purple': { width: 583.19189, height: 328 },
  'Parallelogram/parallelogram_red': { width: 583.19189, height: 328 },
  'Parallelogram/parallelogram_turquoise': { width: 583.19189, height: 328 },
  'Parallelogram/parallelogram_white': { width: 583.19189, height: 328 },
  'Parallelogram/parallelogram_yellow': { width: 583.19189, height: 328 },
  ParenthesesLeftBlack: { width: 48, height: 144 },
  ParenthesesLeftBlue: { width: 48, height: 144 },
  ParenthesesRightBlack: { width: 48, height: 144 },
  ParenthesesRightBlue: { width: 48, height: 144 },
  Part_filled_cylinder_1000mlcap_100mlint: { width: 204.812, height: 455.57171 },
  Peach: { width: 191.99901, height: 162.27627 },
  'Pears_in_a_transparent_bag/Pears_in_a_bag_0': { width: 190.11143, height: 255.44919 },
  'Pears_in_a_transparent_bag/Pears_in_a_bag_1': { width: 188.75941, height: 253.62251 },
  'Pears_in_a_transparent_bag/Pears_in_a_bag_2': { width: 190.11143, height: 255.44919 },
  'Pears_in_a_transparent_bag/Pears_in_a_bag_3': { width: 190.11143, height: 255.44919 },
  'Pears_in_a_transparent_bag/Pears_in_a_bag_4': { width: 190.11143, height: 255.44919 },
  'Pears_in_a_transparent_bag/Pears_in_a_bag_5': { width: 190.11143, height: 255.44919 },
  Pen_green: { width: 78.79367, height: 309.76904 },
  Pencil_case: { width: 428.94815, height: 387.79949 },
  Pencil_sharpener: { width: 183.94546, height: 121.3064 },
  'Pencils/Pencil_green': { width: 739.40625, height: 56.516705 },
  'Pencils/Pencil_red': { width: 739.40625, height: 56.516705 },
  'Pencils/Pencil_yellow': { width: 739.40625, height: 56.516705 },
  'Pentagon_houses/pentagon_house': { width: 328, height: 328.47925 },
  'Pentagon_houses/pentagon_house_blue': { width: 328, height: 328.47925 },
  'Pentagon_houses/pentagon_house_green': { width: 328, height: 328.47925 },
  'Pentagon_houses/pentagon_house_orange': { width: 328, height: 328.47925 },
  'Pentagon_houses/pentagon_house_pink': { width: 328, height: 328.47925 },
  'Pentagon_houses/pentagon_house_purple': { width: 328, height: 328.47925 },
  'Pentagon_houses/pentagon_house_red': { width: 328, height: 328.47925 },
  'Pentagon_houses/pentagon_house_turquoise': { width: 328, height: 328.47925 },
  'Pentagon_houses/pentagon_house_white': { width: 328, height: 328.47925 },
  'Pentagon_houses/pentagon_house_yellow': { width: 328, height: 328.47925 },
  'Pentagons/Irregular_pentagon1_blue': { width: 482.34258, height: 472.93997 },
  'Pentagons/Irregular_pentagon1_blue_one_interior_angle_lhs': { width: 325, height: 319 },
  'Pentagons/Irregular_pentagon1_blue_one_interior_angle_rhs': { width: 325, height: 319 },
  'Pentagons/Irregular_pentagon1_green': { width: 482.34258, height: 472.93997 },
  'Pentagons/Irregular_pentagon1_green_one_interior_angle_lhs': { width: 325, height: 319 },
  'Pentagons/Irregular_pentagon1_green_one_interior_angle_rhs': { width: 325, height: 319 },
  'Pentagons/Irregular_pentagon1_orange': { width: 482.34258, height: 472.93997 },
  'Pentagons/Irregular_pentagon1_pink': { width: 482.34258, height: 472.93997 },
  'Pentagons/Irregular_pentagon1_pink_one_interior_angle_lhs': { width: 325, height: 319 },
  'Pentagons/Irregular_pentagon1_pink_one_interior_angle_rhs': { width: 325, height: 319 },
  'Pentagons/Irregular_pentagon1_purple': { width: 482.34258, height: 472.93997 },
  'Pentagons/Irregular_pentagon1_purple_one_interior_angle_lhs': { width: 325, height: 319 },
  'Pentagons/Irregular_pentagon1_purple_one_interior_angle_rhs': { width: 325, height: 319 },
  'Pentagons/Irregular_pentagon1_red': { width: 482.34258, height: 472.93997 },
  'Pentagons/Irregular_pentagon1_turquoise': { width: 482.34258, height: 472.93997 },
  'Pentagons/Irregular_pentagon1_white': { width: 482.34258, height: 472.93997 },
  'Pentagons/Irregular_pentagon1_white_one_interior_angle_lhs': { width: 325, height: 319 },
  'Pentagons/Irregular_pentagon1_white_one_interior_angle_rhs': { width: 325, height: 319 },
  'Pentagons/Irregular_pentagon1_yellow': { width: 482.34258, height: 472.93997 },
  'Pentagons/Irregular_pentagon1_yellow_one_interior_angle_lhs': { width: 325, height: 319 },
  'Pentagons/Irregular_pentagon1_yellow_one_interior_angle_rhs': { width: 325, height: 319 },
  'Pentagons/Irregular_pentagon2_blue': { width: 396.00798, height: 342.172 },
  'Pentagons/Irregular_pentagon2_green': { width: 396.00798, height: 342.172 },
  'Pentagons/Irregular_pentagon2_orange': { width: 396.00798, height: 342.172 },
  'Pentagons/Irregular_pentagon2_pink': { width: 396.00798, height: 342.172 },
  'Pentagons/Irregular_pentagon2_purple': { width: 396.00798, height: 342.172 },
  'Pentagons/Irregular_pentagon2_red': { width: 396.00798, height: 342.172 },
  'Pentagons/Irregular_pentagon2_turquoise': { width: 396.00798, height: 342.172 },
  'Pentagons/Irregular_pentagon2_white': { width: 396.00798, height: 342.172 },
  'Pentagons/Irregular_pentagon2_yellow': { width: 396.00798, height: 342.172 },
  'Pentagons/Irregular_pentagon3_blue': { width: 419.04396, height: 413.18396 },
  'Pentagons/Irregular_pentagon3_green': { width: 419.04396, height: 413.18396 },
  'Pentagons/Irregular_pentagon3_orange': { width: 419.04396, height: 413.18396 },
  'Pentagons/Irregular_pentagon3_pink': { width: 419.04396, height: 413.18396 },
  'Pentagons/Irregular_pentagon3_purple': { width: 419.04396, height: 413.18396 },
  'Pentagons/Irregular_pentagon3_red': { width: 419.04396, height: 413.18396 },
  'Pentagons/Irregular_pentagon3_turquoise': { width: 419.04396, height: 413.18396 },
  'Pentagons/Irregular_pentagon3_white': { width: 419.04396, height: 413.18396 },
  'Pentagons/Irregular_pentagon3_yellow': { width: 419.04396, height: 413.18396 },
  'Pentagons/Irregular_pentagon4_blue': { width: 340.46132, height: 674.8905 },
  'Pentagons/Irregular_pentagon4_green': { width: 340.46132, height: 674.8905 },
  'Pentagons/Irregular_pentagon4_orange': { width: 340.46132, height: 674.8905 },
  'Pentagons/Irregular_pentagon4_pink': { width: 340.46132, height: 674.8905 },
  'Pentagons/Irregular_pentagon4_purple': { width: 340.46132, height: 674.8905 },
  'Pentagons/Irregular_pentagon4_red': { width: 340.46132, height: 674.8905 },
  'Pentagons/Irregular_pentagon4_turquoise': { width: 340.46132, height: 674.8905 },
  'Pentagons/Irregular_pentagon4_white': { width: 340.46132, height: 674.8905 },
  'Pentagons/Irregular_pentagon4_yellow': { width: 340.46132, height: 674.8905 },
  'Pentagons/Irregular_pentagon5_blue': { width: 845.71458, height: 487.90665 },
  'Pentagons/Irregular_pentagon5_green': { width: 845.71458, height: 487.90665 },
  'Pentagons/Irregular_pentagon5_orange': { width: 845.71458, height: 487.90665 },
  'Pentagons/Irregular_pentagon5_pink': { width: 845.71458, height: 487.90665 },
  'Pentagons/Irregular_pentagon5_purple': { width: 845.71458, height: 487.90665 },
  'Pentagons/Irregular_pentagon5_red': { width: 845.71458, height: 487.90665 },
  'Pentagons/Irregular_pentagon5_turquoise': { width: 845.71458, height: 487.90665 },
  'Pentagons/Irregular_pentagon5_white': { width: 845.71458, height: 487.90665 },
  'Pentagons/Irregular_pentagon5_yellow': { width: 845.71458, height: 487.90665 },
  'Pentagons/Irregular_pentagon6_blue': { width: 574.6013, height: 486.00131 },
  'Pentagons/Irregular_pentagon6_green': { width: 574.6013, height: 486.00131 },
  'Pentagons/Irregular_pentagon6_orange': { width: 574.6013, height: 486.00131 },
  'Pentagons/Irregular_pentagon6_pink': { width: 574.6013, height: 486.00131 },
  'Pentagons/Irregular_pentagon6_purple': { width: 574.6013, height: 486.00131 },
  'Pentagons/Irregular_pentagon6_red': { width: 574.6013, height: 486.00131 },
  'Pentagons/Irregular_pentagon6_turquoise': { width: 574.6013, height: 486.00131 },
  'Pentagons/Irregular_pentagon6_white': { width: 574.6013, height: 486.00131 },
  'Pentagons/Irregular_pentagon6_yellow': { width: 574.6013, height: 486.00131 },
  'Pentagons/pentagon': { width: 341.99026, height: 325.25348 },
  'Pentagons/pentagon_1_arrow': { width: 342, height: 380 },
  'Pentagons/pentagon_1_arrow_blue': { width: 342, height: 380 },
  'Pentagons/pentagon_1_arrow_green': { width: 342, height: 380 },
  'Pentagons/pentagon_1_arrow_pink': { width: 342, height: 380 },
  'Pentagons/pentagon_1_arrow_purple': { width: 342, height: 380 },
  'Pentagons/pentagon_1_arrow_yellow': { width: 342, height: 380 },
  'Pentagons/pentagon_blue': { width: 341.99026, height: 325.25348 },
  'Pentagons/pentagon_green': { width: 341.99026, height: 325.25348 },
  'Pentagons/pentagon_orange': { width: 341.99026, height: 325.25348 },
  'Pentagons/pentagon_pink': { width: 341.99026, height: 325.25348 },
  'Pentagons/pentagon_purple': { width: 341.99026, height: 325.25348 },
  'Pentagons/pentagon_red': { width: 341.99026, height: 325.25348 },
  'Pentagons/pentagon_turquoise': { width: 341.99026, height: 325.25348 },
  'Pentagons/pentagon_white': { width: 341.99026, height: 325.25348 },
  'Pentagons/pentagon_yellow': { width: 341.99026, height: 325.25348 },
  Phone: { width: 236.40399, height: 427.71197 },
  Picture_book: { width: 379.33344, height: 260.24414 },
  'Place_value/0.0001': { width: 300, height: 300 },
  'Place_value/0.001': { width: 104, height: 104 },
  'Place_value/0.01': { width: 104, height: 103 },
  'Place_value/0.1': { width: 104, height: 103 },
  'Place_value/0.1_grey': { width: 104, height: 103 },
  'Place_value/1': { width: 104, height: 104 },
  'Place_value/1-10': { width: 104, height: 103 },
  'Place_value/1-100': { width: 104, height: 104 },
  'Place_value/1-1000': { width: 104, height: 104 },
  'Place_value/1-10000': { width: 300, height: 300 },
  'Place_value/10': { width: 104, height: 103 },
  'Place_value/100': { width: 104, height: 103 },
  'Place_value/1000': { width: 104, height: 104 },
  'Place_value/10000': { width: 300, height: 300 },
  'Place_value/100000': { width: 300, height: 300 },
  'Place_value/1000000': { width: 300, height: 300 },
  'Place_value/1000cube': { width: 190, height: 179 },
  'Place_value/100cube': { width: 152, height: 157 },
  'Place_value/10cube': { width: 150, height: 157 },
  'Place_value/1_grey': { width: 104, height: 104 },
  'Place_value/1cube': { width: 150, height: 157 },
  'Place_value/BlackCounter': { width: 104, height: 104 },
  'Place_value/GreyCounter': { width: 104, height: 104 },
  Plane: { width: 693.70135, height: 693.70135 },
  Plate: { width: 336.61465, height: 200.22665 },
  Playground_birds_eye_view: { width: 1783.75, height: 1070.75 },
  Playground_birds_eye_view_with_arrows: { width: 892.13873, height: 548.164 },
  Plum: { width: 91.959899, height: 127.09458 },
  Pond: { width: 1402, height: 854 },
  Protractor180: { width: 261.43066, height: 142.71867 },
  Protractor360: { width: 261.43039, height: 261.72214 },
  'Rectangle/Rectangle_angles_length_arrows_blue': { width: 560.25249, height: 316.32825 },
  'Rectangle/Rectangle_angles_length_arrows_green': { width: 560.25249, height: 316.32825 },
  'Rectangle/Rectangle_angles_length_arrows_pink': { width: 560.25249, height: 316.32825 },
  'Rectangle/Rectangle_angles_length_arrows_purple': { width: 560.25249, height: 316.32825 },
  'Rectangle/Rectangle_angles_length_arrows_white': { width: 560.25249, height: 316.32825 },
  'Rectangle/Rectangle_angles_length_arrows_yellow': { width: 560.25249, height: 316.32825 },
  'Rectangle/rectangle': { width: 577.33331, height: 328 },
  'Rectangle/rectangle_blue': { width: 577.33331, height: 328 },
  'Rectangle/rectangle_green': { width: 577.33331, height: 328 },
  'Rectangle/rectangle_orange': { width: 577.33331, height: 328 },
  'Rectangle/rectangle_pink': { width: 577.33331, height: 328 },
  'Rectangle/rectangle_purple': { width: 577.33331, height: 328 },
  'Rectangle/rectangle_red': { width: 577.33331, height: 328 },
  'Rectangle/rectangle_turquoise': { width: 577.33331, height: 328 },
  'Rectangle/rectangle_white': { width: 578.66662, height: 329.33331 },
  'Rectangle/rectangle_yellow': { width: 577.33331, height: 328 },
  'Rectilinear_shapes_with_arrows/Rectangle_angles_length_arrows1': {
    width: 950.79447,
    height: 529.47961
  },
  'Rectilinear_shapes_with_arrows/Rectangle_angles_length_arrows2': {
    width: 861.65848,
    height: 480.82999
  },
  'Rectilinear_shapes_with_arrows/Rectangle_angles_length_arrows3': {
    width: 715.63383,
    height: 400.22186
  },
  'Rectilinear_shapes_with_arrows/Rectangle_angles_length_arrows4': {
    width: 560.25249,
    height: 316.32825
  },
  'Rectilinear_shapes_with_arrows/Rectilinear_shape10_2_red_arrows': {
    width: 863.61704,
    height: 361.97626
  },
  'Rectilinear_shapes_with_arrows/Rectilinear_shape10_all_arrows_all_interior_angles': {
    width: 623.86625,
    height: 431.22891
  },
  'Rectilinear_shapes_with_arrows/Rectilinear_shape10_all_arrows_all_interior_angles_blue': {
    width: 623.86625,
    height: 431.22891
  },
  'Rectilinear_shapes_with_arrows/Rectilinear_shape10_all_arrows_all_interior_angles_green': {
    width: 623.86625,
    height: 431.22891
  },
  'Rectilinear_shapes_with_arrows/Rectilinear_shape10_all_arrows_all_interior_angles_pink': {
    width: 623.86625,
    height: 431.22891
  },
  'Rectilinear_shapes_with_arrows/Rectilinear_shape10_all_arrows_all_interior_angles_purple': {
    width: 623.86625,
    height: 431.22891
  },
  'Rectilinear_shapes_with_arrows/Rectilinear_shape10_all_arrows_all_interior_angles_yellow': {
    width: 623.86625,
    height: 431.22891
  },
  'Rectilinear_shapes_with_arrows/Rectilinear_shape11_all_arrows_all_interior_angles': {
    width: 597.63383,
    height: 623.86627
  },
  'Rectilinear_shapes_with_arrows/Rectilinear_shape12_all_arrows_all_interior_angles': {
    width: 861.49357,
    height: 655.11908
  },
  'Rectilinear_shapes_with_arrows/Rectilinear_shape13_all_arrows_all_interior_angles': {
    width: 623.86595,
    height: 597.63385
  },
  'Rectilinear_shapes_with_arrows/Rectilinear_shape14_all_arrows_all_interior_angles': {
    width: 623.86625,
    height: 597.63385
  },
  'Rectilinear_shapes_with_arrows/Rectilinear_shape15_all_arrows_all_interior_angles': {
    width: 863.62504,
    height: 453.34705
  },
  'Rectilinear_shapes_with_arrows/Rectilinear_shape16_all_arrows_all_interior_angles': {
    width: 841.96647,
    height: 299.13345
  },
  'Rectilinear_shapes_with_arrows/Rectilinear_shape17_all_arrows_all_interior_angles': {
    width: 597.63408,
    height: 623.86609
  },
  'Rectilinear_shapes_with_arrows/Rectilinear_shape18_all_arrows_all_interior_angles': {
    width: 786.8574,
    height: 623.86652
  },
  'Rectilinear_shapes_with_arrows/Rectilinear_shape19_all_arrows_all_interior_angles': {
    width: 623.86625,
    height: 431.22919
  },
  'Rectilinear_shapes_with_arrows/Rectilinear_shape19_all_arrows_all_interior_angles_blue': {
    width: 623.86625,
    height: 431.22919
  },
  'Rectilinear_shapes_with_arrows/Rectilinear_shape19_all_arrows_all_interior_angles_green': {
    width: 623.86625,
    height: 431.22919
  },
  'Rectilinear_shapes_with_arrows/Rectilinear_shape19_all_arrows_all_interior_angles_pink': {
    width: 623.86625,
    height: 431.22919
  },
  'Rectilinear_shapes_with_arrows/Rectilinear_shape19_all_arrows_all_interior_angles_purple': {
    width: 623.86625,
    height: 431.22919
  },
  'Rectilinear_shapes_with_arrows/Rectilinear_shape19_all_arrows_all_interior_angles_yellow': {
    width: 623.86625,
    height: 431.22919
  },
  'Rectilinear_shapes_with_arrows/Rectilinear_shape1_2_red_arrows': {
    width: 843.34183,
    height: 623.86609
  },
  'Rectilinear_shapes_with_arrows/Rectilinear_shape1_all_arrows_all_interior_angles': {
    width: 843.34183,
    height: 623.86609
  },
  'Rectilinear_shapes_with_arrows/Rectilinear_shape20_all_arrows_all_interior_angles': {
    width: 623.86625,
    height: 786.8573
  },
  'Rectilinear_shapes_with_arrows/Rectilinear_shape21_all_arrows_all_interior_angles': {
    width: 623.86625,
    height: 431.22891
  },
  'Rectilinear_shapes_with_arrows/Rectilinear_shape21_all_arrows_all_interior_angles_blue': {
    width: 623.86625,
    height: 431.22891
  },
  'Rectilinear_shapes_with_arrows/Rectilinear_shape21_all_arrows_all_interior_angles_green': {
    width: 623.86625,
    height: 431.22891
  },
  'Rectilinear_shapes_with_arrows/Rectilinear_shape21_all_arrows_all_interior_angles_pink': {
    width: 623.86625,
    height: 431.22891
  },
  'Rectilinear_shapes_with_arrows/Rectilinear_shape21_all_arrows_all_interior_angles_purple': {
    width: 623.86625,
    height: 431.22891
  },
  'Rectilinear_shapes_with_arrows/Rectilinear_shape21_all_arrows_all_interior_angles_yellow': {
    width: 623.86625,
    height: 431.22891
  },
  'Rectilinear_shapes_with_arrows/Rectilinear_shape22_all_arrows_all_interior_angles': {
    width: 623.86625,
    height: 431.22891
  },
  'Rectilinear_shapes_with_arrows/Rectilinear_shape22_all_arrows_all_interior_angles_blue': {
    width: 623.86625,
    height: 431.22919
  },
  'Rectilinear_shapes_with_arrows/Rectilinear_shape22_all_arrows_all_interior_angles_green': {
    width: 623.86625,
    height: 431.22919
  },
  'Rectilinear_shapes_with_arrows/Rectilinear_shape22_all_arrows_all_interior_angles_pink': {
    width: 623.86625,
    height: 431.22919
  },
  'Rectilinear_shapes_with_arrows/Rectilinear_shape22_all_arrows_all_interior_angles_purple': {
    width: 623.86625,
    height: 431.22919
  },
  'Rectilinear_shapes_with_arrows/Rectilinear_shape22_all_arrows_all_interior_angles_yellow': {
    width: 623.86625,
    height: 431.22919
  },
  'Rectilinear_shapes_with_arrows/Rectilinear_shape2_2_red_arrows': {
    width: 830.37705,
    height: 709.00348
  },
  'Rectilinear_shapes_with_arrows/Rectilinear_shape2_all_arrows_all_interior_angles': {
    width: 830.37705,
    height: 709.00348
  },
  'Rectilinear_shapes_with_arrows/Rectilinear_shape3_2_red_arrows': {
    width: 842.00889,
    height: 389.11627
  },
  'Rectilinear_shapes_with_arrows/Rectilinear_shape3_all_arrows_all_interior_angles': {
    width: 861.49326,
    height: 655.11908
  },
  'Rectilinear_shapes_with_arrows/Rectilinear_shape4_2_red_arrows': {
    width: 843.3422,
    height: 623.86609
  },
  'Rectilinear_shapes_with_arrows/Rectilinear_shape4_all_arrows_all_interior_angles': {
    width: 861.49357,
    height: 655.11908
  },
  'Rectilinear_shapes_with_arrows/Rectilinear_shape5_2_red_arrows': {
    width: 665.07145,
    height: 669.67145
  },
  'Rectilinear_shapes_with_arrows/Rectilinear_shape5_all_arrows_all_interior_angles': {
    width: 842.00877,
    height: 389.11652
  },
  'Rectilinear_shapes_with_arrows/Rectilinear_shape6_2_red_arrows': {
    width: 842.00877,
    height: 623.86609
  },
  'Rectilinear_shapes_with_arrows/Rectilinear_shape6_all_arrows_all_interior_angles': {
    width: 843.34208,
    height: 623.86609
  },
  'Rectilinear_shapes_with_arrows/Rectilinear_shape7_2_red_arrows': {
    width: 431.22905,
    height: 623.86627
  },
  'Rectilinear_shapes_with_arrows/Rectilinear_shape7_all_arrows_all_interior_angles': {
    width: 665.07145,
    height: 669.67145
  },
  'Rectilinear_shapes_with_arrows/Rectilinear_shape8_2_red_arrows': {
    width: 861.49357,
    height: 655.11908
  },
  'Rectilinear_shapes_with_arrows/Rectilinear_shape8_all_arrows_all_interior_angles': {
    width: 842.00877,
    height: 623.86627
  },
  'Rectilinear_shapes_with_arrows/Rectilinear_shape9_2_red_arrows': {
    width: 863.62504,
    height: 453.34705
  },
  'Rectilinear_shapes_with_arrows/Rectilinear_shape9_all_arrows_all_interior_angles': {
    width: 431.22878,
    height: 623.86627
  },
  'Rectilinear_shapes_with_arrows/Square_angles_length_arrows': {
    width: 568.26518,
    height: 548.64893
  },
  Red_scissors: { width: 497.67077, height: 247.47461 },
  Refrigerator: { width: 217.99826, height: 413.33332 },
  'Rhombus/rhombus': { width: 371.22794, height: 328 },
  'Rhombus/rhombus_blue': { width: 371.22794, height: 328 },
  'Rhombus/rhombus_green': { width: 371.22794, height: 328 },
  'Rhombus/rhombus_orange': { width: 371.22794, height: 328 },
  'Rhombus/rhombus_pink': { width: 371.22794, height: 328 },
  'Rhombus/rhombus_purple': { width: 371.22794, height: 328 },
  'Rhombus/rhombus_red': { width: 371.22794, height: 328 },
  'Rhombus/rhombus_turquoise': { width: 371.22794, height: 328 },
  'Rhombus/rhombus_white': { width: 371.22794, height: 328 },
  'Rhombus/rhombus_yellow': { width: 371.22794, height: 328 },
  RibbonGreen: { width: 1689.4472, height: 88.862389 },
  RibbonGreenStriped: { width: 1211, height: 151 },
  RibbonRed: { width: 461, height: 144 },
  RibbonRedStriped: { width: 1211, height: 151 },
  'Ribbons/1-10': { width: 1210.4703, height: 205.74501 },
  'Ribbons/1-11': { width: 1210.4703, height: 206.0832 },
  'Ribbons/1-12': { width: 1210.4703, height: 205.74496 },
  'Ribbons/1-2': { width: 1210.4703, height: 205.7451 },
  'Ribbons/1-3': { width: 1210.4703, height: 205.74515 },
  'Ribbons/1-4': { width: 1210.4703, height: 205.74487 },
  'Ribbons/1-5': { width: 1210.4703, height: 205.74515 },
  'Ribbons/1-6': { width: 1210.4703, height: 205.74484 },
  'Ribbons/1-7': { width: 1210.4703, height: 205.74528 },
  'Ribbons/1-8': { width: 1210.4703, height: 205.74501 },
  'Ribbons/1-9': { width: 1210.4703, height: 205.74524 },
  'Ribbons/RibbonRed1-1': { width: 1689.4473, height: 88.862389 },
  'Ribbons/RibbonRed1-10': { width: 171.96987, height: 88.296158 },
  'Ribbons/RibbonRed1-11': { width: 156.15365, height: 87.34343 },
  'Ribbons/RibbonRed1-12': { width: 143.30829, height: 86.229721 },
  'Ribbons/RibbonRed1-2': { width: 848.29751, height: 88.862389 },
  'Ribbons/RibbonRed1-3': { width: 566.93831, height: 88.862389 },
  'Ribbons/RibbonRed1-4': { width: 426.32505, height: 88.862389 },
  'Ribbons/RibbonRed1-5': { width: 341.52226, height: 88.862389 },
  'Ribbons/RibbonRed1-6': { width: 284.58665, height: 88.862389 },
  'Ribbons/RibbonRed1-7': { width: 244.28103, height: 88.861687 },
  'Ribbons/RibbonRed1-8': { width: 213.83721, height: 88.860833 },
  'Ribbons/RibbonRed1-9': { width: 190.06205, height: 88.820946 },
  RiceAndBowls: { width: 546.87445, height: 209.62959 },
  'Right_angled_trapeziums/trapezium_RA': { width: 482.49249, height: 328 },
  'Right_angled_trapeziums/trapezium_RA_blue': { width: 482.49249, height: 328 },
  'Right_angled_trapeziums/trapezium_RA_blue_one_interior_angle_lhs': { width: 398, height: 271 },
  'Right_angled_trapeziums/trapezium_RA_blue_one_interior_angle_rhs': { width: 398, height: 271 },
  'Right_angled_trapeziums/trapezium_RA_green': { width: 482.49249, height: 328 },
  'Right_angled_trapeziums/trapezium_RA_green_one_interior_angle_lhs': { width: 398, height: 271 },
  'Right_angled_trapeziums/trapezium_RA_green_one_interior_angle_rhs': { width: 398, height: 271 },
  'Right_angled_trapeziums/trapezium_RA_orange': { width: 482.49249, height: 328 },
  'Right_angled_trapeziums/trapezium_RA_pink': { width: 482.49249, height: 328 },
  'Right_angled_trapeziums/trapezium_RA_pink_one_interior_angle_lhs': { width: 398, height: 271 },
  'Right_angled_trapeziums/trapezium_RA_pink_one_interior_angle_rhs': { width: 398, height: 271 },
  'Right_angled_trapeziums/trapezium_RA_purple': { width: 482.49249, height: 328 },
  'Right_angled_trapeziums/trapezium_RA_purple_one_interior_angle_lhs': { width: 398, height: 271 },
  'Right_angled_trapeziums/trapezium_RA_purple_one_interior_angle_rhs': { width: 398, height: 271 },
  'Right_angled_trapeziums/trapezium_RA_red': { width: 482.49249, height: 328 },
  'Right_angled_trapeziums/trapezium_RA_turquoise': { width: 482.49249, height: 328 },
  'Right_angled_trapeziums/trapezium_RA_white': { width: 482.49249, height: 328 },
  'Right_angled_trapeziums/trapezium_RA_white_one_interior_angle_lhs': { width: 398, height: 271 },
  'Right_angled_trapeziums/trapezium_RA_white_one_interior_angle_rhs': { width: 398, height: 271 },
  'Right_angled_trapeziums/trapezium_RA_yellow': { width: 482.49249, height: 328 },
  'Right_angled_trapeziums/trapezium_RA_yellow_one_interior_angle_lhs': { width: 398, height: 271 },
  'Right_angled_trapeziums/trapezium_RA_yellow_one_interior_angle_rhs': { width: 398, height: 271 },
  'Right_angled_triangles/triangle_RA': { width: 330.82843, height: 330.82843 },
  'Right_angled_triangles/triangle_RA_blue': { width: 330.82843, height: 330.82843 },
  'Right_angled_triangles/triangle_RA_green': { width: 330.82843, height: 330.82843 },
  'Right_angled_triangles/triangle_RA_green_one_interior_angle_lhs': { width: 331, height: 331 },
  'Right_angled_triangles/triangle_RA_green_one_interior_angle_rhs': { width: 331, height: 331 },
  'Right_angled_triangles/triangle_RA_long_blue': { width: 633.074, height: 330.82843 },
  'Right_angled_triangles/triangle_RA_long_blue_one_interior_angle_lhs': {
    width: 430,
    height: 225
  },
  'Right_angled_triangles/triangle_RA_long_blue_one_interior_angle_rhs': {
    width: 436,
    height: 227
  },
  'Right_angled_triangles/triangle_RA_long_green': { width: 633.074, height: 330.82843 },
  'Right_angled_triangles/triangle_RA_long_green_one_interior_angle_lhs': {
    width: 430,
    height: 225
  },
  'Right_angled_triangles/triangle_RA_long_green_one_interior_angle_rhs': {
    width: 436,
    height: 227
  },
  'Right_angled_triangles/triangle_RA_long_orange': { width: 633.074, height: 330.82843 },
  'Right_angled_triangles/triangle_RA_long_pink': { width: 633.074, height: 330.82843 },
  'Right_angled_triangles/triangle_RA_long_pink_one_interior_angle_lhs': {
    width: 430,
    height: 225
  },
  'Right_angled_triangles/triangle_RA_long_pink_one_interior_angle_rhs': {
    width: 436,
    height: 227
  },
  'Right_angled_triangles/triangle_RA_long_purple': { width: 633.074, height: 330.82843 },
  'Right_angled_triangles/triangle_RA_long_purple_one_interior_angle_lhs': {
    width: 430,
    height: 225
  },
  'Right_angled_triangles/triangle_RA_long_purple_one_interior_angle_rhs': {
    width: 436,
    height: 227
  },
  'Right_angled_triangles/triangle_RA_long_red': { width: 633.074, height: 330.82843 },
  'Right_angled_triangles/triangle_RA_long_turquoise': { width: 633.074, height: 330.82843 },
  'Right_angled_triangles/triangle_RA_long_white': { width: 633.074, height: 330.82843 },
  'Right_angled_triangles/triangle_RA_long_white_one_interior_angle_lhs': {
    width: 430,
    height: 225
  },
  'Right_angled_triangles/triangle_RA_long_white_one_interior_angle_rhs': {
    width: 436,
    height: 227
  },
  'Right_angled_triangles/triangle_RA_long_yellow': { width: 633.074, height: 330.82843 },
  'Right_angled_triangles/triangle_RA_long_yellow_one_interior_angle_lhs': {
    width: 430,
    height: 225
  },
  'Right_angled_triangles/triangle_RA_long_yellow_one_interior_angle_rhs': {
    width: 436,
    height: 227
  },
  'Right_angled_triangles/triangle_RA_orange': { width: 330.82843, height: 330.82843 },
  'Right_angled_triangles/triangle_RA_pink': { width: 330.82843, height: 330.82843 },
  'Right_angled_triangles/triangle_RA_pink_one_interior_angle_lhs': { width: 331, height: 331 },
  'Right_angled_triangles/triangle_RA_pink_one_interior_angle_rhs': { width: 331, height: 331 },
  'Right_angled_triangles/triangle_RA_purple': { width: 330.82843, height: 330.82843 },
  'Right_angled_triangles/triangle_RA_purple_one_interior_angle_lhs': { width: 331, height: 331 },
  'Right_angled_triangles/triangle_RA_purple_one_interior_angle_rhs': { width: 331, height: 331 },
  'Right_angled_triangles/triangle_RA_red': { width: 330.82843, height: 330.82843 },
  'Right_angled_triangles/triangle_RA_turquoise': { width: 330.82843, height: 330.82843 },
  'Right_angled_triangles/triangle_RA_white': { width: 330.82843, height: 330.82843 },
  'Right_angled_triangles/triangle_RA_white_one_interior_angle_lhs': { width: 331, height: 331 },
  'Right_angled_triangles/triangle_RA_white_one_interior_angle_rhs': { width: 331, height: 331 },
  'Right_angled_triangles/triangle_RA_yellow': { width: 330.82843, height: 330.82843 },
  'Right_angled_triangles/triangle_RA_yellow_one_interior_angle_lhs': { width: 331, height: 331 },
  'Right_angled_triangles/triangle_RA_yellow_one_interior_angle_rhs': { width: 331, height: 331 },
  Roller_coaster_ad_duration: { width: 319.01446, height: 390.17798 },
  'Rounded_rectangles/Rounded_rectangle_blue': { width: 577.33331, height: 328 },
  'Rounded_rectangles/Rounded_rectangle_green': { width: 577.33331, height: 328 },
  'Rounded_rectangles/Rounded_rectangle_orange': { width: 577.33331, height: 328 },
  'Rounded_rectangles/Rounded_rectangle_pink': { width: 577.33331, height: 328 },
  'Rounded_rectangles/Rounded_rectangle_purple': { width: 577.33331, height: 328 },
  'Rounded_rectangles/Rounded_rectangle_red': { width: 577.33331, height: 328 },
  'Rounded_rectangles/Rounded_rectangle_turquoise': { width: 577.33331, height: 328 },
  'Rounded_rectangles/Rounded_rectangle_yellow': { width: 577.33331, height: 328 },
  'Rounded_squares/Rounded_square_blue': { width: 328.01498, height: 328.01498 },
  'Rounded_squares/Rounded_square_green': { width: 328.01498, height: 328.01498 },
  'Rounded_squares/Rounded_square_orange': { width: 328.01498, height: 328.01498 },
  'Rounded_squares/Rounded_square_pink': { width: 328.01498, height: 328.01498 },
  'Rounded_squares/Rounded_square_purple': { width: 328.01498, height: 328.01498 },
  'Rounded_squares/Rounded_square_red': { width: 328.01498, height: 328.01498 },
  'Rounded_squares/Rounded_square_turquoise': { width: 328.01498, height: 328.01498 },
  'Rounded_squares/Rounded_square_yellow': { width: 328.01498, height: 328.01498 },
  Rubber: { width: 535.06884, height: 156.60967 },
  Rubbish_bin: { width: 296.224, height: 427.31371 },
  Rucksack: { width: 207.08728, height: 250.56845 },
  Rucksack_green: { width: 337.65903, height: 257.48825 },
  Rucksack_purple: { width: 337.65903, height: 257.48825 },
  Rucksack_red: { width: 337.65903, height: 257.48825 },
  Sand_bag: { width: 299.74219, height: 364.62903 },
  'Scalene_triangles/triangle_scalene': { width: 446.37164, height: 330.20886 },
  'Scalene_triangles/triangle_scalene_blue': { width: 446.37164, height: 330.20886 },
  'Scalene_triangles/triangle_scalene_blue_one_interior_angle_lhs': { width: 447, height: 331 },
  'Scalene_triangles/triangle_scalene_blue_one_interior_angle_rhs': { width: 447, height: 331 },
  'Scalene_triangles/triangle_scalene_green': { width: 446.37164, height: 330.20886 },
  'Scalene_triangles/triangle_scalene_green_one_interior_angle_lhs': { width: 447, height: 331 },
  'Scalene_triangles/triangle_scalene_green_one_interior_angle_rhs': { width: 447, height: 331 },
  'Scalene_triangles/triangle_scalene_orange': { width: 446.37164, height: 330.20886 },
  'Scalene_triangles/triangle_scalene_pink': { width: 446.37164, height: 330.20886 },
  'Scalene_triangles/triangle_scalene_pink_one_interior_angle_lhs': { width: 447, height: 331 },
  'Scalene_triangles/triangle_scalene_pink_one_interior_angle_rhs': { width: 447, height: 331 },
  'Scalene_triangles/triangle_scalene_purple': { width: 446.37164, height: 330.20886 },
  'Scalene_triangles/triangle_scalene_purple_one_interior_angle_lhs': { width: 447, height: 331 },
  'Scalene_triangles/triangle_scalene_purple_one_interior_angle_rhs': { width: 447, height: 331 },
  'Scalene_triangles/triangle_scalene_red': { width: 446.37164, height: 330.20886 },
  'Scalene_triangles/triangle_scalene_turquoise': { width: 446.37164, height: 330.20886 },
  'Scalene_triangles/triangle_scalene_white': { width: 446.37164, height: 330.20886 },
  'Scalene_triangles/triangle_scalene_white_one_interior_angle_lhs': { width: 447, height: 331 },
  'Scalene_triangles/triangle_scalene_white_one_interior_angle_rhs': { width: 447, height: 331 },
  'Scalene_triangles/triangle_scalene_yellow': { width: 446.37164, height: 330.20886 },
  'Scalene_triangles/triangle_scalene_yellow_one_interior_angle_lhs': { width: 447, height: 331 },
  'Scalene_triangles/triangle_scalene_yellow_one_interior_angle_rhs': { width: 447, height: 331 },
  'Scales/1000g_scale_100g': { width: 298.10266, height: 340.586 },
  'Scales/1000g_scale_200g': { width: 298.10266, height: 340.586 },
  'Scales/1000g_scale_20g_100g': { width: 298.10266, height: 340.586 },
  'Scales/1000g_scale_250g': { width: 298.10266, height: 340.586 },
  'Scales/1000g_scale_25g_100g': { width: 298.10266, height: 340.586 },
  'Scales/1000g_scale_50g_100g': { width: 298.103, height: 340.586 },
  'Scales/1000g_scale_50g_200g': { width: 298.10266, height: 340.586 },
  'Scales/100g_scale_10g': { width: 297.58398, height: 340.01599 },
  'Scales/100g_scale_20g': { width: 297.58398, height: 340.01599 },
  'Scales/1_kg_scale_100g': { width: 297.57599, height: 340.008 },
  'Scales/1_kg_scale_200_g': { width: 298, height: 340 },
  'Scales/1_kg_scale_250_g': { width: 297.57599, height: 340.008 },
  'Scales/1_kg_scale_500_g': { width: 297.57599, height: 340.008 },
  'Scales/1_kg_scale_50g': { width: 297.57599, height: 340.008 },
  'Scales/200g_scale_100g': { width: 298.97332, height: 341.539 },
  'Scales/200g_scale_10g': { width: 298.97332, height: 341.539 },
  'Scales/200g_scale_20g': { width: 296.97298, height: 341.539 },
  'Scales/3_kg_scale_100_g': { width: 298.35299, height: 338.76401 },
  'Scales/3_kg_scale_200_g': { width: 297.35333, height: 339.76401 },
  'Scales/3_kg_scale_250_g': { width: 297.35333, height: 339.76401 },
  'Scales/3_kg_scale_500_g': { width: 297.35333, height: 339.76401 },
  'Scales/4_kg_scale_100_g': { width: 298.561, height: 340.224 },
  'Scales/4_kg_scale_200_g': { width: 299, height: 341 },
  'Scales/4_kg_scale_250_g': { width: 296.86133, height: 339.22401 },
  'Scales/4_kg_scale_500_g': { width: 296.86133, height: 339.22401 },
  'Scales/500g_scale_10g': { width: 300.07733, height: 342.75101 },
  'Scales/500g_scale_20g': { width: 300.07733, height: 342.75101 },
  'Scales/500g_scale_25g': { width: 300.07733, height: 342.75101 },
  'Scales/5_kg_scale_100_g': { width: 297.19467, height: 339.59 },
  'Scales/5_kg_scale_200_g': { width: 297.19467, height: 339.59 },
  'Scales/5_kg_scale_250_g': { width: 296.67334, height: 339.01701 },
  'Scales/5_kg_scale_500_g': { width: 296.67334, height: 339.01701 },
  'Scales/6_kg_scale_200_g': { width: 297.65332, height: 340.09202 },
  'Scales/6_kg_scale_250_g': { width: 297.35333, height: 339.763 },
  'Scales/6_kg_scale_500_g': { width: 297.35333, height: 339.763 },
  'Scales/Various_kg_scale_10kg': { width: 296.67334, height: 339.017 },
  'Scales/Various_kg_scale_4kg': { width: 296.86133, height: 339.224 },
  'Scales/Various_kg_scale_5kg': { width: 296.67334, height: 339.017 },
  'Scales/Various_kg_scale_6kg': { width: 297.65332, height: 340.09202 },
  'Scales/Various_kg_scale_7kg': { width: 296.67334, height: 339.017 },
  'Scales/Various_kg_scale_8kg': { width: 296.86133, height: 339.224 },
  'Scales/Various_kg_scale_9kg': { width: 297.65332, height: 340.09202 },
  'Scales/arrow': { width: 281.13699, height: 281.13699 },
  'Scales/blank_scale': { width: 296.86133, height: 339.224 },
  'Scales/kg_scale_2': { width: 270, height: 310 },
  'Scales/kg_scale_3': { width: 270, height: 310 },
  'Scales/kg_scale_4': { width: 270, height: 310 },
  'Scales/wooden_balance_scale_equal': { width: 530.52667, height: 110.3564 },
  'Scales/wooden_balance_scale_left': { width: 510.03189, height: 191.86114 },
  'Scales/wooden_balance_scale_right': { width: 510.03189, height: 191.5778 },
  Scooter: { width: 288.29907, height: 462.35824 },
  'Semicircles/circle_semi': { width: 164.66666, height: 329.35217 },
  'Semicircles/circle_semi_blue': { width: 164.66666, height: 329.35217 },
  'Semicircles/circle_semi_green': { width: 164.66666, height: 329.35217 },
  'Semicircles/circle_semi_orange': { width: 164.66666, height: 329.35217 },
  'Semicircles/circle_semi_pink': { width: 164.66666, height: 329.35217 },
  'Semicircles/circle_semi_purple': { width: 164.66666, height: 329.35217 },
  'Semicircles/circle_semi_red': { width: 164.66666, height: 329.35217 },
  'Semicircles/circle_semi_turquoise': { width: 164.66666, height: 329.35217 },
  'Semicircles/circle_semi_white': { width: 164.66666, height: 329.35217 },
  'Semicircles/circle_semi_yellow': { width: 164.66666, height: 329.35217 },
  'Shape_formulae/1_circle_2_triangles': { width: 154.02133, height: 330.89499 },
  'Shape_formulae/1_circle_4_squares': { width: 323.23999, height: 323.23999 },
  'Shape_formulae/1_square_2_circles': { width: 143.01066, height: 320.55972 },
  'Shape_formulae/1_square_4_triangles': { width: 337.97363, height: 337.97363 },
  'Shape_formulae/1_star_2_circles': { width: 255.14494, height: 244.45886 },
  'Shape_formulae/1_triangle_3_circles': { width: 244.47279, height: 244.17039 },
  'Shape_formulae/1_triangle_3_squares': { width: 274.27548, height: 262.61258 },
  'Shape_nets/Cone_net': { width: 549.59721, height: 557.07111 },
  'Shape_nets/Cone_net_noFill': { width: 549.6, height: 557.07 },
  'Shape_nets/Cone_net_without_tabs': { width: 549.59721, height: 511.08435 },
  'Shape_nets/Cube_net': { width: 803.93949, height: 641.51062 },
  'Shape_nets/Cube_net_noFill': { width: 803.94, height: 641.5 },
  'Shape_nets/Cuboid_net': { width: 803.93943, height: 896.64905 },
  'Shape_nets/Cuboid_net_noFill': { width: 803.94, height: 896.65 },
  'Shape_nets/Cuboid_net_without_tabs': { width: 966.36795, height: 773.49493 },
  'Shape_nets/Cylinder_net': { width: 803.94065, height: 637.71979 },
  'Shape_nets/Cylinder_net_noFill': { width: 805.91, height: 639.7 },
  'Shape_nets/Cylinder_net_without_tabs': { width: 722.0391, height: 592.66797 },
  'Shape_nets/Hexagonal_prism_net': { width: 717.2537, height: 737.56262 },
  'Shape_nets/Hexagonal_prism_net_noFill': { width: 719.24, height: 739.55 },
  'Shape_nets/Hexagonal_prism_net_without_tabs': { width: 517.31859, height: 729.52905 },
  'Shape_nets/Hexagonal_pyramid_net_without_tabs': { width: 601.2849, height: 693.99414 },
  'Shape_nets/Octagonal_prism_net_without_tabs': { width: 966.3693, height: 768.41223 },
  'Shape_nets/Octagonal_pyramid_net_without_tabs': { width: 608.46861, height: 608.46997 },
  'Shape_nets/Pentagonal_prism_net': { width: 601.10063, height: 726.60901 },
  'Shape_nets/Pentagonal_prism_net_noFill': { width: 603.09, height: 728.6 },
  'Shape_nets/Pentagonal_prism_net_without_tab': { width: 704.04393, height: 618.16821 },
  'Shape_nets/Pentagonal_pyramid_net_without_tabs': { width: 547.27953, height: 520.59161 },
  'Shape_nets/Square-based_pyramid_net_without_tabs': { width: 580.62028, height: 580.6203 },
  'Shape_nets/Squared_based_pyramid_net': { width: 586.70451, height: 586.70453 },
  'Shape_nets/Squared_based_pyramid_net_noFill': { width: 588.68, height: 588.68 },
  'Shape_nets/Tatrahedron_net_without_tabs': { width: 449.34395, height: 389.4111 },
  'Shape_nets/Tetrahedron_net': { width: 469.27831, height: 423.93759 },
  'Shape_nets/Tetrahedron_net_noFill': { width: 471.27, height: 425.94 },
  'Shape_nets/Triangular_prism_net': { width: 1159.2418, height: 611.0661 },
  'Shape_nets/Triangular_prism_net_noFill': { width: 1161.2, height: 613.05 },
  'Shape_nets/Triangular_prism_net_without_tabs': { width: 420.19918, height: 566.45679 },
  'Shape_nets/correctnetsofcubes1': { width: 391.85598, height: 521.58533 },
  'Shape_nets/correctnetsofcubes10': { width: 391.85598, height: 521.58533 },
  'Shape_nets/correctnetsofcubes11': { width: 262.12533, height: 651.31464 },
  'Shape_nets/correctnetsofcubes2': { width: 391.85598, height: 521.58533 },
  'Shape_nets/correctnetsofcubes3': { width: 391.85598, height: 521.58533 },
  'Shape_nets/correctnetsofcubes4': { width: 391.85598, height: 521.58533 },
  'Shape_nets/correctnetsofcubes5': { width: 391.85598, height: 521.58533 },
  'Shape_nets/correctnetsofcubes6': { width: 391.85598, height: 521.58533 },
  'Shape_nets/correctnetsofcubes7': { width: 391.85598, height: 521.58533 },
  'Shape_nets/correctnetsofcubes8': { width: 391.85598, height: 521.58533 },
  'Shape_nets/correctnetsofcubes9': { width: 391.85598, height: 521.58533 },
  'Shape_nets/incorrectnetsofcubes1': { width: 521.58531, height: 262.12534 },
  'Shape_nets/incorrectnetsofcubes2': { width: 521.58531, height: 262.12534 },
  'Shape_nets/incorrectnetsofcubes3': { width: 262.12585, height: 521.58521 },
  'Shape_nets/incorrectnetsofcubes4': { width: 651.31492, height: 262.12585 },
  'Shape_patterns/Linked_hexagons/3_blue_orange_hexagon_pattern': { width: 1047, height: 545 },
  'Shape_patterns/Linked_hexagons/3_green_yellow_hexagon_pattern': { width: 1047, height: 545 },
  'Shape_patterns/Linked_hexagons/3_red_blue_hexagon_pattern': { width: 1047, height: 545 },
  'Shape_patterns/Linked_hexagons/4_blue_orange_hexagon_pattern': { width: 1359, height: 545 },
  'Shape_patterns/Linked_hexagons/4_green_yellow_hexagon_pattern': { width: 1359, height: 545 },
  'Shape_patterns/Linked_hexagons/4_red_blue_hexagon_pattern': { width: 1359, height: 545 },
  'Shape_patterns/Linked_hexagons/5_blue_orange_hexagon_pattern': { width: 1672, height: 545 },
  'Shape_patterns/Linked_hexagons/5_green_yellow_hexagon_pattern': { width: 1672, height: 545 },
  'Shape_patterns/Linked_hexagons/5_red_blue_hexagon_pattern': { width: 1672, height: 545 },
  'Shape_patterns/Linked_hexagons/6_blue_orange_hexagon_pattern': { width: 1984, height: 547 },
  'Shape_patterns/Linked_hexagons/6_green_yellow_hexagon_pattern': { width: 1984, height: 547 },
  'Shape_patterns/Linked_hexagons/6_red_blue_hexagon_pattern': { width: 1984, height: 547 },
  'Shape_patterns/Linked_octagons/3_blue_orange_octagon_pattern': { width: 1011, height: 716 },
  'Shape_patterns/Linked_octagons/3_green_yellow_octagon_pattern': { width: 1011, height: 716 },
  'Shape_patterns/Linked_octagons/3_red_blue_octagon_pattern': { width: 1011, height: 716 },
  'Shape_patterns/Linked_octagons/4_blue_orange_octagon_pattern': { width: 1305, height: 717 },
  'Shape_patterns/Linked_octagons/4_green_yellow_octagon_pattern': { width: 1305, height: 717 },
  'Shape_patterns/Linked_octagons/4_red_blue_octagon_pattern': { width: 1305, height: 717 },
  'Shape_patterns/Linked_octagons/5_blue_orange_octagon_pattern': { width: 1601, height: 717 },
  'Shape_patterns/Linked_octagons/5_green_yellow_octagon_pattern': { width: 1601, height: 717 },
  'Shape_patterns/Linked_octagons/5_red_blue_octagon_pattern': { width: 1601, height: 717 },
  'Shape_patterns/Linked_octagons/6_blue_orange_octagon_pattern': { width: 1896, height: 717 },
  'Shape_patterns/Linked_octagons/6_green_yellow_octagon_pattern': { width: 1896, height: 717 },
  'Shape_patterns/Linked_octagons/6_red_blue_octagon_pattern': { width: 1896, height: 717 },
  'Shapes_made_from_cubes/Cube_cubes1': { width: 286.33666, height: 275.93918 },
  'Shapes_made_from_cubes/Cuboid_cubes10': { width: 1278.8748, height: 242.1252 },
  'Shapes_made_from_cubes/Cuboid_cubes11': { width: 1278.8748, height: 345.28012 },
  'Shapes_made_from_cubes/Cuboid_cubes12': { width: 1072.5647, height: 448.43506 },
  'Shapes_made_from_cubes/Cuboid_cubes13': { width: 1278.8748, height: 138.96933 },
  'Shapes_made_from_cubes/Cuboid_cubes2': { width: 453.63372, height: 138.96933 },
  'Shapes_made_from_cubes/Cuboid_cubes3': { width: 453.63372, height: 242.1252 },
  'Shapes_made_from_cubes/Cuboid_cubes4': { width: 659.94407, height: 138.96933 },
  'Shapes_made_from_cubes/Cuboid_cubes5': { width: 659.94407, height: 242.1252 },
  'Shapes_made_from_cubes/Cuboid_cubes6': { width: 866.25437, height: 138.96933 },
  'Shapes_made_from_cubes/Cuboid_cubes7': { width: 866.25437, height: 242.1252 },
  'Shapes_made_from_cubes/Cuboid_cubes8': { width: 1072.5647, height: 138.96933 },
  'Shapes_made_from_cubes/Cuboid_cubes9': { width: 1072.5647, height: 242.1252 },
  'Shapes_made_from_cubes/othershapescube1': { width: 350.47851, height: 242.1252 },
  'Shapes_made_from_cubes/othershapescube10': { width: 350.47851, height: 345.28012 },
  'Shapes_made_from_cubes/othershapescube11': { width: 350.47851, height: 448.43506 },
  'Shapes_made_from_cubes/othershapescube12': { width: 556.78917, height: 242.1252 },
  'Shapes_made_from_cubes/othershapescube13': { width: 1072.5647, height: 138.96933 },
  'Shapes_made_from_cubes/othershapescube14': { width: 556.78917, height: 655.01904 },
  'Shapes_made_from_cubes/othershapescube15': { width: 247.32333, height: 551.58984 },
  'Shapes_made_from_cubes/othershapescube16': { width: 556.78917, height: 448.43506 },
  'Shapes_made_from_cubes/othershapescube17': { width: 453.63372, height: 757.90027 },
  'Shapes_made_from_cubes/othershapescube18': { width: 763.09916, height: 448.43506 },
  'Shapes_made_from_cubes/othershapescube19': { width: 247.32333, height: 861.05597 },
  'Shapes_made_from_cubes/othershapescube2': { width: 144.16839, height: 448.43506 },
  'Shapes_made_from_cubes/othershapescube20': { width: 763.09916, height: 242.1252 },
  'Shapes_made_from_cubes/othershapescube3': { width: 350.47851, height: 242.1252 },
  'Shapes_made_from_cubes/othershapescube4': { width: 350.47851, height: 242.1252 },
  'Shapes_made_from_cubes/othershapescube5': { width: 453.63372, height: 345.28012 },
  'Shapes_made_from_cubes/othershapescube6': { width: 350.47851, height: 345.28012 },
  'Shapes_made_from_cubes/othershapescube7': { width: 247.32333, height: 551.58984 },
  'Shapes_made_from_cubes/othershapescube8': { width: 556.78917, height: 242.1252 },
  'Shapes_made_from_cubes/othershapescube9': { width: 866.25437, height: 138.96933 },
  'Shapes_on_grids/Compound_shape10_grid': { width: 836.1099, height: 785.91693 },
  'Shapes_on_grids/Compound_shape11_grid': { width: 837.28208, height: 785.91693 },
  'Shapes_on_grids/Compound_shape12_grid': { width: 837.28208, height: 785.91693 },
  'Shapes_on_grids/Compound_shape13_grid': { width: 837.28208, height: 785.91693 },
  'Shapes_on_grids/Compound_shape14_grid': { width: 837.28208, height: 785.91693 },
  'Shapes_on_grids/Compound_shape15_grid': { width: 837.28208, height: 785.91693 },
  'Shapes_on_grids/Compound_shape16_grid': { width: 837.28208, height: 785.91693 },
  'Shapes_on_grids/Compound_shape1_grid': { width: 838.1099, height: 785.91693 },
  'Shapes_on_grids/Compound_shape2_grid': { width: 838.1099, height: 785.91693 },
  'Shapes_on_grids/Compound_shape3_grid': { width: 842.1099, height: 785.91693 },
  'Shapes_on_grids/Compound_shape4_grid': { width: 840.1099, height: 785.91693 },
  'Shapes_on_grids/Compound_shape5_grid': { width: 838.57529, height: 785.91693 },
  'Shapes_on_grids/Compound_shape6_grid': { width: 836.1099, height: 785.91693 },
  'Shapes_on_grids/Compound_shape7_grid': { width: 836.1099, height: 785.91693 },
  'Shapes_on_grids/Compound_shape8_grid': { width: 838.1099, height: 785.91693 },
  'Shapes_on_grids/Compound_shape9_grid': { width: 836.1099, height: 785.91693 },
  'Shapes_on_grids/Curved_shape1': { width: 1185.8714, height: 867.94598 },
  'Shapes_on_grids/Curved_shape2': { width: 1187.8714, height: 867.94598 },
  'Shapes_on_grids/Curved_shape3': { width: 1189.8714, height: 867.94598 },
  'Shapes_on_grids/Curved_shape4': { width: 1187.8714, height: 867.94598 },
  'Shapes_on_grids/Curved_shape5': { width: 1193.8714, height: 867.94598 },
  'Shapes_on_grids/Curved_shape6': { width: 1193.8714, height: 867.94598 },
  'Shapes_on_grids/Curved_shape7': { width: 1189.8714, height: 867.94598 },
  'Shapes_on_grids/Curved_shape8': { width: 1193.8714, height: 867.94598 },
  'Shapes_on_grids/Equilateral_triangle1_grid': { width: 1152.3704, height: 866.52802 },
  'Shapes_on_grids/Equilateral_triangle2_grid': { width: 1150.0368, height: 866.52802 },
  'Shapes_on_grids/Equilateral_triangle3_grid': { width: 1150.0368, height: 866.52802 },
  'Shapes_on_grids/Equilateral_triangle4_grid': { width: 1150.0368, height: 866.52802 },
  'Shapes_on_grids/Island_shape_a1': { width: 1149.7848, height: 872.26501 },
  'Shapes_on_grids/Island_shape_a2': { width: 1149.7848, height: 872.26501 },
  'Shapes_on_grids/Island_shape_a3': { width: 1149.7848, height: 872.26501 },
  'Shapes_on_grids/Island_shape_a4': { width: 1149.7848, height: 872.26501 },
  'Shapes_on_grids/Island_shape_a5': { width: 1149.7848, height: 872.26501 },
  'Shapes_on_grids/Island_shape_a6': { width: 1149.7848, height: 872.26501 },
  'Shapes_on_grids/Island_shape_b1': { width: 1149.7848, height: 872.26501 },
  'Shapes_on_grids/Island_shape_b2': { width: 1149.7848, height: 872.26501 },
  'Shapes_on_grids/Island_shape_b3': { width: 1149.7848, height: 872.26501 },
  'Shapes_on_grids/Island_shape_b4': { width: 1149.7848, height: 872.26501 },
  'Shapes_on_grids/Island_shape_b5': { width: 1149.7848, height: 872.26501 },
  'Shapes_on_grids/Island_shape_b6': { width: 1149.7848, height: 872.26501 },
  'Shapes_on_grids/Isosceles_triangle1_grid': { width: 1148.5641, height: 866.52869 },
  'Shapes_on_grids/Isosceles_triangle2_grid': { width: 1148.5641, height: 866.52802 },
  'Shapes_on_grids/Isosceles_triangle3_grid': { width: 1148.5641, height: 866.52802 },
  'Shapes_on_grids/Isosceles_triangle4_grid': { width: 1148.5641, height: 866.52802 },
  'Shapes_on_grids/Isosceles_triangle5_grid': { width: 1148.5641, height: 866.52802 },
  'Shapes_on_grids/Isosceles_triangle6_grid': { width: 1148.5641, height: 866.52802 },
  'Shapes_on_grids/Leaf1_ongrid': { width: 1193.8714, height: 867.94598 },
  'Shapes_on_grids/Leaf2_ongrid': { width: 1193.8714, height: 867.94598 },
  'Shapes_on_grids/Leaf3_ongrid': { width: 1193.8714, height: 867.94598 },
  'Shapes_on_grids/Leaf4_ongrid': { width: 1193.8714, height: 867.94598 },
  'Shapes_on_grids/Leaf5_ongrid': { width: 1193.8714, height: 867.94598 },
  'Shapes_on_grids/Leaf6_ongrid': { width: 1193.8714, height: 867.94598 },
  'Shapes_on_grids/Leaf7_ongrid': { width: 1193.8714, height: 868.10626 },
  'Shapes_on_grids/Leaf8_ongrid': { width: 1193.8714, height: 867.94598 },
  'Shapes_on_grids/Opaque_rectangle1_grid': { width: 919.54697, height: 466.80707 },
  'Shapes_on_grids/Opaque_rectangle2_grid': { width: 919.54697, height: 466.80707 },
  'Shapes_on_grids/Opaque_rectangle3_grid': { width: 919.54697, height: 466.80707 },
  'Shapes_on_grids/Opaque_rectangle4_grid': { width: 919.54697, height: 466.80707 },
  'Shapes_on_grids/Opaque_rectangle5_grid': { width: 919.54697, height: 466.80707 },
  'Shapes_on_grids/Opaque_rectangle6_grid': { width: 919.54697, height: 466.80707 },
  'Shapes_on_grids/Opaque_rectangle7_grid': { width: 919.54697, height: 466.80707 },
  'Shapes_on_grids/Opaque_rectangle8_grid': { width: 919.54697, height: 466.80707 },
  'Shapes_on_grids/Parallelogram10_grid': { width: 1632.3211, height: 822.89081 },
  'Shapes_on_grids/Parallelogram11_grid': { width: 1632.3211, height: 822.89081 },
  'Shapes_on_grids/Parallelogram12_grid': { width: 1632.3211, height: 822.89081 },
  'Shapes_on_grids/Parallelogram13_grid': { width: 1632.3211, height: 822.89081 },
  'Shapes_on_grids/Parallelogram14_grid': { width: 1632.3211, height: 822.89081 },
  'Shapes_on_grids/Parallelogram15_grid': { width: 1632.3211, height: 822.89081 },
  'Shapes_on_grids/Parallelogram16_grid': { width: 1632.3211, height: 822.89081 },
  'Shapes_on_grids/Parallelogram17_grid': { width: 1632.3211, height: 822.89081 },
  'Shapes_on_grids/Parallelogram18_grid': { width: 1632.3211, height: 822.89081 },
  'Shapes_on_grids/Parallelogram19_grid': { width: 1632.3211, height: 822.89081 },
  'Shapes_on_grids/Parallelogram1_grid': { width: 1632.2212, height: 822.89081 },
  'Shapes_on_grids/Parallelogram20_grid': { width: 1632.3212, height: 822.8908 },
  'Shapes_on_grids/Parallelogram2_grid': { width: 1632.3211, height: 822.89081 },
  'Shapes_on_grids/Parallelogram3_grid': { width: 1632.3211, height: 822.89081 },
  'Shapes_on_grids/Parallelogram4_grid': { width: 1632.3211, height: 822.89081 },
  'Shapes_on_grids/Parallelogram5_grid': { width: 1632.3211, height: 822.89081 },
  'Shapes_on_grids/Parallelogram6_grid': { width: 1632.3211, height: 822.89081 },
  'Shapes_on_grids/Parallelogram7_grid': { width: 1632.3211, height: 822.89081 },
  'Shapes_on_grids/Parallelogram8_grid': { width: 1632.3211, height: 822.89081 },
  'Shapes_on_grids/Parallelogram9_grid': { width: 1632.3211, height: 822.89081 },
  'Shapes_on_grids/Right_angle_triangle1_grid': { width: 1146.5641, height: 866.52802 },
  'Shapes_on_grids/Right_angle_triangle2_grid': { width: 1146.5641, height: 866.52802 },
  'Shapes_on_grids/Right_angle_triangle3_grid': { width: 1146.5641, height: 866.52802 },
  'Shapes_on_grids/Right_angle_triangle4_grid': { width: 1146.5641, height: 866.52826 },
  'Shapes_on_grids/Right_angle_triangle5_grid': { width: 1146.5641, height: 866.52802 },
  'Shapes_on_grids/Right_angle_triangle6_grid': { width: 1146.5641, height: 866.52802 },
  'Shapes_on_grids/Scalene_triangle1_grid': { width: 1146.5641, height: 866.52802 },
  'Shapes_on_grids/Scalene_triangle2_grid': { width: 1146.5641, height: 866.52802 },
  'Shapes_on_grids/Scalene_triangle3_grid': { width: 1146.5641, height: 866.52802 },
  'Shapes_on_grids/Scalene_triangle4_grid': { width: 1146.5641, height: 866.52802 },
  'Shapes_on_grids/Scalene_triangle5_grid': { width: 1146.5641, height: 866.52802 },
  'Shapes_on_grids/Scalene_triangle6_grid': { width: 1146.5641, height: 866.52802 },
  'Shapes_on_grids/Translucent_rectiliear_shape10_grid': { width: 919.32975, height: 866.22278 },
  'Shapes_on_grids/Translucent_rectiliear_shape10_grid_missing_labelA': {
    width: 918.90479,
    height: 866.22266
  },
  'Shapes_on_grids/Translucent_rectiliear_shape10_grid_missing_labelB': {
    width: 919.38525,
    height: 866.22266
  },
  'Shapes_on_grids/Translucent_rectiliear_shape10_grid_missing_labelC': { width: 869, height: 867 },
  'Shapes_on_grids/Translucent_rectiliear_shape10_grid_missing_labelD': {
    width: 918.65118,
    height: 866.22266
  },
  'Shapes_on_grids/Translucent_rectiliear_shape10_grid_missing_labelE': {
    width: 919.49792,
    height: 866.22266
  },
  'Shapes_on_grids/Translucent_rectiliear_shape10_grid_missing_labelF': {
    width: 917.8504,
    height: 866.22266
  },
  'Shapes_on_grids/Translucent_rectiliear_shape10_grid_missing_labelG': {
    width: 919.05316,
    height: 866.22266
  },
  'Shapes_on_grids/Translucent_rectiliear_shape10_grid_missing_labelH': {
    width: 919.09265,
    height: 866.22266
  },
  'Shapes_on_grids/Translucent_rectiliear_shape10_grid_nolabels': { width: 919.33, height: 866.22 },
  'Shapes_on_grids/Translucent_rectiliear_shape11_grid': { width: 919.54709, height: 866.00549 },
  'Shapes_on_grids/Translucent_rectiliear_shape11_grid_missing_labelA': {
    width: 917.5462,
    height: 866.005
  },
  'Shapes_on_grids/Translucent_rectiliear_shape11_grid_missing_labelB': {
    width: 918.95648,
    height: 866.005
  },
  'Shapes_on_grids/Translucent_rectiliear_shape11_grid_missing_labelC': {
    width: 916.48175,
    height: 866.005
  },
  'Shapes_on_grids/Translucent_rectiliear_shape11_grid_missing_labelD': {
    width: 917.89777,
    height: 866.005
  },
  'Shapes_on_grids/Translucent_rectiliear_shape11_grid_missing_labelE': {
    width: 917.38934,
    height: 866.005
  },
  'Shapes_on_grids/Translucent_rectiliear_shape11_grid_missing_labelF': {
    width: 917.60962,
    height: 866.005
  },
  'Shapes_on_grids/Translucent_rectiliear_shape11_grid_missing_labelG': {
    width: 917.38971,
    height: 866.005
  },
  'Shapes_on_grids/Translucent_rectiliear_shape11_grid_missing_labelH': {
    width: 918.17419,
    height: 866.005
  },
  'Shapes_on_grids/Translucent_rectiliear_shape11_grid_nolabels': { width: 919.55, height: 866.01 },
  'Shapes_on_grids/Translucent_rectiliear_shape12_grid': { width: 919.54709, height: 866.00549 },
  'Shapes_on_grids/Translucent_rectiliear_shape12_grid_missing_labelA': {
    width: 917.80011,
    height: 866.005
  },
  'Shapes_on_grids/Translucent_rectiliear_shape12_grid_missing_labelB': {
    width: 918.38049,
    height: 866.005
  },
  'Shapes_on_grids/Translucent_rectiliear_shape12_grid_missing_labelC': {
    width: 916.96338,
    height: 866.005
  },
  'Shapes_on_grids/Translucent_rectiliear_shape12_grid_missing_labelD': {
    width: 917.73273,
    height: 866.005
  },
  'Shapes_on_grids/Translucent_rectiliear_shape12_grid_missing_labelE': {
    width: 919.54645,
    height: 866.005
  },
  'Shapes_on_grids/Translucent_rectiliear_shape12_grid_missing_labelF': {
    width: 917.54645,
    height: 866.005
  },
  'Shapes_on_grids/Translucent_rectiliear_shape12_grid_missing_labelG': {
    width: 921.54645,
    height: 866.005
  },
  'Shapes_on_grids/Translucent_rectiliear_shape12_grid_missing_labelH': {
    width: 917.10956,
    height: 866.005
  },
  'Shapes_on_grids/Translucent_rectiliear_shape12_grid_nolabels': { width: 919.55, height: 866.01 },
  'Shapes_on_grids/Translucent_rectiliear_shape1_grid': { width: 919.32975, height: 866.22278 },
  'Shapes_on_grids/Translucent_rectiliear_shape1_grid_missing_labelA': {
    width: 918.66156,
    height: 866.22266
  },
  'Shapes_on_grids/Translucent_rectiliear_shape1_grid_missing_labelB': {
    width: 918.2829,
    height: 866.22266
  },
  'Shapes_on_grids/Translucent_rectiliear_shape1_grid_missing_labelC': {
    width: 917.50964,
    height: 866.22266
  },
  'Shapes_on_grids/Translucent_rectiliear_shape1_grid_missing_labelD': {
    width: 918.71155,
    height: 866.22266
  },
  'Shapes_on_grids/Translucent_rectiliear_shape1_grid_missing_labelE': {
    width: 919.18176,
    height: 866.22266
  },
  'Shapes_on_grids/Translucent_rectiliear_shape1_grid_missing_labelF': {
    width: 918.17609,
    height: 866.22266
  },
  'Shapes_on_grids/Translucent_rectiliear_shape1_grid_nolabels': { width: 919.33, height: 866.22 },
  'Shapes_on_grids/Translucent_rectiliear_shape2_grid': { width: 919.32975, height: 866.22278 },
  'Shapes_on_grids/Translucent_rectiliear_shape2_grid_missing_labelA': {
    width: 918.61816,
    height: 866.22266
  },
  'Shapes_on_grids/Translucent_rectiliear_shape2_grid_missing_labelB': {
    width: 918.76331,
    height: 866.22266
  },
  'Shapes_on_grids/Translucent_rectiliear_shape2_grid_missing_labelC': {
    width: 919.43298,
    height: 866.22266
  },
  'Shapes_on_grids/Translucent_rectiliear_shape2_grid_missing_labelD': {
    width: 919.26526,
    height: 866.22266
  },
  'Shapes_on_grids/Translucent_rectiliear_shape2_grid_missing_labelE': {
    width: 919.31494,
    height: 866.22266
  },
  'Shapes_on_grids/Translucent_rectiliear_shape2_grid_missing_labelF': {
    width: 918.80481,
    height: 866.22266
  },
  'Shapes_on_grids/Translucent_rectiliear_shape2_grid_nolabels': { width: 919.33, height: 866.22 },
  'Shapes_on_grids/Translucent_rectiliear_shape3_grid': { width: 919.32975, height: 866.22278 },
  'Shapes_on_grids/Translucent_rectiliear_shape3_grid_missing_labelA': {
    width: 920.72296,
    height: 866.22266
  },
  'Shapes_on_grids/Translucent_rectiliear_shape3_grid_missing_labelB': {
    width: 920.6781,
    height: 866.22266
  },
  'Shapes_on_grids/Translucent_rectiliear_shape3_grid_missing_labelC': {
    width: 919.62262,
    height: 866.22266
  },
  'Shapes_on_grids/Translucent_rectiliear_shape3_grid_missing_labelD': {
    width: 918.25494,
    height: 866.22266
  },
  'Shapes_on_grids/Translucent_rectiliear_shape3_grid_missing_labelE': {
    width: 917.51794,
    height: 866.22266
  },
  'Shapes_on_grids/Translucent_rectiliear_shape3_grid_missing_labelF': {
    width: 918.90564,
    height: 866.22266
  },
  'Shapes_on_grids/Translucent_rectiliear_shape3_grid_nolabels': { width: 919.33, height: 866.22 },
  'Shapes_on_grids/Translucent_rectiliear_shape4_grid': { width: 919.32975, height: 866.22278 },
  'Shapes_on_grids/Translucent_rectiliear_shape4_grid_missing_labelA': {
    width: 919.90021,
    height: 866.22266
  },
  'Shapes_on_grids/Translucent_rectiliear_shape4_grid_missing_labelB': {
    width: 918.06561,
    height: 866.22266
  },
  'Shapes_on_grids/Translucent_rectiliear_shape4_grid_missing_labelC': {
    width: 919.12378,
    height: 866.22266
  },
  'Shapes_on_grids/Translucent_rectiliear_shape4_grid_missing_labelD': {
    width: 920.24615,
    height: 866.22266
  },
  'Shapes_on_grids/Translucent_rectiliear_shape4_grid_missing_labelE': {
    width: 922.28473,
    height: 866.22266
  },
  'Shapes_on_grids/Translucent_rectiliear_shape4_grid_missing_labelF': {
    width: 920.15936,
    height: 866.22266
  },
  'Shapes_on_grids/Translucent_rectiliear_shape4_grid_nolabels': { width: 919.33, height: 866.22 },
  'Shapes_on_grids/Translucent_rectiliear_shape5_grid': { width: 919.32975, height: 866.22278 },
  'Shapes_on_grids/Translucent_rectiliear_shape5_grid_missing_labelA': {
    width: 918.15662,
    height: 866.22266
  },
  'Shapes_on_grids/Translucent_rectiliear_shape5_grid_missing_labelB': {
    width: 918.94495,
    height: 866.22266
  },
  'Shapes_on_grids/Translucent_rectiliear_shape5_grid_missing_labelC': {
    width: 918.112,
    height: 866.22266
  },
  'Shapes_on_grids/Translucent_rectiliear_shape5_grid_missing_labelD': {
    width: 917.92078,
    height: 866.22266
  },
  'Shapes_on_grids/Translucent_rectiliear_shape5_grid_missing_labelE': {
    width: 919.70911,
    height: 866.22266
  },
  'Shapes_on_grids/Translucent_rectiliear_shape5_grid_missing_labelF': {
    width: 921.86163,
    height: 866.22266
  },
  'Shapes_on_grids/Translucent_rectiliear_shape5_grid_nolabels': { width: 919.33, height: 866.22 },
  'Shapes_on_grids/Translucent_rectiliear_shape6_grid': { width: 919.32975, height: 866.22278 },
  'Shapes_on_grids/Translucent_rectiliear_shape6_grid_missing_labelA': {
    width: 920.45178,
    height: 866.22266
  },
  'Shapes_on_grids/Translucent_rectiliear_shape6_grid_missing_labelB': {
    width: 917.41138,
    height: 866.22266
  },
  'Shapes_on_grids/Translucent_rectiliear_shape6_grid_missing_labelC': {
    width: 918.8053,
    height: 866.22266
  },
  'Shapes_on_grids/Translucent_rectiliear_shape6_grid_missing_labelD': {
    width: 918.52966,
    height: 866.22266
  },
  'Shapes_on_grids/Translucent_rectiliear_shape6_grid_missing_labelE': {
    width: 918.04633,
    height: 866.22266
  },
  'Shapes_on_grids/Translucent_rectiliear_shape6_grid_missing_labelF': {
    width: 918.44818,
    height: 866.22266
  },
  'Shapes_on_grids/Translucent_rectiliear_shape6_grid_nolabels': { width: 919.33, height: 866.22 },
  'Shapes_on_grids/Translucent_rectiliear_shape7_grid': { width: 919.32975, height: 866.22278 },
  'Shapes_on_grids/Translucent_rectiliear_shape7_grid_missing_labelA': {
    width: 920.06421,
    height: 866.22266
  },
  'Shapes_on_grids/Translucent_rectiliear_shape7_grid_missing_labelB': {
    width: 919.30237,
    height: 866.22266
  },
  'Shapes_on_grids/Translucent_rectiliear_shape7_grid_missing_labelC': {
    width: 919.09625,
    height: 866.22266
  },
  'Shapes_on_grids/Translucent_rectiliear_shape7_grid_missing_labelD': {
    width: 917.32776,
    height: 866.22266
  },
  'Shapes_on_grids/Translucent_rectiliear_shape7_grid_missing_labelE': {
    width: 919.80902,
    height: 866.22266
  },
  'Shapes_on_grids/Translucent_rectiliear_shape7_grid_missing_labelF': {
    width: 921.24457,
    height: 866.22266
  },
  'Shapes_on_grids/Translucent_rectiliear_shape7_grid_missing_labelG': {
    width: 920.56757,
    height: 866.22266
  },
  'Shapes_on_grids/Translucent_rectiliear_shape7_grid_missing_labelH': {
    width: 917.22736,
    height: 866.22266
  },
  'Shapes_on_grids/Translucent_rectiliear_shape7_grid_nolabels': { width: 919.33, height: 866.22 },
  'Shapes_on_grids/Translucent_rectiliear_shape8_grid': { width: 919.32975, height: 866.22278 },
  'Shapes_on_grids/Translucent_rectiliear_shape8_grid_missing_labelA': {
    width: 918.38373,
    height: 866.22266
  },
  'Shapes_on_grids/Translucent_rectiliear_shape8_grid_missing_labelB': {
    width: 919.96875,
    height: 866.22266
  },
  'Shapes_on_grids/Translucent_rectiliear_shape8_grid_missing_labelC': {
    width: 919.82355,
    height: 866.22266
  },
  'Shapes_on_grids/Translucent_rectiliear_shape8_grid_missing_labelD': {
    width: 918.30646,
    height: 866.22266
  },
  'Shapes_on_grids/Translucent_rectiliear_shape8_grid_missing_labelE': {
    width: 919.19196,
    height: 866.22266
  },
  'Shapes_on_grids/Translucent_rectiliear_shape8_grid_missing_labelF': {
    width: 920.95465,
    height: 866.22266
  },
  'Shapes_on_grids/Translucent_rectiliear_shape8_grid_missing_labelG': {
    width: 919.74805,
    height: 866.22266
  },
  'Shapes_on_grids/Translucent_rectiliear_shape8_grid_missing_labelH': {
    width: 918.38562,
    height: 866.22266
  },
  'Shapes_on_grids/Translucent_rectiliear_shape8_grid_nolabels': { width: 919.33, height: 866.22 },
  'Shapes_on_grids/Translucent_rectiliear_shape9_grid': { width: 919.32975, height: 866.22278 },
  'Shapes_on_grids/Translucent_rectiliear_shape9_grid_missing_labelA': {
    width: 918.39606,
    height: 866.22241
  },
  'Shapes_on_grids/Translucent_rectiliear_shape9_grid_missing_labelB': {
    width: 918.80011,
    height: 866.22241
  },
  'Shapes_on_grids/Translucent_rectiliear_shape9_grid_missing_labelC': {
    width: 920.03217,
    height: 866.22241
  },
  'Shapes_on_grids/Translucent_rectiliear_shape9_grid_missing_labelD': {
    width: 919.64868,
    height: 866.22241
  },
  'Shapes_on_grids/Translucent_rectiliear_shape9_grid_missing_labelE': {
    width: 918.32886,
    height: 866.22241
  },
  'Shapes_on_grids/Translucent_rectiliear_shape9_grid_missing_labelF': {
    width: 918.04492,
    height: 866.22241
  },
  'Shapes_on_grids/Translucent_rectiliear_shape9_grid_missing_labelG': {
    width: 918.13629,
    height: 866.22241
  },
  'Shapes_on_grids/Translucent_rectiliear_shape9_grid_missing_labelH': {
    width: 920.64667,
    height: 866.22241
  },
  'Shapes_on_grids/Translucent_rectiliear_shape9_grid_nolabels': { width: 919.33, height: 866.22 },
  'Shapes_on_grids/Various_shapes1_grid': { width: 1193.8714, height: 867.94598 },
  'Shapes_on_grids/Various_shapes2_grid': { width: 1193.8714, height: 867.94598 },
  'Shapes_on_grids/Various_shapes3_grid': { width: 1193.8714, height: 867.94598 },
  'Shapes_on_grids/Various_shapes4_grid': { width: 1193.8714, height: 867.94598 },
  'Shapes_on_grids/Various_shapes5_grid': { width: 1193.8714, height: 867.94598 },
  'Shapes_on_grids/Various_shapes6_grid': { width: 1193.8714, height: 867.94598 },
  'Shapes_on_grids/Various_shapes7_grid': { width: 1193.8714, height: 867.94598 },
  'Shapes_on_grids/Various_shapes8_grid': { width: 1193.8714, height: 867.94598 },
  'Shapes_on_grids/Various_shapes9_grid': { width: 1193.8714, height: 867.94598 },
  'Shapes_with_arrows/2_circles_with_arrows': { width: 652.55864, height: 652.56 },
  'Shapes_with_arrows/Compound_shape1_arrows': { width: 756.88572, height: 411.28784 },
  'Shapes_with_arrows/Compound_shape2_arrows': { width: 403.41558, height: 516.71478 },
  'Shapes_with_arrows/Compound_shape3_arrows': { width: 486.19411, height: 431.83398 },
  'Shapes_with_arrows/Compound_shape4_arrows': { width: 363.25972, height: 487.65506 },
  'Shapes_with_arrows/Compound_shape5_arrows': { width: 763.57127, height: 347.14346 },
  'Shapes_with_arrows/Compound_shape6_arrows': { width: 525.35771, height: 439.85425 },
  'Shapes_with_arrows/Compound_shape7_arrows': { width: 662.76597, height: 378.31265 },
  'Shapes_with_arrows/Compound_shape8_arrows': { width: 756.88572, height: 411.28784 },
  'Shapes_with_arrows/Compound_shape9_arrows': { width: 363.25972, height: 487.65506 },
  'Shapes_with_arrows/Equilateral_triangle_1__arrow': { width: 844.08781, height: 752.28174 },
  'Shapes_with_arrows/Irregular_heptagon1_all_arrows': { width: 547.33598, height: 785.87732 },
  'Shapes_with_arrows/Irregular_heptagon1_all_arrows_blue': { width: 547.33598, height: 785.87732 },
  'Shapes_with_arrows/Irregular_heptagon1_all_arrows_green': {
    width: 547.33598,
    height: 785.87732
  },
  'Shapes_with_arrows/Irregular_heptagon1_all_arrows_pink': { width: 547.33598, height: 785.87732 },
  'Shapes_with_arrows/Irregular_heptagon1_all_arrows_purple': {
    width: 547.33598,
    height: 785.87732
  },
  'Shapes_with_arrows/Irregular_heptagon1_all_arrows_yellow': {
    width: 547.33598,
    height: 785.87732
  },
  'Shapes_with_arrows/Irregular_hexagon1_all_arrows': { width: 830.28794, height: 431.6228 },
  'Shapes_with_arrows/Irregular_hexagon1_all_arrows_blue': { width: 830.28794, height: 431.6228 },
  'Shapes_with_arrows/Irregular_hexagon1_all_arrows_green': { width: 830.28794, height: 431.6228 },
  'Shapes_with_arrows/Irregular_hexagon1_all_arrows_pink': { width: 830.28794, height: 431.6228 },
  'Shapes_with_arrows/Irregular_hexagon1_all_arrows_purple': { width: 830.28794, height: 431.6228 },
  'Shapes_with_arrows/Irregular_hexagon1_all_arrows_yellow': { width: 830.28794, height: 431.6228 },
  'Shapes_with_arrows/Irregular_hexagon2_all_arrows': { width: 605.57622, height: 312.70105 },
  'Shapes_with_arrows/Irregular_hexagon2_all_arrows_blue': { width: 605.57622, height: 312.70105 },
  'Shapes_with_arrows/Irregular_hexagon2_all_arrows_green': { width: 605.57622, height: 312.70105 },
  'Shapes_with_arrows/Irregular_hexagon2_all_arrows_pink': { width: 605.57622, height: 312.70105 },
  'Shapes_with_arrows/Irregular_hexagon2_all_arrows_purple': {
    width: 605.57622,
    height: 312.70105
  },
  'Shapes_with_arrows/Irregular_hexagon2_all_arrows_yellow': {
    width: 605.57622,
    height: 312.70105
  },
  'Shapes_with_arrows/Irregular_hexagon3_all_arrows': { width: 719.75584, height: 420.82959 },
  'Shapes_with_arrows/Irregular_hexagon3_all_arrows_blue': { width: 719.75584, height: 420.82959 },
  'Shapes_with_arrows/Irregular_hexagon3_all_arrows_green': { width: 719.75584, height: 420.82959 },
  'Shapes_with_arrows/Irregular_hexagon3_all_arrows_pink': { width: 719.75584, height: 420.82959 },
  'Shapes_with_arrows/Irregular_hexagon3_all_arrows_purple': {
    width: 719.75584,
    height: 420.82959
  },
  'Shapes_with_arrows/Irregular_hexagon3_all_arrows_yellow': {
    width: 719.75584,
    height: 420.82959
  },
  'Shapes_with_arrows/Irregular_hexagon4_all_arrows': { width: 558.56316, height: 693.86694 },
  'Shapes_with_arrows/Irregular_hexagon4_all_arrows_blue': { width: 558.56316, height: 693.86694 },
  'Shapes_with_arrows/Irregular_hexagon4_all_arrows_green': { width: 558.56316, height: 693.86694 },
  'Shapes_with_arrows/Irregular_hexagon4_all_arrows_pink': { width: 558.56316, height: 693.86694 },
  'Shapes_with_arrows/Irregular_hexagon4_all_arrows_purple': {
    width: 558.56316,
    height: 693.86694
  },
  'Shapes_with_arrows/Irregular_hexagon4_all_arrows_yellow': {
    width: 558.56316,
    height: 693.86694
  },
  'Shapes_with_arrows/Irregular_hexagon5_all_arrows': { width: 915.98368, height: 607.20905 },
  'Shapes_with_arrows/Irregular_hexagon5_all_arrows_blue': { width: 915.98368, height: 607.20905 },
  'Shapes_with_arrows/Irregular_hexagon5_all_arrows_green': { width: 915.98368, height: 607.20905 },
  'Shapes_with_arrows/Irregular_hexagon5_all_arrows_pink': { width: 915.98368, height: 607.20905 },
  'Shapes_with_arrows/Irregular_hexagon5_all_arrows_purple': {
    width: 915.98368,
    height: 607.20905
  },
  'Shapes_with_arrows/Irregular_hexagon5_all_arrows_yellow': {
    width: 915.98368,
    height: 607.20905
  },
  'Shapes_with_arrows/Irregular_hexagon6_all_arrows': { width: 869.79728, height: 604.35974 },
  'Shapes_with_arrows/Irregular_hexagon6_all_arrows_blue': { width: 869.79728, height: 604.35974 },
  'Shapes_with_arrows/Irregular_hexagon6_all_arrows_green': { width: 869.79728, height: 604.35974 },
  'Shapes_with_arrows/Irregular_hexagon6_all_arrows_pink': { width: 869.79728, height: 604.35974 },
  'Shapes_with_arrows/Irregular_hexagon6_all_arrows_purple': {
    width: 869.79728,
    height: 604.35974
  },
  'Shapes_with_arrows/Irregular_hexagon6_all_arrows_yellow': {
    width: 869.79728,
    height: 604.35974
  },
  'Shapes_with_arrows/Irregular_hexagon7_all_arrows': { width: 426.16838, height: 570.11584 },
  'Shapes_with_arrows/Irregular_hexagon7_all_arrows_blue': { width: 426.16838, height: 570.11584 },
  'Shapes_with_arrows/Irregular_hexagon7_all_arrows_green': { width: 426.16838, height: 570.11584 },
  'Shapes_with_arrows/Irregular_hexagon7_all_arrows_pink': { width: 426.16838, height: 570.11584 },
  'Shapes_with_arrows/Irregular_hexagon7_all_arrows_purple': {
    width: 426.16838,
    height: 570.11584
  },
  'Shapes_with_arrows/Irregular_hexagon7_all_arrows_yellow': {
    width: 426.16838,
    height: 570.11584
  },
  'Shapes_with_arrows/Irregular_octagon1_all_arrows': { width: 619.22423, height: 695.67664 },
  'Shapes_with_arrows/Irregular_octagon1_all_arrows_blue': { width: 619.22423, height: 695.67664 },
  'Shapes_with_arrows/Irregular_octagon1_all_arrows_green': { width: 619.22423, height: 695.67664 },
  'Shapes_with_arrows/Irregular_octagon1_all_arrows_pink': { width: 619.22423, height: 695.67664 },
  'Shapes_with_arrows/Irregular_octagon1_all_arrows_purple': {
    width: 619.22423,
    height: 695.67664
  },
  'Shapes_with_arrows/Irregular_octagon1_all_arrows_yellow': {
    width: 619.22423,
    height: 695.67664
  },
  'Shapes_with_arrows/Irregular_pentagon1_all_arrows': { width: 817.64957, height: 446.3204 },
  'Shapes_with_arrows/Irregular_pentagon1_all_arrows_blue': { width: 817.64957, height: 446.3204 },
  'Shapes_with_arrows/Irregular_pentagon1_all_arrows_green': { width: 817.64957, height: 446.3204 },
  'Shapes_with_arrows/Irregular_pentagon1_all_arrows_pink': { width: 817.64957, height: 446.3204 },
  'Shapes_with_arrows/Irregular_pentagon1_all_arrows_purple': {
    width: 817.64957,
    height: 446.3204
  },
  'Shapes_with_arrows/Irregular_pentagon1_all_arrows_yellow': {
    width: 817.64957,
    height: 446.3204
  },
  'Shapes_with_arrows/Irregular_pentagon2_all_arrows': { width: 902.06339, height: 667.06573 },
  'Shapes_with_arrows/Irregular_pentagon2_all_arrows_blue': { width: 902.06339, height: 667.06573 },
  'Shapes_with_arrows/Irregular_pentagon2_all_arrows_green': {
    width: 902.06339,
    height: 667.06573
  },
  'Shapes_with_arrows/Irregular_pentagon2_all_arrows_pink': { width: 902.06339, height: 667.06573 },
  'Shapes_with_arrows/Irregular_pentagon2_all_arrows_purple': {
    width: 902.06339,
    height: 667.06573
  },
  'Shapes_with_arrows/Irregular_pentagon2_all_arrows_yellow': {
    width: 902.06339,
    height: 667.06573
  },
  'Shapes_with_arrows/Irregular_pentagon3_all_arrows': { width: 885.99302, height: 387.91986 },
  'Shapes_with_arrows/Irregular_pentagon3_all_arrows_blue': { width: 885.99302, height: 387.91986 },
  'Shapes_with_arrows/Irregular_pentagon3_all_arrows_green': {
    width: 885.99302,
    height: 387.91986
  },
  'Shapes_with_arrows/Irregular_pentagon3_all_arrows_pink': { width: 885.99302, height: 387.91986 },
  'Shapes_with_arrows/Irregular_pentagon3_all_arrows_purple': {
    width: 885.99302,
    height: 387.91986
  },
  'Shapes_with_arrows/Irregular_pentagon3_all_arrows_yellow': {
    width: 885.99302,
    height: 387.91986
  },
  'Shapes_with_arrows/Irregular_pentagon4_all_arrows': { width: 887.27286, height: 542.94464 },
  'Shapes_with_arrows/Irregular_pentagon4_all_arrows_blue': { width: 887.27286, height: 542.94464 },
  'Shapes_with_arrows/Irregular_pentagon4_all_arrows_green': {
    width: 887.27286,
    height: 542.94464
  },
  'Shapes_with_arrows/Irregular_pentagon4_all_arrows_pink': { width: 887.27286, height: 542.94464 },
  'Shapes_with_arrows/Irregular_pentagon4_all_arrows_purple': {
    width: 887.27286,
    height: 542.94464
  },
  'Shapes_with_arrows/Irregular_pentagon4_all_arrows_yellow': {
    width: 887.27286,
    height: 542.94464
  },
  'Shapes_with_arrows/Irregular_pentagon5_all_arrows': { width: 686.08689, height: 792.95251 },
  'Shapes_with_arrows/Irregular_pentagon5_all_arrows_blue': { width: 686.08689, height: 792.95251 },
  'Shapes_with_arrows/Irregular_pentagon5_all_arrows_green': {
    width: 686.08689,
    height: 792.95251
  },
  'Shapes_with_arrows/Irregular_pentagon5_all_arrows_pink': { width: 686.08689, height: 792.95251 },
  'Shapes_with_arrows/Irregular_pentagon5_all_arrows_purple': {
    width: 686.08689,
    height: 792.95251
  },
  'Shapes_with_arrows/Irregular_pentagon5_all_arrows_yellow': {
    width: 686.08689,
    height: 792.95251
  },
  'Shapes_with_arrows/Irregular_triangle_all_arrows': { width: 1038.4592, height: 588.53467 },
  'Shapes_with_arrows/Isosceles_triangle_with_arrows_equal': { width: 207.37814, height: 171.1082 },
  'Shapes_with_arrows/Isosceles_triangle_with_arrows_short': {
    width: 208.00612,
    height: 107.79363
  },
  'Shapes_with_arrows/Isosceles_triangle_with_arrows_tall': { width: 207.27263, height: 222.51323 },
  'Shapes_with_arrows/Labelled_compound_shape1': { width: 639.47221, height: 463.146 },
  'Shapes_with_arrows/Labelled_compound_shape2': { width: 630.38981, height: 463.146 },
  'Shapes_with_arrows/Labelled_compound_shape3': { width: 526.76598, height: 356.3364 },
  'Shapes_with_arrows/Labelled_compound_shape4': { width: 639.47184, height: 463.67972 },
  'Shapes_with_arrows/Labelled_compound_shape5': { width: 639.47184, height: 463.67972 },
  'Shapes_with_arrows/Labelled_compound_shape6': { width: 639.47184, height: 463.67972 },
  'Shapes_with_arrows/Parallelogram10_2_arrows_right_angle': {
    width: 804.25175,
    height: 411.39853
  },
  'Shapes_with_arrows/Parallelogram10_3_arrows_right_angle': {
    width: 232.33799,
    height: 764.68024
  },
  'Shapes_with_arrows/Parallelogram10_3_arrows_right_angle_filled': {
    width: 829.01089,
    height: 420.07706
  },
  'Shapes_with_arrows/Parallelogram1_2_arrows_right_angle': { width: 668.66661, height: 620.71173 },
  'Shapes_with_arrows/Parallelogram1_3_arrows_right_angle': { width: 685.03154, height: 620.7113 },
  'Shapes_with_arrows/Parallelogram1_3_arrows_right_angle_filled': {
    width: 692.99964,
    height: 632.18547
  },
  'Shapes_with_arrows/Parallelogram2_2_arrows_right_angle': { width: 460.83861, height: 699.60254 },
  'Shapes_with_arrows/Parallelogram2_3_arrows_right_angle': { width: 921.87375, height: 620.7113 },
  'Shapes_with_arrows/Parallelogram2_3_arrows_right_angle_filled': {
    width: 493.66127,
    height: 710.97274
  },
  'Shapes_with_arrows/Parallelogram3_2_arrows_right_angle': { width: 772.99705, height: 659.409 },
  'Shapes_with_arrows/Parallelogram3_3_arrows_right_angle': { width: 485.5613, height: 747.797 },
  'Shapes_with_arrows/Parallelogram4_2_arrows_right_angle': { width: 843.03055, height: 174.35387 },
  'Shapes_with_arrows/Parallelogram4_3_arrows_right_angle': { width: 487.15663, height: 749.05859 },
  'Shapes_with_arrows/Parallelogram5_2_arrows_right_angle': { width: 468.06471, height: 487.64825 },
  'Shapes_with_arrows/Parallelogram5_3_arrows_right_angle': { width: 590.38475, height: 678.07019 },
  'Shapes_with_arrows/Parallelogram5_3_arrows_right_angle_filled': {
    width: 493.85831,
    height: 498.21561
  },
  'Shapes_with_arrows/Parallelogram6_2_arrows_right_angle': { width: 568.13957, height: 669.06378 },
  'Shapes_with_arrows/Parallelogram6_3_arrows_right_angle': { width: 566.00169, height: 620.71118 },
  'Shapes_with_arrows/Parallelogram7_2_arrows_right_angle': { width: 621.65184, height: 667.80261 },
  'Shapes_with_arrows/Parallelogram7_3_arrows_right_angle': { width: 565.20421, height: 751.1792 },
  'Shapes_with_arrows/Parallelogram7_3_arrows_right_angle_filled': {
    width: 631.57951,
    height: 694.34046
  },
  'Shapes_with_arrows/Parallelogram8_2_arrows_right_angle': { width: 400.86086, height: 480.81985 },
  'Shapes_with_arrows/Parallelogram8_3_arrows_right_angle': { width: 410.93358, height: 767.31396 },
  'Shapes_with_arrows/Parallelogram9_2_arrows_right_angle': { width: 529.9279, height: 581.1557 },
  'Shapes_with_arrows/Parallelogram9_3_arrows_right_angle': { width: 566.66649, height: 581.15613 },
  'Shapes_with_arrows/Parallelogram_and_rectangle1': { width: 1268.171, height: 868.13867 },
  'Shapes_with_arrows/Parallelogram_and_rectangle10': { width: 1268.171, height: 868.13867 },
  'Shapes_with_arrows/Parallelogram_and_rectangle11': { width: 1268.171, height: 868.13867 },
  'Shapes_with_arrows/Parallelogram_and_rectangle12': { width: 1268.171, height: 868.13867 },
  'Shapes_with_arrows/Parallelogram_and_rectangle13': { width: 1268.171, height: 868.13867 },
  'Shapes_with_arrows/Parallelogram_and_rectangle14': { width: 1268.171, height: 868.13867 },
  'Shapes_with_arrows/Parallelogram_and_rectangle15': { width: 1268.171, height: 868.13867 },
  'Shapes_with_arrows/Parallelogram_and_rectangle16': { width: 1268.171, height: 868.13867 },
  'Shapes_with_arrows/Parallelogram_and_rectangle17': { width: 1268.171, height: 868.13867 },
  'Shapes_with_arrows/Parallelogram_and_rectangle18': { width: 1268.171, height: 868.13867 },
  'Shapes_with_arrows/Parallelogram_and_rectangle19': { width: 1268.171, height: 868.13867 },
  'Shapes_with_arrows/Parallelogram_and_rectangle2': { width: 1268.171, height: 868.13867 },
  'Shapes_with_arrows/Parallelogram_and_rectangle20': { width: 1268.171, height: 868.13867 },
  'Shapes_with_arrows/Parallelogram_and_rectangle3': { width: 1268.171, height: 868.13867 },
  'Shapes_with_arrows/Parallelogram_and_rectangle4': { width: 1268.171, height: 868.13867 },
  'Shapes_with_arrows/Parallelogram_and_rectangle5': { width: 1268.171, height: 868.13867 },
  'Shapes_with_arrows/Parallelogram_and_rectangle6': { width: 1268.171, height: 868.13867 },
  'Shapes_with_arrows/Parallelogram_and_rectangle7': { width: 1268.171, height: 868.13867 },
  'Shapes_with_arrows/Parallelogram_and_rectangle8': { width: 1268.171, height: 868.13867 },
  'Shapes_with_arrows/Parallelogram_and_rectangle9': { width: 1268.171, height: 868.13867 },
  'Shapes_with_arrows/Quadrilateral_all_arrows': { width: 499.86223, height: 633.40186 },
  'Shapes_with_arrows/Rectangle1_2_arrows': { width: 401.03292, height: 487.59399 },
  'Shapes_with_arrows/Rectangle2_2_arrows': { width: 123.57093, height: 487.59439 },
  'Shapes_with_arrows/Rectangle3_2_arrows': { width: 487.59438, height: 92.802528 },
  'Shapes_with_arrows/Rectangle4_2_arrows': { width: 487.59438, height: 171.0788 },
  'Shapes_with_arrows/Rectangle5_2_arrows': { width: 365.90957, height: 229.28546 },
  'Shapes_with_arrows/Rectangle6_2_arrows': { width: 837.47489, height: 229.28546 },
  'Shapes_with_arrows/Rectangle7_2_arrows': { width: 197.04573, height: 412.21906 },
  'Shapes_with_arrows/Rectangle8_4_arrows': { width: 686.01304, height: 323.13492 },
  'Shapes_with_arrows/Rectangle_all_arrows': { width: 689.84849, height: 660.34692 },
  'Shapes_with_arrows/Rectilinear_shape10_2_red_arrows': { width: 861.49357, height: 655.11908 },
  'Shapes_with_arrows/Rectilinear_shape10_all_arrows': { width: 623.86625, height: 431.22891 },
  'Shapes_with_arrows/Rectilinear_shape10_all_arrows_blue': { width: 623.86625, height: 431.22891 },
  'Shapes_with_arrows/Rectilinear_shape10_all_arrows_green': {
    width: 623.86625,
    height: 431.22891
  },
  'Shapes_with_arrows/Rectilinear_shape10_all_arrows_pink': { width: 623.86625, height: 431.22891 },
  'Shapes_with_arrows/Rectilinear_shape10_all_arrows_purple': {
    width: 623.86625,
    height: 431.22891
  },
  'Shapes_with_arrows/Rectilinear_shape10_all_arrows_yellow': {
    width: 623.86625,
    height: 431.22891
  },
  'Shapes_with_arrows/Rectilinear_shape11_2_red_arrows': { width: 863.61686, height: 361.97678 },
  'Shapes_with_arrows/Rectilinear_shape11_all_arrows': { width: 597.63383, height: 623.86627 },
  'Shapes_with_arrows/Rectilinear_shape11_all_arrows_blue': { width: 597.63383, height: 623.86627 },
  'Shapes_with_arrows/Rectilinear_shape11_all_arrows_green': {
    width: 597.63383,
    height: 623.86627
  },
  'Shapes_with_arrows/Rectilinear_shape11_all_arrows_pink': { width: 597.63383, height: 623.86627 },
  'Shapes_with_arrows/Rectilinear_shape11_all_arrows_purple': {
    width: 597.63383,
    height: 623.86627
  },
  'Shapes_with_arrows/Rectilinear_shape11_all_arrows_yellow': {
    width: 597.63383,
    height: 623.86627
  },
  'Shapes_with_arrows/Rectilinear_shape12_2_red_arrows': { width: 863.62504, height: 453.34692 },
  'Shapes_with_arrows/Rectilinear_shape12_all_arrows': { width: 861.49357, height: 655.11908 },
  'Shapes_with_arrows/Rectilinear_shape12_all_arrows_blue': { width: 861.49357, height: 655.11908 },
  'Shapes_with_arrows/Rectilinear_shape12_all_arrows_green': {
    width: 861.49357,
    height: 655.11908
  },
  'Shapes_with_arrows/Rectilinear_shape12_all_arrows_pink': { width: 861.49357, height: 655.11908 },
  'Shapes_with_arrows/Rectilinear_shape12_all_arrows_purple': {
    width: 861.49357,
    height: 655.11908
  },
  'Shapes_with_arrows/Rectilinear_shape12_all_arrows_yellow': {
    width: 861.49357,
    height: 655.11908
  },
  'Shapes_with_arrows/Rectilinear_shape13_2_red_arrows': { width: 861.49357, height: 595.51343 },
  'Shapes_with_arrows/Rectilinear_shape13_all_arrows': { width: 623.86595, height: 597.63385 },
  'Shapes_with_arrows/Rectilinear_shape13_all_arrows_blue': { width: 623.86595, height: 597.63385 },
  'Shapes_with_arrows/Rectilinear_shape13_all_arrows_green': {
    width: 623.86595,
    height: 597.63385
  },
  'Shapes_with_arrows/Rectilinear_shape13_all_arrows_pink': { width: 623.86595, height: 597.63385 },
  'Shapes_with_arrows/Rectilinear_shape13_all_arrows_purple': {
    width: 623.86595,
    height: 597.63385
  },
  'Shapes_with_arrows/Rectilinear_shape13_all_arrows_yellow': {
    width: 623.86595,
    height: 597.63385
  },
  'Shapes_with_arrows/Rectilinear_shape14_2_red_arrows': { width: 1097.4862, height: 655.11908 },
  'Shapes_with_arrows/Rectilinear_shape14_all_arrows': { width: 623.86625, height: 597.63385 },
  'Shapes_with_arrows/Rectilinear_shape14_all_arrows_blue': { width: 623.86625, height: 597.63385 },
  'Shapes_with_arrows/Rectilinear_shape14_all_arrows_green': {
    width: 623.86625,
    height: 597.63385
  },
  'Shapes_with_arrows/Rectilinear_shape14_all_arrows_pink': { width: 623.86625, height: 597.63385 },
  'Shapes_with_arrows/Rectilinear_shape14_all_arrows_purple': {
    width: 623.86625,
    height: 597.63385
  },
  'Shapes_with_arrows/Rectilinear_shape14_all_arrows_yellow': {
    width: 623.86625,
    height: 597.63385
  },
  'Shapes_with_arrows/Rectilinear_shape15_2_red_arrows': { width: 655.11888, height: 699.33588 },
  'Shapes_with_arrows/Rectilinear_shape15_all_arrows': { width: 863.62504, height: 453.34705 },
  'Shapes_with_arrows/Rectilinear_shape15_all_arrows_blue': { width: 863.62504, height: 453.34705 },
  'Shapes_with_arrows/Rectilinear_shape15_all_arrows_green': {
    width: 863.62504,
    height: 453.34705
  },
  'Shapes_with_arrows/Rectilinear_shape15_all_arrows_pink': { width: 863.62504, height: 453.34705 },
  'Shapes_with_arrows/Rectilinear_shape15_all_arrows_purple': {
    width: 863.62504,
    height: 453.34705
  },
  'Shapes_with_arrows/Rectilinear_shape15_all_arrows_yellow': {
    width: 863.62504,
    height: 453.34705
  },
  'Shapes_with_arrows/Rectilinear_shape16_2_red_arrows': { width: 595.51329, height: 771.41974 },
  'Shapes_with_arrows/Rectilinear_shape16_all_arrows': { width: 841.96647, height: 299.13345 },
  'Shapes_with_arrows/Rectilinear_shape16_all_arrows_blue': { width: 841.96647, height: 299.13345 },
  'Shapes_with_arrows/Rectilinear_shape16_all_arrows_green': {
    width: 841.96647,
    height: 299.13345
  },
  'Shapes_with_arrows/Rectilinear_shape16_all_arrows_pink': { width: 841.96647, height: 299.13345 },
  'Shapes_with_arrows/Rectilinear_shape16_all_arrows_purple': {
    width: 841.96647,
    height: 299.13345
  },
  'Shapes_with_arrows/Rectilinear_shape16_all_arrows_yellow': {
    width: 841.96647,
    height: 299.13345
  },
  'Shapes_with_arrows/Rectilinear_shape17_2_red_arrows': { width: 850.95518, height: 617.2132 },
  'Shapes_with_arrows/Rectilinear_shape17_all_arrows': { width: 597.63408, height: 623.86609 },
  'Shapes_with_arrows/Rectilinear_shape17_all_arrows_blue': { width: 597.63408, height: 623.86609 },
  'Shapes_with_arrows/Rectilinear_shape17_all_arrows_green': {
    width: 597.63408,
    height: 623.86609
  },
  'Shapes_with_arrows/Rectilinear_shape17_all_arrows_pink': { width: 597.63408, height: 623.86609 },
  'Shapes_with_arrows/Rectilinear_shape17_all_arrows_purple': {
    width: 597.63408,
    height: 623.86609
  },
  'Shapes_with_arrows/Rectilinear_shape17_all_arrows_yellow': {
    width: 597.63408,
    height: 623.86609
  },
  'Shapes_with_arrows/Rectilinear_shape18_2_red_arrows': { width: 617.2133, height: 766.55811 },
  'Shapes_with_arrows/Rectilinear_shape18_all_arrows': { width: 786.8574, height: 623.86652 },
  'Shapes_with_arrows/Rectilinear_shape18_all_arrows_blue': { width: 786.8574, height: 623.86652 },
  'Shapes_with_arrows/Rectilinear_shape18_all_arrows_green': { width: 786.8574, height: 623.86652 },
  'Shapes_with_arrows/Rectilinear_shape18_all_arrows_pink': { width: 786.8574, height: 623.86652 },
  'Shapes_with_arrows/Rectilinear_shape18_all_arrows_purple': {
    width: 786.8574,
    height: 623.86652
  },
  'Shapes_with_arrows/Rectilinear_shape18_all_arrows_yellow': {
    width: 786.8574,
    height: 623.86652
  },
  'Shapes_with_arrows/Rectilinear_shape19_2_red_arrows': { width: 491.78798, height: 709.00372 },
  'Shapes_with_arrows/Rectilinear_shape19_all_arrows': { width: 623.86625, height: 431.22919 },
  'Shapes_with_arrows/Rectilinear_shape19_all_arrows_blue': { width: 623.86625, height: 431.22919 },
  'Shapes_with_arrows/Rectilinear_shape19_all_arrows_green': {
    width: 623.86625,
    height: 431.22919
  },
  'Shapes_with_arrows/Rectilinear_shape19_all_arrows_pink': { width: 623.86625, height: 431.22919 },
  'Shapes_with_arrows/Rectilinear_shape19_all_arrows_purple': {
    width: 623.86625,
    height: 431.22919
  },
  'Shapes_with_arrows/Rectilinear_shape19_all_arrows_yellow': {
    width: 623.86625,
    height: 431.22919
  },
  'Shapes_with_arrows/Rectilinear_shape1_2_red_arrows': { width: 843.34183, height: 623.86652 },
  'Shapes_with_arrows/Rectilinear_shape1_all_arrows': { width: 843.34183, height: 623.86609 },
  'Shapes_with_arrows/Rectilinear_shape1_all_arrows_blue': { width: 843.34183, height: 623.86609 },
  'Shapes_with_arrows/Rectilinear_shape1_all_arrows_green': { width: 843.34183, height: 623.86609 },
  'Shapes_with_arrows/Rectilinear_shape1_all_arrows_pink': { width: 843.34183, height: 623.86609 },
  'Shapes_with_arrows/Rectilinear_shape1_all_arrows_purple': {
    width: 843.34183,
    height: 623.86609
  },
  'Shapes_with_arrows/Rectilinear_shape1_all_arrows_yellow': {
    width: 843.34183,
    height: 623.86609
  },
  'Shapes_with_arrows/Rectilinear_shape20_2_red_arrows': { width: 830.37705, height: 709.0036 },
  'Shapes_with_arrows/Rectilinear_shape20_all_arrows': { width: 623.86625, height: 786.8573 },
  'Shapes_with_arrows/Rectilinear_shape20_all_arrows_blue': { width: 623.86625, height: 786.8573 },
  'Shapes_with_arrows/Rectilinear_shape20_all_arrows_green': { width: 623.86625, height: 786.8573 },
  'Shapes_with_arrows/Rectilinear_shape20_all_arrows_pink': { width: 623.86625, height: 786.8573 },
  'Shapes_with_arrows/Rectilinear_shape20_all_arrows_purple': {
    width: 623.86625,
    height: 786.8573
  },
  'Shapes_with_arrows/Rectilinear_shape20_all_arrows_yellow': {
    width: 623.86625,
    height: 786.8573
  },
  'Shapes_with_arrows/Rectilinear_shape21_all_arrows': { width: 623.86625, height: 786.8573 },
  'Shapes_with_arrows/Rectilinear_shape21_all_arrows_blue': { width: 623.86625, height: 786.8573 },
  'Shapes_with_arrows/Rectilinear_shape21_all_arrows_green': { width: 623.86625, height: 786.8573 },
  'Shapes_with_arrows/Rectilinear_shape21_all_arrows_pink': { width: 623.86625, height: 786.8573 },
  'Shapes_with_arrows/Rectilinear_shape21_all_arrows_purple': {
    width: 623.86625,
    height: 786.8573
  },
  'Shapes_with_arrows/Rectilinear_shape21_all_arrows_yellow': {
    width: 623.86625,
    height: 786.8573
  },
  'Shapes_with_arrows/Rectilinear_shape22_all_arrows': { width: 786.8574, height: 623.86639 },
  'Shapes_with_arrows/Rectilinear_shape22_all_arrows_blue': { width: 786.8574, height: 623.86639 },
  'Shapes_with_arrows/Rectilinear_shape22_all_arrows_green': { width: 786.8574, height: 623.86639 },
  'Shapes_with_arrows/Rectilinear_shape22_all_arrows_pink': { width: 786.8574, height: 623.86639 },
  'Shapes_with_arrows/Rectilinear_shape22_all_arrows_purple': {
    width: 786.8574,
    height: 623.86639
  },
  'Shapes_with_arrows/Rectilinear_shape22_all_arrows_yellow': {
    width: 786.8574,
    height: 623.86639
  },
  'Shapes_with_arrows/Rectilinear_shape23_all_arrows': { width: 843.34208, height: 623.86639 },
  'Shapes_with_arrows/Rectilinear_shape23_all_arrows_blue': { width: 843.34208, height: 623.86639 },
  'Shapes_with_arrows/Rectilinear_shape23_all_arrows_green': {
    width: 843.34208,
    height: 623.86639
  },
  'Shapes_with_arrows/Rectilinear_shape23_all_arrows_pink': { width: 843.34208, height: 623.86639 },
  'Shapes_with_arrows/Rectilinear_shape23_all_arrows_purple': {
    width: 843.34208,
    height: 623.86639
  },
  'Shapes_with_arrows/Rectilinear_shape23_all_arrows_yellow': {
    width: 843.34208,
    height: 623.86639
  },
  'Shapes_with_arrows/Rectilinear_shape24_all_arrows': { width: 428.62078, height: 586.16931 },
  'Shapes_with_arrows/Rectilinear_shape24_all_arrows_blue': { width: 428.62078, height: 586.16931 },
  'Shapes_with_arrows/Rectilinear_shape24_all_arrows_green': {
    width: 428.62078,
    height: 586.16931
  },
  'Shapes_with_arrows/Rectilinear_shape24_all_arrows_pink': { width: 428.62078, height: 586.16931 },
  'Shapes_with_arrows/Rectilinear_shape24_all_arrows_purple': {
    width: 428.62078,
    height: 586.16931
  },
  'Shapes_with_arrows/Rectilinear_shape24_all_arrows_yellow': {
    width: 428.62078,
    height: 586.16931
  },
  'Shapes_with_arrows/Rectilinear_shape25_all_arrows': { width: 478.34612, height: 535.01892 },
  'Shapes_with_arrows/Rectilinear_shape25_all_arrows_blue': { width: 478.34612, height: 535.01892 },
  'Shapes_with_arrows/Rectilinear_shape25_all_arrows_green': {
    width: 478.34612,
    height: 535.01892
  },
  'Shapes_with_arrows/Rectilinear_shape25_all_arrows_pink': { width: 478.34612, height: 535.01892 },
  'Shapes_with_arrows/Rectilinear_shape25_all_arrows_purple': {
    width: 478.34612,
    height: 535.01892
  },
  'Shapes_with_arrows/Rectilinear_shape25_all_arrows_yellow': {
    width: 478.34612,
    height: 535.01892
  },
  'Shapes_with_arrows/Rectilinear_shape26_all_arrows': { width: 381.00237, height: 535.01892 },
  'Shapes_with_arrows/Rectilinear_shape26_all_arrows_blue': { width: 381.00237, height: 535.01892 },
  'Shapes_with_arrows/Rectilinear_shape26_all_arrows_green': {
    width: 381.00237,
    height: 535.01892
  },
  'Shapes_with_arrows/Rectilinear_shape26_all_arrows_pink': { width: 381.00237, height: 535.01892 },
  'Shapes_with_arrows/Rectilinear_shape26_all_arrows_purple': {
    width: 381.00237,
    height: 535.01892
  },
  'Shapes_with_arrows/Rectilinear_shape26_all_arrows_yellow': {
    width: 381.00237,
    height: 535.01892
  },
  'Shapes_with_arrows/Rectilinear_shape27_all_arrows': { width: 381.00264, height: 424.18011 },
  'Shapes_with_arrows/Rectilinear_shape27_all_arrows_blue': { width: 381.00264, height: 424.18011 },
  'Shapes_with_arrows/Rectilinear_shape27_all_arrows_green': {
    width: 381.00264,
    height: 424.18011
  },
  'Shapes_with_arrows/Rectilinear_shape27_all_arrows_pink': { width: 381.00264, height: 424.18011 },
  'Shapes_with_arrows/Rectilinear_shape27_all_arrows_purple': {
    width: 381.00264,
    height: 424.18011
  },
  'Shapes_with_arrows/Rectilinear_shape27_all_arrows_yellow': {
    width: 381.00264,
    height: 424.18011
  },
  'Shapes_with_arrows/Rectilinear_shape28_all_arrows': { width: 422.47078, height: 302.84344 },
  'Shapes_with_arrows/Rectilinear_shape28_all_arrows_blue': { width: 422.47078, height: 302.84344 },
  'Shapes_with_arrows/Rectilinear_shape28_all_arrows_green': {
    width: 422.47078,
    height: 302.84344
  },
  'Shapes_with_arrows/Rectilinear_shape28_all_arrows_pink': { width: 422.47078, height: 302.84344 },
  'Shapes_with_arrows/Rectilinear_shape28_all_arrows_purple': {
    width: 422.47078,
    height: 302.84344
  },
  'Shapes_with_arrows/Rectilinear_shape28_all_arrows_yellow': {
    width: 422.47078,
    height: 302.84344
  },
  'Shapes_with_arrows/Rectilinear_shape29_all_arrows': { width: 660.81999, height: 422.21066 },
  'Shapes_with_arrows/Rectilinear_shape29_all_arrows_blue': { width: 660.81999, height: 422.21066 },
  'Shapes_with_arrows/Rectilinear_shape29_all_arrows_green': {
    width: 660.81999,
    height: 422.21066
  },
  'Shapes_with_arrows/Rectilinear_shape29_all_arrows_pink': { width: 660.81999, height: 422.21066 },
  'Shapes_with_arrows/Rectilinear_shape29_all_arrows_purple': {
    width: 660.81999,
    height: 422.21066
  },
  'Shapes_with_arrows/Rectilinear_shape29_all_arrows_yellow': {
    width: 660.81999,
    height: 422.21066
  },
  'Shapes_with_arrows/Rectilinear_shape2_2_red_arrows': { width: 843.34196, height: 623.86652 },
  'Shapes_with_arrows/Rectilinear_shape2_all_arrows': { width: 830.37705, height: 709.00348 },
  'Shapes_with_arrows/Rectilinear_shape2_all_arrows_blue': { width: 830.37705, height: 709.00348 },
  'Shapes_with_arrows/Rectilinear_shape2_all_arrows_green': { width: 830.37705, height: 709.00348 },
  'Shapes_with_arrows/Rectilinear_shape2_all_arrows_pink': { width: 830.37705, height: 709.00348 },
  'Shapes_with_arrows/Rectilinear_shape2_all_arrows_purple': {
    width: 830.37705,
    height: 709.00348
  },
  'Shapes_with_arrows/Rectilinear_shape2_all_arrows_yellow': {
    width: 830.37705,
    height: 709.00348
  },
  'Shapes_with_arrows/Rectilinear_shape30_all_arrows': { width: 422.21065, height: 660.82037 },
  'Shapes_with_arrows/Rectilinear_shape30_all_arrows_blue': { width: 422.21065, height: 660.82037 },
  'Shapes_with_arrows/Rectilinear_shape30_all_arrows_green': {
    width: 422.21065,
    height: 660.82037
  },
  'Shapes_with_arrows/Rectilinear_shape30_all_arrows_pink': { width: 422.21065, height: 660.82037 },
  'Shapes_with_arrows/Rectilinear_shape30_all_arrows_purple': {
    width: 422.21065,
    height: 660.82037
  },
  'Shapes_with_arrows/Rectilinear_shape30_all_arrows_yellow': {
    width: 422.21065,
    height: 660.82037
  },
  'Shapes_with_arrows/Rectilinear_shape31_all_arrows': { width: 660.81999, height: 532.49384 },
  'Shapes_with_arrows/Rectilinear_shape31_all_arrows_blue': { width: 660.81999, height: 532.49384 },
  'Shapes_with_arrows/Rectilinear_shape31_all_arrows_green': {
    width: 660.81999,
    height: 532.49384
  },
  'Shapes_with_arrows/Rectilinear_shape31_all_arrows_pink': { width: 660.81999, height: 532.49384 },
  'Shapes_with_arrows/Rectilinear_shape31_all_arrows_purple': {
    width: 660.81999,
    height: 532.49384
  },
  'Shapes_with_arrows/Rectilinear_shape31_all_arrows_yellow': {
    width: 660.81999,
    height: 532.49384
  },
  'Shapes_with_arrows/Rectilinear_shape32_all_arrows': { width: 863.61704, height: 361.97626 },
  'Shapes_with_arrows/Rectilinear_shape32_all_arrows_blue': { width: 863.61704, height: 361.97626 },
  'Shapes_with_arrows/Rectilinear_shape32_all_arrows_green': {
    width: 863.61704,
    height: 361.97626
  },
  'Shapes_with_arrows/Rectilinear_shape32_all_arrows_pink': { width: 863.61704, height: 361.97626 },
  'Shapes_with_arrows/Rectilinear_shape32_all_arrows_purple': {
    width: 863.61704,
    height: 361.97626
  },
  'Shapes_with_arrows/Rectilinear_shape32_all_arrows_yellow': {
    width: 863.61704,
    height: 361.97626
  },
  'Shapes_with_arrows/Rectilinear_shape33_all_arrows': { width: 428.62117, height: 586.16907 },
  'Shapes_with_arrows/Rectilinear_shape33_all_arrows_blue': { width: 428.62117, height: 586.16907 },
  'Shapes_with_arrows/Rectilinear_shape33_all_arrows_green': {
    width: 428.62117,
    height: 586.16907
  },
  'Shapes_with_arrows/Rectilinear_shape33_all_arrows_pink': { width: 428.62117, height: 586.16907 },
  'Shapes_with_arrows/Rectilinear_shape33_all_arrows_purple': {
    width: 428.62117,
    height: 586.16907
  },
  'Shapes_with_arrows/Rectilinear_shape33_all_arrows_yellow': {
    width: 428.62117,
    height: 586.16907
  },
  'Shapes_with_arrows/Rectilinear_shape34_all_arrows': { width: 428.62117, height: 586.16907 },
  'Shapes_with_arrows/Rectilinear_shape34_all_arrows_blue': { width: 428.62117, height: 586.16907 },
  'Shapes_with_arrows/Rectilinear_shape34_all_arrows_green': {
    width: 428.62117,
    height: 586.16907
  },
  'Shapes_with_arrows/Rectilinear_shape34_all_arrows_pink': { width: 428.62117, height: 586.16907 },
  'Shapes_with_arrows/Rectilinear_shape34_all_arrows_purple': {
    width: 428.62117,
    height: 586.16907
  },
  'Shapes_with_arrows/Rectilinear_shape34_all_arrows_yellow': {
    width: 428.62117,
    height: 586.16907
  },
  'Shapes_with_arrows/Rectilinear_shape35_all_arrows': { width: 637.83568, height: 586.16907 },
  'Shapes_with_arrows/Rectilinear_shape35_all_arrows_blue': { width: 637.83568, height: 586.16907 },
  'Shapes_with_arrows/Rectilinear_shape35_all_arrows_green': {
    width: 637.83568,
    height: 586.16907
  },
  'Shapes_with_arrows/Rectilinear_shape35_all_arrows_pink': { width: 637.83568, height: 586.16907 },
  'Shapes_with_arrows/Rectilinear_shape35_all_arrows_purple': {
    width: 637.83568,
    height: 586.16907
  },
  'Shapes_with_arrows/Rectilinear_shape35_all_arrows_yellow': {
    width: 637.83568,
    height: 586.16907
  },
  'Shapes_with_arrows/Rectilinear_shape36_all_arrows': { width: 472.88317, height: 659.48663 },
  'Shapes_with_arrows/Rectilinear_shape36_all_arrows_blue': { width: 472.88317, height: 659.48663 },
  'Shapes_with_arrows/Rectilinear_shape36_all_arrows_green': {
    width: 472.88317,
    height: 659.48663
  },
  'Shapes_with_arrows/Rectilinear_shape36_all_arrows_pink': { width: 472.88317, height: 659.48663 },
  'Shapes_with_arrows/Rectilinear_shape36_all_arrows_purple': {
    width: 472.88317,
    height: 659.48663
  },
  'Shapes_with_arrows/Rectilinear_shape36_all_arrows_yellow': {
    width: 472.88317,
    height: 659.48663
  },
  'Shapes_with_arrows/Rectilinear_shape37_all_arrows': { width: 414.66613, height: 659.48663 },
  'Shapes_with_arrows/Rectilinear_shape37_all_arrows_blue': { width: 414.66613, height: 659.48663 },
  'Shapes_with_arrows/Rectilinear_shape37_all_arrows_green': {
    width: 414.66613,
    height: 659.48663
  },
  'Shapes_with_arrows/Rectilinear_shape37_all_arrows_pink': { width: 414.66613, height: 659.48663 },
  'Shapes_with_arrows/Rectilinear_shape37_all_arrows_purple': {
    width: 414.66613,
    height: 659.48663
  },
  'Shapes_with_arrows/Rectilinear_shape37_all_arrows_yellow': {
    width: 414.66613,
    height: 659.48663
  },
  'Shapes_with_arrows/Rectilinear_shape38_all_arrows': { width: 483.61983, height: 586.16907 },
  'Shapes_with_arrows/Rectilinear_shape38_all_arrows_blue': { width: 483.61983, height: 586.16907 },
  'Shapes_with_arrows/Rectilinear_shape38_all_arrows_green': {
    width: 483.61983,
    height: 586.16907
  },
  'Shapes_with_arrows/Rectilinear_shape38_all_arrows_pink': { width: 483.61983, height: 586.16907 },
  'Shapes_with_arrows/Rectilinear_shape38_all_arrows_purple': {
    width: 483.61983,
    height: 586.16907
  },
  'Shapes_with_arrows/Rectilinear_shape38_all_arrows_yellow': {
    width: 483.61983,
    height: 586.16907
  },
  'Shapes_with_arrows/Rectilinear_shape3_2_red_arrows': { width: 597.63383, height: 623.86652 },
  'Shapes_with_arrows/Rectilinear_shape3_all_arrows': { width: 861.49326, height: 655.11908 },
  'Shapes_with_arrows/Rectilinear_shape3_all_arrows_blue': { width: 861.49326, height: 655.11908 },
  'Shapes_with_arrows/Rectilinear_shape3_all_arrows_green': { width: 861.49326, height: 655.11908 },
  'Shapes_with_arrows/Rectilinear_shape3_all_arrows_pink': { width: 861.49326, height: 655.11908 },
  'Shapes_with_arrows/Rectilinear_shape3_all_arrows_purple': {
    width: 861.49326,
    height: 655.11908
  },
  'Shapes_with_arrows/Rectilinear_shape3_all_arrows_yellow': {
    width: 861.49326,
    height: 655.11908
  },
  'Shapes_with_arrows/Rectilinear_shape4_2_red_arrows': { width: 841.96677, height: 299.13345 },
  'Shapes_with_arrows/Rectilinear_shape4_all_arrows': { width: 861.49357, height: 655.11908 },
  'Shapes_with_arrows/Rectilinear_shape4_all_arrows_blue': { width: 861.49357, height: 655.11908 },
  'Shapes_with_arrows/Rectilinear_shape4_all_arrows_green': { width: 861.49357, height: 655.11908 },
  'Shapes_with_arrows/Rectilinear_shape4_all_arrows_pink': { width: 861.49357, height: 655.11908 },
  'Shapes_with_arrows/Rectilinear_shape4_all_arrows_purple': {
    width: 861.49357,
    height: 655.11908
  },
  'Shapes_with_arrows/Rectilinear_shape4_all_arrows_yellow': {
    width: 861.49357,
    height: 655.11908
  },
  'Shapes_with_arrows/Rectilinear_shape5_2_red_arrows': { width: 623.86638, height: 786.8573 },
  'Shapes_with_arrows/Rectilinear_shape5_all_arrows': { width: 842.00877, height: 389.11652 },
  'Shapes_with_arrows/Rectilinear_shape5_all_arrows_blue': { width: 842.00877, height: 389.11652 },
  'Shapes_with_arrows/Rectilinear_shape5_all_arrows_green': { width: 842.00877, height: 389.11652 },
  'Shapes_with_arrows/Rectilinear_shape5_all_arrows_pink': { width: 842.00877, height: 389.11652 },
  'Shapes_with_arrows/Rectilinear_shape5_all_arrows_purple': {
    width: 842.00877,
    height: 389.11652
  },
  'Shapes_with_arrows/Rectilinear_shape5_all_arrows_yellow': {
    width: 842.00877,
    height: 389.11652
  },
  'Shapes_with_arrows/Rectilinear_shape6_2_red_arrows': { width: 381.00252, height: 535.01917 },
  'Shapes_with_arrows/Rectilinear_shape6_all_arrows': { width: 843.34208, height: 623.86609 },
  'Shapes_with_arrows/Rectilinear_shape6_all_arrows_blue': { width: 843.34208, height: 623.86609 },
  'Shapes_with_arrows/Rectilinear_shape6_all_arrows_green': { width: 843.34208, height: 623.86609 },
  'Shapes_with_arrows/Rectilinear_shape6_all_arrows_pink': { width: 843.34208, height: 623.86609 },
  'Shapes_with_arrows/Rectilinear_shape6_all_arrows_purple': {
    width: 843.34208,
    height: 623.86609
  },
  'Shapes_with_arrows/Rectilinear_shape6_all_arrows_yellow': {
    width: 843.34208,
    height: 623.86609
  },
  'Shapes_with_arrows/Rectilinear_shape7_2_red_arrows': { width: 863.62504, height: 453.34705 },
  'Shapes_with_arrows/Rectilinear_shape7_all_arrows': { width: 665.07145, height: 669.67145 },
  'Shapes_with_arrows/Rectilinear_shape7_all_arrows_blue': { width: 665.07145, height: 669.67145 },
  'Shapes_with_arrows/Rectilinear_shape7_all_arrows_green': { width: 665.07145, height: 669.67145 },
  'Shapes_with_arrows/Rectilinear_shape7_all_arrows_pink': { width: 665.07145, height: 669.67145 },
  'Shapes_with_arrows/Rectilinear_shape7_all_arrows_purple': {
    width: 665.07145,
    height: 669.67145
  },
  'Shapes_with_arrows/Rectilinear_shape7_all_arrows_yellow': {
    width: 665.07145,
    height: 669.67145
  },
  'Shapes_with_arrows/Rectilinear_shape8_2_red_arrows': { width: 861.49357, height: 655.11908 },
  'Shapes_with_arrows/Rectilinear_shape8_all_arrows': { width: 842.00877, height: 623.86627 },
  'Shapes_with_arrows/Rectilinear_shape8_all_arrows_blue': { width: 842.00877, height: 623.86627 },
  'Shapes_with_arrows/Rectilinear_shape8_all_arrows_green': { width: 842.00877, height: 623.86627 },
  'Shapes_with_arrows/Rectilinear_shape8_all_arrows_pink': { width: 842.00877, height: 623.86627 },
  'Shapes_with_arrows/Rectilinear_shape8_all_arrows_purple': {
    width: 842.00877,
    height: 623.86627
  },
  'Shapes_with_arrows/Rectilinear_shape8_all_arrows_yellow': {
    width: 842.00877,
    height: 623.86627
  },
  'Shapes_with_arrows/Rectilinear_shape9_2_red_arrows': { width: 861.49357, height: 655.11908 },
  'Shapes_with_arrows/Rectilinear_shape9_all_arrows': { width: 431.22878, height: 623.86627 },
  'Shapes_with_arrows/Rectilinear_shape9_all_arrows_blue': { width: 431.22878, height: 623.86627 },
  'Shapes_with_arrows/Rectilinear_shape9_all_arrows_green': { width: 431.22878, height: 623.86627 },
  'Shapes_with_arrows/Rectilinear_shape9_all_arrows_pink': { width: 431.22878, height: 623.86627 },
  'Shapes_with_arrows/Rectilinear_shape9_all_arrows_purple': {
    width: 431.22878,
    height: 623.86627
  },
  'Shapes_with_arrows/Rectilinear_shape9_all_arrows_yellow': {
    width: 431.22878,
    height: 623.86627
  },
  'Shapes_with_arrows/Regular_decagon_1__arrow': { width: 716.78056, height: 731.89081 },
  'Shapes_with_arrows/Regular_heptagon_1__arrow': { width: 751.30546, height: 744.354 },
  'Shapes_with_arrows/Regular_hexagon_1__arrow': { width: 861.83597, height: 732.35999 },
  'Shapes_with_arrows/Regular_nonagon_1__arrow': { width: 761.88865, height: 732.42413 },
  'Shapes_with_arrows/Regular_octagon_1__arrow': { width: 744.6934, height: 736.6933 },
  'Shapes_with_arrows/Regular_pentagon__1__arrow': { width: 786.55326, height: 732.59607 },
  'Shapes_with_arrows/Rhombus_all__sides_marked': { width: 519.49065, height: 618.42407 },
  'Shapes_with_arrows/Right_angle_triangle10_3_arrows': { width: 857.97513, height: 554.02826 },
  'Shapes_with_arrows/Right_angle_triangle11_3_arrows': { width: 612.05412, height: 648.28876 },
  'Shapes_with_arrows/Right_angle_triangle1_2_arrows': { width: 849.56303, height: 545.77899 },
  'Shapes_with_arrows/Right_angle_triangle1_3_arrows': { width: 370.69292, height: 555.39532 },
  'Shapes_with_arrows/Right_angle_triangle2_2_arrows': { width: 635.40489, height: 331.80783 },
  'Shapes_with_arrows/Right_angle_triangle2_3_arrows': { width: 646.70878, height: 353.27921 },
  'Shapes_with_arrows/Right_angle_triangle3_2_arrows': { width: 474.79469, height: 356.27963 },
  'Shapes_with_arrows/Right_angle_triangle3_3_arrows': { width: 319.10732, height: 648.31213 },
  'Shapes_with_arrows/Right_angle_triangle4_2_arrows': { width: 555.86119, height: 356.27939 },
  'Shapes_with_arrows/Right_angle_triangle4_3_arrows': { width: 776.6229, height: 499.53839 },
  'Shapes_with_arrows/Right_angle_triangle5_2_arrows': { width: 186.60917, height: 777.05115 },
  'Shapes_with_arrows/Right_angle_triangle5_3_arrows': { width: 702.05784, height: 452.43945 },
  'Shapes_with_arrows/Right_angle_triangle6_2_arrows': { width: 521.00316, height: 518.82886 },
  'Shapes_with_arrows/Right_angle_triangle6_3_arrows': { width: 860.75754, height: 687.93427 },
  'Shapes_with_arrows/Right_angle_triangle7_3_arrows': { width: 905.31968, height: 581.92346 },
  'Shapes_with_arrows/Right_angle_triangle8_3_arrows': { width: 869.10154, height: 222.4908 },
  'Shapes_with_arrows/Right_angle_triangle9_3_arrows': { width: 435.46892, height: 767.56708 },
  'Shapes_with_arrows/Square_1_arrows': { width: 532.71587, height: 516.17548 },
  'Shapes_with_arrows/Square_2_arrows': { width: 532.71587, height: 532.71545 },
  'Shapes_with_arrows/Square__1__arrow': { width: 732.35996, height: 751.82928 },
  'Shapes_with_arrows/Square_all__sides_marked': { width: 516.17558, height: 516.17548 },
  'Shapes_with_arrows/Trapezium1_all_arrows': { width: 836.96726, height: 512.9541 },
  'Shapes_with_arrows/Trapezium2_all_arrows': { width: 846.72117, height: 512.95422 },
  'Shapes_with_arrows/Triangle10_3_arrows_right_angle': { width: 369.63625, height: 377.98306 },
  'Shapes_with_arrows/Triangle1_2_arrows': { width: 758.75706, height: 499.63138 },
  'Shapes_with_arrows/Triangle1_3_arrows_no_right_angle': { width: 769.48344, height: 504.87146 },
  'Shapes_with_arrows/Triangle1_3_arrows_right_angle': { width: 682.67833, height: 698.04773 },
  'Shapes_with_arrows/Triangle1_4_arrows_right_angle': { width: 702.57227, height: 698.04773 },
  'Shapes_with_arrows/Triangle2_2_arrows': { width: 672.72117, height: 690.97504 },
  'Shapes_with_arrows/Triangle2_3_arrows_no_right_angle': { width: 828.52647, height: 699.00934 },
  'Shapes_with_arrows/Triangle2_3_arrows_right_angle': { width: 621.60728, height: 622.49036 },
  'Shapes_with_arrows/Triangle2_4_arrows_right_angle': { width: 639.98553, height: 622.49036 },
  'Shapes_with_arrows/Triangle3_2_arrows': { width: 632.17021, height: 412.42392 },
  'Shapes_with_arrows/Triangle3_3_arrows_no_right_angle': { width: 542.24706, height: 602.84534 },
  'Shapes_with_arrows/Triangle3_3_arrows_right_angle': { width: 682.67833, height: 698.04773 },
  'Shapes_with_arrows/Triangle3_4_arrows_right_angle': { width: 700.81708, height: 698.04773 },
  'Shapes_with_arrows/Triangle4_2_arrows': { width: 631.72917, height: 608.27014 },
  'Shapes_with_arrows/Triangle4_3_arrows_no_right_angle': { width: 629.81053, height: 690.49878 },
  'Shapes_with_arrows/Triangle4_3_arrows_right_angle': { width: 748.70695, height: 758.10437 },
  'Shapes_with_arrows/Triangle4_4_arrows_right_angle': { width: 767.6358, height: 758.5459 },
  'Shapes_with_arrows/Triangle5_2_arrows': { width: 610.05461, height: 419.69421 },
  'Shapes_with_arrows/Triangle5_3_arrows_no_right_angle': { width: 715.81394, height: 538.24969 },
  'Shapes_with_arrows/Triangle5_3_arrows_right_angle': { width: 629.45781, height: 497.33084 },
  'Shapes_with_arrows/Triangle5_4_arrows_right_angle': { width: 629.45782, height: 508.89984 },
  'Shapes_with_arrows/Triangle6_2_arrows': { width: 1051.874, height: 684.79193 },
  'Shapes_with_arrows/Triangle6_3_arrows_right_angle': { width: 632.17021, height: 427.98141 },
  'Shapes_with_arrows/Triangle6_4_arrows_right_angle': { width: 636.81989, height: 435.40573 },
  'Shapes_with_arrows/Triangle7_2_arrows': { width: 1151.2608, height: 430.16742 },
  'Shapes_with_arrows/Triangle7_3_arrows_right_angle': { width: 506.11318, height: 792.30811 },
  'Shapes_with_arrows/Triangle7_4_arrows_right_angle': { width: 521.67102, height: 792.30811 },
  'Shapes_with_arrows/Triangle8_3_arrows_right_angle': { width: 481.39296, height: 430.92014 },
  'Shapes_with_arrows/Triangle9_3_arrows_right_angle': { width: 483.10201, height: 508.84293 },
  'Shapes_with_arrows/Triangle9_4_arrows_right_angle': { width: 495.021, height: 508.84293 },
  'Shapes_with_dimension_arrows/Square_blue_arrows_4': { width: 549.2556, height: 549.25562 },
  'Shapes_with_dimension_arrows/Square_green_arrows_4': { width: 549.2556, height: 549.25562 },
  'Shapes_with_dimension_arrows/Square_orange_arrows_4': { width: 549.2556, height: 549.25562 },
  'Shapes_with_dimension_arrows/Square_purple_arrows_4': { width: 549.2556, height: 549.25562 },
  'Shapes_with_dimension_arrows/Square_red_arrows_4': { width: 549.2556, height: 549.25562 },
  'Shapes_with_dimension_arrows/hexagon_blue_arrows': { width: 414, height: 369 },
  'Shapes_with_dimension_arrows/hexagon_green_arrows': { width: 414, height: 369 },
  'Shapes_with_dimension_arrows/hexagon_orange_arrows': { width: 414, height: 369 },
  'Shapes_with_dimension_arrows/hexagon_purple_arrows': { width: 414, height: 369 },
  'Shapes_with_dimension_arrows/hexagon_red_arrows': { width: 414, height: 369 },
  'Shapes_with_dimension_arrows/pentagon_blue_arrows': { width: 381, height: 363 },
  'Shapes_with_dimension_arrows/pentagon_green_arrows': { width: 381, height: 363 },
  'Shapes_with_dimension_arrows/pentagon_orange_arrows': { width: 381, height: 363 },
  'Shapes_with_dimension_arrows/pentagon_purple_arrows': { width: 381, height: 363 },
  'Shapes_with_dimension_arrows/pentagon_red_arrows': { width: 382, height: 363 },
  'Shapes_with_dimension_arrows/rectangle_blue_arrows_2': { width: 615.19946, height: 366.8656 },
  'Shapes_with_dimension_arrows/rectangle_blue_arrows_4': { width: 652.39862, height: 402.39865 },
  'Shapes_with_dimension_arrows/rectangle_green_arrows_2': { width: 615.19946, height: 366.8656 },
  'Shapes_with_dimension_arrows/rectangle_green_arrows_4': { width: 652.39862, height: 402.39865 },
  'Shapes_with_dimension_arrows/rectangle_orange_arrows_2': { width: 615.19946, height: 366.8656 },
  'Shapes_with_dimension_arrows/rectangle_orange_arrows_4': { width: 652.39862, height: 402.39865 },
  'Shapes_with_dimension_arrows/rectangle_purple_arrows_2': { width: 615.19946, height: 366.8656 },
  'Shapes_with_dimension_arrows/rectangle_purple_arrows_4': { width: 652.39862, height: 402.39865 },
  'Shapes_with_dimension_arrows/rectangle_red_arrows_2': { width: 615.19946, height: 366.8656 },
  'Shapes_with_dimension_arrows/rectangle_red_arrows_4': { width: 652.39862, height: 402.39865 },
  'Shapes_with_dimension_arrows/trapezium_isosceles_blue_arrows': { width: 483, height: 372 },
  'Shapes_with_dimension_arrows/trapezium_isosceles_green_arrows': { width: 483, height: 372 },
  'Shapes_with_dimension_arrows/trapezium_isosceles_pink_arrows': { width: 483, height: 372 },
  'Shapes_with_dimension_arrows/trapezium_isosceles_purple_arrows': { width: 483, height: 372 },
  'Shapes_with_dimension_arrows/trapezium_isosceles_white_arrows': { width: 483, height: 372 },
  'Shapes_with_dimension_arrows/trapezium_isosceles_yellow_arrows': { width: 483, height: 372 },
  'Shapes_with_dimension_arrows/triangle_RA2_blue_arrows': { width: 559, height: 366 },
  'Shapes_with_dimension_arrows/triangle_RA2_green_arrows': { width: 559, height: 366 },
  'Shapes_with_dimension_arrows/triangle_RA2_orange_arrows': { width: 559, height: 366 },
  'Shapes_with_dimension_arrows/triangle_RA2_purple_arrows': { width: 559, height: 366 },
  'Shapes_with_dimension_arrows/triangle_RA2_red_arrows': { width: 559, height: 366 },
  'Shapes_with_dimension_arrows/triangle_RA_blue_arrows': { width: 367, height: 366 },
  'Shapes_with_dimension_arrows/triangle_RA_green_arrows': { width: 367, height: 366 },
  'Shapes_with_dimension_arrows/triangle_RA_orange_arrows': { width: 367, height: 366 },
  'Shapes_with_dimension_arrows/triangle_RA_purple_arrows': { width: 367, height: 366 },
  'Shapes_with_dimension_arrows/triangle_RA_red_arrows': { width: 368, height: 366 },
  'Shapes_with_dimension_arrows/triangle_equal_1_arrow': { width: 402, height: 341 },
  'Shapes_with_dimension_arrows/triangle_equal_1_arrow_blue': { width: 402, height: 341 },
  'Shapes_with_dimension_arrows/triangle_equal_1_arrow_green': { width: 402, height: 341 },
  'Shapes_with_dimension_arrows/triangle_equal_1_arrow_orange': { width: 402, height: 341 },
  'Shapes_with_dimension_arrows/triangle_equal_1_arrow_pink': { width: 402, height: 341 },
  'Shapes_with_dimension_arrows/triangle_equal_1_arrow_purple': { width: 402, height: 341 },
  'Shapes_with_dimension_arrows/triangle_equal_1_arrow_red': { width: 402, height: 341 },
  'Shapes_with_dimension_arrows/triangle_equal_1_arrow_yellow': { width: 402, height: 341 },
  'Shapes_with_dimension_arrows/triangle_equal_blue_arrows': { width: 421, height: 363 },
  'Shapes_with_dimension_arrows/triangle_equal_green_arrows': { width: 421, height: 363 },
  'Shapes_with_dimension_arrows/triangle_equal_orange_arrows': { width: 421, height: 363 },
  'Shapes_with_dimension_arrows/triangle_equal_purple_arrows': { width: 421, height: 363 },
  'Shapes_with_dimension_arrows/triangle_equal_red_arrows': { width: 421, height: 363 },
  'Shapes_with_dimension_arrows/triangle_isos_narrow_blue_arrows': { width: 313, height: 360 },
  'Shapes_with_dimension_arrows/triangle_isos_narrow_green_arrows': { width: 313, height: 360 },
  'Shapes_with_dimension_arrows/triangle_isos_narrow_orange_arrows': { width: 313, height: 360 },
  'Shapes_with_dimension_arrows/triangle_isos_narrow_purple_arrows': { width: 313, height: 360 },
  'Shapes_with_dimension_arrows/triangle_isos_narrow_red_arrows': { width: 313, height: 360 },
  'Shapes_with_dimension_arrows/triangle_isos_wide_blue_arrows': { width: 474, height: 363 },
  'Shapes_with_dimension_arrows/triangle_isos_wide_green_arrows': { width: 474, height: 363 },
  'Shapes_with_dimension_arrows/triangle_isos_wide_orange_arrows': { width: 474, height: 363 },
  'Shapes_with_dimension_arrows/triangle_isos_wide_purple_arrows': { width: 474, height: 363 },
  'Shapes_with_dimension_arrows/triangle_isos_wide_red_arrows': { width: 474, height: 363 },
  'Shapes_with_dimension_arrows/triangle_scalene_blue_arrows': { width: 559, height: 195 },
  'Shapes_with_dimension_arrows/triangle_scalene_green_arrows': { width: 559, height: 195 },
  'Shapes_with_dimension_arrows/triangle_scalene_orange_arrows': { width: 559, height: 195 },
  'Shapes_with_dimension_arrows/triangle_scalene_purple_arrows': { width: 559, height: 195 },
  'Shapes_with_dimension_arrows/triangle_scalene_red_arrows': { width: 559, height: 195 },
  'Shapes_with_interior_angles/Equilateral_triangle_1_interior_angle': {
    width: 600.24516,
    height: 520.09454
  },
  'Shapes_with_interior_angles/Equilateral_triangle_all_interior_angles': {
    width: 602.24498,
    height: 522.09448
  },
  'Shapes_with_interior_angles/Equilateral_triangle_interior_angles': {
    width: 558.94383,
    height: 484.32657
  },
  'Shapes_with_interior_angles/Hexagon1_interior_angles': { width: 437.05071, height: 378.49731 },
  'Shapes_with_interior_angles/Hexagon2_interior_angles': { width: 382.23171, height: 436.98505 },
  'Shapes_with_interior_angles/Hexagon3_interior_angles': { width: 401.372, height: 478.89163 },
  'Shapes_with_interior_angles/Hexagon4_interior_angles': { width: 329.77517, height: 378.49731 },
  'Shapes_with_interior_angles/Hexagon5_interior_angles': { width: 683.11668, height: 243.55733 },
  'Shapes_with_interior_angles/Interior_angles_in_triangle1': {
    width: 562.12517,
    height: 487.08255
  },
  'Shapes_with_interior_angles/Interior_angles_in_triangle10': {
    width: 938.40494,
    height: 418.15195
  },
  'Shapes_with_interior_angles/Interior_angles_in_triangle11': {
    width: 466.24105,
    height: 268.1106
  },
  'Shapes_with_interior_angles/Interior_angles_in_triangle12': {
    width: 491.485,
    height: 245.82661
  },
  'Shapes_with_interior_angles/Interior_angles_in_triangle13': {
    width: 472.87355,
    height: 472.87317
  },
  'Shapes_with_interior_angles/Interior_angles_in_triangle14': {
    width: 786.41837,
    height: 418.15195
  },
  'Shapes_with_interior_angles/Interior_angles_in_triangle2': {
    width: 1269.7999,
    height: 746.89197
  },
  'Shapes_with_interior_angles/Interior_angles_in_triangle3': {
    width: 877.74619,
    height: 324.15598
  },
  'Shapes_with_interior_angles/Interior_angles_in_triangle4': {
    width: 877.74607,
    height: 278.82394
  },
  'Shapes_with_interior_angles/Interior_angles_in_triangle5': {
    width: 278.82391,
    height: 519.36157
  },
  'Shapes_with_interior_angles/Interior_angles_in_triangle6': {
    width: 443.65975,
    height: 278.82391
  },
  'Shapes_with_interior_angles/Interior_angles_in_triangle7': {
    width: 322.06252,
    height: 440.73309
  },
  'Shapes_with_interior_angles/Interior_angles_in_triangle8': {
    width: 786.41837,
    height: 418.15195
  },
  'Shapes_with_interior_angles/Interior_angles_in_triangle9': {
    width: 472.87355,
    height: 472.87317
  },
  'Shapes_with_interior_angles/Irregular_decagon1_with_interior_triangles_copy_5': {
    width: 486.99196,
    height: 386.48398
  },
  'Shapes_with_interior_angles/Irregular_decagon2_with_interior_triangles_copy_5': {
    width: 528.74498,
    height: 536.3493
  },
  'Shapes_with_interior_angles/Irregular_decagon_one_interior_angle': {
    width: 407.55196,
    height: 414.23596
  },
  'Shapes_with_interior_angles/Irregular_heptagon1_marked_interior_angles': {
    width: 803.5518,
    height: 549.27991
  },
  'Shapes_with_interior_angles/Irregular_heptagon1_with_interior_triangles_copy_2': {
    width: 537.12395,
    height: 515.64661
  },
  'Shapes_with_interior_angles/Irregular_heptagon2_marked_interior_angles': {
    width: 629.6732,
    height: 549.27997
  },
  'Shapes_with_interior_angles/Irregular_heptagon2_with_interior_triangles_copy_2': {
    width: 447.52397,
    height: 416.1973
  },
  'Shapes_with_interior_angles/Irregular_heptagon3_marked_interior_angles': {
    width: 560.23051,
    height: 516.3291
  },
  'Shapes_with_interior_angles/Irregular_heptagon_one_interior_angle': { width: 476, height: 386 },
  'Shapes_with_interior_angles/Irregular_hexagon1_marked_interior_angles': {
    width: 622.92509,
    height: 417.85999
  },
  'Shapes_with_interior_angles/Irregular_hexagon1_with_interior_triangles_copy': {
    width: 663.29722,
    height: 353.03464
  },
  'Shapes_with_interior_angles/Irregular_hexagon2_marked_interior_angles': {
    width: 586.60527,
    height: 417.85864
  },
  'Shapes_with_interior_angles/Irregular_hexagon2_with_interior_triangles_copy': {
    width: 503.30385,
    height: 316.09326
  },
  'Shapes_with_interior_angles/Irregular_hexagon3_marked_interior_angles': {
    width: 630.42387,
    height: 467.76263
  },
  'Shapes_with_interior_angles/Irregular_hexagon_one_interior_angle': { width: 628, height: 404 },
  'Shapes_with_interior_angles/Irregular_nonagon1_with_interior_triangles_copy_4': {
    width: 500.08663,
    height: 425.564
  },
  'Shapes_with_interior_angles/Irregular_nonagon2_with_interior_triangles_copy_4': {
    width: 463.00264,
    height: 497.06921
  },
  'Shapes_with_interior_angles/Irregular_nonagon_one_interior_angle': { width: 641, height: 429 },
  'Shapes_with_interior_angles/Irregular_octagon1_marked_interior_angles': {
    width: 650.75193,
    height: 549.27997
  },
  'Shapes_with_interior_angles/Irregular_octagon1_with_interior_triangles_copy_3': {
    width: 543.37596,
    height: 447.31326
  },
  'Shapes_with_interior_angles/Irregular_octagon2_marked_interior_angles': {
    width: 603.47709,
    height: 668.95441
  },
  'Shapes_with_interior_angles/Irregular_octagon2_with_interior_triangles_copy_3': {
    width: 509.38262,
    height: 478.06262
  },
  'Shapes_with_interior_angles/Irregular_octagon3_marked_interior_angles': {
    width: 732.33171,
    height: 644.1239
  },
  'Shapes_with_interior_angles/Irregular_octagon_one_interior_angle': { width: 642, height: 429 },
  'Shapes_with_interior_angles/Irregular_pentagon1_marked_interior_angles': {
    width: 878.1345,
    height: 489.91864
  },
  'Shapes_with_interior_angles/Irregular_pentagon1_with_interior_triangles': {
    width: 461.81059,
    height: 394.92395
  },
  'Shapes_with_interior_angles/Irregular_pentagon2_marked_interior_angles': {
    width: 616.23723,
    height: 515.69061
  },
  'Shapes_with_interior_angles/Irregular_pentagon2_with_interior_triangles': {
    width: 503.91463,
    height: 355.66663
  },
  'Shapes_with_interior_angles/Irregular_pentagon3_marked_interior_angles': {
    width: 927.79441,
    height: 410.18665
  },
  'Shapes_with_interior_angles/Irregular_pentagon_one_interior_angle': { width: 621, height: 415 },
  'Shapes_with_interior_angles/Irregular_quadrilateral1_interior_angles': {
    width: 580.73723,
    height: 458.85062
  },
  'Shapes_with_interior_angles/Irregular_quadrilateral1_marked_interior_angles': {
    width: 525.48924,
    height: 461.05997
  },
  'Shapes_with_interior_angles/Irregular_quadrilateral2_interior_angles': {
    width: 760.71055,
    height: 505.6893
  },
  'Shapes_with_interior_angles/Irregular_quadrilateral2_marked_interior_angles': {
    width: 745.03178,
    height: 501.36658
  },
  'Shapes_with_interior_angles/Irregular_quadrilateral3_interior_angles': {
    width: 658.91056,
    height: 377.99197
  },
  'Shapes_with_interior_angles/Irregular_quadrilateral3_marked_interior_angles': {
    width: 533.08391,
    height: 647.57318
  },
  'Shapes_with_interior_angles/Irregular_quadrilateral4_interior_angles': {
    width: 675.94914,
    height: 388.63461
  },
  'Shapes_with_interior_angles/Irregular_triangle1_marked_interior_angles': {
    width: 743.83433,
    height: 346.51862
  },
  'Shapes_with_interior_angles/Irregular_triangle2_marked_interior_angles': {
    width: 656.21141,
    height: 351.74911
  },
  'Shapes_with_interior_angles/Irregular_triangle3_marked_interior_angles': {
    width: 581.23308,
    height: 660.30371
  },
  'Shapes_with_interior_angles/Isosceles_triangle1_interior_angles': {
    width: 322.21325,
    height: 484.32645
  },
  'Shapes_with_interior_angles/Isosceles_triangle2_interior_angles': {
    width: 322.21322,
    height: 348.30917
  },
  'Shapes_with_interior_angles/Isosceles_triangle3_interior_angles': {
    width: 549.15965,
    height: 565.58649
  },
  'Shapes_with_interior_angles/Kite_two_isosceles_triangles1': {
    width: 321.46386,
    height: 422.25851
  },
  'Shapes_with_interior_angles/Kite_two_isosceles_triangles2': {
    width: 284.00533,
    height: 632.11993
  },
  'Shapes_with_interior_angles/Kite_two_isosceles_triangles3': {
    width: 632.1012,
    height: 323.25342
  },
  'Shapes_with_interior_angles/Kite_two_isosceles_triangles4': {
    width: 412.73842,
    height: 361.17725
  },
  'Shapes_with_interior_angles/Parallelogram1_interior_angles': {
    width: 596.05992,
    height: 365.84
  },
  'Shapes_with_interior_angles/Parallelogram1_with_interior_triangles': {
    width: 821.68656,
    height: 286.564
  },
  'Shapes_with_interior_angles/Parallelogram2_interior_angles': {
    width: 803.03983,
    height: 366.16132
  },
  'Shapes_with_interior_angles/Parallelogram2_with_interior_triangles': {
    width: 286.56399,
    height: 821.68658
  },
  'Shapes_with_interior_angles/Parallelogram3_interior_angles': {
    width: 604.14384,
    height: 613.51196
  },
  'Shapes_with_interior_angles/Parallelogram4_interior_angles': {
    width: 569.71416,
    height: 389.81091
  },
  'Shapes_with_interior_angles/Pentagon1_interior_angles': { width: 361.73061, height: 344.12531 },
  'Shapes_with_interior_angles/Pentagon2_interior_angles': { width: 359.53063, height: 359.46664 },
  'Shapes_with_interior_angles/Pentagon3_interior_angles': { width: 361.73049, height: 213.44519 },
  'Shapes_with_interior_angles/Pentagon4_interior_angles': { width: 444.95323, height: 291.09598 },
  'Shapes_with_interior_angles/Pentagon5_interior_angles': { width: 315.56396, height: 409.66794 },
  'Shapes_with_interior_angles/Quadrilateral10_interior_angles': {
    width: 299.92419,
    height: 262.02548
  },
  'Shapes_with_interior_angles/Quadrilateral11_interior_angles': {
    width: 310.38455,
    height: 239.49156
  },
  'Shapes_with_interior_angles/Quadrilateral1_interior_angles': {
    width: 631.12657,
    height: 451.72662
  },
  'Shapes_with_interior_angles/Quadrilateral1_with_interior_triangles': {
    width: 753.79978,
    height: 497.25192
  },
  'Shapes_with_interior_angles/Quadrilateral2_interior_angles': {
    width: 556.75371,
    height: 455.63931
  },
  'Shapes_with_interior_angles/Quadrilateral2_with_interior_triangles': {
    width: 716.98887,
    height: 400.21048
  },
  'Shapes_with_interior_angles/Quadrilateral3_interior_angles': {
    width: 440.2546,
    height: 465.94257
  },
  'Shapes_with_interior_angles/Quadrilateral4_interior_angles': {
    width: 442.48925,
    height: 490.85059
  },
  'Shapes_with_interior_angles/Quadrilateral5_interior_angles': {
    width: 465.02925,
    height: 593.30652
  },
  'Shapes_with_interior_angles/Quadrilateral6_interior_angles': { width: 632, height: 452 },
  'Shapes_with_interior_angles/Quadrilateral7_interior_angles': { width: 632, height: 452 },
  'Shapes_with_interior_angles/Quadrilateral8_interior_angles': {
    width: 456.11911,
    height: 267.79965
  },
  'Shapes_with_interior_angles/Quadrilateral9_interior_angles': {
    width: 456.11771,
    height: 165.62681
  },
  'Shapes_with_interior_angles/Rectangle1_interior_angles': { width: 722.99461, height: 283.80533 },
  'Shapes_with_interior_angles/Rectangle1_interior_lines_and_angles': {
    width: 597.91331,
    height: 399.276
  },
  'Shapes_with_interior_angles/Rectangle2_interior_angles': { width: 999.98392, height: 147.70667 },
  'Shapes_with_interior_angles/Rectangle2_interior_lines_and_angles': {
    width: 710.92265,
    height: 233.448
  },
  'Shapes_with_interior_angles/Rectangle3_interior_lines_and_angles': {
    width: 710.92265,
    height: 172.53867
  },
  'Shapes_with_interior_angles/Rectangle4_interior_lines_and_angles': { width: 451, height: 713 },
  'Shapes_with_interior_angles/Rectangle_with_interior_triangles': {
    width: 691.93327,
    height: 323.25333
  },
  'Shapes_with_interior_angles/Regular_decagon_1_interior_angle': {
    width: 520.09465,
    height: 520.09467
  },
  'Shapes_with_interior_angles/Regular_decagon_all_interior_angles': {
    width: 522.09465,
    height: 522.09467
  },
  'Shapes_with_interior_angles/Regular_decagon_one_interior_angle': { width: 615, height: 429 },
  'Shapes_with_interior_angles/Regular_decagon_with_interior_triangles': {
    width: 469.82396,
    height: 446.92667
  },
  'Shapes_with_interior_angles/Regular_heptagon_1_interior_angle': {
    width: 533.41863,
    height: 520.09467
  },
  'Shapes_with_interior_angles/Regular_heptagon_all_interior_angles': {
    width: 535.41863,
    height: 522.09461
  },
  'Shapes_with_interior_angles/Regular_heptagon_one_interior_angle': { width: 568, height: 429 },
  'Shapes_with_interior_angles/Regular_heptagon_with_interior_triangles': {
    width: 459.04262,
    height: 447.58398
  },
  'Shapes_with_interior_angles/Regular_hexagon_1_interior_angle': {
    width: 595.09324,
    height: 515.6333
  },
  'Shapes_with_interior_angles/Regular_hexagon_all_interior_angles': {
    width: 597.09324,
    height: 517.6333
  },
  'Shapes_with_interior_angles/Regular_hexagon_one_interior_angle': { width: 596, height: 429 },
  'Shapes_with_interior_angles/Regular_hexagon_with_interior_triangles': {
    width: 475.82796,
    height: 412.34665
  },
  'Shapes_with_interior_angles/Regular_nonagon_1_interior_angle': { width: 435, height: 429 },
  'Shapes_with_interior_angles/Regular_nonagon_all_interior_angles': {
    width: 434.38599,
    height: 427.83298
  },
  'Shapes_with_interior_angles/Regular_nonagon_one_interior_angle': {
    width: 433.38665,
    height: 426.83197
  },
  'Shapes_with_interior_angles/Regular_nonagon_with_interior_triangles': {
    width: 454.18398,
    height: 447.31332
  },
  'Shapes_with_interior_angles/Regular_octagon_1_interior_angle': {
    width: 520.09465,
    height: 520.09467
  },
  'Shapes_with_interior_angles/Regular_octagon_all_interior_angles': {
    width: 522.09465,
    height: 522.09467
  },
  'Shapes_with_interior_angles/Regular_octagon_one_interior_angle': { width: 637, height: 429 },
  'Shapes_with_interior_angles/Regular_octagon_with_interior_triangles': {
    width: 447.31331,
    height: 447.31332
  },
  'Shapes_with_interior_angles/Regular_pentagon_1_interior_angle': {
    width: 543.15727,
    height: 516.67065
  },
  'Shapes_with_interior_angles/Regular_pentagon_all_interior_angles': {
    width: 545.15721,
    height: 518.67059
  },
  'Shapes_with_interior_angles/Regular_pentagon_one_interior_angle': { width: 499, height: 429 },
  'Shapes_with_interior_angles/Regular_pentagon_with_interior_triangles': {
    width: 433.46395,
    height: 412.34662
  },
  'Shapes_with_interior_angles/Rhombus1_interior_angles': { width: 870.38767, height: 424.06506 },
  'Shapes_with_interior_angles/Rhombus2_interior_angles': { width: 424.06505, height: 870.3877 },
  'Shapes_with_interior_angles/Rhombus3_interior_angles': { width: 1064.0101, height: 327.97864 },
  'Shapes_with_interior_angles/Rhombus4_interior_angles': { width: 584.53056, height: 520.93463 },
  'Shapes_with_interior_angles/Rhombus_with_interior_triangles': {
    width: 634.66252,
    height: 439.58398
  },
  'Shapes_with_interior_angles/Right_angled_triangle_interior_angles': {
    width: 484.32717,
    height: 484.32651
  },
  'Shapes_with_interior_angles/Scalene_triangle1_interior_angles': {
    width: 774.19029,
    height: 332.90131
  },
  'Shapes_with_interior_angles/Scalene_triangle2_interior_angles': {
    width: 862.47959,
    height: 332.90131
  },
  'Shapes_with_interior_angles/Scalene_triangle3_interior_angles': {
    width: 862.47971,
    height: 471.25327
  },
  'Shapes_with_interior_angles/Scalene_triangle4_interior_angles': {
    width: 792.58189,
    height: 341.70911
  },
  'Shapes_with_interior_angles/Scalene_triangle5_interior_angles': {
    width: 1084.2988,
    height: 170.40799
  },
  'Shapes_with_interior_angles/Square_1_interior_angle': { width: 520.09465, height: 520.09467 },
  'Shapes_with_interior_angles/Square_all_interior_angles': { width: 522.09465, height: 522.09467 },
  'Shapes_with_interior_angles/Square_interior_angles': { width: 484.32799, height: 484.32666 },
  'Shapes_with_interior_angles/Square_with_interior_triangles': {
    width: 392.15596,
    height: 392.15598
  },
  'Shapes_with_interior_angles/Trapezium1_interior_angles': { width: 683.04387, height: 567.06042 },
  'Shapes_with_interior_angles/Trapezium1_with_interior_triangles': {
    width: 763.52116,
    height: 325.93732
  },
  'Shapes_with_interior_angles/Trapezium2_interior_angles': { width: 683.04454, height: 480.34842 },
  'Shapes_with_interior_angles/Trapezium2_with_interior_triangles': {
    width: 890.59049,
    height: 464.63998
  },
  'Shapes_with_interior_angles/Trapezium3_interior_angles': { width: 683.04387, height: 567.06042 },
  'Shapes_with_interior_angles/Trapezium4_interior_angles': { width: 683.04387, height: 567.06042 },
  'Shapes_with_marked_sides/Equilateral_triangle_all__sides_blue': {
    width: 542.27739,
    height: 494.04919
  },
  'Shapes_with_marked_sides/Equilateral_triangle_all__sides_green': {
    width: 542.27739,
    height: 494.04919
  },
  'Shapes_with_marked_sides/Equilateral_triangle_all__sides_marked': {
    width: 542.27739,
    height: 494.04919
  },
  'Shapes_with_marked_sides/Equilateral_triangle_all__sides_pink': {
    width: 542.27739,
    height: 494.04919
  },
  'Shapes_with_marked_sides/Equilateral_triangle_all__sides_purple': {
    width: 542.27739,
    height: 494.04919
  },
  'Shapes_with_marked_sides/Equilateral_triangle_all__sides_yellow': {
    width: 542.27739,
    height: 494.04919
  },
  'Shapes_with_marked_sides/Isosceles1_markedlines': { width: 623.70927, height: 623.70947 },
  'Shapes_with_marked_sides/Isosceles1_markedlines_blue': { width: 623.70927, height: 623.70947 },
  'Shapes_with_marked_sides/Isosceles1_markedlines_green': { width: 623.70927, height: 623.70947 },
  'Shapes_with_marked_sides/Isosceles1_markedlines_pink': { width: 623.70927, height: 623.70947 },
  'Shapes_with_marked_sides/Isosceles1_markedlines_purple': { width: 623.70927, height: 623.70947 },
  'Shapes_with_marked_sides/Isosceles1_markedlines_yellow': { width: 623.70927, height: 623.70947 },
  'Shapes_with_marked_sides/Isosceles2_markedlines': { width: 305.27727, height: 704.24762 },
  'Shapes_with_marked_sides/Isosceles2_markedlines_blue': { width: 305.27727, height: 704.24762 },
  'Shapes_with_marked_sides/Isosceles2_markedlines_green': { width: 305.27727, height: 704.24762 },
  'Shapes_with_marked_sides/Isosceles2_markedlines_pink': { width: 305.27727, height: 704.24762 },
  'Shapes_with_marked_sides/Isosceles2_markedlines_purple': { width: 305.27727, height: 704.24762 },
  'Shapes_with_marked_sides/Isosceles2_markedlines_yellow': { width: 305.27727, height: 704.24762 },
  'Shapes_with_marked_sides/Isosceles3_markedlines': { width: 534.18907, height: 332.48792 },
  'Shapes_with_marked_sides/Isosceles3_markedlines_blue': { width: 534.18907, height: 332.48792 },
  'Shapes_with_marked_sides/Isosceles3_markedlines_green': { width: 534.18907, height: 332.48792 },
  'Shapes_with_marked_sides/Isosceles3_markedlines_pink': { width: 534.18907, height: 332.48792 },
  'Shapes_with_marked_sides/Isosceles3_markedlines_purple': { width: 534.18907, height: 332.48792 },
  'Shapes_with_marked_sides/Isosceles3_markedlines_yellow': { width: 534.18907, height: 332.48792 },
  'Shapes_with_marked_sides/Isosceles4_markedlines': { width: 1058.8983, height: 530.44928 },
  'Shapes_with_marked_sides/Isosceles4_markedlines_blue': { width: 1058.8983, height: 530.44928 },
  'Shapes_with_marked_sides/Isosceles4_markedlines_green': { width: 1058.8983, height: 530.44928 },
  'Shapes_with_marked_sides/Isosceles4_markedlines_pink': { width: 1058.8983, height: 530.44928 },
  'Shapes_with_marked_sides/Isosceles4_markedlines_purple': { width: 1058.8983, height: 530.44928 },
  'Shapes_with_marked_sides/Isosceles4_markedlines_yellow': { width: 1058.8983, height: 530.44928 },
  'Shapes_with_marked_sides/Regular_decagon_all__sides_marked': {
    width: 492.74291,
    height: 516.17548
  },
  'Shapes_with_marked_sides/Regular_decagon_all__sides_marked_blue': {
    width: 492.74291,
    height: 516.17548
  },
  'Shapes_with_marked_sides/Regular_decagon_all__sides_marked_green': {
    width: 492.74291,
    height: 516.17548
  },
  'Shapes_with_marked_sides/Regular_decagon_all__sides_marked_pink': {
    width: 492.74291,
    height: 516.17548
  },
  'Shapes_with_marked_sides/Regular_decagon_all__sides_marked_purple': {
    width: 492.74291,
    height: 516.17548
  },
  'Shapes_with_marked_sides/Regular_decagon_all__sides_marked_yellow': {
    width: 492.74291,
    height: 516.17548
  },
  'Shapes_with_marked_sides/Regular_heptagon_all__sides_marked': {
    width: 481.55254,
    height: 492.26364
  },
  'Shapes_with_marked_sides/Regular_heptagon_all__sides_marked_blue': {
    width: 481.55254,
    height: 492.26364
  },
  'Shapes_with_marked_sides/Regular_heptagon_all__sides_marked_green': {
    width: 481.55254,
    height: 492.26364
  },
  'Shapes_with_marked_sides/Regular_heptagon_all__sides_marked_pink': {
    width: 481.55254,
    height: 492.26364
  },
  'Shapes_with_marked_sides/Regular_heptagon_all__sides_marked_purple': {
    width: 481.55254,
    height: 492.26364
  },
  'Shapes_with_marked_sides/Regular_heptagon_all__sides_marked_yellow': {
    width: 481.55254,
    height: 492.26364
  },
  'Shapes_with_marked_sides/Regular_hexagon_all__sides_marked': {
    width: 541.12407,
    height: 514.70184
  },
  'Shapes_with_marked_sides/Regular_hexagon_all__sides_marked_blue': {
    width: 541.12407,
    height: 514.70184
  },
  'Shapes_with_marked_sides/Regular_hexagon_all__sides_marked_green': {
    width: 541.12407,
    height: 514.70184
  },
  'Shapes_with_marked_sides/Regular_hexagon_all__sides_marked_pink': {
    width: 541.12407,
    height: 514.70184
  },
  'Shapes_with_marked_sides/Regular_hexagon_all__sides_marked_purple': {
    width: 541.12407,
    height: 514.70184
  },
  'Shapes_with_marked_sides/Regular_hexagon_all__sides_marked_yellow': {
    width: 541.12407,
    height: 514.70184
  },
  'Shapes_with_marked_sides/Regular_nonagon_all__sides_marked': {
    width: 494.22804,
    height: 492.81778
  },
  'Shapes_with_marked_sides/Regular_nonagon_all__sides_marked_blue': {
    width: 494.22804,
    height: 492.81778
  },
  'Shapes_with_marked_sides/Regular_nonagon_all__sides_marked_green': {
    width: 494.22804,
    height: 492.81778
  },
  'Shapes_with_marked_sides/Regular_nonagon_all__sides_marked_pink': {
    width: 494.22804,
    height: 492.81778
  },
  'Shapes_with_marked_sides/Regular_nonagon_all__sides_marked_purple': {
    width: 494.22804,
    height: 492.81778
  },
  'Shapes_with_marked_sides/Regular_nonagon_all__sides_marked_yellow': {
    width: 494.22804,
    height: 492.81778
  },
  'Shapes_with_marked_sides/Regular_octagon_all__sides_marked': {
    width: 516.17546,
    height: 516.17548
  },
  'Shapes_with_marked_sides/Regular_octagon_all__sides_marked_blue': {
    width: 516.17546,
    height: 516.17548
  },
  'Shapes_with_marked_sides/Regular_octagon_all__sides_marked_green': {
    width: 516.17546,
    height: 516.17548
  },
  'Shapes_with_marked_sides/Regular_octagon_all__sides_marked_pink': {
    width: 516.17546,
    height: 516.17548
  },
  'Shapes_with_marked_sides/Regular_octagon_all__sides_marked_purple': {
    width: 516.17546,
    height: 516.17548
  },
  'Shapes_with_marked_sides/Regular_octagon_all__sides_marked_yellow': {
    width: 516.17546,
    height: 516.17548
  },
  'Shapes_with_marked_sides/Regular_pentagon_all__sides_marked': {
    width: 492.99111,
    height: 492.40738
  },
  'Shapes_with_marked_sides/Regular_pentagon_all__sides_marked_blue': {
    width: 492.99111,
    height: 492.40738
  },
  'Shapes_with_marked_sides/Regular_pentagon_all__sides_marked_green': {
    width: 492.99111,
    height: 492.40738
  },
  'Shapes_with_marked_sides/Regular_pentagon_all__sides_marked_pink': {
    width: 492.99111,
    height: 492.40738
  },
  'Shapes_with_marked_sides/Regular_pentagon_all__sides_marked_purple': {
    width: 492.99111,
    height: 492.40738
  },
  'Shapes_with_marked_sides/Regular_pentagon_all__sides_marked_yellow': {
    width: 492.99111,
    height: 492.40738
  },
  'Shapes_with_marked_sides/Square_all__sides_marked_blue': { width: 516.17558, height: 516.17548 },
  'Shapes_with_marked_sides/Square_all__sides_marked_green': {
    width: 516.17558,
    height: 516.17548
  },
  'Shapes_with_marked_sides/Square_all__sides_marked_pink': { width: 516.17558, height: 516.17548 },
  'Shapes_with_marked_sides/Square_all__sides_marked_purple': {
    width: 516.17558,
    height: 516.17548
  },
  'Shapes_with_marked_sides/Square_all__sides_marked_yellow': {
    width: 516.17558,
    height: 516.17548
  },
  'Shapes_with_missing_parts/Missing_part_shape1': { width: 554.20262, height: 177.70132 },
  'Shapes_with_missing_parts/Missing_part_shape10': { width: 602.13463, height: 228.62399 },
  'Shapes_with_missing_parts/Missing_part_shape2': { width: 377.76799, height: 419.51999 },
  'Shapes_with_missing_parts/Missing_part_shape3': { width: 561.46666, height: 345.30933 },
  'Shapes_with_missing_parts/Missing_part_shape4': { width: 454.80263, height: 468.32132 },
  'Shapes_with_missing_parts/Missing_part_shape5': { width: 592.67595, height: 317.51599 },
  'Shapes_with_missing_parts/Missing_part_shape6': { width: 512.80663, height: 229.02533 },
  'Shapes_with_missing_parts/Missing_part_shape7': { width: 602.13463, height: 228.62399 },
  'Shapes_with_missing_parts/Missing_part_shape8': { width: 454.80263, height: 468.32132 },
  'Shapes_with_missing_parts/Missing_part_shape9': { width: 512.80663, height: 229.02533 },
  'Shapes_with_no_grid/Translucent_rectilinear_shape1': { width: 749.10411, height: 608.44464 },
  'Shapes_with_no_grid/Translucent_rectilinear_shape10': { width: 750.22247, height: 686.22009 },
  'Shapes_with_no_grid/Translucent_rectilinear_shape11': { width: 747.59617, height: 687.39831 },
  'Shapes_with_no_grid/Translucent_rectilinear_shape12': { width: 503.36104, height: 608.138 },
  'Shapes_with_no_grid/Translucent_rectilinear_shape2': { width: 671.40642, height: 603.60339 },
  'Shapes_with_no_grid/Translucent_rectilinear_shape3': { width: 750.06413, height: 602.87683 },
  'Shapes_with_no_grid/Translucent_rectilinear_shape4': { width: 665.98503, height: 769.29358 },
  'Shapes_with_no_grid/Translucent_rectilinear_shape5': { width: 652.929, height: 368.82221 },
  'Shapes_with_no_grid/Translucent_rectilinear_shape6': { width: 747.10368, height: 767.74017 },
  'Shapes_with_no_grid/Translucent_rectilinear_shape7': { width: 721.9915, height: 768.13861 },
  'Shapes_with_no_grid/Translucent_rectilinear_shape8': { width: 747.54826, height: 687.18738 },
  'Shapes_with_no_grid/Translucent_rectilinear_shape9': { width: 745.24974, height: 686.5318 },
  Shed: { width: 442.69305, height: 394.23184 },
  Sheep: { width: 262.68674, height: 190.11697 },
  Shopping_trolley: { width: 595.28, height: 595.28 },
  Sink: { width: NaN, height: NaN },
  SliderArrow: { width: 26, height: 111 },
  Soap_dispenser: { width: 184.46399, height: 352.86825 },
  Spider: { width: 239.09561, height: 242.21926 },
  Spinner: { width: 170, height: 170 },
  Sports_ball_football: { width: 301.33331, height: 301.33331 },
  Sports_ball_rugby_ball: { width: 425.99466, height: 256.13598 },
  Square: { width: 100, height: 100 },
  'Square/square': { width: 328, height: 328 },
  'Square/square_1_arrow': { width: 377, height: 328 },
  'Square/square_1_arrow_blue': { width: 377, height: 328 },
  'Square/square_1_arrow_green': { width: 377, height: 328 },
  'Square/square_1_arrow_pink': { width: 377, height: 328 },
  'Square/square_1_arrow_purple': { width: 377, height: 328 },
  'Square/square_1_arrow_yellow': { width: 377, height: 328 },
  'Square/square_blue': { width: 328, height: 328 },
  'Square/square_green': { width: 328, height: 328 },
  'Square/square_grey': { width: 328, height: 328 },
  'Square/square_orange': { width: 328, height: 328 },
  'Square/square_pink': { width: 328, height: 328 },
  'Square/square_purple': { width: 328, height: 328 },
  'Square/square_red': { width: 328, height: 328 },
  'Square/square_turquoise': { width: 328, height: 328 },
  'Square/square_white': { width: 328, height: 328 },
  'Square/square_yellow': { width: 328, height: 328 },
  'Stack_of_Cubes_in_3D_Shape/cube_cubes': { width: 255.13641, height: 285.04559 },
  'Stack_of_Cubes_in_3D_Shape/cylinder_cubes': { width: 130.06282, height: 264.0452 },
  'Stack_of_Cubes_in_3D_Shape/hexagonal_prism_cubes': { width: 158.05989, height: 238.81774 },
  'Stack_of_Cubes_in_3D_Shape/square_based_pyramid_cubes': { width: 255.13629, height: 238.83999 },
  'Stack_of_Cubes_in_3D_Shape/triangular_prism_cubes': { width: 321.37305, height: 315.90973 },
  Star: { width: 47, height: 46 },
  StarSilver: { width: 47, height: 46 },
  Star_blue: { width: 299.45816, height: 284.99686 },
  Star_green: { width: 299.45816, height: 284.99686 },
  Star_pink: { width: 299.45816, height: 284.99686 },
  Star_purple: { width: 299.45816, height: 284.99686 },
  Star_red: { width: 299.45816, height: 284.99686 },
  Star_yellow: { width: 299.45816, height: 284.99686 },
  Sticker_sheet: { width: 1233.21, height: 959 },
  Stopwatch: { width: 401.12665, height: 507.40985 },
  Suitcase: { width: 265.30399, height: 203.9616 },
  Sunflower: { width: 212.07147, height: 433.31204 },
  'Sweets/SweetBlue': { width: 70.184, height: 48.657 },
  'Sweets/SweetGreen': { width: 70.184, height: 48.657 },
  'Sweets/SweetPink': { width: 70.184, height: 48.657 },
  'Sweets/SweetRed': { width: 70.184, height: 48.657 },
  'SymmetricalShapes/both11_green': { width: 395.42065, height: 352.22595 },
  'SymmetricalShapes/both11_pink': { width: 395.42065, height: 352.22595 },
  'SymmetricalShapes/both11_purple': { width: 395.42065, height: 352.22595 },
  'SymmetricalShapes/both11_white': { width: 395.42065, height: 352.22595 },
  'SymmetricalShapes/both11_yellow': { width: 395.42065, height: 352.22595 },
  'SymmetricalShapes/both12_green': { width: 553.31982, height: 306.98931 },
  'SymmetricalShapes/both12_pink': { width: 553.31982, height: 306.98931 },
  'SymmetricalShapes/both12_purple': { width: 553.31982, height: 306.98931 },
  'SymmetricalShapes/both12_white': { width: 553.31982, height: 306.98931 },
  'SymmetricalShapes/both12_yellow': { width: 553.31982, height: 306.98931 },
  'SymmetricalShapes/both1_green': { width: 457.82397, height: 104.36933 },
  'SymmetricalShapes/both1_pink': { width: 457.82397, height: 104.36933 },
  'SymmetricalShapes/both1_purple': { width: 457.82397, height: 104.36933 },
  'SymmetricalShapes/both1_white': { width: 457.82397, height: 104.36933 },
  'SymmetricalShapes/both1_yellow': { width: 457.82397, height: 104.36933 },
  'SymmetricalShapes/both3_green': { width: 498.15634, height: 426.42123 },
  'SymmetricalShapes/both3_pink': { width: 498.15634, height: 426.42123 },
  'SymmetricalShapes/both3_purple': { width: 498.15634, height: 426.42123 },
  'SymmetricalShapes/both3_white': { width: 498.15634, height: 426.42123 },
  'SymmetricalShapes/both3_yellow': { width: 498.15634, height: 426.42123 },
  'SymmetricalShapes/both4_green': { width: 170.90266, height: 338.74398 },
  'SymmetricalShapes/both4_pink': { width: 170.90266, height: 338.74398 },
  'SymmetricalShapes/both4_purple': { width: 170.90266, height: 338.74398 },
  'SymmetricalShapes/both4_white': { width: 170.90266, height: 338.74398 },
  'SymmetricalShapes/both4_yellow': { width: 170.90266, height: 338.74398 },
  'SymmetricalShapes/both6_green': { width: 339.56665, height: 339.56533 },
  'SymmetricalShapes/both6_pink': { width: 339.56665, height: 339.56533 },
  'SymmetricalShapes/both6_purple': { width: 339.56665, height: 339.56533 },
  'SymmetricalShapes/both6_white': { width: 339.56665, height: 339.56533 },
  'SymmetricalShapes/both6_yellow': { width: 339.56665, height: 339.56533 },
  'SymmetricalShapes/both8_green': { width: 523.31097, height: 349.16732 },
  'SymmetricalShapes/both8_pink': { width: 523.31097, height: 349.16732 },
  'SymmetricalShapes/both8_purple': { width: 523.31097, height: 349.16732 },
  'SymmetricalShapes/both8_white': { width: 523.31097, height: 349.16732 },
  'SymmetricalShapes/both8_yellow': { width: 523.31097, height: 349.16732 },
  'SymmetricalShapes/both9_green': { width: 99.263999, height: 345.51333 },
  'SymmetricalShapes/both9_pink': { width: 99.263999, height: 345.51333 },
  'SymmetricalShapes/both9_purple': { width: 99.263999, height: 345.51333 },
  'SymmetricalShapes/both9_white': { width: 99.263999, height: 345.51333 },
  'SymmetricalShapes/both9_yellow': { width: 99.263999, height: 345.51333 },
  'SymmetricalShapes/horizontal1_green': { width: 350.08819, height: 293.92932 },
  'SymmetricalShapes/horizontal1_pink': { width: 350.08819, height: 293.92932 },
  'SymmetricalShapes/horizontal1_purple': { width: 350.08819, height: 293.92932 },
  'SymmetricalShapes/horizontal1_white': { width: 350.08819, height: 293.92932 },
  'SymmetricalShapes/horizontal1_yellow': { width: 350.08819, height: 293.92932 },
  'SymmetricalShapes/horizontal2_green': { width: 374.29074, height: 433.95312 },
  'SymmetricalShapes/horizontal2_pink': { width: 374.29074, height: 433.95312 },
  'SymmetricalShapes/horizontal2_purple': { width: 374.29074, height: 433.95312 },
  'SymmetricalShapes/horizontal2_white': { width: 374.29074, height: 433.95312 },
  'SymmetricalShapes/horizontal2_yellow': { width: 374.29074, height: 433.95312 },
  'SymmetricalShapes/horizontal3_green': { width: 333.38666, height: 320.62133 },
  'SymmetricalShapes/horizontal3_pink': { width: 333.38666, height: 320.62133 },
  'SymmetricalShapes/horizontal3_purple': { width: 333.38666, height: 320.62133 },
  'SymmetricalShapes/horizontal3_white': { width: 333.38666, height: 320.62133 },
  'SymmetricalShapes/horizontal3_yellow': { width: 333.38666, height: 320.62133 },
  'SymmetricalShapes/horizontal4_green': { width: 407.03528, height: 539.14886 },
  'SymmetricalShapes/horizontal4_pink': { width: 407.03528, height: 539.14886 },
  'SymmetricalShapes/horizontal4_purple': { width: 407.03528, height: 539.14886 },
  'SymmetricalShapes/horizontal4_white': { width: 407.03528, height: 539.14886 },
  'SymmetricalShapes/horizontal4_yellow': { width: 407.03528, height: 539.14886 },
  'SymmetricalShapes/vertical1_green': { width: 348.86132, height: 336.127 },
  'SymmetricalShapes/vertical1_pink': { width: 348.86132, height: 336.127 },
  'SymmetricalShapes/vertical1_purple': { width: 348.86132, height: 336.127 },
  'SymmetricalShapes/vertical1_white': { width: 348.86132, height: 336.127 },
  'SymmetricalShapes/vertical1_yellow': { width: 348.86132, height: 336.127 },
  'SymmetricalShapes/vertical2_green': { width: 346.45199, height: 346.45333 },
  'SymmetricalShapes/vertical2_pink': { width: 346.45199, height: 346.45333 },
  'SymmetricalShapes/vertical2_purple': { width: 346.45199, height: 346.45333 },
  'SymmetricalShapes/vertical2_white': { width: 346.45199, height: 346.45333 },
  'SymmetricalShapes/vertical2_yellow': { width: 346.45199, height: 346.45333 },
  'SymmetricalShapes/vertical3_green': { width: 367.76672, height: 351.45999 },
  'SymmetricalShapes/vertical3_pink': { width: 367.76672, height: 351.45999 },
  'SymmetricalShapes/vertical3_purple': { width: 367.76672, height: 351.45999 },
  'SymmetricalShapes/vertical3_white': { width: 367.76672, height: 351.45999 },
  'SymmetricalShapes/vertical3_yellow': { width: 367.76672, height: 351.45999 },
  'Symmetrical_shapes_with_lines/shape_10_incorrect_line_of_symmetry_a': {
    width: 293.92798,
    height: 448.75466
  },
  'Symmetrical_shapes_with_lines/shape_10_incorrect_line_of_symmetry_b': {
    width: 392.94266,
    height: 350.08657
  },
  'Symmetrical_shapes_with_lines/shape_10_line_of_symmetry_b': {
    width: 293.92798,
    height: 447.51333
  },
  'Symmetrical_shapes_with_lines/shape_11_incorrect_line_of_symmetry_a': {
    width: 531.54932,
    height: 374.28921
  },
  'Symmetrical_shapes_with_lines/shape_11_incorrect_line_of_symmetry_b': {
    width: 433.94958,
    height: 472.54397
  },
  'Symmetrical_shapes_with_lines/shape_11_line_of_symmetry_c': {
    width: 433.94958,
    height: 472.70666
  },
  'Symmetrical_shapes_with_lines/shape_12_incorrect_line_of_symmetry_a': {
    width: 564.82262,
    height: 320.33904
  },
  'Symmetrical_shapes_with_lines/shape_12_incorrect_line_of_symmetry_b': {
    width: 466.96789,
    height: 418.77599
  },
  'Symmetrical_shapes_with_lines/shape_12_line_of_symmetry_a': {
    width: 466.96789,
    height: 418.95864
  },
  'Symmetrical_shapes_with_lines/shape_13_incorrect_line_of_symmetry_a': {
    width: 450.04532,
    height: 367.76418
  },
  'Symmetrical_shapes_with_lines/shape_13_incorrect_line_of_symmetry_b': {
    width: 351.45865,
    height: 466.07198
  },
  'Symmetrical_shapes_with_lines/shape_13_line_of_symmetry_c': {
    width: 351.45865,
    height: 460.51199
  },
  'Symmetrical_shapes_with_lines/shape_14_incorrect_line_of_symmetry_a': {
    width: 320.61999,
    height: 419.51065
  },
  'Symmetrical_shapes_with_lines/shape_14_incorrect_line_of_symmetry_b': {
    width: 420.31467,
    height: 320.61999
  },
  'Symmetrical_shapes_with_lines/shape_14_line_of_symmetry_b': {
    width: 320.61999,
    height: 419.61864
  },
  'Symmetrical_shapes_with_lines/shape_14_line_of_symmetry_c': {
    width: 419.62133,
    height: 320.61999
  },
  'Symmetrical_shapes_with_lines/shape_15_incorrect_line_of_symmetry_a': {
    width: 348.85998,
    height: 434.02798
  },
  'Symmetrical_shapes_with_lines/shape_15_incorrect_line_of_symmetry_b': {
    width: 447.24264,
    height: 336.12582
  },
  'Symmetrical_shapes_with_lines/shape_15_line_of_symmetry_b': {
    width: 348.85998,
    height: 433.77199
  },
  'Symmetrical_shapes_with_lines/shape_16_incorrect_line_of_symmetry_a': {
    width: 419.36798,
    height: 333.38531
  },
  'Symmetrical_shapes_with_lines/shape_16_incorrect_line_of_symmetry_b': {
    width: 320.61999,
    height: 431.97866
  },
  'Symmetrical_shapes_with_lines/shape_16_line_of_symmetry_a': {
    width: 170.90134,
    height: 437.92531
  },
  'Symmetrical_shapes_with_lines/shape_16_line_of_symmetry_c': {
    width: 269.97732,
    height: 338.74264
  },
  'Symmetrical_shapes_with_lines/shape_17_incorrect_line_of_symmetry_a': {
    width: 539.14697,
    height: 506.17464
  },
  'Symmetrical_shapes_with_lines/shape_17_incorrect_line_of_symmetry_b': {
    width: 637.35333,
    height: 407.03338
  },
  'Symmetrical_shapes_with_lines/shape_17_line_of_symmetry_b': {
    width: 369.50992,
    height: 416.272
  },
  'Symmetrical_shapes_with_lines/shape_17_line_of_symmetry_c': {
    width: 467.52264,
    height: 318.14666
  },
  'Symmetrical_shapes_with_lines/shape_18_incorrect_line_of_symmetry_a': {
    width: 346.45199,
    height: 445.13864
  },
  'Symmetrical_shapes_with_lines/shape_18_incorrect_line_of_symmetry_b': {
    width: 445.63199,
    height: 346.45065
  },
  'Symmetrical_shapes_with_lines/shape_18_line_of_symmetry_a': {
    width: 339.56534,
    height: 431.96932
  },
  'Symmetrical_shapes_with_lines/shape_18_line_of_symmetry_d': {
    width: 438.98532,
    height: 339.56399
  },
  'Symmetrical_shapes_with_lines/shape_19_incorrect_line_of_symmetry_a': {
    width: 395.41876,
    height: 450.70932
  },
  'Symmetrical_shapes_with_lines/shape_19_incorrect_line_of_symmetry_b': {
    width: 494.112,
    height: 352.22408
  },
  'Symmetrical_shapes_with_lines/shape_19_line_of_symmetry_d': {
    width: 320.61999,
    height: 430.9533
  },
  'Symmetrical_shapes_with_lines/shape_1_incorrect_line_of_symmetry_a': {
    width: 457.82266,
    height: 202.31467
  },
  'Symmetrical_shapes_with_lines/shape_1_incorrect_line_of_symmetry_b': {
    width: 556.82935,
    height: 104.368
  },
  'Symmetrical_shapes_with_lines/shape_1_line_of_symmetry_b': {
    width: 457.82266,
    height: 196.75733
  },
  'Symmetrical_shapes_with_lines/shape_1_line_of_symmetry_d': { width: 548.58929, height: 104.368 },
  'Symmetrical_shapes_with_lines/shape_20_incorrect_line_of_symmetry_a': {
    width: 651.88262,
    height: 306.988
  },
  'Symmetrical_shapes_with_lines/shape_20_incorrect_line_of_symmetry_b': {
    width: 553.31817,
    height: 406.14266
  },
  'Symmetrical_shapes_with_lines/shape_20_line_of_symmetry_d': {
    width: 539.14697,
    height: 506.14797
  },
  'Symmetrical_shapes_with_lines/shape_21_incorrect_line_of_symmetry_a': {
    width: 385.60931,
    height: 486.98931
  },
  'Symmetrical_shapes_with_lines/shape_21_incorrect_line_of_symmetry_b': {
    width: 484.38666,
    height: 389.16644
  },
  'Symmetrical_shapes_with_lines/shape_21_line_of_symmetry_d': {
    width: 346.45199,
    height: 445.39599
  },
  'Symmetrical_shapes_with_lines/shape_22_line_of_symmetry_d': {
    width: 448.92667,
    height: 293.92797
  },
  'Symmetrical_shapes_with_lines/shape_23_line_of_symmetry_c': {
    width: 472.63332,
    height: 433.94958
  },
  'Symmetrical_shapes_with_lines/shape_24_line_of_symmetry_b': {
    width: 395.41876,
    height: 445.95864
  },
  'Symmetrical_shapes_with_lines/shape_24_line_of_symmetry_d': {
    width: 489.97598,
    height: 352.22408
  },
  'Symmetrical_shapes_with_lines/shape_25_line_of_symmetry_a': {
    width: 651.59198,
    height: 306.988
  },
  'Symmetrical_shapes_with_lines/shape_25_line_of_symmetry_c': {
    width: 553.31817,
    height: 405.68798
  },
  'Symmetrical_shapes_with_lines/shape_26_line_of_symmetry_a': {
    width: 385.60931,
    height: 484.1693
  },
  'Symmetrical_shapes_with_lines/shape_2_incorrect_line_of_symmetry_a': {
    width: 394.14398,
    height: 293.92797
  },
  'Symmetrical_shapes_with_lines/shape_2_incorrect_line_of_symmetry_b': {
    width: 295.74798,
    height: 393.14397
  },
  'Symmetrical_shapes_with_lines/shape_2_line_of_symmetry_a': {
    width: 295.74798,
    height: 392.69064
  },
  'Symmetrical_shapes_with_lines/shape_2_line_of_symmetry_c': {
    width: 393.39065,
    height: 293.92797
  },
  'Symmetrical_shapes_with_lines/shape_3_incorrect_line_of_symmetry_a': {
    width: 593.82532,
    height: 426.41576
  },
  'Symmetrical_shapes_with_lines/shape_3_incorrect_line_of_symmetry_b': {
    width: 498.15207,
    height: 522.7
  },
  'Symmetrical_shapes_with_lines/shape_3_line_of_symmetry_b': { width: 498.14901, height: 517.484 },
  'Symmetrical_shapes_with_lines/shape_3_line_of_symmetry_d': {
    width: 592.52398,
    height: 426.41576
  },
  'Symmetrical_shapes_with_lines/shape_4_incorrect_line_of_symmetry_a': {
    width: 368.2767,
    height: 449.03197
  },
  'Symmetrical_shapes_with_lines/shape_4_incorrect_line_of_symmetry_b': {
    width: 467.38666,
    height: 350.25198
  },
  'Symmetrical_shapes_with_lines/shape_4_line_of_symmetry_a': {
    width: 368.2767,
    height: 448.61065
  },
  'Symmetrical_shapes_with_lines/shape_5_incorrect_line_of_symmetry_a': {
    width: 369.50992,
    height: 416.54931
  },
  'Symmetrical_shapes_with_lines/shape_5_incorrect_line_of_symmetry_b': {
    width: 462.58132,
    height: 318.14666
  },
  'Symmetrical_shapes_with_lines/shape_5_line_of_symmetry_b': {
    width: 369.50992,
    height: 416.87197
  },
  'Symmetrical_shapes_with_lines/shape_5_line_of_symmetry_c': {
    width: 441.83865,
    height: 318.14666
  },
  'Symmetrical_shapes_with_lines/shape_6_incorrect_line_of_symmetry_a': {
    width: 438.60931,
    height: 339.56399
  },
  'Symmetrical_shapes_with_lines/shape_6_incorrect_line_of_symmetry_b': {
    width: 339.56534,
    height: 438.56664
  },
  'Symmetrical_shapes_with_lines/shape_6_line_of_symmetry_a': {
    width: 339.56534,
    height: 438.24932
  },
  'Symmetrical_shapes_with_lines/shape_6_line_of_symmetry_d': {
    width: 437.81732,
    height: 339.56399
  },
  'Symmetrical_shapes_with_lines/shape_7_incorrect_line_of_symmetry_a': {
    width: 399.95865,
    height: 392.56533
  },
  'Symmetrical_shapes_with_lines/shape_7_incorrect_line_of_symmetry_b': {
    width: 498.31467,
    height: 293.92797
  },
  'Symmetrical_shapes_with_lines/shape_7_line_of_symmetry_a': {
    width: 498.45865,
    height: 293.92797
  },
  'Symmetrical_shapes_with_lines/shape_7_line_of_symmetry_c': {
    width: 399.95865,
    height: 390.62533
  },
  'Symmetrical_shapes_with_lines/shape_8_incorrect_line_of_symmetry_a': {
    width: 523.30853,
    height: 448.0533
  },
  'Symmetrical_shapes_with_lines/shape_8_incorrect_line_of_symmetry_b': {
    width: 621.25598,
    height: 349.16573
  },
  'Symmetrical_shapes_with_lines/shape_8_line_of_symmetry_b': {
    width: 523.30853,
    height: 447.67864
  },
  'Symmetrical_shapes_with_lines/shape_8_line_of_symmetry_c': {
    width: 617.89197,
    height: 349.16573
  },
  'Symmetrical_shapes_with_lines/shape_9_incorrect_line_of_symmetry_a': {
    width: 532.51733,
    height: 312.02798
  },
  'Symmetrical_shapes_with_lines/shape_9_incorrect_line_of_symmetry_b': {
    width: 433.43567,
    height: 411.30532
  },
  'Symmetrical_shapes_with_lines/shape_9_line_of_symmetry_d': {
    width: 433.43567,
    height: 411.16265
  },
  Teddy_bear_1: { width: 421.72018, height: 511.74704 },
  Teddy_bear_2: { width: 299.05954, height: 325.76681 },
  Television: { width: 581.74798, height: 333.12533 },
  'Thermometers/Horizontal_Thermometer': { width: 766, height: 142 },
  'Thermometers/Vertical_Thermometer_blank': { width: 113.18533, height: 390.62534 },
  'Tiles/White_blue_17_17': { width: 5512.0005, height: 5512 },
  'Tiles/White_blue_18_18': { width: 5836.001, height: 5836 },
  'Tiles/White_blue_19_19': { width: 6160.0005, height: 6160 },
  'Tiles/White_blue_21_21': { width: 6808.0005, height: 6808 },
  'Tiles/White_blue_22_22': { width: 7132.0005, height: 7132 },
  'Tiles/White_blue_23_23': { width: 7456.0005, height: 7456.0005 },
  'Tiles/White_blue_24_24': { width: 7780.0005, height: 7780.0005 },
  'Tiles/White_blue_25_25': { width: 8104.0005, height: 8104.0005 },
  'Tiles/White_blue_26_26': { width: 8428, height: 8428 },
  'Tiles/White_blue_27_27': { width: 8752, height: 8752 },
  'Tiles/White_blue_28_28': { width: 9076, height: 9076 },
  'Tiles/White_blue_29_29': { width: 9400, height: 9400 },
  'Tiles/White_green_17_17': { width: 5512.0005, height: 5512 },
  'Tiles/White_green_18_18': { width: 5836.001, height: 5836 },
  'Tiles/White_green_19_19': { width: 6160.0005, height: 6160 },
  'Tiles/White_green_21_21': { width: 6808.0005, height: 6808 },
  'Tiles/White_green_22_22': { width: 7132.0005, height: 7132 },
  'Tiles/White_green_23_23': { width: 7456.0005, height: 7456.0005 },
  'Tiles/White_green_24_24': { width: 7780.0005, height: 7780.0005 },
  'Tiles/White_green_25_25': { width: 8104.0005, height: 8104.0005 },
  'Tiles/White_green_26_26': { width: 8428, height: 8428 },
  'Tiles/White_green_27_27': { width: 8752, height: 8752 },
  'Tiles/White_green_28_28': { width: 9076, height: 9076 },
  'Tiles/White_green_29_29': { width: 9400, height: 9400 },
  'Tiles/White_pink_17_17': { width: 5512.0005, height: 5512 },
  'Tiles/White_pink_18_18': { width: 5836.001, height: 5836 },
  'Tiles/White_pink_19_19': { width: 6160.0005, height: 6160 },
  'Tiles/White_pink_21_21': { width: 6808.0005, height: 6808 },
  'Tiles/White_pink_22_22': { width: 7132.0005, height: 7132 },
  'Tiles/White_pink_23_23': { width: 7456.0005, height: 7456.0005 },
  'Tiles/White_pink_24_24': { width: 7780.0005, height: 7780.0005 },
  'Tiles/White_pink_25_25': { width: 8104.0005, height: 8104.0005 },
  'Tiles/White_pink_26_26': { width: 8428, height: 8428 },
  'Tiles/White_pink_27_27': { width: 8752, height: 8752 },
  'Tiles/White_pink_28_28': { width: 9076, height: 9076 },
  'Tiles/White_pink_29_29': { width: 9400, height: 9400 },
  'Tiles/White_purple_17_17': { width: 5512.0005, height: 5512 },
  'Tiles/White_purple_18_18': { width: 5836.001, height: 5836 },
  'Tiles/White_purple_19_19': { width: 6160.0005, height: 6160 },
  'Tiles/White_purple_21_21': { width: 6808.0005, height: 6808 },
  'Tiles/White_purple_22_22': { width: 7132.0005, height: 7132 },
  'Tiles/White_purple_23_23': { width: 7456.0005, height: 7456.0005 },
  'Tiles/White_purple_24_24': { width: 7780.0005, height: 7780.0005 },
  'Tiles/White_purple_25_25': { width: 8104.0005, height: 8104.0005 },
  'Tiles/White_purple_26_26': { width: 8428, height: 8428 },
  'Tiles/White_purple_27_27': { width: 8752, height: 8752 },
  'Tiles/White_purple_28_28': { width: 9076, height: 9076 },
  'Tiles/White_purple_29_29': { width: 9400, height: 9400 },
  'Tiles/White_yellow_17_17': { width: 5512.0005, height: 5512 },
  'Tiles/White_yellow_18_18': { width: 5836.001, height: 5836 },
  'Tiles/White_yellow_19_19': { width: 6160.0005, height: 6160 },
  'Tiles/White_yellow_21_21': { width: 6808.0005, height: 6808 },
  'Tiles/White_yellow_22_22': { width: 7132.0005, height: 7132 },
  'Tiles/White_yellow_23_23': { width: 7456.0005, height: 7456.0005 },
  'Tiles/White_yellow_24_24': { width: 7780.0005, height: 7780.0005 },
  'Tiles/White_yellow_25_25': { width: 8104.0005, height: 8104.0005 },
  'Tiles/White_yellow_26_26': { width: 8428, height: 8428 },
  'Tiles/White_yellow_27_27': { width: 8752, height: 8752 },
  'Tiles/White_yellow_28_28': { width: 9076, height: 9076 },
  'Tiles/White_yellow_29_29': { width: 9400, height: 9400 },
  Tiny: { width: 247, height: 173 },
  TinySmiling: { width: 123.44401, height: 94.318672 },
  Tomato_sauce_ketchup: { width: 238.43178, height: 565.91571 },
  Toolbox: { width: 662.27356, height: 482.15731 },
  Toy_car: { width: 674.20245, height: 219.63171 },
  Transparent_barrel: { width: 187.18799, height: 236.71199 },
  'Transport_toys/Train_carriage': { width: 418.0264, height: 200.06868 },
  'Transport_toys/Transport_toys_Car': { width: 332.58392, height: 192.68742 },
  'Transport_toys/Transport_toys_Sailboat': { width: 372.99411, height: 289.81317 },
  'Transport_toys/Transport_toys_Train': { width: 345.60868, height: 250.81676 },
  'Transport_toys/Transport_toys_plane': { width: 407.84998, height: 202.03567 },
  'Trapezium/trapezium_isosceles': { width: 435.93967, height: 328 },
  'Trapezium/trapezium_isosceles_blue': { width: 435.93967, height: 328 },
  'Trapezium/trapezium_isosceles_blue_one_interior_angle_lhs': { width: 355, height: 267 },
  'Trapezium/trapezium_isosceles_blue_one_interior_angle_rhs': { width: 355, height: 267 },
  'Trapezium/trapezium_isosceles_green': { width: 435.93967, height: 328 },
  'Trapezium/trapezium_isosceles_green_one_interior_angle_lhs': { width: 355, height: 267 },
  'Trapezium/trapezium_isosceles_green_one_interior_angle_rhs': { width: 355, height: 267 },
  'Trapezium/trapezium_isosceles_orange': { width: 435.93967, height: 328 },
  'Trapezium/trapezium_isosceles_pink': { width: 435.93967, height: 328 },
  'Trapezium/trapezium_isosceles_pink_one_interior_angle_lhs': { width: 355, height: 267 },
  'Trapezium/trapezium_isosceles_pink_one_interior_angle_rhs': { width: 355, height: 267 },
  'Trapezium/trapezium_isosceles_purple': { width: 435.93967, height: 328 },
  'Trapezium/trapezium_isosceles_purple_one_interior_angle_lhs': { width: 355, height: 267 },
  'Trapezium/trapezium_isosceles_purple_one_interior_angle_rhs': { width: 355, height: 267 },
  'Trapezium/trapezium_isosceles_red': { width: 435.93967, height: 328 },
  'Trapezium/trapezium_isosceles_turquoise': { width: 435.93967, height: 328 },
  'Trapezium/trapezium_isosceles_white': { width: 435.93967, height: 328 },
  'Trapezium/trapezium_isosceles_yellow': { width: 435.93967, height: 328 },
  'Trapezium/trapezium_isosceles_yellow_one_interior_angle_lhs': { width: 355, height: 267 },
  'Trapezium/trapezium_isosceles_yellow_one_interior_angle_rhs': { width: 355, height: 267 },
  Tree_A: { width: 260.82464, height: 255.94374 },
  Tree_B: { width: 252.39358, height: 360.27987 },
  Triangle: { width: 88, height: 75 },
  TriangleMan: { width: 168, height: 158 },
  TriangleWhite: { width: 88, height: 75 },
  True: { width: 18, height: 18 },
  Tube_of_crisps: { width: 106.54504, height: 297.83585 },
  'Turns_and_angles/Fullturn_antclockwise': { width: 248.97999, height: 442.99026 },
  'Turns_and_angles/Fullturn_clockwise': { width: 248.97865, height: 442.99026 },
  'Turns_and_angles/Halfturn_anticlockwise': { width: 134.4628, height: 636.76038 },
  'Turns_and_angles/Halfturn_clockwise': { width: 134.46173, height: 636.76038 },
  'Turns_and_angles/Quarterturn_anticlockwise': { width: 328.186, height: 328.47253 },
  'Turns_and_angles/Quarterturn_clockwise': { width: 328.186, height: 328.47253 },
  'Turns_and_angles/Threequarterturn_anticlockwise': { width: 442.70452, height: 442.98959 },
  'Turns_and_angles/Threequarterturn_clockwise': { width: 442.70436, height: 442.99066 },
  'Unbroken_shapes/arrow_transparent': { width: 431.08823, height: 253.75083 },
  'Unbroken_shapes/circle_semi_transparent': { width: 164.66666, height: 329.35217 },
  'Unbroken_shapes/circle_transparent': { width: 328, height: 328 },
  'Unbroken_shapes/cross_transparent': { width: 328, height: 328 },
  'Unbroken_shapes/hexagon_transparent': { width: 376.6188, height: 326.16132 },
  'Unbroken_shapes/kite_transparent': { width: 241.97533, height: 327.06537 },
  'Unbroken_shapes/parallelogram_transparent': { width: 583.19189, height: 328 },
  'Unbroken_shapes/pentagon_house_transparent': { width: 328, height: 328.47925 },
  'Unbroken_shapes/pentagon_transparent': { width: 341.99026, height: 325.25348 },
  'Unbroken_shapes/rectangle_transparent': { width: 577.33331, height: 328 },
  'Unbroken_shapes/rhombus_transparent': { width: 371.22794, height: 328 },
  'Unbroken_shapes/square_transparent': { width: 328, height: 328 },
  'Unbroken_shapes/trapezium_RA_transparent': { width: 482.49249, height: 328 },
  'Unbroken_shapes/trapezium_isosceles_transparent': { width: 435.93967, height: 328 },
  'Unbroken_shapes/triangle_RA_transparent': { width: 330.82843, height: 330.82843 },
  'Unbroken_shapes/triangle_equal_transparent': { width: 379.87177, height: 329.52768 },
  'Unbroken_shapes/triangle_isos_narrow_transparent': { width: 272.25427, height: 330.77796 },
  'Unbroken_shapes/triangle_isos_wide_transparent': { width: 441.78482, height: 329.11145 },
  'Unbroken_shapes/triangle_scalene_transparent': { width: 446.37164, height: 330.20886 },
  'Unequal_shapes_10_parts/Circle_unequal_10-10': { width: 310.09598, height: 310.09598 },
  'Unequal_shapes_10_parts/Pentagon_unequal_10-10': { width: 341.99026, height: 325.25348 },
  'Unequal_shapes_10_parts/Square_unequal_10-10': { width: 286.728, height: 286.728 },
  'Unequal_shapes_11_parts/Circle_unequal_11-11': { width: 310.09598, height: 310.09598 },
  'Unequal_shapes_11_parts/Rectangle_unequal_11-11': { width: 406.944, height: 231.71066 },
  'Unequal_shapes_11_parts/Square_unequal_11-11': { width: 286.728, height: 286.728 },
  'Unequal_shapes_12_parts/Circle_unequal_12-12': { width: 310.09598, height: 310.09598 },
  'Unequal_shapes_12_parts/Rectangle_unequal_12-12': { width: 406.944, height: 231.71066 },
  'Unequal_shapes_12_parts/Square_unequal_12-12': { width: 286.728, height: 286.728 },
  'Unequal_shapes_2_parts/Arrow_unequal_1_2_1_blue': { width: 350, height: 280 },
  'Unequal_shapes_2_parts/Arrow_unequal_1_2_1_green': { width: 350, height: 280 },
  'Unequal_shapes_2_parts/Arrow_unequal_1_2_1_yellow': { width: 350, height: 280 },
  'Unequal_shapes_2_parts/Arrow_unequal_1_2_2_blue': { width: 350, height: 280 },
  'Unequal_shapes_2_parts/Arrow_unequal_1_2_2_green': { width: 350, height: 280 },
  'Unequal_shapes_2_parts/Arrow_unequal_1_2_2_yellow': { width: 350, height: 280 },
  'Unequal_shapes_2_parts/Arrow_unequal_1_2_3_blue': { width: 350, height: 280 },
  'Unequal_shapes_2_parts/Arrow_unequal_1_2_3_green': { width: 350, height: 280 },
  'Unequal_shapes_2_parts/Arrow_unequal_1_2_3_yellow': { width: 350, height: 280 },
  'Unequal_shapes_2_parts/Arrow_unequal_1_2_4_blue': { width: 350, height: 280 },
  'Unequal_shapes_2_parts/Arrow_unequal_1_2_4_green': { width: 350, height: 280 },
  'Unequal_shapes_2_parts/Arrow_unequal_1_2_4_yellow': { width: 350, height: 280 },
  'Unequal_shapes_2_parts/Circle_unequal_1_2_1_blue': { width: 309, height: 309 },
  'Unequal_shapes_2_parts/Circle_unequal_1_2_1_green': { width: 309, height: 309 },
  'Unequal_shapes_2_parts/Circle_unequal_1_2_1_yellow': { width: 309, height: 309 },
  'Unequal_shapes_2_parts/Circle_unequal_1_2_2_blue': { width: 308, height: 309 },
  'Unequal_shapes_2_parts/Circle_unequal_1_2_2_green': { width: 308, height: 309 },
  'Unequal_shapes_2_parts/Circle_unequal_1_2_2_yellow': { width: 308, height: 309 },
  'Unequal_shapes_2_parts/Circle_unequal_1_2_3_blue': { width: 309, height: 309 },
  'Unequal_shapes_2_parts/Circle_unequal_1_2_3_green': { width: 309, height: 309 },
  'Unequal_shapes_2_parts/Circle_unequal_1_2_3_yellow': { width: 309, height: 309 },
  'Unequal_shapes_2_parts/Circle_unequal_1_2_4_blue': { width: 309, height: 308 },
  'Unequal_shapes_2_parts/Circle_unequal_1_2_4_green': { width: 309, height: 308 },
  'Unequal_shapes_2_parts/Circle_unequal_1_2_4_yellow': { width: 309, height: 308 },
  'Unequal_shapes_2_parts/Circle_unequal_1_2_5_blue': { width: 309, height: 309 },
  'Unequal_shapes_2_parts/Circle_unequal_1_2_5_green': { width: 309, height: 309 },
  'Unequal_shapes_2_parts/Circle_unequal_1_2_5_yellow': { width: 309, height: 309 },
  'Unequal_shapes_2_parts/Circle_unequal_1_2_6_blue': { width: 309, height: 309 },
  'Unequal_shapes_2_parts/Circle_unequal_1_2_6_green': { width: 309, height: 309 },
  'Unequal_shapes_2_parts/Circle_unequal_1_2_6_yellow': { width: 309, height: 309 },
  'Unequal_shapes_2_parts/Heart_unequal_1_2_1_blue': { width: 290, height: 290 },
  'Unequal_shapes_2_parts/Heart_unequal_1_2_1_green': { width: 290, height: 290 },
  'Unequal_shapes_2_parts/Heart_unequal_1_2_1_yellow': { width: 290, height: 290 },
  'Unequal_shapes_2_parts/Heart_unequal_1_2_2_blue': { width: 290, height: 290 },
  'Unequal_shapes_2_parts/Heart_unequal_1_2_2_green': { width: 290, height: 290 },
  'Unequal_shapes_2_parts/Heart_unequal_1_2_2_yellow': { width: 290, height: 290 },
  'Unequal_shapes_2_parts/Hexagon_unequal_1_2_1_blue': { width: 378, height: 327 },
  'Unequal_shapes_2_parts/Hexagon_unequal_1_2_1_green': { width: 378, height: 327 },
  'Unequal_shapes_2_parts/Hexagon_unequal_1_2_1_yellow': { width: 378, height: 327 },
  'Unequal_shapes_2_parts/Hexagon_unequal_1_2_2_blue': { width: 378, height: 328 },
  'Unequal_shapes_2_parts/Hexagon_unequal_1_2_2_green': { width: 378, height: 328 },
  'Unequal_shapes_2_parts/Hexagon_unequal_1_2_2_yellow': { width: 378, height: 328 },
  'Unequal_shapes_2_parts/Hexagon_unequal_1_2_3_blue': { width: 378, height: 328 },
  'Unequal_shapes_2_parts/Hexagon_unequal_1_2_3_green': { width: 378, height: 328 },
  'Unequal_shapes_2_parts/Hexagon_unequal_1_2_3_yellow': { width: 378, height: 328 },
  'Unequal_shapes_2_parts/Kite_unequal_1-2': { width: 241.97533, height: 327.06537 },
  'Unequal_shapes_2_parts/Kite_unequal_2-2': { width: 241.97533, height: 327.06537 },
  'Unequal_shapes_2_parts/Octagon_unequal_1_2_1_blue': { width: 334, height: 334 },
  'Unequal_shapes_2_parts/Octagon_unequal_1_2_1_green': { width: 334, height: 334 },
  'Unequal_shapes_2_parts/Octagon_unequal_1_2_1_yellow': { width: 334, height: 334 },
  'Unequal_shapes_2_parts/Octagon_unequal_1_2_2_blue': { width: 334, height: 334 },
  'Unequal_shapes_2_parts/Octagon_unequal_1_2_2_green': { width: 334, height: 334 },
  'Unequal_shapes_2_parts/Octagon_unequal_1_2_2_yellow': { width: 334, height: 334 },
  'Unequal_shapes_2_parts/Octagon_unequal_1_2_3_blue': { width: 334, height: 334 },
  'Unequal_shapes_2_parts/Octagon_unequal_1_2_3_green': { width: 334, height: 334 },
  'Unequal_shapes_2_parts/Octagon_unequal_1_2_3_yellow': { width: 334, height: 334 },
  'Unequal_shapes_2_parts/Octagon_unequal_1_2_4_blue': { width: 334, height: 334 },
  'Unequal_shapes_2_parts/Octagon_unequal_1_2_4_green': { width: 334, height: 334 },
  'Unequal_shapes_2_parts/Octagon_unequal_1_2_4_yellow': { width: 334, height: 334 },
  'Unequal_shapes_2_parts/Rectangle_unequal_1_2_1_blue': { width: 544, height: 288 },
  'Unequal_shapes_2_parts/Rectangle_unequal_1_2_1_green': { width: 544, height: 288 },
  'Unequal_shapes_2_parts/Rectangle_unequal_1_2_1_yellow': { width: 544, height: 288 },
  'Unequal_shapes_2_parts/Rectangle_unequal_1_2_2_blue': { width: 544, height: 288 },
  'Unequal_shapes_2_parts/Rectangle_unequal_1_2_2_green': { width: 544, height: 288 },
  'Unequal_shapes_2_parts/Rectangle_unequal_1_2_2_yellow': { width: 544, height: 288 },
  'Unequal_shapes_2_parts/Rectangle_unequal_1_2_3_blue': { width: 548, height: 286 },
  'Unequal_shapes_2_parts/Rectangle_unequal_1_2_3_green': { width: 548, height: 286 },
  'Unequal_shapes_2_parts/Rectangle_unequal_1_2_3_yellow': { width: 548, height: 286 },
  'Unequal_shapes_2_parts/Rectangle_unequal_1_2_4_blue': { width: 548, height: 286 },
  'Unequal_shapes_2_parts/Rectangle_unequal_1_2_4_green': { width: 548, height: 286 },
  'Unequal_shapes_2_parts/Rectangle_unequal_1_2_4_yellow': { width: 548, height: 286 },
  'Unequal_shapes_2_parts/Rectangle_unequal_1_2_5_blue': { width: 548, height: 287 },
  'Unequal_shapes_2_parts/Rectangle_unequal_1_2_5_green': { width: 548, height: 287 },
  'Unequal_shapes_2_parts/Rectangle_unequal_1_2_5_yellow': { width: 548, height: 287 },
  'Unequal_shapes_2_parts/Rectangle_unequal_1_2_6_blue': { width: 548, height: 287 },
  'Unequal_shapes_2_parts/Rectangle_unequal_1_2_6_green': { width: 548, height: 287 },
  'Unequal_shapes_2_parts/Rectangle_unequal_1_2_6_yellow': { width: 548, height: 287 },
  'Unequal_shapes_2_parts/Square_unequal_1-2': { width: 286.728, height: 286.728 },
  'Unequal_shapes_2_parts/Square_unequal_1_2_1_blue': { width: 287, height: 287 },
  'Unequal_shapes_2_parts/Square_unequal_1_2_1_green': { width: 287, height: 287 },
  'Unequal_shapes_2_parts/Square_unequal_1_2_1_yellow': { width: 287, height: 287 },
  'Unequal_shapes_2_parts/Square_unequal_1_2_2_blue': { width: 287, height: 287 },
  'Unequal_shapes_2_parts/Square_unequal_1_2_2_green': { width: 287, height: 287 },
  'Unequal_shapes_2_parts/Square_unequal_1_2_2_yellow': { width: 287, height: 287 },
  'Unequal_shapes_2_parts/Square_unequal_1_2_3_blue': { width: 294, height: 288 },
  'Unequal_shapes_2_parts/Square_unequal_1_2_3_green': { width: 294, height: 288 },
  'Unequal_shapes_2_parts/Square_unequal_1_2_3_yellow': { width: 294, height: 288 },
  'Unequal_shapes_2_parts/Square_unequal_1_2_4_blue': { width: 294, height: 288 },
  'Unequal_shapes_2_parts/Square_unequal_1_2_4_green': { width: 294, height: 288 },
  'Unequal_shapes_2_parts/Square_unequal_1_2_4_yellow': { width: 294, height: 288 },
  'Unequal_shapes_2_parts/Square_unequal_1_2_5_blue': { width: 294, height: 287 },
  'Unequal_shapes_2_parts/Square_unequal_1_2_5_green': { width: 294, height: 287 },
  'Unequal_shapes_2_parts/Square_unequal_1_2_5_yellow': { width: 294, height: 287 },
  'Unequal_shapes_2_parts/Square_unequal_1_2_6_blue': { width: 294, height: 287 },
  'Unequal_shapes_2_parts/Square_unequal_1_2_6_green': { width: 294, height: 287 },
  'Unequal_shapes_2_parts/Square_unequal_1_2_6_yellow': { width: 294, height: 287 },
  'Unequal_shapes_2_parts/Square_unequal_2-2': { width: 286.728, height: 286.728 },
  'Unequal_shapes_2_parts/Star_unequal_1_2_1_blue': { width: 350, height: 350 },
  'Unequal_shapes_2_parts/Star_unequal_1_2_1_green': { width: 350, height: 350 },
  'Unequal_shapes_2_parts/Star_unequal_1_2_1_yellow': { width: 350, height: 350 },
  'Unequal_shapes_2_parts/Star_unequal_1_2_2_blue': { width: 350, height: 350 },
  'Unequal_shapes_2_parts/Star_unequal_1_2_2_green': { width: 350, height: 350 },
  'Unequal_shapes_2_parts/Star_unequal_1_2_2_yellow': { width: 350, height: 350 },
  'Unequal_shapes_2_parts/Triangle_unequal_1-2': { width: 323.30908, height: 280.461 },
  'Unequal_shapes_2_parts/Triangle_unequal_1_2_1_blue': { width: 410, height: 410 },
  'Unequal_shapes_2_parts/Triangle_unequal_1_2_1_green': { width: 410, height: 410 },
  'Unequal_shapes_2_parts/Triangle_unequal_1_2_1_yellow': { width: 410, height: 410 },
  'Unequal_shapes_2_parts/Triangle_unequal_1_2_2_blue': { width: 324, height: 281 },
  'Unequal_shapes_2_parts/Triangle_unequal_1_2_2_green': { width: 324, height: 281 },
  'Unequal_shapes_2_parts/Triangle_unequal_1_2_2_yellow': { width: 324, height: 281 },
  'Unequal_shapes_2_parts/Triangle_unequal_1_2_3_blue': { width: 410, height: 410 },
  'Unequal_shapes_2_parts/Triangle_unequal_1_2_3_green': { width: 410, height: 410 },
  'Unequal_shapes_2_parts/Triangle_unequal_1_2_3_yellow': { width: 410, height: 410 },
  'Unequal_shapes_2_parts/Triangle_unequal_2-2': { width: 323.30908, height: 280.461 },
  'Unequal_shapes_3_parts/Circle_unequal_3-1_1_blue': { width: 316, height: 316 },
  'Unequal_shapes_3_parts/Circle_unequal_3-1_1_green': { width: 316, height: 316 },
  'Unequal_shapes_3_parts/Circle_unequal_3-1_1_yellow': { width: 316, height: 316 },
  'Unequal_shapes_3_parts/Circle_unequal_3-3': { width: 310.09598, height: 310.09598 },
  'Unequal_shapes_3_parts/Hexagon_unequal_3-1_1_blue': { width: 94, height: 108 },
  'Unequal_shapes_3_parts/Hexagon_unequal_3-1_1_green': { width: 94, height: 108 },
  'Unequal_shapes_3_parts/Hexagon_unequal_3-1_1_yellow': { width: 94, height: 108 },
  'Unequal_shapes_3_parts/Rectangle_unequal_3-1_1_blue': { width: 555, height: 294 },
  'Unequal_shapes_3_parts/Rectangle_unequal_3-1_1_green': { width: 555, height: 294 },
  'Unequal_shapes_3_parts/Rectangle_unequal_3-1_1_yellow': { width: 555, height: 294 },
  'Unequal_shapes_3_parts/Square_unequal_1-3': { width: 286.728, height: 286.728 },
  'Unequal_shapes_3_parts/Square_unequal_3-1_1_blue': { width: 292, height: 295 },
  'Unequal_shapes_3_parts/Square_unequal_3-1_1_green': { width: 292, height: 295 },
  'Unequal_shapes_3_parts/Square_unequal_3-1_1_yellow': { width: 292, height: 295 },
  'Unequal_shapes_3_parts/Square_unequal_3-3': { width: 286.728, height: 286.728 },
  'Unequal_shapes_3_parts/Triangle_unequal_1-3': { width: 323.30908, height: 280.461 },
  'Unequal_shapes_3_parts/Triangle_unequal_3-1_1_blue': { width: 369, height: 321 },
  'Unequal_shapes_3_parts/Triangle_unequal_3-1_1_green': { width: 369, height: 321 },
  'Unequal_shapes_3_parts/Triangle_unequal_3-1_1_yellow': { width: 369, height: 321 },
  'Unequal_shapes_3_parts/Triangle_unequal_3-3': { width: 323.30908, height: 280.461 },
  'Unequal_shapes_4_parts/Arrow_unequal_1_4_1_blue': { width: 355, height: 290 },
  'Unequal_shapes_4_parts/Arrow_unequal_1_4_1_green': { width: 355, height: 290 },
  'Unequal_shapes_4_parts/Arrow_unequal_1_4_1_yellow': { width: 355, height: 290 },
  'Unequal_shapes_4_parts/Arrow_unequal_1_4_2_blue': { width: 355, height: 290 },
  'Unequal_shapes_4_parts/Arrow_unequal_1_4_2_green': { width: 355, height: 290 },
  'Unequal_shapes_4_parts/Arrow_unequal_1_4_2_yellow': { width: 355, height: 290 },
  'Unequal_shapes_4_parts/Arrow_unequal_3_4_1_blue': { width: 355, height: 290 },
  'Unequal_shapes_4_parts/Arrow_unequal_3_4_1_green': { width: 355, height: 290 },
  'Unequal_shapes_4_parts/Arrow_unequal_3_4_1_yellow': { width: 355, height: 290 },
  'Unequal_shapes_4_parts/Circle_unequal_1_4_1_blue': { width: 312, height: 313 },
  'Unequal_shapes_4_parts/Circle_unequal_1_4_1_green': { width: 312, height: 313 },
  'Unequal_shapes_4_parts/Circle_unequal_1_4_1_yellow': { width: 312, height: 313 },
  'Unequal_shapes_4_parts/Circle_unequal_1_4_2_blue': { width: 312, height: 313 },
  'Unequal_shapes_4_parts/Circle_unequal_1_4_2_green': { width: 312, height: 313 },
  'Unequal_shapes_4_parts/Circle_unequal_1_4_2_yellow': { width: 312, height: 313 },
  'Unequal_shapes_4_parts/Circle_unequal_3_4_1_blue': { width: 312, height: 313 },
  'Unequal_shapes_4_parts/Circle_unequal_3_4_1_green': { width: 312, height: 313 },
  'Unequal_shapes_4_parts/Circle_unequal_3_4_1_yellow': { width: 312, height: 313 },
  'Unequal_shapes_4_parts/Circle_unequal_4-4': { width: 310.09598, height: 310.09598 },
  'Unequal_shapes_4_parts/Cross_unequal_1-4': { width: 328, height: 328 },
  'Unequal_shapes_4_parts/Cross_unequal_3-4': { width: 328, height: 328 },
  'Unequal_shapes_4_parts/Cross_unequal_4-4': { width: 328, height: 328 },
  'Unequal_shapes_4_parts/Heart_unequal_1_4_1_blue': { width: 294, height: 297 },
  'Unequal_shapes_4_parts/Heart_unequal_1_4_1_green': { width: 294, height: 297 },
  'Unequal_shapes_4_parts/Heart_unequal_1_4_1_yellow': { width: 294, height: 297 },
  'Unequal_shapes_4_parts/Heart_unequal_1_4_2_blue': { width: 294, height: 297 },
  'Unequal_shapes_4_parts/Heart_unequal_1_4_2_green': { width: 294, height: 297 },
  'Unequal_shapes_4_parts/Heart_unequal_1_4_2_yellow': { width: 294, height: 297 },
  'Unequal_shapes_4_parts/Heart_unequal_1_4_3_blue': { width: 294, height: 296 },
  'Unequal_shapes_4_parts/Heart_unequal_1_4_3_green': { width: 294, height: 296 },
  'Unequal_shapes_4_parts/Heart_unequal_1_4_3_yellow': { width: 294, height: 296 },
  'Unequal_shapes_4_parts/Heart_unequal_1_4_4_blue': { width: 294, height: 296 },
  'Unequal_shapes_4_parts/Heart_unequal_1_4_4_green': { width: 294, height: 296 },
  'Unequal_shapes_4_parts/Heart_unequal_1_4_4_yellow': { width: 294, height: 296 },
  'Unequal_shapes_4_parts/Heart_unequal_3_4_3_blue': { width: 294, height: 296 },
  'Unequal_shapes_4_parts/Heart_unequal_3_4_3_green': { width: 294, height: 296 },
  'Unequal_shapes_4_parts/Heart_unequal_3_4_3_yellow': { width: 294, height: 296 },
  'Unequal_shapes_4_parts/Hexagon_unequal_1_4_1_blue': { width: 383, height: 342 },
  'Unequal_shapes_4_parts/Hexagon_unequal_1_4_1_green': { width: 383, height: 342 },
  'Unequal_shapes_4_parts/Hexagon_unequal_1_4_1_yellow': { width: 383, height: 342 },
  'Unequal_shapes_4_parts/Hexagon_unequal_1_4_2_blue': { width: 383, height: 342 },
  'Unequal_shapes_4_parts/Hexagon_unequal_1_4_2_green': { width: 383, height: 342 },
  'Unequal_shapes_4_parts/Hexagon_unequal_1_4_2_yellow': { width: 383, height: 342 },
  'Unequal_shapes_4_parts/Hexagon_unequal_3_4_2_blue': { width: 383, height: 342 },
  'Unequal_shapes_4_parts/Hexagon_unequal_3_4_2_green': { width: 383, height: 342 },
  'Unequal_shapes_4_parts/Hexagon_unequal_3_4_2_yellow': { width: 383, height: 342 },
  'Unequal_shapes_4_parts/Octagon_unequal_1_4_1_blue': { width: 334, height: 332 },
  'Unequal_shapes_4_parts/Octagon_unequal_1_4_1_green': { width: 334, height: 332 },
  'Unequal_shapes_4_parts/Octagon_unequal_1_4_1_yellow': { width: 334, height: 332 },
  'Unequal_shapes_4_parts/Octagon_unequal_1_4_2_blue': { width: 334, height: 332 },
  'Unequal_shapes_4_parts/Octagon_unequal_1_4_2_green': { width: 334, height: 332 },
  'Unequal_shapes_4_parts/Octagon_unequal_1_4_2_yellow': { width: 334, height: 332 },
  'Unequal_shapes_4_parts/Rectangle_unequal_1_4_1_blue': { width: 552, height: 290 },
  'Unequal_shapes_4_parts/Rectangle_unequal_1_4_1_green': { width: 552, height: 290 },
  'Unequal_shapes_4_parts/Rectangle_unequal_1_4_1_yellow': { width: 552, height: 290 },
  'Unequal_shapes_4_parts/Rectangle_unequal_1_4_2_blue': { width: 552, height: 290 },
  'Unequal_shapes_4_parts/Rectangle_unequal_1_4_2_green': { width: 552, height: 290 },
  'Unequal_shapes_4_parts/Rectangle_unequal_1_4_2_yellow': { width: 552, height: 290 },
  'Unequal_shapes_4_parts/Rectangle_unequal_3_4_1_blue': { width: 552, height: 290 },
  'Unequal_shapes_4_parts/Rectangle_unequal_3_4_1_green': { width: 552, height: 290 },
  'Unequal_shapes_4_parts/Rectangle_unequal_3_4_1_yellow': { width: 552, height: 290 },
  'Unequal_shapes_4_parts/Square_unequal_1-4': { width: 286.728, height: 286.728 },
  'Unequal_shapes_4_parts/Square_unequal_1_4_1_blue': { width: 291, height: 291 },
  'Unequal_shapes_4_parts/Square_unequal_1_4_1_green': { width: 291, height: 291 },
  'Unequal_shapes_4_parts/Square_unequal_1_4_1_yellow': { width: 291, height: 291 },
  'Unequal_shapes_4_parts/Square_unequal_1_4_2_blue': { width: 291, height: 291 },
  'Unequal_shapes_4_parts/Square_unequal_1_4_2_green': { width: 291, height: 291 },
  'Unequal_shapes_4_parts/Square_unequal_1_4_2_yellow': { width: 291, height: 291 },
  'Unequal_shapes_4_parts/Square_unequal_3_4_1_blue': { width: 291, height: 291 },
  'Unequal_shapes_4_parts/Square_unequal_3_4_1_green': { width: 291, height: 291 },
  'Unequal_shapes_4_parts/Square_unequal_3_4_1_yellow': { width: 291, height: 291 },
  'Unequal_shapes_4_parts/Square_unequal_4-4': { width: 286.728, height: 286.728 },
  'Unequal_shapes_4_parts/Star_unequal_1_4_1_blue': { width: 347, height: 329 },
  'Unequal_shapes_4_parts/Star_unequal_1_4_1_green': { width: 347, height: 329 },
  'Unequal_shapes_4_parts/Star_unequal_1_4_1_yellow': { width: 347, height: 329 },
  'Unequal_shapes_4_parts/Star_unequal_1_4_2_blue': { width: 347, height: 329 },
  'Unequal_shapes_4_parts/Star_unequal_1_4_2_green': { width: 347, height: 329 },
  'Unequal_shapes_4_parts/Star_unequal_1_4_2_yellow': { width: 347, height: 329 },
  'Unequal_shapes_4_parts/Triangle_unequal_1_4_1_blue': { width: 363, height: 314 },
  'Unequal_shapes_4_parts/Triangle_unequal_1_4_1_green': { width: 363, height: 314 },
  'Unequal_shapes_4_parts/Triangle_unequal_1_4_1_yellow': { width: 363, height: 314 },
  'Unequal_shapes_4_parts/Triangle_unequal_1_4_2_blue': { width: 363, height: 314 },
  'Unequal_shapes_4_parts/Triangle_unequal_1_4_2_green': { width: 363, height: 314 },
  'Unequal_shapes_4_parts/Triangle_unequal_1_4_2_yellow': { width: 363, height: 314 },
  'Unequal_shapes_4_parts/Triangle_unequal_3_4_1_blue': { width: 363, height: 314 },
  'Unequal_shapes_4_parts/Triangle_unequal_3_4_1_green': { width: 363, height: 314 },
  'Unequal_shapes_4_parts/Triangle_unequal_3_4_1_yellow': { width: 363, height: 314 },
  'Unequal_shapes_5_parts/Circle_unequal_5-5': { width: 310.09598, height: 310.09598 },
  'Unequal_shapes_5_parts/Pentagon_unequal_1-5': { width: 341.99026, height: 325.25348 },
  'Unequal_shapes_5_parts/Pentagon_unequal_5-5': { width: 341.99026, height: 325.25348 },
  'Unequal_shapes_5_parts/Square_unequal_1-5': { width: 286.728, height: 286.728 },
  'Unequal_shapes_5_parts/Square_unequal_5-5': { width: 286.728, height: 286.728 },
  'Unequal_shapes_6_parts/Circle_unequal_6-6': { width: 310.09598, height: 310.31467 },
  'Unequal_shapes_6_parts/Hexagon_unequal6-6': { width: 345.34946, height: 299.08133 },
  'Unequal_shapes_6_parts/Square_unequal_6-6': { width: 286.728, height: 286.728 },
  'Unequal_shapes_7_parts/Circle_unequal_7-7': { width: 305.26932, height: 305.26932 },
  'Unequal_shapes_7_parts/Rectangle_unequal_7-7': { width: 406.944, height: 231.71066 },
  'Unequal_shapes_7_parts/Square_unequal_7-7': { width: 286.728, height: 286.728 },
  'Unequal_shapes_8_parts/Circle_unequal_8-8': { width: 310.09598, height: 310.09598 },
  'Unequal_shapes_8_parts/Cross_unequal_8-8': { width: 328, height: 328 },
  'Unequal_shapes_8_parts/Square_unequal_8-8': { width: 286.728, height: 287.05423 },
  'Unequal_shapes_9_parts/Circle_unequal_9-9': { width: 305.48801, height: 305.48801 },
  'Unequal_shapes_9_parts/Rectangle_unequal_9-9': { width: 406.944, height: 231.71066 },
  'Unequal_shapes_9_parts/Square_unequal_9-9': { width: 286.728, height: 286.728 },
  Wardrobe: { width: 305.23733, height: 518.66064 },
  Water_bottle: { width: 126.07066, height: 428.35772 },
  Water_bottle_glass: { width: 238.3448, height: 559.45825 },
  Water_bottle_glass_empty: { width: 238.3448, height: 559.45825 },
  Water_bottles_pack_of_12: { width: 389.58532, height: 358.41998 },
  Watering_can: { width: 602.56457, height: 363.4324 },
  Watermelon: { width: 285.4928, height: 289.66937 },
  'Wavy_circles/Wavy_circle_blue': { width: 86.900938, height: 86.900938 },
  'Wavy_circles/Wavy_circle_green': { width: 86.900938, height: 86.900938 },
  'Wavy_circles/Wavy_circle_orange': { width: 86.900938, height: 86.900938 },
  'Wavy_circles/Wavy_circle_pink': { width: 86.900938, height: 86.900938 },
  'Wavy_circles/Wavy_circle_purple': { width: 86.900938, height: 86.900938 },
  'Wavy_circles/Wavy_circle_red': { width: 86.900938, height: 86.900938 },
  'Wavy_circles/Wavy_circle_turquoise': { width: 86.900938, height: 86.900938 },
  'Wavy_circles/Wavy_circle_yellow': { width: 86.900938, height: 86.900938 },
  'Weights/Weight': { width: 208.61069, height: 207.1144 },
  'Weights/Weights_100g': { width: 208.61069, height: 207.1144 },
  'Weights/Weights_10g': { width: 108.02697, height: 107.2644 },
  'Weights/Weights_1g': { width: 76.497858, height: 74.500879 },
  'Weights/Weights_1kg': { width: 372.74521, height: 368.91989 },
  'Weights/Weights_200g': { width: 222.64899, height: 221.04987 },
  'Weights/Weights_20g': { width: 133.263, height: 132.31627 },
  'Weights/Weights_20kg': { width: 472.72818, height: 406.43505 },
  'Weights/Weights_25g': { width: 144.14082, height: 142.26286 },
  'Weights/Weights_2g': { width: 68.118455, height: 66.849427 },
  'Weights/Weights_2kg': { width: 402.35022, height: 374.38882 },
  'Weights/Weights_500g': { width: 333.461, height: 331.05212 },
  'Weights/Weights_50g': { width: 165.61829, height: 164.43599 },
  'Weights/Weights_50kg': { width: 465.41001, height: 447.39364 },
  'Weights/Weights_5g': { width: 80.643106, height: 80.801583 },
  'Weights/Weights_5kg': { width: 414.95679, height: 389.83636 },
  WhiteRoseInfinity: { width: 415.4473267, height: 108.3203812 },
  WhiteRoseInfinityDark: { width: 229, height: 60 },
  White_van: { width: 683.11743, height: 310.5748 },
  'Whole_shapes/Whole_shape_1': { width: 554.20262, height: 177.70132 },
  'Whole_shapes/Whole_shape_2': { width: 377.76931, height: 419.52133 },
  'Whole_shapes/Whole_shape_3': { width: 561.46532, height: 345.30798 },
  'Whole_shapes/Whole_shape_5': { width: 592.67595, height: 317.51599 },
  Wooden_barrel: { width: 255.56409, height: 305.56653 },
  Wooden_crate: { width: 320.336, height: 233.46533 },
  Worm: { width: 561.97229, height: 384.14496 },
  Wrapped_gifts_blue: { width: 291.87723, height: 234.67 },
  Wrapped_gifts_pink: { width: 291.87723, height: 234.67 },
  Wrapped_gifts_red: { width: 296.08478, height: 293.31207 },
  WrmLogo: { width: 178, height: 64 },
  Yoyo: { width: 448.26037, height: 223.08983 },
  bird_blue: { width: 446.98267, height: 384.45868 },
  'bowls/Bowl_Beans': { width: 239.43466, height: 173.2951 },
  'bowls/Bowl_Cereal': { width: 239.43466, height: 181.4095 },
  'bowls/Bowl_Empty': { width: 239.43466, height: 131.20934 },
  'bowls/Bowl_Rice': { width: 239.43466, height: 176.96982 },
  cafe_birds_eye_view: { width: 306.89172, height: 336.9407 },
  cupOfSand: { width: 111, height: 121 },
  cup_red: { width: 110.43697, height: 120.15202 },
  drinking_straw: { width: 1160.588, height: 37.921333 },
  drinking_straw_vertical: { width: 37.921333, height: 1160.588 },
  'fingers/Hand_1': { width: 505, height: 998 },
  'fingers/Hand_2': { width: 509, height: 1044 },
  'fingers/Hand_3': { width: 509, height: 1070 },
  'fingers/Hand_4': { width: 668, height: 1112 },
  'fingers/Hand_5': { width: 828, height: 1111 },
  full_swimming_pool: { width: 551.91711, height: 167.08533 },
  glass_empty: { width: 595, height: 782 },
  hospital_birds_eye_view: { width: 325.40658, height: 321.77524 },
  icecream: { width: 134.56444, height: 223.33408 },
  lollipop_ball: { width: 195.94972, height: 195.94933 },
  lollipop_stick: { width: 621.59467, height: 21.045332 },
  marshmallow: { width: 169.87604, height: 165.16972 },
  park_birds_eye_view: { width: 739.13464, height: 519.49334 },
  park_birds_eye_view_with_arrows: { width: 766, height: 546 },
  'parts_of_a_whole/bicycle/Bicycle': { width: 597.49, height: 350.19 },
  'parts_of_a_whole/bicycle/Frame': { width: 410.48, height: 231.67 },
  'parts_of_a_whole/bicycle/Handlebar': { width: 69.996, height: 68.084 },
  'parts_of_a_whole/bicycle/Helmet': { width: 170.71, height: 168.24 },
  'parts_of_a_whole/bicycle/Pedal': { width: 133.64, height: 135.75 },
  'parts_of_a_whole/bicycle/Seat': { width: 97.216, height: 40.192 },
  'parts_of_a_whole/bicycle/Wheel': { width: 215.45, height: 214.43 },
  'parts_of_a_whole/house/Chimney': { width: 9.361, height: 17.044 },
  'parts_of_a_whole/house/Door_black': { width: 23.077, height: 48.232 },
  'parts_of_a_whole/house/Door_blue': { width: 23.077, height: 48.232 },
  'parts_of_a_whole/house/Door_red': { width: 23.077, height: 48.232 },
  'parts_of_a_whole/house/House': { width: 149.28, height: 172.07 },
  'parts_of_a_whole/house/Roof_black': { width: 149.28, height: 36.516 },
  'parts_of_a_whole/house/Roof_brown': { width: 149.28, height: 36.516 },
  'parts_of_a_whole/house/Window_bottomLeft': { width: 50.628, height: 34.905 },
  'parts_of_a_whole/house/Window_topLeft': { width: 38.244, height: 36.688 },
  'parts_of_a_whole/house/Window_topRight': { width: 38.244, height: 36.688 },
  'parts_of_a_whole/icecream/Cone': { width: 104.31, height: 169.5 },
  'parts_of_a_whole/icecream/Flake': { width: 77.651, height: 143.91 },
  'parts_of_a_whole/icecream/Icecream': { width: 162.18, height: 314.52 },
  'parts_of_a_whole/icecream/Scoop_chocolate': { width: 107.49, height: 106.06 },
  'parts_of_a_whole/icecream/Scoop_mint': { width: 107.94, height: 106.07 },
  'parts_of_a_whole/icecream/Scoop_strawberry': { width: 107.94, height: 106.07 },
  'parts_of_a_whole/icecream/Scoop_vanilla': { width: 107.94, height: 106.07 },
  'parts_of_a_whole/icecream/Sprinkles': { width: 136.74, height: 82.997 },
  'parts_of_a_whole/icecream/Tub': { width: 126.68, height: 119.73 },
  'pencil_packs/Pack_of_pencils_10': { width: 245.75465, height: 427.888 },
  'pencil_packs/Pack_of_pencils_100': { width: 245.75465, height: 427.888 },
  'pencil_packs/Pack_of_pencils_unlabelled': { width: 245.75465, height: 427.888 },
  pencil_rubber: { width: 79.999999, height: 57.333331 },
  pencil_tip: { width: 80.170669, height: 56.057227 },
  pool_birds_eye_view: { width: 391.80771, height: 222.24266 },
  ruler_15_cm: { width: 1227.3839, height: 179.43333 },
  ruler_8_cm: { width: 687.38395, height: 179.43333 },
  school_birds_eye_view: { width: 247.20799, height: 268.108 },
  stick: { width: 826.16129, height: 133.53635 },
  tablespoon: { width: 691.01941, height: 107.19114 },
  teacup: { width: 289, height: 196 },
  tennis_ball: { width: 73.932, height: 73.930665 },
  trees_birds_eye_view: { width: 394.09076, height: 257.78247 },
  triangle_grey: { width: 88, height: 75 },
  'zest/rotate-left': { width: 38, height: 43 }
};
